var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/CardElement/CardElement.tsx
import classNames7 from "classnames";
import { forwardRef, useEffect as useEffect5, useImperativeHandle, useRef as useRef2 } from "react";
import { FormProvider, useForm } from "react-hook-form";

// ../internal-components/src/Cards/Tokenization/context/CardsContextProvider.tsx
import { createContext, useReducer } from "react";

// ../internal-components/src/Cards/Tokenization/context/model.ts
var IS_TOKENIZATION = true;
var defaultState = (recipient = {}, sessionType, acceptedCards, urls, schema, accessKey, accessToken, threeDSVersion, sessionId, confirmUrl, environment, magicValuesEnabled, locale, onSuccess = () => {
}, onError = () => {
}, offer, amount, actionButtonType, checkoutFields, showGeneralTandC, showPaymentMethodTandC) => ({
  sessionId,
  isTokenization: IS_TOKENIZATION,
  recipient,
  onSuccess,
  onError,
  isLoading: false,
  offer,
  amount,
  sessionType,
  actionButtonType: actionButtonType || "save",
  acceptedCards,
  urls,
  schema,
  accessKey,
  accessToken,
  threeDSVersion,
  environment,
  confirm: confirmUrl,
  magicValuesEnabled: magicValuesEnabled || false,
  locale: locale || "en",
  redirectUrl: null,
  inChallenge: false,
  successfulTokenization: false,
  onReturnFromChallenge: () => null,
  sessionExpired: false,
  checkoutFields: checkoutFields ?? [],
  showGeneralTandC: showGeneralTandC ?? true,
  showPaymentMethodTandC: showPaymentMethodTandC ?? true
});

// ../internal-components/src/Cards/Tokenization/context/actions.ts
var startChallenge = (redirectUrl, onReturnFromChallenge, trace) => ({
  type: "START_CHALLENGE" /* START_CHALLENGE */,
  redirectUrl,
  onReturnFromChallenge,
  trace
});
var startRechallenge = (redirectUrl) => ({
  type: "START_RECHALLENGE" /* START_RECHALLENGE */,
  redirectUrl
});
var returnFromSuccessfulChallenge = () => ({
  type: "RETURN_FROM_SUCCESSFUL_CHALLENGE" /* RETURN_FROM_SUCCESSFUL_CHALLENGE */
});
var returnFromFailedChallenge = () => ({
  type: "RETURN_FROM_FAILED_CHALLENGE" /* RETURN_FROM_FAILED_CHALLENGE */
});
var showLoading = () => ({
  type: "SHOW_LOADING" /* SHOW_LOADING */
});
var hideLoading = () => ({
  type: "HIDE_LOADING" /* HIDE_LOADING */
});

// ../internal-components/src/Cards/Tokenization/context/reducer.ts
var reducer = (state, action) => {
  switch (action.type) {
    case "SHOW_EXPIRED_SESSION_ERROR" /* SHOW_EXPIRED_SESSION_ERROR */:
      return { ...state, isLoading: false, error: void 0, sessionExpired: true };
    case "SHOW_ERROR" /* SHOW_ERROR */:
      return {
        ...state,
        error: action.error,
        isLoading: false
      };
    case "START_CHALLENGE" /* START_CHALLENGE */:
      return {
        ...state,
        error: void 0,
        inChallenge: true,
        redirectUrl: action.redirectUrl,
        onReturnFromChallenge: action.onReturnFromChallenge,
        trace: action.trace
      };
    case "START_RECHALLENGE" /* START_RECHALLENGE */:
      return {
        ...state,
        error: void 0,
        inChallenge: true,
        redirectUrl: action.redirectUrl
      };
    case "RETURN_FROM_SUCCESSFUL_CHALLENGE" /* RETURN_FROM_SUCCESSFUL_CHALLENGE */:
      return {
        ...state,
        inChallenge: false,
        successfulTokenization: true,
        redirectUrl: null,
        error: void 0
      };
    case "RETURN_FROM_FAILED_CHALLENGE" /* RETURN_FROM_FAILED_CHALLENGE */:
      return {
        ...state,
        inChallenge: false,
        successfulTokenization: false,
        redirectUrl: null,
        error: "challenge_error"
      };
    case "RETURN_BACK_TO_FORM" /* RETURN_BACK_TO_FORM */:
      return {
        ...state,
        inChallenge: false,
        successfulTokenization: false,
        redirectUrl: null,
        error: void 0,
        isLoading: false
      };
    case "SUCCESSFUL_TOKENIZATION" /* SUCCESSFUL_TOKENIZATION */:
      return {
        ...state,
        successfulTokenization: true,
        isLoading: false
      };
    case "SHOW_LOADING" /* SHOW_LOADING */:
      return { ...state, isLoading: true };
    case "HIDE_LOADING" /* HIDE_LOADING */:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

// ../internal-components/src/Cards/Tokenization/context/CardsContextProvider.tsx
import { jsx } from "react/jsx-runtime";
var CardsContext = createContext(void 0);
CardsContext.displayName = "CardsContext";
var CardsContextProvider = (props) => {
  const {
    sessionId,
    children,
    recipient,
    recipientId,
    onSuccess,
    onError,
    offer,
    amount,
    type,
    actionButtonType,
    acceptedCards,
    fetchCountriesUrl,
    storePaymentsDetailsUrl,
    createPayerUrl,
    ddcIssuerDomain,
    ddcIssuerUrl,
    ddcProviderUrl,
    createPaymentUrl,
    tokenizeCardUrl,
    returnUrl,
    completeFormUrl,
    schema,
    accessKey,
    accessToken,
    threeDSVersion,
    locale,
    magicValuesEnabled,
    paymentOptionsCurrenciesUrl,
    validateCardsUrl,
    fetchOffersUrl,
    confirmUrl,
    binLookupUrl,
    environment,
    checkoutFields,
    showGeneralTandC,
    showPaymentMethodTandC
  } = props;
  const urls = {
    fetchCountries: fetchCountriesUrl,
    updateSessionsPayer: createPayerUrl,
    storeCardInVault: storePaymentsDetailsUrl,
    ddcDomain: ddcIssuerDomain,
    ddcIssuer: ddcIssuerUrl,
    ddcProvider: ddcProviderUrl,
    zeroDollarCharge: tokenizeCardUrl,
    storeCardInPlatform: returnUrl,
    completeSession: completeFormUrl,
    fetchPaymentOptions: paymentOptionsCurrenciesUrl,
    validateCard: validateCardsUrl,
    createPayment: createPaymentUrl,
    fetchOffer: fetchOffersUrl,
    binLookup: binLookupUrl
  };
  const [state, dispatch] = useReducer(
    reducer,
    defaultState(
      { ...recipient, id: recipientId },
      type,
      acceptedCards,
      urls,
      schema,
      accessKey,
      accessToken,
      threeDSVersion,
      sessionId,
      confirmUrl,
      environment,
      magicValuesEnabled,
      locale,
      onSuccess,
      onError,
      offer,
      amount,
      actionButtonType,
      checkoutFields,
      showGeneralTandC,
      showPaymentMethodTandC
    )
  );
  return /* @__PURE__ */ jsx(CardsContext.Provider, { value: { state, dispatch }, children });
};

// ../internal-components/src/hooks/useSafeContext.ts
import { useContext } from "react";
function useSafeContext(contextType, contextName = contextType.displayName) {
  const context = useContext(contextType);
  if (!contextName) {
    console.warn(
      "You are using useSafeContext with a hook without displayName.\nPlease provide one by doing MyContext.displayName = 'wadus'"
    );
  }
  if (!context)
    throw new Error(`No ${contextName}.Provider found when calling ${contextName}.`);
  return context;
}

// ../internal-components/src/Cards/Tokenization/context/useCardsContext.ts
var useCardsContext = () => useSafeContext(CardsContext);

// ../internal-components/src/components/CardForm/CardForm.tsx
import classNames5 from "classnames";
import { createContext as createContext3, useCallback, useState as useState4 } from "react";
import { useFormContext as useFormContext3, useWatch as useWatch2 } from "react-hook-form";

// ../internal-components/src/DirectDebit/model.ts
var PERSONAL_ACCOUNT_TYPE = "personal";
var BUSINESS_ACCOUNT_TYPE = "business";
var FIELDS = {
  ACCOUNT_HOLDER_TYPE: "account_holder_type",
  BUSINESS_NAME: "business_name",
  NAME: "name",
  SURNAME: "surname",
  COUNTRY: "country",
  CITY: "city",
  ADDRESS: "address",
  PHONE: "phone",
  EMAIL: "email",
  ZIP: "zip",
  BIC: "bic",
  IBAN: "iban",
  STATE: "state",
  ACCOUNT_NUMBER: "accountnumber",
  SORT_CODE: "sortcode",
  CARD_NUMBER: "cardNumber",
  CARD_EXPIRY_DATE: "expiryDate",
  CARD_CVV: "cvv",
  GENERAL_T_AND_C: "general-t-and-c",
  PAYMENT_METHOD_T_AND_C: "payment-method-t-and-c",
  ACH_ACCOUNT_NUMBER: "ach_account_number",
  ROUTING_NUMBER: "routing_number",
  ACH_ACCOUNT_TYPE: "account_type"
};
var COUNTRY_CODES = [
  "AT",
  "AD",
  "AX",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "GF",
  "DE",
  "GR",
  "GP",
  "HU",
  "IS",
  "IE",
  "IT",
  "LV",
  "LI",
  "LT",
  "LU",
  "MT",
  "MQ",
  "YT",
  "MC",
  "NL",
  "NO",
  "PL",
  "PT",
  "RE",
  "RO",
  "BL",
  "MF",
  "PM",
  "SM",
  "SK",
  "SI",
  "ES",
  "SE",
  "CH",
  "GB",
  "VA"
];

// ../internal-components/src/components/CardCVV/CardCVV.tsx
import classNames from "classnames";
import { useEffect as useEffect2, useState as useState2 } from "react";

// ../internal-components/src/components/CardCVV/HelpIcon.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
function HelpIcon(props) {
  return /* @__PURE__ */ jsx2("span", { ...props, children: /* @__PURE__ */ jsx2("svg", { xmlns: "http://www.w3.org/2000/svg", width: "17", height: "17", children: /* @__PURE__ */ jsxs("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx2("circle", { cx: "8.5", cy: "8.5", r: "8.5", fill: "#454F5B" }),
    /* @__PURE__ */ jsx2(
      "path",
      {
        fill: "#FFF",
        d: "M7.582 9.848v-.434c0-.375.08-.701.24-.978.16-.278.453-.573.88-.885.41-.293.68-.531.81-.715a1.03 1.03 0 00.197-.615c0-.254-.094-.448-.281-.58-.188-.133-.45-.2-.785-.2-.586 0-1.254.192-2.004.575L6 4.732A5.582 5.582 0 018.771 4c.805 0 1.445.193 1.92.58.474.387.711.902.711 1.547 0 .43-.097.8-.293 1.113-.195.313-.566.664-1.113 1.055-.375.277-.612.488-.712.633-.1.144-.15.334-.15.568v.352H7.583m-.187 2.004c0-.329.087-.577.263-.745.176-.168.432-.252.768-.252.324 0 .575.086.753.258.177.172.266.418.266.739 0 .308-.09.551-.27.73-.179.177-.429.266-.75.266-.327 0-.581-.087-.76-.261-.18-.174-.27-.419-.27-.735"
      }
    )
  ] }) }) });
}

// ../internal-components/src/components/CardCVV/Tooltip.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var Tooltip = (props) => {
  return /* @__PURE__ */ jsxs2(
    "div",
    {
      id: props.domId,
      className: `
           fw-w-36 fw-cursor-default
           fw-transition-opacity fw-duration-200 fw-ease-in-out fw-bg-no-repeat
           fw-pointer-events-none fw-py-3 fw-px-4 fw-top-12 fw-h-auto
           fw-block fw-z-10 fw-bg-slate-800 fw-absolute fw-rounded-md
            fw-opacity-${props.show ? 100 : 0}  fw-right-[0.3rem] before:fw-left-[85%] before:fw-top-[-1.4rem] before:fw-text-[0rem] before:fw-h-6
            before:fw-border-solid before:fw-border-transparent before:fw-border-[9px] before:fw-border-t-0
            before:fw-border-b-[10px] before:fw-border-b-solid before:fw-border-b-slate-800 before:fw-absolute before:fw-w-0
            `,
      role: "tooltip",
      children: [
        /* @__PURE__ */ jsx3(CVVExampleIcon, {}),
        /* @__PURE__ */ jsx3("div", { className: " fw-font-normal fw-tracking-[0.003em] fw-pt-1 fw-text-[0.8rem] fw-text-white/80 fw-leading-[1.4]", children: props.message })
      ]
    }
  );
};
var CVVExampleIcon = () => {
  return /* @__PURE__ */ jsxs2("div", { className: "fw-pl-1 fw-flex fw-justify-around fw-items-center", children: [
    /* @__PURE__ */ jsxs2(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "34",
        height: "23",
        children: [
          /* @__PURE__ */ jsx3("defs", { children: /* @__PURE__ */ jsx3(
            "path",
            {
              id: "a",
              d: "M1.905 0h30.19C33.147 0 34 .853 34 1.905v16.023a1.905 1.905 0 01-1.905 1.905H1.905A1.905 1.905 0 010 17.928V1.905C0 .853.853 0 1.905 0z"
            }
          ) }),
          /* @__PURE__ */ jsxs2("g", { fill: "none", fillRule: "evenodd", children: [
            /* @__PURE__ */ jsx3("mask", { id: "b", fill: "#fff", children: /* @__PURE__ */ jsx3("use", { xlinkHref: "#a" }) }),
            /* @__PURE__ */ jsx3("use", { fill: "#D7DADE", fillRule: "nonzero", xlinkHref: "#a" }),
            /* @__PURE__ */ jsx3("path", { fill: "#1B2733", fillRule: "nonzero", d: "M0 2.833h34v3.778H0z", mask: "url(#b)" }),
            /* @__PURE__ */ jsx3(
              "path",
              {
                fill: "#FFF",
                fillRule: "nonzero",
                d: "M1.889 9.444h14.167v2.833H1.889z",
                mask: "url(#b)"
              }
            ),
            /* @__PURE__ */ jsx3(
              "path",
              {
                fill: "#FFF",
                fillRule: "nonzero",
                stroke: "#EC2941",
                strokeWidth: "0.756",
                d: "M17.944 6.611h14.167v9.444H17.944z",
                mask: "url(#b)"
              }
            ),
            /* @__PURE__ */ jsx3(
              "path",
              {
                fill: "#1B2733",
                d: "M21.593 13.438a.132.132 0 01-.102-.042.149.149 0 01-.038-.105V9.695l-1.071.823a.145.145 0 01-.096.038c-.038 0-.074-.021-.108-.064l-.153-.197a.153.153 0 01-.032-.09c0-.046.021-.085.063-.114L21.44 9.02a.302.302 0 01.166-.045h.3a.143.143 0 01.146.147v4.169a.143.143 0 01-.147.146h-.312zm1.409 0a.143.143 0 01-.147-.147V13.1c0-.098.053-.192.16-.28l1.39-1.384c.314-.268.53-.487.65-.657a.929.929 0 00.178-.542c0-.25-.07-.447-.21-.59-.14-.142-.345-.213-.612-.213-.255 0-.457.074-.606.223-.149.149-.24.349-.274.6a.167.167 0 01-.064.108.17.17 0 01-.102.038h-.306a.13.13 0 01-.096-.038.122.122 0 01-.038-.09 1.49 1.49 0 01.182-.653c.113-.21.28-.382.5-.516.221-.134.49-.201.804-.201.476 0 .834.124 1.074.373.24.248.36.564.36.947 0 .267-.065.508-.194.723-.13.215-.333.441-.61.679l-1.255 1.275h2.008c.047 0 .083.013.108.038a.147.147 0 01.039.109v.242a.143.143 0 01-.147.146h-2.792zm5.15.063c-.33 0-.618-.054-.86-.162a1.325 1.325 0 01-.551-.424.996.996 0 01-.201-.542.12.12 0 01.038-.093.136.136 0 01.096-.035h.287a.2.2 0 01.114.03c.03.018.053.055.07.11.056.217.176.37.36.46.186.089.403.133.654.133.306 0 .55-.073.73-.22.18-.146.271-.355.271-.627 0-.519-.317-.778-.95-.778h-.6a.143.143 0 01-.146-.147v-.165c0-.064.024-.12.07-.166l1.243-1.377H26.89a.149.149 0 01-.105-.038.132.132 0 01-.041-.103v-.229a.15.15 0 01.041-.112.143.143 0 01.105-.041h2.525a.15.15 0 01.112.041.15.15 0 01.041.112v.21a.233.233 0 01-.064.147l-1.243 1.396h.102c.434.013.777.125 1.03.338.253.213.379.523.379.93 0 .281-.07.522-.207.724-.138.202-.33.357-.577.466a2.055 2.055 0 01-.835.162z",
                mask: "url(#b)"
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs2(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "42",
        height: "23",
        children: [
          /* @__PURE__ */ jsx3("defs", { children: /* @__PURE__ */ jsx3(
            "path",
            {
              id: "a",
              d: "M1.825 0h28.921c1.008 0 1.825.817 1.825 1.825v15.35A1.825 1.825 0 0130.746 19H1.826A1.825 1.825 0 010 17.175V1.825C0 .817.817 0 1.825 0z"
            }
          ) }),
          /* @__PURE__ */ jsxs2("g", { fill: "none", fillRule: "evenodd", children: [
            /* @__PURE__ */ jsx3("mask", { id: "b", fill: "#fff", children: /* @__PURE__ */ jsx3("use", { xlinkHref: "#a" }) }),
            /* @__PURE__ */ jsx3("use", { fill: "#D7DADE", fillRule: "nonzero", xlinkHref: "#a" }),
            /* @__PURE__ */ jsx3(
              "path",
              {
                fill: "#FFF",
                fillRule: "nonzero",
                d: "M2 9h4v2H2zm0 4h16v2H2zm6-4h4v2H8zm6 0h4v2h-4z",
                mask: "url(#b)"
              }
            ),
            /* @__PURE__ */ jsx3(
              "path",
              {
                fill: "#FFF",
                fillRule: "nonzero",
                stroke: "#EC2941",
                strokeWidth: "0.905",
                d: "M20.81 3.619H41v11.857H20.81z"
              }
            ),
            /* @__PURE__ */ jsx3(
              "path",
              {
                fill: "#1B2733",
                d: "M25.522 12.429a.15.15 0 01-.116-.047.17.17 0 01-.044-.12V8.18l-1.216.934a.164.164 0 01-.108.043c-.044 0-.085-.024-.123-.072l-.174-.225a.174.174 0 01-.036-.101c0-.053.024-.097.072-.13l1.57-1.216a.343.343 0 01.189-.051h.34a.162.162 0 01.167.166v4.734a.162.162 0 01-.167.167h-.354zm1.6 0a.162.162 0 01-.167-.167v-.217c0-.111.06-.217.18-.319l1.579-1.57c.357-.304.603-.553.738-.746.135-.193.202-.398.202-.615 0-.285-.08-.508-.238-.67-.16-.161-.391-.242-.695-.242-.29 0-.519.084-.688.253-.169.17-.272.396-.311.68a.19.19 0 01-.072.124.193.193 0 01-.116.043h-.348a.147.147 0 01-.108-.043.139.139 0 01-.044-.102 1.69 1.69 0 01.207-.741 1.52 1.52 0 01.568-.587c.25-.152.555-.228.912-.228.54 0 .947.141 1.22.424.272.282.408.64.408 1.075 0 .304-.073.577-.22.821-.148.244-.378.5-.692.771l-1.426 1.448h2.28c.054 0 .095.014.123.043.03.029.044.07.044.123v.275a.162.162 0 01-.167.167h-3.17zm5.848.072a2.38 2.38 0 01-.978-.185 1.505 1.505 0 01-.626-.481 1.131 1.131 0 01-.228-.615c0-.044.015-.079.044-.105a.155.155 0 01.108-.04h.326c.053 0 .097.01.13.033.034.021.06.064.08.126a.75.75 0 00.409.521c.21.102.457.152.742.152.347 0 .623-.083.829-.25.205-.166.307-.403.307-.712 0-.589-.36-.883-1.078-.883h-.68a.162.162 0 01-.167-.167v-.188c0-.072.026-.135.08-.188l1.41-1.564h-2.142a.17.17 0 01-.119-.043.15.15 0 01-.047-.116v-.26c0-.053.016-.096.047-.127a.162.162 0 01.12-.047h2.866a.17.17 0 01.126.047.171.171 0 01.047.127v.238a.265.265 0 01-.072.167l-1.411 1.585h.115c.493.015.882.142 1.17.384.286.241.43.593.43 1.056 0 .319-.078.593-.235.822-.157.23-.375.405-.655.528s-.596.185-.948.185zm5.095-.072a.162.162 0 01-.166-.167v-1.057h-2.353a.162.162 0 01-.166-.166v-.268a.39.39 0 01.08-.217l2.178-3.069a.24.24 0 01.109-.09.384.384 0 01.159-.033h.492c.053 0 .094.014.123.043.03.03.044.07.044.123v3.07h.658a.162.162 0 01.167.166v.275a.162.162 0 01-.167.166h-.658v1.057a.162.162 0 01-.167.167h-.333zm-1.932-1.817h1.773V8.093l-1.773 2.519z"
              }
            )
          ] })
        ]
      }
    )
  ] });
};

// ../internal-components/src/components/Input/Input.tsx
import { useEffect, useRef } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";

// ../internal-components/src/components/Input/InputError.tsx
import { Field } from "@flywire/react-headlessui";
import { jsx as jsx4 } from "react/jsx-runtime";
var InputError = ({ children }) => {
  return /* @__PURE__ */ jsx4(
    Field.Error,
    {
      className: `fw-absolute !fw-opacity-0 fw-top-3/4 fw-m-0 fw-mt-2 fw-transition-all fw-ease-in-out fw-duration-200 fw-leading-3 md:fw-leading-4 fw-text-xs fw-text-red-600 fw-font-medium ${children ? "fw-top-full !fw-opacity-100" : ""}`,
      children
    }
  );
};

// ../internal-components/src/components/Input/InputLabel.tsx
import { Field as Field2 } from "@flywire/react-headlessui";
import { jsx as jsx5 } from "react/jsx-runtime";
var InputLabel = ({
  children,
  placeholder
}) => {
  return /* @__PURE__ */ jsx5(
    Field2.Label,
    {
      className: "fw-absolute fw-top-[6px] left-0 fw-m-0 fw-text-xs fw-text-shuttle-gray-500 fw-transition-all peer-placeholder-shown:fw-top-4 peer-placeholder-shown:fw-text-sm peer-focus:fw-top-[6px] peer-focus:fw-text-xs fw-overflow-hidden fw-whitespace-nowrap fw-w-full fw-text-ellipsis fw-px-2.5 fw-py-0",
      "aria-placeholder": placeholder,
      children
    }
  );
};

// ../internal-components/src/components/Input/Input.tsx
import { Field as Field3, useMaskInput } from "@flywire/react-headlessui";
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var InputHint = ({ children }) => {
  return /* @__PURE__ */ jsx6(
    Field3.Hint,
    {
      className: `fw-absolute fw-top-3/4 fw-transition-all !fw-opacity-0 fw-duration-200 fw-ease-in-out fw-right-0 fw-mt-2 fw-text-xs fw-text-shuttle-gray-500 fw-text-right fw-font-medium ${children ? "fw-top-full !fw-opacity-100" : ""}`,
      children
    }
  );
};
var Input = (props) => {
  const {
    initialValue,
    label,
    name,
    error,
    required,
    readOnly,
    hint,
    mask,
    patternErrorMessage,
    validate,
    onFocus
  } = props;
  const {
    control,
    setValue,
    getFieldState,
    formState: { isSubmitted: isFormAlreadySubmitted }
  } = useFormContext();
  const formValue = useWatch({ control, name, exact: true });
  const maskedInputRef = useRef(null);
  const { maxLength, minLength, pattern } = props;
  const commonProps = {
    name,
    label,
    required,
    readOnly,
    disabled: readOnly,
    "data-testid": props["data-testid"],
    type: props.type ?? "text",
    "aria-labelledby": props["aria-labelledby"],
    "aria-describedby": props["aria-describedby"],
    autoComplete: props.autoComplete
  };
  const { inputProps: maskInputProps } = useMaskInput({
    initialValue,
    mask,
    onFocus,
    onChange: (e) => {
      setValue(name, e.target.value, {
        shouldDirty: true,
        shouldValidate: isFormAlreadySubmitted
      });
      props.onChange?.(name, e.target.value);
    },
    ...commonProps
  });
  useEffect(() => {
    const forcedUpdateIsNeeded = mask && formValue === "" && maskedInputRef.current;
    if (forcedUpdateIsNeeded && maskedInputRef.current) {
      maskedInputRef.current.value = formValue;
    }
  }, [formValue, initialValue, mask, maskInputProps, maskInputProps.ref]);
  return /* @__PURE__ */ jsx6("div", { className: props.className, children: /* @__PURE__ */ jsx6(
    Controller,
    {
      defaultValue: initialValue || "",
      name: commonProps.name,
      control,
      disabled: props.disabled,
      rules: {
        deps: props.fieldDeps,
        maxLength,
        minLength,
        pattern: { value: pattern, message: patternErrorMessage },
        required: { value: required, message: props.requiredErrorMessage || "Invalid field" },
        validate
      },
      render: ({ field: { onChange, value, onBlur, name: name2, ...rest } }) => {
        return /* @__PURE__ */ jsxs3(Field3, { children: [
          /* @__PURE__ */ jsx6(
            Field3.Input,
            {
              className: `fw-relative fw-text-base fw-text-mirage-900 fw-peer fw-block fw-h-12 fw-w-full fw-appearance-none
          fw-rounded-sm fw-border fw-border-shuttle-gray-100 hover:fw-border-shuttle-gray-200 fw-outline-none
          fw-px-2 fw-pt-4 focus:fw-border-primary-600 focus:fw-shadow-lg-blue focus:fw-outline-none placeholder:fw-invisible ${error ? "fw-shadow-lg-red !fw-border-red-600 hover:fw-border-red-600 focus:fw-border-red-600 focus:fw-shadow-lg-red" : ""}
          ${readOnly ? "fw-cursor-not-allowed fw-bg-shuttle-gray-50" : ""}
          `,
              placeholder: " ",
              ...maskInputProps,
              ...rest,
              onBlur: (e) => {
                props.onBlur?.(name2, e.target.value);
                onBlur();
              },
              name: name2,
              ref: maskedInputRef,
              ...!mask ? {
                value,
                onChange: (e) => {
                  onChange(e);
                  props.onChange?.(name2, e.target.value);
                }
              } : {},
              ...mask && false ? {
                value,
                onChange
              } : {},
              required: false
            }
          ),
          /* @__PURE__ */ jsx6(InputLabel, { placeholder: label, children: label }),
          /* @__PURE__ */ jsx6(InputError, { children: error }),
          /* @__PURE__ */ jsx6(InputHint, { children: error ? null : hint })
        ] });
      }
    }
  ) });
};
Input.Label = InputLabel;
Input.Error = InputError;
Input.Hint = InputHint;

// ../internal-components/src/context/TranslationsContext.tsx
import { useState } from "react";
import { createContext as createContext2 } from "react";

// ../internal-components/src/utils/translations/locales/ar.ts
var ar = {
  "session_expired.title": "\u0644\u0642\u062F \u0627\u0646\u062A\u0647\u062A \u0627\u0644\u062C\u0644\u0633\u0629",
  "tokenizationForm.payment-terms.text1": "\u0623\u0641\u0648\u0636 Flywire \u0644\u062A\u062E\u0632\u064A\u0646 \u0648\u0627\u0644\u062E\u0635\u0645 \u0645\u0646 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u062E\u0635\u0645/\u0627\u0644\u0627\u0626\u062A\u0645\u0627\u0646 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u064A \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0646\u064A\u0627\u0628\u0629\u064B \u0639\u0646 {{recipientName}}. \u0644\u0642\u062F \u0642\u0631\u0623\u062A \u0648\u0641\u0647\u0645\u062A \u0648\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649",
  "tokenizationForm.general-terms.link2": "\u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
  "tokenizationForm.general-terms.link-joint": " \u0648 ",
  "tokenizationForm.general-terms.link1": "\u0634\u0631\u0648\u0637 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
  "tokenizationForm.payment-terms.link": "\u0634\u0631\u0648\u0637 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 Flywire \u0644\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A\u0629",
  "tokenizationForm.labels.cvvTooltip": "3 \u0623\u0631\u0642\u0627\u0645 \u0645\u0648\u062C\u0648\u062F\u0629 \u0641\u064A \u0627\u0644\u062C\u0632\u0621 \u0627\u0644\u062E\u0644\u0641\u064A \u0644\u0628\u0637\u0627\u0642\u062A\u0643 \u0623\u0648 4 \u0623\u0631\u0642\u0627\u0645 \u0641\u064A \u0627\u0644\u0623\u0645\u0627\u0645",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 (MM/YY)",
  "tokenizationForm.labels.cardNumber": "\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
  "tokenizationForm.labels.phone": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641",
  "tokenizationForm.labels.zip": "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A",
  "tokenizationForm.labels.address": "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
  "cardsForm.labels.state": "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
  "tokenizationForm.labels.country": "\u0627\u0644\u062F\u0648\u0644\u0629",
  "tokenizationForm.labels.city": "\u0627\u0644\u0645\u062F\u064A\u0646\u0629",
  "tokenizationForm.labels.email": "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  "tokenizationForm.labels.lastName": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062E\u064A\u0631",
  "tokenizationForm.labels.firstName": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644",
  "tokenizationForm.labels.dynamicFields.document": "\u0631\u0642\u0645 CPF \u0623\u0648 CNPJ",
  "cardsForm.title": "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062D\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629",
  "success.title": "\u0623\u0645\u0648\u0627\u0644\u0643 \u0641\u064A \u0627\u0644\u0637\u0631\u064A\u0642",
  "success.title.info": "\u064A\u064F\u0631\u062C\u0649 \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631 2-3 \u0623\u064A\u0627\u0645 \u0639\u0645\u0644 \u062D\u062A\u0649 \u062A\u0635\u0644 \u0627\u0644\u0623\u0645\u0648\u0627\u0644.\n\u0648\u0633\u062A\u062A\u0644\u0642\u0649 \u0631\u0633\u0627\u0644\u0629 \u0639\u0628\u0631 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0639\u0646\u062F \u062A\u0633\u0644\u064A\u0645 \u0627\u0644\u0623\u0645\u0648\u0627\u0644.",
  "bankAccountForm.hints.generic": "\u0645\u062B\u0627\u0644: {{label}}",
  "bankAccountForm.hints.account_number": "\u064A\u062C\u0628 \u0623\u0646 \u064A\u062A\u0631\u0627\u0648\u062D \u0637\u0648\u0644 \u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0628\u064A\u0646 1 \u0648 17 \u062D\u0631\u0641\u064B\u0627",
  "bankAccountForm.hints.routing_number": "\u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 \u0637\u0648\u0644 \u0631\u0642\u0645 \u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0628\u0646\u0643\u064A 9 \u0623\u0631\u0642\u0627\u0645",
  "bankAccountForm.labels.accountZipCode": "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A",
  "bankAccountForm.labels.accountIban": "\u0631\u0642\u0645 IBAN",
  "bankAccountForm.labels.accountBicCode": "\u0643\u0648\u062F BIC",
  "bankAccountForm.labels.accountNumber": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A",
  "bankAccountForm.labels.accountSortCode": "\u0643\u0648\u062F \u0627\u0644\u0641\u0631\u0632",
  "bankAccountForm.labels.accountRoutingNumber": "\u0631\u0642\u0645 \u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0628\u0646\u0643\u064A",
  "bankAccountForm.labels.accountType": "\u0646\u0648\u0639 \u0627\u0644\u062D\u0633\u0627\u0628",
  "bankAccountForm.labels.eftProviderWidnow": "\u0633\u0646\u0646\u062A\u0642\u0644 \u0628\u0643 \u0625\u0644\u0649 \u0645\u0646\u0635\u0629 \u0627\u0644\u0645\u0639\u0627\u0644\u062C\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u0637\u0631\u0641 \u0627\u0644\u0634\u0631\u064A\u0643\u061B \u0644\u0625\u0643\u0645\u0627\u0644 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u0633\u062F\u0627\u062F \u0647\u0630\u0647. \u0628\u0645\u062C\u0631\u062F \u0627\u0643\u062A\u0645\u0627\u0644 \u0627\u0644\u0639\u0645\u0644\u064A\u0629\u060C \u0633\u064A\u064F\u0639\u0627\u062F\u064F \u062A\u0648\u062C\u064A\u0647\u0643 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0625\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629.",
  "bankAccountForm.labels.termsFlywire": "\u0644\u0642\u062F \u0642\u0631\u0623\u062A <a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>\u0634\u0631\u0648\u0637 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645</a> <a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>\u0648\u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629</a> \u0627\u0644\u062E\u0627\u0635\u062A\u064A\u0646 \u0628\u0634\u0631\u0643\u0629 Flywire\u060C \u0648\u0641\u0647\u0645\u062A\u0647\u0645\u0627 \u0648\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647\u0645\u0627.",
  "bankAccountForm.labels.termsDirectDebit": "\u0623\u0624\u0643\u062F \u0623\u0646\u064A \u0645\u0627\u0644\u0643 \u0647\u0630\u0627 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u0648\u0623\u0646\u064A \u0627\u0644\u0634\u062E\u0635 \u0627\u0644\u0648\u062D\u064A\u062F \u0635\u0627\u062D\u0628 \u0627\u0644\u062A\u0648\u0642\u064A\u0639\u060C \u0648\u0627\u0644\u0630\u064A \u064A\u0645\u0644\u0643 \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0633\u0645\u0627\u062D \u0628\u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0647\u0630\u0647",
  "bankAccountForm.labels.termsEft": "\u0644\u0642\u062F \u0642\u0631\u0623\u062A <a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>\u0627\u062A\u0641\u0627\u0642\u064A\u0629 \u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0627\u0644\u0645\u064F\u0639\u062A\u0645\u062F\u0629 \u0645\u064F\u0633\u0628\u0642\u064B\u0627</a> \u0647\u0630\u0647 \u0648\u0641\u0647\u0645\u062A\u0647\u0627 \u0648\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647\u0627.",
  "bankAccountForm.labels.city": "\u0627\u0644\u0645\u062F\u064A\u0646\u0629",
  "bankAccountForm.labels.country": "\u0627\u0644\u062F\u0648\u0644\u0629",
  "bankAccountForm.labels.selectCountry": "\u062D\u062F\u062F \u062F\u0648\u0644\u0629",
  "bankAccountForm.title": "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0635\u0627\u062D\u0628 \u0627\u0644\u062D\u0633\u0627\u0628",
  "failure.tryAgain": "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
  "failure.title": "\u0641\u0634\u0644\u062A \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629",
  "failure.connectivity.message": "\u062A\u0639\u0630\u0651\u0631\u062A \u0627\u0644\u0639\u0645\u0644\u064A\u0629\u060C \u0642\u062F \u064A\u0643\u0648\u0646 \u0647\u0630\u0627 \u0628\u0633\u0628\u0628 \u0645\u0634\u0627\u0643\u0644 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644.",
  "failure.message": "\u0641\u0634\u0644\u062A \u0647\u0630\u0647 \u0627\u0644\u0645\u064F\u0639\u0627\u0645\u0644\u0629. \u0642\u062F \u064A\u0643\u0648\u0646 \u0627\u0644\u0633\u0628\u0628 \u0641\u064A \u0630\u0644\u0643 \u0647\u0648 \u0648\u062C\u0648\u062F \u0645\u0634\u0643\u0644\u0627\u062A \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644\u061B \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649. \u0625\u0646 \u0627\u0633\u062A\u0645\u0631\u062A \u0647\u0630\u0647 \u0627\u0644\u0645\u0634\u0643\u0644\u0629\u060C \u064A\u064F\u0631\u062C\u0649 \u062A\u062C\u0631\u0628\u0629 \u0648\u0633\u064A\u0644\u0629 \u062F\u0641\u0639 \u0623\u062E\u0631\u0649\u060C \u0623\u0648 \u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u0628\u0646\u0643",
  "sessionExpired.text": "\u0644\u0642\u062F \u0627\u0646\u062A\u0647\u062A \u0627\u0644\u062C\u0644\u0633\u0629",
  "LoadingError.title": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627.",
  "LoadingError.message": "\u062D\u062F\u062B \u062E\u0637\u0623 \u0623\u062B\u0646\u0627\u0621 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0646\u0645\u0648\u0630\u062C.",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "\u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0633\u062F\u0627\u062F \u063A\u064A\u0631 \u0645\u062A\u0627\u062D\u0629 \u0644\u0644\u062F\u0648\u0644\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629",
  "bankAccountForm.labels.accountHolderType.personal": "\u062D\u0633\u0627\u0628 \u0634\u062E\u0635\u064A",
  "bankAccountForm.labels.accountHolderType.business": "\u062D\u0633\u0627\u0628 \u062A\u062C\u0627\u0631\u064A",
  "bankAccountForm.labels.name": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644",
  "bankAccountForm.labels.businessName": "\u0627\u0633\u0645 \u0627\u0644\u0646\u0634\u0627\u0637 \u0627\u0644\u062A\u062C\u0627\u0631\u064A",
  "bankAccountForm.labels.surname": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062E\u064A\u0631",
  "bankAccountForm.labels.phone": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641",
  "bankAccountForm.labels.email": "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  "bankAccountForm.labels.zip": "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A",
  "bankAccountForm.labels.accountAddress": "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
  "bankAccountForm.labels.address": "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
  "bankAccountForm.errors.dynamicFields": "{{field}} \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "bankAccountForm.errors.dynamicFields.document": "\u0631\u0642\u0645 CPF \u0623\u0648 CNPJ \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "bankAccountForm.errors.dynamicFields.documentPattern": "\u064A\u064F\u0631\u062C\u0649 \u062A\u0636\u0645\u064A\u0646 \u0631\u0642\u0645 CPF/CNPJ \u0628\u062F\u0648\u0646 hyphens (\u0648\u0627\u0635\u0644\u0627\u062A) \u0623\u0648 dashes (\u0634\u064E\u0631\u0637\u0627\u062A)",
  "bankAccountForm.labels.saveButton": "\u062D\u0641\u0638",
  "bankAccountForm.labels.nextButton": "\u0627\u0644\u062A\u0627\u0644\u064A",
  "bankAccountForm.labels.payButton": "\u0627\u0644\u062F\u0641\u0639",
  "bankAccountForm.errors.cardNumber": "\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "tokenizationForm.errors.cardNumber": "\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "tokenizationForm.errors.cvv": "\u0631\u0642\u0645 CVV \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "bankAccountForm.errors.cvv": "\u0631\u0642\u0645 CVV \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "tokenizationForm.errors.unsupportedCardTypes": "{{acceptedCardsList}} \u0647\u064A \u0627\u0644\u0645\u062F\u0639\u0648\u0645\u0629 \u0641\u0642\u0637",
  "tokenizationForm.errors.unsupportedCardType": "\u062A\u064F\u062F\u0639\u0645 {{acceptedCard}} \u0641\u0642\u0637",
  "tokenizationForm.errors.cardType.and": "\u0648",
  "tokenizationForm.errors.name": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "tokenizationForm.errors.email": "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "tokenizationForm.errors.country": "\u0627\u0644\u062F\u0648\u0644\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  "tokenizationForm.errors.state": "\u0627\u0644\u0648\u0644\u0627\u064A\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  "tokenizationForm.errors.city": "\u0627\u0644\u0645\u062F\u064A\u0646\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  "tokenizationForm.errors.address": "\u0639\u0646\u0648\u0627\u0646 \u062E\u0627\u0637\u0626",
  "tokenizationForm.errors.addressIsPoBox": "\u0644\u0627 \u0646\u0642\u0628\u0644 \u0635\u0646\u0627\u062F\u064A\u0642 \u0628\u0631\u064A\u062F \u0641\u064A \u062D\u0642\u0644 \u0627\u0644\u0639\u0646\u0648\u0627\u0646.",
  "tokenizationForm.errors.onlyLetterOrNumbers": "\u062A\u062A\u0636\u0645\u0646 \u0627\u0644\u0623\u062D\u0631\u0641 \u0627\u0644\u0635\u0627\u0644\u062D\u0629 A-Z \u06480-9 \u0641\u0642\u0637",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": '\u0627\u0644\u0623\u062D\u0631\u0641 \u0627\u0644\u0645\u0642\u0628\u0648\u0644\u0629 \u062A\u062A\u0636\u0645\u0646: \u0645\u0646 A \u0625\u0644\u0649 Z \u0648\u0645\u0646 0 \u0625\u0644\u0649 9 \u0648 \u0627\u0644\u0639\u0644\u0627\u0645\u062A\u064A\u0646 \u0628\u064A\u0646 \u0627\u0644\u0642\u0648\u0633\u064A\u0646: "/ -" \u0641\u0642\u0637',
  "tokenizationForm.errors.zip": "\u0645\u0644\u0641 \u0645\u0636\u063A\u0648\u0637 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "tokenizationForm.errors.expiryDate": "\u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "bankAccountForm.errors.expiryDate": "\u062A\u0627\u0631\u064A\u062E \u0627\u0646\u062A\u0647\u0627\u0621 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "tokenizationForm.errors.surname": "\u0627\u0633\u0645 \u0627\u0644\u0639\u0627\u0626\u0644\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "tokenizationForm.errors.phone": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "tokenizationForm.errors.length": "\u0627\u0644\u0645\u062F\u062E\u0644\u0627\u062A \u0637\u0648\u064A\u0644\u0629 \u062C\u062F\u064B\u0627 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0647\u0648 256 \u062D\u0631\u0641\u064B\u0627)",
  "bankAccountForm.errors.name": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "bankAccountForm.errors.name.maxSizeExceeded": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u0623\u0637\u0648\u0644 \u0645\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0647\u0648 140 \u062D\u0631\u0641\u064B\u0627)",
  "form.errors.name.maxSizeExceeded": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u0637\u0648\u064A\u0644 \u0644\u0644\u063A\u0627\u064A\u0629 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0647\u0648 {{limit}} \u062D\u0631\u0641\u064B\u0627)",
  "form.errors.surname.maxSizeExceeded": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062E\u064A\u0631 \u0637\u0648\u064A\u0644 \u0644\u0644\u063A\u0627\u064A\u0629 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0647\u0648 {{limit}} \u062D\u0631\u0641\u064B\u0627)",
  "form.errors.business_name.maxSizeExceeded": "\u0627\u0633\u0645 \u0627\u0644\u0646\u0634\u0627\u0637 \u0627\u0644\u062A\u062C\u0627\u0631\u064A \u0637\u0648\u064A\u0644 \u0644\u0644\u063A\u0627\u064A\u0629 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0647\u0648 {{limit}} \u062D\u0631\u0641\u064B\u0627)",
  "form.errors.city.maxSizeExceeded": "\u0627\u0633\u0645 \u0627\u0644\u0645\u062F\u064A\u0646\u0629 \u0637\u0648\u064A\u0644 \u0644\u0644\u063A\u0627\u064A\u0629 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0647\u0648 {{limit}} \u062D\u0631\u0641\u064B\u0627)",
  "form.errors.address.maxSizeExceeded": "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0637\u0648\u064A\u0644 \u0644\u0644\u063A\u0627\u064A\u0629 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0647\u0648 {{limit}} \u062D\u0631\u0641\u064B\u0627)",
  "bankAccountForm.errors.business_name": "\u0627\u0633\u0645 \u0627\u0644\u0646\u0634\u0627\u0637 \u0627\u0644\u062A\u062C\u0627\u0631\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "\u0627\u0633\u0645 \u0627\u0644\u0646\u0634\u0627\u0637 \u0627\u0644\u062A\u062C\u0627\u0631\u064A \u0637\u0648\u064A\u0644 \u062C\u062F\u064B\u0627 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0647\u0648 140 \u062D\u0631\u0641\u064B\u0627)",
  "bankAccountForm.errors.surname": "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062E\u064A\u0631 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "bankAccountForm.errors.surname.maxSizeExceeded": "\u0627\u0644\u0623\u0633\u0645 \u0627\u0644\u0623\u062E\u064A\u0631 \u0623\u0637\u0648\u0644 \u0645\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0647\u0648 140 \u062D\u0631\u0641\u064B\u0627)",
  "bankAccountForm.errors.country": "\u0627\u0644\u0628\u0644\u062F \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "bankAccountForm.errors.address": "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u062E\u0627\u0637\u0626",
  "bankAccountForm.errors.address.maxSizeExceeded": "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0623\u0637\u0648\u0644 \u0645\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0647\u0648 256 \u062D\u0631\u0641\u064B\u0627)",
  "bankAccountForm.errors.city": "\u0627\u0644\u0645\u062F\u064A\u0646\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
  "bankAccountForm.errors.city.maxSizeExceeded": "\u0627\u0633\u0645 \u0627\u0644\u0645\u062F\u064A\u0646\u0629 \u0623\u0637\u0648\u0644 \u0645\u0646 \u0627\u0644\u062D\u062F \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647 (\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0647\u0648 256 \u062D\u0631\u0641\u064B\u0627)",
  "bankAccountForm.errors.email": "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "bankAccountForm.errors.state": "\u0627\u0644\u0648\u0644\u0627\u064A\u0629 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629",
  "bankAccountForm.errors.iban": "\u0631\u0642\u0645 IBAN \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "bankAccountForm.errors.bic": "\u0631\u0645\u0632 BIC \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "bankAccountForm.errors.accountnumber": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "bankAccountForm.errors.sortcode": "\u0643\u0648\u062F \u0627\u0644\u0641\u0631\u0632 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "bankAccountForm.errors.account_type": "\u0646\u0648\u0639 \u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "bankAccountForm.errors.addressIsPoBox": "\u0644\u0627 \u0646\u0642\u0628\u0644 \u0635\u0646\u0627\u062F\u064A\u0642 \u0628\u0631\u064A\u062F \u0641\u064A \u062D\u0642\u0644 \u0627\u0644\u0639\u0646\u0648\u0627\u0646.",
  "bankAccountForm.errors.onlyLetterOrNumbers": "\u062A\u062A\u0636\u0645\u0646 \u0627\u0644\u0623\u062D\u0631\u0641 \u0627\u0644\u0635\u0627\u0644\u062D\u0629 A-Z \u06480-9 \u0641\u0642\u0637",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "\u0627\u0644\u0623\u062D\u0631\u0641 \u0627\u0644\u0635\u0627\u0644\u062D\u0629 \u0647\u064A: A-Z 0-9 / \u060C -",
  "bankAccountForm.errors.zip": "\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "bankAccountForm.errors.phone": "\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
  "bankAccountForm.errors.ach_account_number": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "bankAccountForm.errors.routing_number": "\u0631\u0642\u0645 \u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0628\u0646\u0643\u064A \u063A\u064A\u0631 \u0635\u062D\u064A\u062D",
  "bankAccountForm.errors.offer": "\u0644\u0627 \u062A\u062A\u0648\u0641\u0631 \u062E\u064A\u0627\u0631\u0627\u062A \u0633\u062F\u0627\u062F - \u0625\u0630\u0627 \u0643\u0627\u0646 \u0644\u062F\u064A\u0643 \u062D\u0633\u0627\u0628 \u0628\u0646\u0643\u064A \u0641\u064A \u062F\u0648\u0644\u0629 \u0623\u062E\u0631\u0649\u060C \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062F \u0647\u0630\u0647 \u0627\u0644\u062F\u0648\u0644\u0629 \u0623\u0648 \u0627\u062E\u062A\u064A\u0627\u0631 \u0628\u0637\u0627\u0642\u0629 \u0623\u062E\u0631\u0649\u060C \u0648\u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649. \u0648\u0625\u0630\u0627 \u0644\u0645 \u064A\u0624\u062F\u0650 \u0630\u0644\u0643 \u0625\u0644\u0649 \u062D\u0644 \u0627\u0644\u0645\u0634\u0643\u0644\u0629\u060C \u0641\u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0640 {{recipientName}}",
  "confirmationPage.labels.edit": "\u062A\u062D\u0631\u064A\u0631",
  "confirmationPage.labels.confirm": "\u062A\u0623\u0643\u064A\u062F",
  "confirmationPage.labels.title": "\u0645\u0631\u0627\u062C\u0639\u0629 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062A\u0641\u0648\u064A\u0636",
  "confirmationPage.labels.typeOfPayment": "\u0646\u0648\u0639 \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A",
  "confirmationPage.labels.paymentRecipient": "\u0645\u0633\u062A\u0644\u0645 \u0627\u0644\u062F\u0641\u0639\u0629",
  "confirmationPage.labels.typeOfPayment.oneOff": "\u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629",
  "confirmationPage.labels.typeOfPayment.recurring": "\u0645\u062A\u0643\u0631\u0631\u0629",
  "confirmationPage.labels.directDebitInformation": "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
  "confirmationPage.labels.directDebitInformation.title": "\u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0644\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064A \u062A\u062A\u0639\u0627\u0645\u0644 \u0645\u0639\u0647",
  "confirmationPage.labels.directDebitInformation.creditor": "\u0627\u0644\u062F\u0627\u0626\u0646",
  "confirmationPage.labels.directDebitInformation.creditorId": "\u0645\u0639\u0631\u0641 \u0627\u0644\u062F\u0627\u0626\u0646",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "\u0627\u0644\u0627\u0633\u0645 \u0641\u064A \u0643\u0634\u0641 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "\u0645\u0639\u0631\u0641 \u0645\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u062E\u062F\u0645\u0629",
  "confirmationPage.labels.directDebitInformation.address": "\u0639\u0646\u0648\u0627\u0646 Flywire",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0646\u0634\u0626",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "\u0639\u0646\u0648\u0627\u0646 Originator",
  "confirmationPage.labels.bankAccountInformation": "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A",
  "confirmationPage.labels.bankAccountInformation.name": "\u0627\u0644\u0627\u0633\u0645",
  "confirmationPage.labels.bankAccountInformation.iban": "\u0631\u0642\u0645 IBAN",
  "confirmationPage.labels.bankAccountInformation.email": "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
  "confirmationPage.labels.bankAccountInformation.country": "\u0627\u0644\u062F\u0648\u0644\u0629",
  "confirmationPage.labels.bankAccountInformation.state": "\u0627\u0644\u0648\u0644\u0627\u064A\u0629",
  "confirmationPage.labels.bankAccountInformation.city": "\u0627\u0644\u0645\u062F\u064A\u0646\u0629",
  "confirmationPage.labels.bankAccountInformation.bicCode": "\u0643\u0648\u062F BIC",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A",
  "confirmationPage.labels.bankAccountInformation.sortCode": "\u0643\u0648\u062F \u0627\u0644\u0641\u0631\u0632",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "\u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "\u0631\u0642\u0645 \u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0628\u0646\u0643\u064A",
  "confirmationPage.labels.bankAccountInformation.accountType": "\u0646\u0648\u0639 \u0627\u0644\u062D\u0633\u0627\u0628",
  "confirmationPage.labels.changeAccountEft": "\u062A\u063A\u064A\u064A\u0631 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064A",
  "confirmationPage.labels.editPayerEft": "\u062A\u062D\u0631\u064A\u0631 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645 \u0628\u0627\u0644\u0633\u062F\u0627\u062F",
  "confirmationPage.labels.useAccountEft": "\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0646\u062A\u0647\u064A \u0628\u0640 **** {{lastFour}}",
  "confirmationPage.labels.termsSepa": "\u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0639\u0644\u0649 \u0646\u0645\u0648\u0630\u062C \u0627\u0644\u062A\u0641\u0648\u064A\u0636 \u0647\u0630\u0627\u060C \u0641\u0625\u0646\u0643 \u062A\u0641\u0648\u0636 (\u0623) FLYWIRE EUROPE UAB \u0644\u0625\u0631\u0633\u0627\u0644 \u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0625\u0644\u0649 \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064A \u062A\u062A\u0639\u0627\u0645\u0644 \u0645\u0639\u0647 \u0644\u0644\u062E\u0635\u0645 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643 \u0648(\u0628) \u0648\u0625\u0631\u0633\u0627\u0644 \u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0644\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064A \u062A\u062A\u0639\u0627\u0645\u0644 \u0645\u0639\u0647 \u0644\u0644\u062E\u0635\u0645 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643 \u0648\u0641\u0642\u064B\u0627 \u0644\u062A\u0639\u0644\u064A\u0645\u0627\u062A FLYWIRE EUROPE UAB. \u0648\u0633\u064A\u062A\u0645 \u0625\u062E\u0637\u0627\u0631\u0643 \u0642\u0628\u0644 3 \u0623\u064A\u0627\u0645 \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0645\u0646 \u062A\u062D\u0635\u064A\u0644 \u0627\u0644\u0631\u0633\u0648\u0645.",
  "confirmationPage.labels.termsBacs": "\u0627\u0637\u0644\u0628 \u0645\u0646 \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064A \u062A\u062A\u0639\u0627\u0645\u0644 \u0645\u0639\u0647 \u0623\u0646 \u064A\u062A\u0645 \u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0625\u0644\u0649 Flywire Payments Limited \u0645\u0646 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0641\u0635\u0644 \u0641\u064A \u0647\u0630\u0647 \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0648\u0641\u0642\u064B\u0627 \u0644\u0644\u0636\u0645\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u0636\u0645\u0646\u0647\u0627 \u0636\u0645\u0627\u0646 \u0627\u0644\u062E\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631. \u0623\u0641\u0647\u0645 \u0623\u0646 \u0647\u0630\u0647 \u0627\u0644\u062A\u0639\u0644\u064A\u0645\u0627\u062A \u0642\u062F \u062A\u0638\u0644 \u0645\u0639 Flywire Payments Limited\u060C \u0648\u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0623\u0645\u0631 \u0643\u0630\u0644\u0643\u060C \u0641\u0633\u064A\u062A\u0645 \u062A\u0645\u0631\u064A\u0631 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u064B\u0627 \u0625\u0644\u0649 \u0628\u0646\u0643\u064A/\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0645\u0644\u0627\u0643 \u0627\u0644\u062E\u0627\u0635 \u0628\u064A.",
  "confirmationPage.labels.termsAch": '\n     \u0628\u0627\u0644\u0646\u0642\u0631 \u0639\u0644\u0649 "\u062A\u0623\u0643\u064A\u062F"\u060C \u0623\u0646\u062A \u0628\u0630\u0644\u0643 \u062A\u0624\u0643\u062F \u0623\u0646 \u0644\u062F\u064A\u0643 \u0627\u0644\u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 \u0648\u0623\u0646\u0643 \u0628\u0645\u0648\u062C\u0628 \u0647\u0630\u0627 \u0627\u0644\u0627\u062A\u0641\u0627\u0642 \u062A\u0641\u0648\u0651\u0650\u0636 Flywire \u0646\u064A\u0627\u0628\u0629 \u0639\u0646 \u0627\u0644\u0645\u0633\u062A\u0644\u0645 \u0627\u0644\u0645\u062D\u062F\u062F \n ("\u0627\u0644\u0645\u0633\u062A\u0641\u064A\u062F") \u0641\u064A \u062E\u0635\u0645 \u0623\u064A \u0645\u0628\u0644\u063A \u0645\u0633\u062A\u062D\u0642 \u0645\u0646 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u0627\u0644\u0630\u064A \u0642\u062F\u062A\u0647 \u0645\u0642\u0627\u0628\u0644: \u0627\u0644\u0631\u0633\u0648\u0645 \u0627\u0644\u0646\u0627\u0634\u0626\u0629 \u0639\u0646 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0643 \u0644\u062E\u062F\u0645\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0641\u064A\u062F\n \u0648/\u0623\u0648 \u0634\u0631\u0627\u0621 \u0645\u0646\u062A\u062C\u0627\u062A \u0645\u0646 \u0627\u0644\u0645\u0633\u062A\u0641\u064A\u062F\u060C \u0648\u062A\u0635\u062D\u064A\u062D \u0627\u0644\u0623\u0631\u0635\u062F\u0629 \u0627\u0644\u0645\u062F\u064A\u0646\u0629 \u0627\u0644\u0645\u063A\u0644\u0648\u0637\u0629 \u0625\u0630\u0627 \u0644\u0632\u0645 \u0627\u0644\u0623\u0645\u0631\u060C \u0648\u0630\u0644\u0643 \u0641\u0642\u064B\u0627 \u0644\u0634\u0631\u0648\u0637 \u0627\u0644\u0645\u0633\u062A\u0641\u064A\u062F\u060C \u0625\u0644\u0649 \u0623\u0646 \u064A\u062A\u0645\n \u0625\u0644\u063A\u0627\u0621 \u0647\u0630\u0627 \u0627\u0644\u062A\u0641\u0648\u064A\u0636. \u0641\u064A \u062D\u0627\u0644\u0629 \u0631\u0641\u0636 \u0645\u0639\u0627\u0645\u0644\u0629 \u063A\u0631\u0641\u0629 \u0627\u0644\u0645\u0642\u0627\u0635\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629 (ACH) \u0628\u0633\u0628\u0628 \u0639\u062F\u0645 \u0643\u0641\u0627\u064A\u0629 \u0627\u0644\u0631\u0635\u064A\u062F\u060C \u0623\u062F\u0631\u0643 \u0623\u0646\u0647 \u0633\u062A\u064F\u062D\u0635\u0644\u064F \u0645\u0646\u064A \n \u0631\u0633\u0648\u0645 \u0639\u062F\u0645 \u0643\u0641\u0627\u064A\u0629 \u0627\u0644\u0631\u0635\u064A\u062F (NSF)\u060C \u0648\u0623\u0646 Flywire \u0642\u062F \u062A\u0639\u064A\u062F \u0645\u062D\u0627\u0648\u0644\u0629 \u0625\u062C\u0631\u0627\u0621 \u0639\u0645\u0644\u064A\u0629 \u062E\u0635\u0645 \u0627\u0644\u0631\u0633\u0648\u0645 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649\u060C \u0648\u0630\u0644\u0643 \u0641\u0642\u064B\u0627 \u0644\u062A\u0642\u062F\u064A\u0631\u0647\u0627 \u0644\u062C\u062F\u0648\u0649 \u0630\u0644\u0643.\n     ',
  "confirmationPage.labels.termsAch2": "\n     \u0625\u0630\u0627 \u0643\u0646\u062A \u062A\u0633\u062A\u062E\u062F\u0645 \u062E\u062F\u0645\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u0641\u064A\u062F \u0648/\u0623\u0648 \u062A\u0634\u062A\u0631\u064A \u0645\u0646\u062A\u062C\u0627\u062A \u0625\u0636\u0627\u0641\u064A\u0629 \u0645\u0646\u0647 \u0628\u0634\u0643\u0644 \u062F\u0648\u0631\u064A\u060C \u060C \u0641\u0623\u0646\u062A \u0628\u0630\u0644\u0643 \u062A\u0641\u0648\u0651\u064E\u0636 \n Flywire\u060C \u0646\u064A\u0627\u0628\u0629 \u0639\u0646 \u0627\u0644\u0645\u0633\u062A\u0641\u064A\u062F\u060C \u0641\u064A \u0627\u0644\u062E\u0635\u0645 \u0628\u0634\u0643\u0644 \u062F\u0648\u0631\u064A \u0645\u0646 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0635\u0631\u0641\u064A \u0627\u0644\u0630\u064A \u0642\u062F\u0645\u062A\u0647\u060C \u0648\u0641\u0642\u064B\u0627 \u0644\u0634\u0631\u0648\u0637 \u0627\u0644\u0645\u0633\u062A\u0641\u064A\u062F. \u0644\u0627 \u062A\u062E\u0635\u0645 \u0623\u064A \u0645\u062F\u0641\u0648\u0639\u0627\u062A \u0623\u062E\u0631\u0649 \u062A\u0642\u0639 \u062E\u0627\u0631\u062C \u0646\u0637\u0627\u0642 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062E\u0635\u0645 \n \u0627\u0644\u0645\u0635\u0631\u062D \u0628\u0647\u0627 \u0623\u0639\u0644\u0627\u0647 \u0625\u0644\u0627 \u0628\u0639\u062F \u0627\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u062A\u0641\u0648\u064A\u0636 \u0645\u0646\u0643 \u0639\u0628\u0631 \u062D\u0633\u0627\u0628\u0643\u060C \u0623\u0648 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0623\u0648 \u0631\u0645\u0632 \u0623\u0648 \u063A\u064A\u0631 \u0630\u0644\u0643 \n \u0645\u0645\u0627 \u064A\u0639\u0627\u062F\u0644 \u062A\u0648\u0642\u064A\u0639\u0643.\n     ",
  "confirmationPage.labels.termsAch3": "\n     \u064A\u0645\u0643\u0646\u0643 \u0625\u0644\u063A\u0627\u0621 \u0647\u0630\u0627 \u0627\u0644\u062A\u0641\u0648\u064A\u0636 \u0641\u064A \u0623\u064A \u0648\u0642\u062A \u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0633\u062A\u0641\u064A\u062F. \u064A\u062C\u0628 \u0627\u0633\u062A\u0644\u0627\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u062A\u0641\u0648\u064A\u0636 \u0642\u0628\u0644 \u0645\u0648\u0639\u062F \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0645\u0642\u0631\u0631\u0629 \n \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0628\u0645\u062F\u0629 [10 \u0623\u064A\u0627\u0645 \u0639\u0645\u0644] \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644.\n    ",
  "confirmationPage.labels.print": "\u0637\u0628\u0627\u0639\u0629 \u0627\u0644\u0627\u062A\u0641\u0627\u0642\u064A\u0629",
  "amountPanel.labels.amountFromLabel": "\u0633\u0648\u0641 \u062A\u062F\u0641\u0639",
  "amountPanel.labels.surchargeFeeInfo": "\u0631\u0633\u0648\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0645\u0634\u0645\u0648\u0644\u0629.",
  "amountPanel.labels.whyThisFee": "\u0645\u0627 \u0633\u0628\u0628 \u0647\u0630\u0647 \u0627\u0644\u0631\u0633\u0648\u0645\u061F",
  "amountPanel.labels.whyThisFeeTooltip": "\n  \u0631\u0633\u0648\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 {{percentage}} % \u0625\u0630\u0627 \u062A\u0627\u0628\u0639\u062A \u0627\u0644\u0633\u062F\u0627\u062F. \u0639\u0645\u0644\u0629 \u0628\u0637\u0627\u0642\u062A\u0643 {{cardScheme}} \u0647\u064A {{currency}}. \u064A\u064F\u0631\u062C\u0649 \u0627\u062E\u062A\u064A\u0627\u0631 \u0628\u0637\u0627\u0642\u0629 \u0623\u0648 \u0628\u0644\u062F \u064A\u062A\u0645\u0627\u0634\u0649 \u0645\u0639 \u0628\u0637\u0627\u0642\u062A\u0643 \u0644\u062A\u062C\u0646\u0628 \u0627\u0644\u0631\u0633\u0648\u0645 \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0629.\n     ",
  "amountPanel.labels.currencyChangeWarning": "\u0644\u0642\u062F \u062C\u0631\u0649 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0639\u0645\u0644\u0629 \u0644\u062A\u0646\u0627\u0633\u0628 \u0639\u0645\u0644\u0629 \u0628\u0637\u0627\u0642\u062A\u0643",
  "amountPanel.labels.amountToLabel": "\u0633\u0648\u0641 \u062A\u062A\u0644\u0642\u0649 {{recipientName}} ",
  AX: "\u062C\u0632\u0631 \u0622\u0644\u0627\u0646\u062F",
  AD: "\u0623\u0646\u062F\u0648\u0631\u0627",
  BG: "\u0628\u0644\u063A\u0627\u0631\u064A\u0627",
  AT: "\u0627\u0644\u0646\u0645\u0633\u0627",
  BE: "\u0628\u0644\u062C\u064A\u0643\u0627",
  HR: "\u0643\u0631\u0648\u0627\u062A\u064A\u0627",
  CY: "\u0642\u0628\u0631\u0635",
  CZ: "\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062A\u0634\u064A\u0643",
  DK: "\u0627\u0644\u062F\u0646\u0645\u0627\u0631\u0643",
  EE: "\u0625\u0633\u062A\u0648\u0646\u064A\u0627",
  FI: "\u0641\u0646\u0644\u0646\u062F\u0627",
  FR: "\u0641\u0631\u0646\u0633\u0627",
  GP: "\u062C\u0632\u0631 \u062C\u0648\u0627\u062F\u0644\u0648\u0628",
  DE: "\u0623\u0644\u0645\u0627\u0646\u064A\u0627",
  GR: "\u0627\u0644\u064A\u0648\u0646\u0627\u0646",
  HU: "\u0627\u0644\u0645\u062C\u0631",
  IS: "\u0623\u064A\u0633\u0644\u0646\u062F\u0627",
  IE: "\u0623\u064A\u0631\u0644\u0646\u062F\u0627",
  VA: "\u0627\u0644\u0643\u0631\u0633\u064A \u0627\u0644\u0631\u0633\u0648\u0644\u064A (\u062F\u0648\u0644\u0629 \u0627\u0644\u0641\u0627\u062A\u064A\u0643\u0627\u0646)",
  IT: "\u0625\u064A\u0637\u0627\u0644\u064A\u0627",
  LI: "\u0644\u064A\u062E\u062A\u0646\u0634\u062A\u0627\u064A\u0646",
  LT: "\u0644\u064A\u062A\u0648\u0627\u0646\u064A\u0627",
  LU: "\u0644\u0648\u0643\u0633\u0645\u0628\u0648\u0631\u063A",
  YT: "\u0645\u0627\u064A\u0648\u062A",
  MT: "\u0645\u0627\u0644\u0637\u0627",
  MQ: "\u062C\u0632\u0631 \u0627\u0644\u0645\u0627\u0631\u062A\u064A\u0646\u064A\u0643",
  ES: "\u0625\u0633\u0628\u0627\u0646\u064A\u0627",
  NO: "\u0627\u0644\u0646\u0631\u0648\u064A\u062C",
  NL: "\u0647\u0648\u0644\u0646\u062F\u0627",
  PL: "\u0628\u0648\u0644\u0646\u062F\u0627",
  PT: "\u0627\u0644\u0628\u0631\u062A\u063A\u0627\u0644",
  SE: "\u0627\u0644\u0633\u0648\u064A\u062F",
  RE: "\u0631\u064A\u0648\u0646\u064A\u0648\u0646",
  RO: "\u0631\u0648\u0645\u0627\u0646\u064A\u0627",
  CH: "\u0633\u0648\u064A\u0633\u0631\u0627",
  BL: "\u0633\u0627\u0646\u062A \u0628\u0627\u0631\u062A\u064A\u0644\u064A\u0645\u064A",
  GB: "\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
  MC: "\u0645\u0648\u0646\u0627\u0643\u0648",
  MF: "\u0633\u0627\u0646\u062A \u0645\u0627\u0631\u062A\u0646 (\u0627\u0644\u062C\u0632\u0621 \u0627\u0644\u0641\u0631\u0646\u0633\u064A)",
  PM: "\u0633\u0627\u0646\u062A \u0628\u064A\u064A\u0631 \u0648\u0645\u064A\u0643\u0644\u0648\u0646",
  SM: "\u0633\u0627\u0646 \u0645\u0627\u0631\u064A\u0646\u0648",
  SK: "\u0633\u0644\u0648\u0641\u0627\u0643\u064A\u0627",
  SI: "\u0633\u0644\u0648\u0641\u064A\u0646\u064A\u0627",
  GF: "\u063A\u0648\u064A\u0627\u0646\u0627 \u0627\u0644\u0641\u0631\u0646\u0633\u064A\u0629",
  LV: "\u0644\u0627\u062A\u0641\u064A\u0627",
  CA: "\u0643\u0646\u062F\u0627",
  US: "\u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/locales/de-DE.ts
var de = {
  "session_expired.title": "Die Sitzung ist abgelaufen",
  "tokenizationForm.payment-terms.text1": "Ich erm\xE4chtige Flywire, meine Debit-/Kreditkarte im Auftrag von {{recipientName}} zu speichern und automatisch zu belasten. Ich habe Folgendes gelesen, verstanden und stimme dem zu:",
  "tokenizationForm.general-terms.link2": "Flywires Datenschutzrichtlinie",
  "tokenizationForm.general-terms.link-joint": " und ",
  "tokenizationForm.general-terms.link1": "Flywires Nutzungsbedingungen",
  "tokenizationForm.payment-terms.link": "Flywire Nutzungsbedingungen f\xFCr automatisierte Zahlungen",
  "tokenizationForm.labels.cvvTooltip": "3 Ziffern auf der R\xFCckseite Ihrer Karte oder 4 Ziffern auf der Vorderseite",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "Ablaufdatum (MM/JJ)",
  "tokenizationForm.labels.cardNumber": "Kartennummer",
  "tokenizationForm.labels.phone": "Telefonnummer",
  "tokenizationForm.labels.zip": "Postleitzahl",
  "tokenizationForm.labels.address": "Adresse",
  "cardsForm.labels.state": "Bundesland",
  "tokenizationForm.labels.country": "Land",
  "tokenizationForm.labels.city": "Ort",
  "tokenizationForm.labels.email": "E-Mail-Adresse",
  "tokenizationForm.labels.lastName": "Nachname",
  "tokenizationForm.labels.firstName": "Vorname",
  "tokenizationForm.labels.dynamicFields.document": "CPF- oder CNPJ-Nummer",
  "cardsForm.title": "Informationen zum Karteninhaber",
  "success.title": "Ihr Geld ist unterwegs",
  "success.title.info": "Es kann 2\u20133 Werktage dauern, bis das Geld eintrifft.\nSie erhalten eine E-Mail, sobald das Geld eingetroffen ist.",
  "bankAccountForm.hints.generic": "Beispiel: {{label}}",
  "bankAccountForm.hints.account_number": "Die Kontonummer muss zwischen 1 und 17\xA0Zeichen lang sein",
  "bankAccountForm.hints.routing_number": "Die Bankleitzahl (USA) muss 9 Ziffern lang sein.",
  "bankAccountForm.labels.accountZipCode": "Postleitzahl",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "BIC",
  "bankAccountForm.labels.accountNumber": "Kontonummer",
  "bankAccountForm.labels.accountSortCode": "Bankleitzahl",
  "bankAccountForm.labels.accountRoutingNumber": "Routingnummer",
  "bankAccountForm.labels.accountType": "Kontotyp",
  "bankAccountForm.labels.eftProviderWidnow": "Sie werden auf die Plattform unseres Partners weitergeleitet, um diese Zahlung abzuschlie\xDFen. Sobald das erledigt ist, werden Sie wieder auf diese Seite zur\xFCckgeleitet",
  "bankAccountForm.labels.termsFlywire": "Ich habe die <a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>Nutzungsbedingungen</a> und die <a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Datenschutzrichtlinie</a> von Flywire gelesen, verstanden und stimme diesen zu",
  "bankAccountForm.labels.termsDirectDebit": "Ich best\xE4tige, dass ich der/die Kontoinhaber/in dieses Kontos und der/die einzige Unterzeichner/in bin, der/die zur Autorisierung dieses Lastschriftverfahrens erforderlich ist",
  "bankAccountForm.labels.termsEft": "Ich habe die <a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Vorautorisierte Lastschriftvereinbarung</a> gelesen, verstanden und stimme ihr zu.",
  "bankAccountForm.labels.city": "Ort",
  "bankAccountForm.labels.country": "Land",
  "bankAccountForm.labels.selectCountry": "Land ausw\xE4hlen",
  "bankAccountForm.title": "Informationen zum Kontoinhaber",
  "failure.tryAgain": "Erneut versuchen",
  "failure.title": "Transaktion fehlgeschlagen",
  "failure.connectivity.message": "Der Vorgang ist fehlgeschlagen, eventuell aufgrund von Verbindungsproblemen.",
  "failure.message": "Die Transaktion ist fehlgeschlagen. Dies k\xF6nnte auf Verbindungsprobleme zur\xFCckzuf\xFChren sein. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, versuchen Sie es bitte mit einer anderen Zahlungsmethode oder wenden Sie sich an Ihre Bank",
  "sessionExpired.text": "Die Sitzung ist abgelaufen",
  "LoadingError.title": "Es ist ein Fehler aufgetreten",
  "LoadingError.message": "Fehler beim Laden des Formulars",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "F\xFCr das gew\xE4hlte Land sind keine Zahlungsoptionen verf\xFCgbar",
  "bankAccountForm.labels.accountHolderType.personal": "Pers\xF6nliches Konto",
  "bankAccountForm.labels.accountHolderType.business": "Gesch\xE4ftskonto",
  "bankAccountForm.labels.name": "Vorname",
  "bankAccountForm.labels.businessName": "Name des Unternehmens",
  "bankAccountForm.labels.surname": "Nachname",
  "bankAccountForm.labels.phone": "Telefonnummer",
  "bankAccountForm.labels.email": "E-Mail-Adresse",
  "bankAccountForm.labels.zip": "Postleitzahl",
  "bankAccountForm.labels.accountAddress": "Adresse",
  "bankAccountForm.labels.address": "Adresse",
  "bankAccountForm.errors.dynamicFields": "{{field}} ung\xFCltig",
  "bankAccountForm.errors.dynamicFields.document": "Ung\xFCltige CPF- oder CNPJ-Nummer",
  "bankAccountForm.errors.dynamicFields.documentPattern": "Bitte geben Sie Ihre CPF/CNPJ-Nummer ohne Bindestriche oder Gedankenstriche an",
  "bankAccountForm.labels.saveButton": "Speichern",
  "bankAccountForm.labels.nextButton": "Weiter",
  "bankAccountForm.labels.payButton": "Bezahlen",
  "bankAccountForm.errors.cardNumber": "Ung\xFCltige Kartennummer",
  "tokenizationForm.errors.cardNumber": "Ung\xFCltige Kartennummer",
  "tokenizationForm.errors.cvv": "Ung\xFCltige CVV-Nummer",
  "bankAccountForm.errors.cvv": "Ung\xFCltige CVV-Nummer",
  "tokenizationForm.errors.unsupportedCardTypes": "Nur {{acceptedCardsList}} werden unterst\xFCtzt",
  "tokenizationForm.errors.unsupportedCardType": "Nur {{acceptedCard}} wird unterst\xFCtzt",
  "tokenizationForm.errors.cardType.and": "und",
  "tokenizationForm.errors.name": "Ung\xFCltiger Vorname",
  "tokenizationForm.errors.email": "Ung\xFCltige E-Mail",
  "tokenizationForm.errors.country": "Ung\xFCltiges Land",
  "tokenizationForm.errors.state": "Ung\xFCltiges Bundesland",
  "tokenizationForm.errors.city": "Ung\xFCltige Stadt",
  "tokenizationForm.errors.address": "Ung\xFCltige Adresse",
  "tokenizationForm.errors.addressIsPoBox": "Wir akzeptieren keine Postf\xE4cher im Adressfeld.",
  "tokenizationForm.errors.onlyLetterOrNumbers": "G\xFCltige Zeichen sind nur A\u2013Z und 0\u20139",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": "G\xFCltige Zeichen sind nur A\u2013Z, 0\u20139 und \u201E/, -\u201D",
  "tokenizationForm.errors.zip": "Ung\xFCltige Postleitzahl",
  "tokenizationForm.errors.expiryDate": "Ung\xFCltiges Ablaufdatum",
  "bankAccountForm.errors.expiryDate": "Ung\xFCltiges Ablaufdatum",
  "tokenizationForm.errors.surname": "Ung\xFCltiger Familienname",
  "tokenizationForm.errors.phone": "Ung\xFCltige Telefonnummer",
  "tokenizationForm.errors.length": "Das Feld ist zu lang (maximal 256 Zeichen)",
  "bankAccountForm.errors.name": "Ung\xFCltiger Vorname",
  "bankAccountForm.errors.name.maxSizeExceeded": "Der Vorname ist zu lang (h\xF6chstens 140 Zeichen)",
  "form.errors.name.maxSizeExceeded": "Der Vorname ist zu lang (h\xF6chstens {{limit}} Zeichen)",
  "form.errors.surname.maxSizeExceeded": "Der Nachname ist zu lang (h\xF6chstens {{limit}} Zeichen)",
  "form.errors.business_name.maxSizeExceeded": "Der Name des Unternehmens ist zu lang (h\xF6chstens {{limit}} Zeichen)",
  "form.errors.city.maxSizeExceeded": "Der Ortsname ist zu lang (h\xF6chstens {{limit}} Zeichen)",
  "form.errors.address.maxSizeExceeded": "Die Adresse ist zu lang (h\xF6chstens {{limit}} Zeichen)",
  "bankAccountForm.errors.business_name": "Ung\xFCltiger Unternehmensname",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "Der Name des Unternehmens ist zu lang (h\xF6chstens 140 Zeichen)",
  "bankAccountForm.errors.surname": "Ung\xFCltiger Nachname",
  "bankAccountForm.errors.surname.maxSizeExceeded": "Der Nachname ist zu lang (h\xF6chstens 140 Zeichen)",
  "bankAccountForm.errors.country": "Ung\xFCltiges Land",
  "bankAccountForm.errors.address": "Ung\xFCltige Adresse",
  "bankAccountForm.errors.address.maxSizeExceeded": "Die Adresse ist zu lang (h\xF6chstens 256 Zeichen)",
  "bankAccountForm.errors.city": "Ung\xFCltige Stadt",
  "bankAccountForm.errors.city.maxSizeExceeded": "Der Ortsname ist zu lang (h\xF6chstens 256 Zeichen)",
  "bankAccountForm.errors.email": "Ung\xFCltige E-Mail",
  "bankAccountForm.errors.state": "Ung\xFCltiges Bundesland",
  "bankAccountForm.errors.iban": "Ung\xFCltige IBAN",
  "bankAccountForm.errors.bic": "Ung\xFCltiger BIC",
  "bankAccountForm.errors.accountnumber": "Ung\xFCltige Kontonummer",
  "bankAccountForm.errors.sortcode": "Ung\xFCltige Bankleitzahl",
  "bankAccountForm.errors.account_type": "Ung\xFCltiger Kontotyp",
  "bankAccountForm.errors.addressIsPoBox": "Wir akzeptieren keine Postf\xE4cher im Adressfeld.",
  "bankAccountForm.errors.onlyLetterOrNumbers": "G\xFCltige Zeichen sind nur A\u2013Z und 0\u20139",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "G\xFCltige Zeichen sind: A\u2013Z 0\u20139 / , -",
  "bankAccountForm.errors.zip": "Ung\xFCltige Postleitzahl",
  "bankAccountForm.errors.phone": "Ung\xFCltige Telefonnummer",
  "bankAccountForm.errors.ach_account_number": "Ung\xFCltige Kontonummer",
  "bankAccountForm.errors.routing_number": "Ung\xFCltige Routingnummer",
  "bankAccountForm.errors.offer": "Keine Zahlungsoptionen verf\xFCgbar \u2013 Wenn Sie ein Bankkonto in einem anderen Land haben, w\xE4hlen Sie bitte dieses Land aus oder w\xE4hlen Sie eine andere Karte und versuchen Sie es erneut. Wenn sich das Problem so nicht l\xF6sen l\xE4sst, wenden Sie sich bitte an {{recipientName}}.",
  "confirmationPage.labels.edit": "Bearbeiten",
  "confirmationPage.labels.confirm": "Best\xE4tigen",
  "confirmationPage.labels.title": "Mandatsdaten pr\xFCfen",
  "confirmationPage.labels.typeOfPayment": "Zahlungsart",
  "confirmationPage.labels.paymentRecipient": "Zahlungsempf\xE4nger",
  "confirmationPage.labels.typeOfPayment.oneOff": "Einmalig",
  "confirmationPage.labels.typeOfPayment.recurring": "Wiederkehrend",
  "confirmationPage.labels.directDebitInformation": "Infos zum Lastschriftverfahren",
  "confirmationPage.labels.directDebitInformation.title": "Anweisungen f\xFCr Ihre Bank",
  "confirmationPage.labels.directDebitInformation.creditor": "Zahlungsempf\xE4nger",
  "confirmationPage.labels.directDebitInformation.creditorId": "Zahlungsempf\xE4nger-ID",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "Name in Ihrem Kontoauszug",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "Dienstbenutzer-ID",
  "confirmationPage.labels.directDebitInformation.address": "Flywire-Adresse",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "Originator ID-Nummer",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "Originator Adresse",
  "confirmationPage.labels.bankAccountInformation": "Bankkonto-Daten",
  "confirmationPage.labels.bankAccountInformation.name": "Name",
  "confirmationPage.labels.bankAccountInformation.iban": "IBAN",
  "confirmationPage.labels.bankAccountInformation.email": "E-Mail-Adresse",
  "confirmationPage.labels.bankAccountInformation.country": "Land",
  "confirmationPage.labels.bankAccountInformation.state": "Bundesland",
  "confirmationPage.labels.bankAccountInformation.city": "Ort",
  "confirmationPage.labels.bankAccountInformation.bicCode": "BIC",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "Kontonummer",
  "confirmationPage.labels.bankAccountInformation.sortCode": "Bankleitzahl",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "Kontonummer",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "Routingnummer",
  "confirmationPage.labels.bankAccountInformation.accountType": "Kontotyp",
  "confirmationPage.labels.changeAccountEft": "Kontodaten \xE4ndern",
  "confirmationPage.labels.editPayerEft": "Angaben zur zahlenden Person bearbeiten",
  "confirmationPage.labels.useAccountEft": "Verwenden Sie das Konto mit den Endziffern **** {{lastFour}}",
  "confirmationPage.labels.termsSepa": "Ich erm\xE4chtige/Wir erm\xE4chtigen (A) FLYWIRE EUROPE UAB Zahlungen von meinem/unserem Konto mittels Lastschrift einzuziehen. Zugleich (B) weise ich mein/weisen wir unser Kreditinstitut an, die von FLYWIRE EUROPE UAB auf mein/unser Konto gezogenen Lastschriften einzul\xF6sen. Sie werden mindestens 3 Tage vor der Abbuchung benachrichtigt.",
  "confirmationPage.labels.termsBacs": "Weisen Sie Ihre Bank an, Lastschriften von dem in dieser Anweisung angegebenen Konto an Flywire Payments Limited zu zahlen, vorbehaltlich der durch die Lastschriftgarantie gew\xE4hrleisteten Sicherheiten. Ich verstehe, dass diese Anweisung bei Flywire Payments Limited verbleiben kann. In diesem Fall werden die Daten elektronisch an meine Bank/Bausparkasse weitergeleitet.",
  "confirmationPage.labels.termsAch": "\n     Indem Sie auf \u201EBest\xE4tigen\u201D klicken, best\xE4tigen Sie, dass Sie ordnungsgem\xE4\xDF bevollm\xE4chtigt sind und erm\xE4chtigen hiermit Flywire im Namen des angegebenen Empf\xE4ngers \n (\u201EZahlungsempf\xE4nger\u201D), das von Ihnen angegebene Bankkonto mit allen geschuldeten Betr\xE4gen f\xFCr Geb\xFChren zu belasten, die sich aus Ihrer Nutzung der Dienste des Zahlungsempf\xE4ngers \n und/oder dem Kauf von Produkten des Zahlungsempf\xE4ngers ergeben, und, falls erforderlich, fehlerhafte Abbuchungen gem\xE4\xDF den Bedingungen des Zahlungsempf\xE4ngers zu korrigieren, bis diese \n Vollmacht widerrufen wird. F\xFCr den Fall, dass eine ACH-Transaktion wegen unzureichender Deckung abgelehnt wird, verstehe ich, dass mir eine \n NSF-Geb\xFChr berechnet wird und dass Flywire nach eigenem Ermessen versuchen kann, die Geb\xFChr erneut zu verarbeiten.\n     ",
  "confirmationPage.labels.termsAch2": "\n     Wenn Sie gem\xE4\xDF den Bedingungen des Zahlungsempf\xE4ngers regelm\xE4\xDFig zus\xE4tzliche Produkte und/oder Dienstleistungen des Zahlungsempf\xE4ngers nutzen oder erwerben, erm\xE4chtigen Sie \n Flywire im Namen des Zahlungsempf\xE4ngers, das von Ihnen angegebene Bankkonto regelm\xE4\xDFig zu belasten. Zahlungen, die au\xDFerhalb der oben genannten Einzugserm\xE4chtigung \n liegen, werden erst abgebucht, nachdem Ihre Genehmigung \xFCber Ihr Konto oder ein Passwort, einen Code oder eine andere \n gleichwertige Unterschrift eingeholt wurde.\n     ",
  "confirmationPage.labels.termsAch3": "\n     Sie k\xF6nnen diese Vollmacht jederzeit widerrufen, indem Sie sich an den Zahlungsempf\xE4nger wenden. Ihr Widerruf muss mindestens [10 Werktage] \n vor der n\xE4chsten geplanten Zahlung eingehen.\n    ",
  "confirmationPage.labels.print": "Vereinbarung drucken",
  "amountPanel.labels.amountFromLabel": "Sie zahlen",
  "amountPanel.labels.surchargeFeeInfo": "Kartengeb\xFChr inbegriffen.",
  "amountPanel.labels.whyThisFee": "Warum diese Geb\xFChr?",
  "amountPanel.labels.whyThisFeeTooltip": "\n  {{percentage}} % Kartengeb\xFChren, wenn Sie mit der Zahlung fortfahren. Die W\xE4hrung Ihrer {{cardScheme}}-Karte ist {{currency}}. Bitte w\xE4hlen Sie eine Karte und ein Land, die mit Ihrer Karte \xFCbereinstimmen, um zus\xE4tzliche Geb\xFChren zu vermeiden.\n     ",
  "amountPanel.labels.currencyChangeWarning": "Die W\xE4hrung wurde ge\xE4ndert, sodass sie Ihrer Kartenw\xE4hrung entspricht",
  "amountPanel.labels.amountToLabel": "{{recipientName}} wird empfangen",
  AX: "\xC5land-Inseln",
  AD: "Andorra",
  BG: "Bulgarien",
  AT: "\xD6sterreich",
  BE: "Belgien",
  HR: "Kroatien",
  CY: "Zypern",
  CZ: "Tschechien",
  DK: "D\xE4nemark",
  EE: "Estland",
  FI: "Finnland",
  FR: "Frankreich",
  GP: "Guadeloupe",
  DE: "Deutschland",
  GR: "Griechenland",
  HU: "Ungarn",
  IS: "Island",
  IE: "Irland",
  VA: "Heiliger Stuhl (Staat Vatikanstadt)",
  IT: "Italien",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  YT: "Mayotte",
  MT: "Malta",
  MQ: "Martinique",
  ES: "Spanien",
  NO: "Norwegen",
  NL: "Niederlande",
  PL: "Polen",
  PT: "Portugal",
  SE: "Schweden",
  RE: "R\xE9union",
  RO: "Rum\xE4nien",
  CH: "Schweiz",
  BL: "Saint-Barth\xE9lemy",
  GB: "Vereinigtes K\xF6nigreich",
  MC: "Monaco",
  MF: "Saint Martin (franz\xF6sischer Teil)",
  PM: "St. Pierre und Miquelon",
  SM: "San Marino",
  SK: "Slowakei",
  SI: "Slowenien",
  GF: "Franz\xF6sisch-Guayana",
  LV: "Lettland",
  CA: "Kanada",
  US: "Vereinigte Staaten",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/locales/en-US.ts
var enUS = {
  "session_expired.title": "The session has expired",
  "tokenizationForm.labels.amountFromLabel": "You will pay",
  "tokenizationForm.general-terms.link2": "Privacy Policy",
  "tokenizationForm.general-terms.link-joint": " and ",
  "tokenizationForm.general-terms.link1": "Terms of Use",
  "tokenizationForm.payment-terms.link": "Flywire's Terms of Use for automated payments",
  "tokenizationForm.labels.cvvTooltip": "3 digits in the back of your card or 4 digits in the front",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "Expiry date (MM/YY)",
  "tokenizationForm.labels.cardNumber": "Card number",
  "tokenizationForm.labels.phone": "Phone number",
  "tokenizationForm.labels.zip": "Zip code",
  "tokenizationForm.labels.address": "Address",
  "cardsForm.labels.state": "State",
  "tokenizationForm.labels.country": "Country",
  "tokenizationForm.labels.city": "City",
  "tokenizationForm.labels.email": "Email",
  "tokenizationForm.labels.lastName": "Last name",
  "tokenizationForm.labels.firstName": "First name",
  "cardsForm.title": "Cardholder information",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "There are no payment options available for the selected country",
  "success.title": "Your funds are on the way",
  "success.title.info": "Please allow 2-3 business days for the funds to arrive.\nYou will receive an email when the funds are delivered.",
  "bankAccountForm.hints.generic": "Example: {{label}}",
  "bankAccountForm.labels.accountZipCode": "Zip code",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "BIC code",
  "bankAccountForm.labels.accountNumber": "Account number",
  "bankAccountForm.labels.accountSortCode": "Sort code",
  "bankAccountForm.labels.accountRoutingNumber": "Routing number",
  "bankAccountForm.labels.eftProviderWidnow": "You will be taken to the partner's processing platform to complete this payment. Once it is done, you will be redirected to this page again",
  "bankAccountForm.labels.termsFlywire": "I have read, understand, and agree to the Flywire's <a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>Terms of Use</a> and <a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Privacy Policy</a>",
  "bankAccountForm.labels.termsDirectDebit": "I confirm I am the account owner of this account and the only one signatory required to authorize this direct debit",
  "bankAccountForm.labels.termsEft": "I have read, understand, and agree to the <a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Pre-Authorized Debit Agreement</a>",
  "bankAccountForm.labels.city": "City",
  "bankAccountForm.labels.country": "Country",
  "bankAccountForm.labels.selectCountry": "Select a country",
  "bankAccountForm.title": "Accountholder information",
  "failure.tryAgain": "Try again",
  "failure.title": "Transaction failed",
  "failure.connectivity.message": "The operation failed, this could be due to some connectivity issues.",
  "failure.message": "The transaction failed. This could be due to connectivity issues. Please try again. If the problem persists, please try another payment method or contact your bank",
  "sessionExpired.text": "The session has expired",
  "LoadingError.title": "Something went wrong",
  "bankAccountForm.labels.name": "First name",
  "bankAccountForm.labels.accountHolderType.personal": "Personal Account",
  "bankAccountForm.labels.accountHolderType.business": "Business Account",
  "bankAccountForm.labels.businessName": "Business name",
  "bankAccountForm.labels.surname": "Last name",
  "bankAccountForm.labels.phone": "Phone number",
  "bankAccountForm.errors.offer": "No payment options available - If you have a bank account in another country, please select this country or pick another card and try again. If this does not solve the problem, please contact {{recipientName}}",
  "bankAccountForm.labels.email": "Email",
  "bankAccountForm.labels.zip": "Zip code",
  "bankAccountForm.labels.address": "Address",
  "bankAccountForm.labels.saveButton": "Save",
  "bankAccountForm.labels.nextButton": "Next",
  "bankAccountForm.labels.payButton": "Pay",
  "bankAccountForm.labels.accountAddress": "Address",
  "bankAccountForm.errors.name": "Invalid first name",
  "bankAccountForm.errors.name.maxSizeExceeded": "First name is too long (maximum is 140 characters)",
  "bankAccountForm.errors.business_name": "Invalid business name",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "First name is too long (maximum is 140 characters)",
  "bankAccountForm.errors.surname": "Invalid last name",
  "bankAccountForm.errors.surname.maxSizeExceeded": "Last name is too long (maximum is 140 characters)",
  "bankAccountForm.errors.email": "Invalid email",
  "bankAccountForm.errors.state": "Invalid state",
  "bankAccountForm.errors.iban": "Invalid IBAN",
  "bankAccountForm.errors.country": "Invalid country",
  "bankAccountForm.errors.address": "Invalid address",
  "bankAccountForm.errors.address.maxSizeExceeded": "Address is too long (maximum is 256 characters)",
  "bankAccountForm.errors.city": "Invalid city",
  "bankAccountForm.errors.city.maxSizeExceeded": "City is too long (maximum is 256 characters)",
  "bankAccountForm.errors.bic": "Invalid BIC code",
  "bankAccountForm.errors.accountnumber": "Invalid Account number",
  "bankAccountForm.errors.sortcode": "Invalid Sort code",
  "bankAccountForm.errors.addressIsPoBox": "We do not accept PO Boxes in the address field.",
  "bankAccountForm.errors.onlyLetterOrNumbers": "Valid characters include A-Z and 0-9 only",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": 'Valid characters include A-Z, 0-9 and "/, -" only',
  "bankAccountForm.errors.zip": "Invalid zip",
  "bankAccountForm.errors.phone": "Invalid phone number",
  "bankAccountForm.errors.ach_account_number": "Account number length must be between 1 and 17 characters",
  "bankAccountForm.errors.routing_number": "Routing number length must be 9 characters",
  "confirmationPage.labels.edit": "Edit",
  "confirmationPage.labels.confirm": "Confirm",
  "confirmationPage.labels.title": "Review mandate info",
  "confirmationPage.labels.typeOfPayment": "Type of payment",
  "confirmationPage.labels.paymentRecipient": "Payment recipient",
  "confirmationPage.labels.typeOfPayment.oneOff": "One-off",
  "confirmationPage.labels.typeOfPayment.recurring": "Recurring",
  "confirmationPage.labels.directDebitInformation": "Direct debit information",
  "confirmationPage.labels.directDebitInformation.title": "Instructions to your bank",
  "confirmationPage.labels.directDebitInformation.creditor": "Creditor",
  "confirmationPage.labels.directDebitInformation.creditorId": "Creditor ID",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "Name in your statement",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "Service user ID",
  "confirmationPage.labels.directDebitInformation.address": "Flywire address",
  "confirmationPage.labels.bankAccountInformation": "Bank account information",
  "confirmationPage.labels.bankAccountInformation.name": "Name",
  "confirmationPage.labels.bankAccountInformation.iban": "IBAN number",
  "confirmationPage.labels.bankAccountInformation.email": "Email",
  "confirmationPage.labels.bankAccountInformation.country": "Country",
  "confirmationPage.labels.bankAccountInformation.city": "City",
  "confirmationPage.labels.bankAccountInformation.bicCode": "BIC code",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "Account number",
  "confirmationPage.labels.bankAccountInformation.sortCode": "Sort code",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "Account number",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "Routing number",
  "confirmationPage.labels.bankAccountInformation.accountType": "Account type",
  "confirmationPage.labels.changeAccountEft": "Change bank account details",
  "confirmationPage.labels.editPayerEft": "Edit Payer Details",
  "confirmationPage.labels.useAccountEft": "Use Account ending in **** {{lastFour}}",
  "confirmationPage.labels.termsSepa": "By signing this mandate form, you authorise (A) FLYWIRE EUROPE UAB to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with the instructions from FLYWIRE EUROPE UAB. You will be notified at least 3 days prior to being charged.",
  "confirmationPage.labels.termsBacs": "Instruct your bank to pay Flywire Payments Limited Direct Debits from the account detailed in this instruction subject to the safeguards assured by the Direct Debit Guarantee. I understand this instruction may remain with Flywire Payments Limited and, if so, details will be passed electronically to my bank/building society.",
  "amountPanel.labels.amountFromLabel": "You will pay",
  "amountPanel.labels.amountToLabel": "{{recipientName}} will receive",
  AX: "\xC5land Islands",
  AD: "Andorra",
  BG: "Bulgaria",
  AT: "Austria",
  BE: "Belgium",
  HR: "Croatia",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  EE: "Estonia",
  FI: "Finland",
  FR: "France",
  GP: "Guadeloupe",
  DE: "Germany",
  GR: "Greece",
  HU: "Hungary",
  IS: "Iceland",
  IE: "Ireland",
  VA: "Holy See (Vatican City State)",
  IT: "Italy",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  YT: "Mayotte",
  MT: "Malta",
  MQ: "Martinique",
  ES: "Spain",
  NO: "Norway",
  NL: "Netherlands",
  PL: "Poland",
  PT: "Portugal",
  SE: "Sweden",
  RE: "R\xE9union",
  RO: "Romania",
  CH: "Switzerland",
  BL: "Saint Barth\xE9lemy",
  GB: "United Kingdom",
  MC: "Monaco",
  MF: "Saint Martin (French part)",
  PM: "Saint Pierre and Miquelon",
  SM: "San Marino",
  SK: "Slovakia",
  SI: "Slovenia",
  GF: "French Guiana",
  LV: "Latvia",
  CA: "Canada",
  US: "United States",
  "tokenizationForm.errors.cardNumber": "Invalid card number",
  "tokenizationForm.errors.cvv": "Invalid CVV Number",
  "tokenizationForm.errors.unsupportedCardTypes": "Only {{acceptedCardsList}} are supported",
  "tokenizationForm.errors.cardType.and": "and",
  "tokenizationForm.errors.name": "Invalid first name",
  "tokenizationForm.errors.email": "Invalid email",
  "tokenizationForm.errors.country": "Invalid country",
  "tokenizationForm.errors.state": "Invalid state",
  "tokenizationForm.errors.city": "Invalid city",
  "tokenizationForm.errors.address": "Invalid address",
  "tokenizationForm.errors.addressIsPoBox": "We do not accept PO Boxes in the address field.",
  "tokenizationForm.errors.onlyLetterOrNumbers": "Valid characters include A-Z and 0-9 only",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": 'Valid characters include A-Z, 0-9 and "/, -" only',
  "tokenizationForm.errors.zip": "Invalid zip",
  "tokenizationForm.errors.expiryDate": "Invalid expiration date",
  "tokenizationForm.errors.surname": "Invalid family name",
  "tokenizationForm.errors.phone": "Invalid phone number",
  "tokenizationForm.errors.length": "Field is too long (maximum is 256 characters)",
  "bankAccountForm.errors.cardNumber": "Invalid card number",
  "bankAccountForm.errors.expiryDate": "Invalid expiration date",
  "bankAccountForm.errors.cvv": "Invalid CVV Number",
  "LoadingError.message": "There was an error loading the form.",
  "tokenizationForm.payment-terms.text1": "I authorize Flywire to store and charge my debit/credit card automatically on behalf of {{recipientName}}. I have read, understand, and agree to",
  "bankAccountForm.hints.account_number": "Account number length must be between 1 and 17 characters",
  "bankAccountForm.hints.routing_number": "Routing number length must be 9 digits",
  "bankAccountForm.labels.accountType": "Account type",
  "bankAccountForm.errors.accountType": "Invalid account type",
  "bankAccountForm.errors.account_type": "Invalid Account type",
  "confirmationPage.labels.bankAccountInformation.state": "State",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "Originator ID",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "Originator address",
  "confirmationPage.labels.termsAch2": "  \n     If you use or purchase additional products and/or services of the Payee periodically, pursuant to the Payee\u2019s terms, you authorize \n     Flywire, on behalf of the Payee, to periodically debit the bank account provided by you. Payments that fall outside of the debit \n     authorized above will only be debited after your authorization is obtained via your account, or else a password, code, or other \n     signature equivalent.\n     ",
  "confirmationPage.labels.termsAch": "  \n     By clicking \u201CConfirm\u201D, you affirm that you have proper authority to and hereby authorize Flywire on behalf of the specified recipient \n     (\u201CPayee\u201D) to debit the bank account provided by you for any amount owed for charges arising from your use of the Payee\u2019s services \n     and/or purchase of products from the Payee, and if necessary, to correct erroneous debits, pursuant to the Payee\u2019s terms, until this \n     authorization is revoked. In the case of an ACH transaction being rejected for insufficient funds I understand that I will be charged an \n     NSF fee, and that Flywire may at its discretion attempt to process the charge again.",
  "confirmationPage.labels.termsAch3": "  \n     You may revoke this authorization at any time by contacting the Payee. Your revocation must be received at least [10 business days] \n     prior to the next scheduled payment.\n    ",
  "confirmationPage.labels.print": "Print agreement",
  "form.errors.name.maxSizeExceeded": "First name is too long (maximum is {{limit}} characters)",
  "form.errors.surname.maxSizeExceeded": "Last name is too long (maximum is {{limit}} characters)",
  "form.errors.business_name.maxSizeExceeded": "Business name is too long (maximum is {{limit}} characters)",
  "form.errors.city.maxSizeExceeded": "City is too long (maximum is {{limit}} characters)",
  "form.errors.address.maxSizeExceeded": "Address is too long (maximum is {{limit}} characters)",
  "bankAccountForm.errors.dynamicFields": "Invalid {{field}}",
  "tokenizationForm.labels.dynamicFields.document": "CPF or CNPJ Number",
  "bankAccountForm.errors.dynamicFields.document": "Invalid CPF or CNPJ Number",
  "bankAccountForm.errors.dynamicFields.documentPattern": "Please include your CPF/CNPJ number with no hyphens or dashes",
  "tokenizationForm.errors.unsupportedCardType": "Only {{acceptedCard}} is supported",
  "amountPanel.labels.surchargeFeeInfo": "card fee included.",
  "amountPanel.labels.whyThisFee": "Why this fee?",
  "amountPanel.labels.whyThisFeeTooltip": "\n  {{percentage}}  card fees if you proceed with the payment. Your {{cardScheme}} card currency is {{currency}}. Please select a card or country aligned with your card to avoid additional charges.\n     ",
  "amountPanel.labels.currencyChangeWarning": "Currency has changed to match your card currency",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/locales/en.ts
var en = {
  "modal.close": "Close",
  "session_expired.title": "The session has expired",
  "tokenizationForm.payment-terms.text1": "I authorize Flywire to store and charge my debit/credit card automatically on behalf of {{recipientName}}. I have read, understand, and agree to",
  "tokenizationForm.general-terms.link2": "Privacy Policy",
  "tokenizationForm.general-terms.link-joint": " and ",
  "tokenizationForm.general-terms.link1": "Terms of Use",
  "tokenizationForm.payment-terms.link": "Flywire's Terms of Use for automated payments",
  "tokenizationForm.labels.cvvTooltip": "3 digits in the back of your card or 4 digits in the front",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "Expiry date (MM/YY)",
  "tokenizationForm.labels.cardNumber": "Card number",
  "tokenizationForm.labels.phone": "Phone number",
  "tokenizationForm.labels.zip": "Zip code",
  "tokenizationForm.labels.address": "Address",
  "cardsForm.labels.state": "State",
  "tokenizationForm.labels.country": "Country",
  "tokenizationForm.labels.city": "City",
  "tokenizationForm.labels.email": "Email",
  "tokenizationForm.labels.lastName": "Last name",
  "tokenizationForm.labels.firstName": "First name",
  "tokenizationForm.labels.dynamicFields.document": "CPF or CNPJ Number",
  "cardsForm.title": "Cardholder information",
  "success.title": "Your funds are on the way",
  "success.title.info": "Please allow 2-3 business days for the funds to arrive.\nYou will receive an email when the funds are delivered.",
  "bankAccountForm.hints.generic": "Example: {{label}}",
  "bankAccountForm.hints.account_number": "Account number length must be between 1 and 17 characters",
  "bankAccountForm.hints.routing_number": "Routing number length must be 9 digits",
  "bankAccountForm.labels.accountZipCode": "Post code",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "BIC code",
  "bankAccountForm.labels.accountNumber": "Account number",
  "bankAccountForm.labels.accountSortCode": "Sort code",
  "bankAccountForm.labels.accountRoutingNumber": "Routing number",
  "bankAccountForm.labels.accountType": "Account type",
  "bankAccountForm.labels.eftProviderWidnow": "You will be taken to the partner's processing platform to complete this payment. Once it is done, you will be redirected to this page again",
  "bankAccountForm.labels.termsFlywire": "I have read, understand, and agree to the Flywire's <a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>Terms of Use</a> and <a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Privacy Policy</a>",
  "bankAccountForm.labels.termsDirectDebit": "I confirm I am the account owner of this account and the only one signatory required to authorize this direct debit",
  "bankAccountForm.labels.termsEft": "I have read, understand, and agree to the <a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Pre-Authorized Debit Agreement</a>",
  "bankAccountForm.labels.city": "City",
  "bankAccountForm.labels.country": "Country",
  "bankAccountForm.labels.selectCountry": "Select a country",
  "bankAccountForm.title": "Accountholder information",
  "failure.tryAgain": "Try again",
  "failure.title": "Transaction failed",
  "failure.connectivity.message": "The operation failed, this could be due to some connectivity issues.",
  "failure.message": "The transaction failed. This could be due to connectivity issues. Please try again. If the problem persists, please try another payment method or contact your bank",
  "sessionExpired.text": "The session has expired",
  "LoadingError.title": "Something went wrong",
  "LoadingError.message": "There was an error loading the form",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "There are no payment options available for the selected country",
  "bankAccountForm.labels.accountHolderType.personal": "Personal Account",
  "bankAccountForm.labels.accountHolderType.business": "Business Account",
  "bankAccountForm.labels.name": "First name",
  "bankAccountForm.labels.businessName": "Business name",
  "bankAccountForm.labels.surname": "Last name",
  "bankAccountForm.labels.phone": "Phone number",
  "bankAccountForm.labels.email": "Email",
  "bankAccountForm.labels.zip": "Zip code",
  "bankAccountForm.labels.accountAddress": "Address",
  "bankAccountForm.labels.address": "Address",
  "bankAccountForm.errors.dynamicFields": "Invalid {{field}}",
  "bankAccountForm.errors.dynamicFields.document": "Invalid CPF or CNPJ Number",
  "bankAccountForm.errors.dynamicFields.documentPattern": "Please include your CPF/CNPJ number with no hyphens or dashes",
  "bankAccountForm.labels.saveButton": "Save",
  "bankAccountForm.labels.nextButton": "Next",
  "bankAccountForm.labels.payButton": "Pay",
  "bankAccountForm.errors.cardNumber": "Invalid card number",
  "tokenizationForm.errors.cardNumber": "Invalid card number",
  "tokenizationForm.errors.cvv": "Invalid CVV Number",
  "bankAccountForm.errors.cvv": "Invalid CVV Number",
  "tokenizationForm.errors.unsupportedCardTypes": "Only {{acceptedCardsList}} are supported",
  "tokenizationForm.errors.unsupportedCardType": "Only {{acceptedCard}} is supported",
  "tokenizationForm.errors.cardType.and": "and",
  "tokenizationForm.errors.name": "Invalid first name",
  "tokenizationForm.errors.email": "Invalid email",
  "tokenizationForm.errors.country": "Invalid country",
  "tokenizationForm.errors.state": "Invalid state",
  "tokenizationForm.errors.city": "Invalid city",
  "tokenizationForm.errors.address": "Invalid address",
  "tokenizationForm.errors.addressIsPoBox": "We do not accept PO Boxes in the address field.",
  "tokenizationForm.errors.onlyLetterOrNumbers": "Valid characters include A-Z and 0-9 only",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": 'Valid characters include A-Z, 0-9 and "/, -" only',
  "tokenizationForm.errors.zip": "Invalid zip",
  "tokenizationForm.errors.expiryDate": "Invalid expiration date",
  "bankAccountForm.errors.expiryDate": "Invalid expiration date",
  "tokenizationForm.errors.surname": "Invalid family name",
  "tokenizationForm.errors.phone": "Invalid phone number",
  "tokenizationForm.errors.length": "Field is too long (maximum is 256 characters)",
  "bankAccountForm.errors.name": "Invalid first name",
  "bankAccountForm.errors.name.maxSizeExceeded": "First name is too long (maximum is 140 characters)",
  "form.errors.name.maxSizeExceeded": "First name is too long (maximum is {{limit}} characters)",
  "form.errors.surname.maxSizeExceeded": "Last name is too long (maximum is {{limit}} characters)",
  "form.errors.business_name.maxSizeExceeded": "Business name is too long (maximum is {{limit}} characters)",
  "form.errors.city.maxSizeExceeded": "City is too long (maximum is {{limit}} characters)",
  "form.errors.address.maxSizeExceeded": "Address is too long (maximum is {{limit}} characters)",
  "bankAccountForm.errors.business_name": "Invalid business name",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "Business name is too long (maximum is 140 characters)",
  "bankAccountForm.errors.surname": "Invalid last name",
  "bankAccountForm.errors.surname.maxSizeExceeded": "Last name is too long (maximum is 140 characters)",
  "bankAccountForm.errors.country": "Invalid country",
  "bankAccountForm.errors.address": "Invalid address",
  "bankAccountForm.errors.address.maxSizeExceeded": "Address is too long (maximum is 256 characters)",
  "bankAccountForm.errors.city": "Invalid city",
  "bankAccountForm.errors.city.maxSizeExceeded": "City is too long (maximum is 256 characters)",
  "bankAccountForm.errors.email": "Invalid email",
  "bankAccountForm.errors.state": "Invalid state",
  "bankAccountForm.errors.iban": "Invalid IBAN",
  "bankAccountForm.errors.bic": "Invalid BIC code",
  "bankAccountForm.errors.accountnumber": "Invalid Account number",
  "bankAccountForm.errors.sortcode": "Invalid Sort code",
  "bankAccountForm.errors.account_type": "Invalid Account type",
  "bankAccountForm.errors.addressIsPoBox": "We do not accept PO Boxes in the address field.",
  "bankAccountForm.errors.onlyLetterOrNumbers": "Valid characters include A-Z and 0-9 only",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "Valid characters are: A-Z 0-9 / , -",
  "bankAccountForm.errors.zip": "Invalid post code",
  "bankAccountForm.errors.phone": "Invalid phone number",
  "bankAccountForm.errors.ach_account_number": "Invalid Account number",
  "bankAccountForm.errors.routing_number": "Invalid Routing number",
  "bankAccountForm.errors.offer": "No payment options available - If you have a bank account in another country, please select this country or pick another card and try again. If this does not solve the problem, please contact {{recipientName}}",
  "confirmationPage.labels.edit": "Edit",
  "confirmationPage.labels.confirm": "Confirm",
  "confirmationPage.labels.title": "Review mandate info",
  "confirmationPage.labels.typeOfPayment": "Type of payment",
  "confirmationPage.labels.paymentRecipient": "Payment recipient",
  "confirmationPage.labels.typeOfPayment.oneOff": "One-off",
  "confirmationPage.labels.typeOfPayment.recurring": "Recurring",
  "confirmationPage.labels.directDebitInformation": "Direct debit information",
  "confirmationPage.labels.directDebitInformation.title": "Instructions to your bank",
  "confirmationPage.labels.directDebitInformation.creditor": "Creditor",
  "confirmationPage.labels.directDebitInformation.creditorId": "Creditor ID",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "Name in your statement",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "Service user ID",
  "confirmationPage.labels.directDebitInformation.address": "Flywire address",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "Originator ID",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "Originator address",
  "confirmationPage.labels.bankAccountInformation": "Bank account information",
  "confirmationPage.labels.bankAccountInformation.name": "Name",
  "confirmationPage.labels.bankAccountInformation.iban": "IBAN number",
  "confirmationPage.labels.bankAccountInformation.email": "Email",
  "confirmationPage.labels.bankAccountInformation.country": "Country",
  "confirmationPage.labels.bankAccountInformation.state": "State",
  "confirmationPage.labels.bankAccountInformation.city": "City",
  "confirmationPage.labels.bankAccountInformation.bicCode": "BIC code",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "Account number",
  "confirmationPage.labels.bankAccountInformation.sortCode": "Sort code",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "Account number",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "Routing number",
  "confirmationPage.labels.bankAccountInformation.accountType": "Account type",
  "confirmationPage.labels.changeAccountEft": "Change bank account details",
  "confirmationPage.labels.editPayerEft": "Edit Payer Details",
  "confirmationPage.labels.useAccountEft": "Use Account ending in **** {{lastFour}}",
  "confirmationPage.labels.termsSepa": "By signing this mandate form, you authorise (A) FLYWIRE EUROPE UAB to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with the instructions from FLYWIRE EUROPE UAB. You will be notified at least 3 days prior to being charged.",
  "confirmationPage.labels.termsBacs": "Instruct your bank to pay Flywire Payments Limited Direct Debits from the account detailed in this instruction subject to the safeguards assured by the Direct Debit Guarantee. I understand this instruction may remain with Flywire Payments Limited and, if so, details will be passed electronically to my bank/building society.",
  "confirmationPage.labels.termsAch": `
     By clicking \u201CConfirm\u201D, you affirm that you have proper authority to and hereby authorize Flywire on behalf of the specified recipient
     (\u201CPayee\u201D) to debit the bank account provided by you for any amount owed for charges arising from your use of the Payee\u2019s services
     and/or purchase of products from the Payee, and if necessary, to correct erroneous debits, pursuant to the Payee\u2019s terms, until this
     authorization is revoked. In the case of an ACH transaction being rejected for insufficient funds I understand that I will be charged an
     NSF fee, and that Flywire may at its discretion attempt to process the charge again.
     `,
  "confirmationPage.labels.termsAch2": `
     If you use or purchase additional products and/or services of the Payee periodically, pursuant to the Payee\u2019s terms, you authorize
     Flywire, on behalf of the Payee, to periodically debit the bank account provided by you. Payments that fall outside of the debit
     authorized above will only be debited after your authorization is obtained via your account, or else a password, code, or other
     signature equivalent.
     `,
  "confirmationPage.labels.termsAch3": `
     You may revoke this authorization at any time by contacting the Payee. Your revocation must be received at least [10 business days]
     prior to the next scheduled payment.
    `,
  "confirmationPage.labels.print": "Print agreement",
  "amountPanel.labels.amountFromLabel": "You will pay",
  "amountPanel.labels.surchargeFeeInfo": "card fee included.",
  "amountPanel.labels.whyThisFee": "Why this fee?",
  "amountPanel.labels.whyThisFeeTooltip": `
  {{percentage}} card fees if you proceed with the payment. Your {{cardScheme}} card currency is {{currency}}. Please select a card or country aligned with your card to avoid additional charges.
     `,
  "amountPanel.labels.currencyChangeWarning": "Currency has changed to match your card currency",
  "amountPanel.labels.amountToLabel": "{{recipientName}} will receive",
  AX: "\xC5land Islands",
  AD: "Andorra",
  BG: "Bulgaria",
  AT: "Austria",
  BE: "Belgium",
  HR: "Croatia",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  EE: "Estonia",
  FI: "Finland",
  FR: "France",
  GP: "Guadeloupe",
  DE: "Germany",
  GR: "Greece",
  HU: "Hungary",
  IS: "Iceland",
  IE: "Ireland",
  VA: "Holy See (Vatican City State)",
  IT: "Italy",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  YT: "Mayotte",
  MT: "Malta",
  MQ: "Martinique",
  ES: "Spain",
  NO: "Norway",
  NL: "Netherlands",
  PL: "Poland",
  PT: "Portugal",
  SE: "Sweden",
  RE: "R\xE9union",
  RO: "Romania",
  CH: "Switzerland",
  BL: "Saint Barth\xE9lemy",
  GB: "United Kingdom",
  MC: "Monaco",
  MF: "Saint Martin (French part)",
  PM: "Saint Pierre and Miquelon",
  SM: "San Marino",
  SK: "Slovakia",
  SI: "Slovenia",
  GF: "French Guiana",
  LV: "Latvia",
  CA: "Canada",
  US: "United States"
};

// ../internal-components/src/utils/translations/locales/es-ES.ts
var es = {
  "session_expired.title": "La sesi\xF3n ha caducado",
  "tokenizationForm.payment-terms.text1": "Autorizo a Flywire a almacenar y cobrar en mi tarjeta de d\xE9bito/cr\xE9dito autom\xE1ticamente en nombre de {{recipientName}}. He le\xEDdo, entiendo y acepto",
  "tokenizationForm.general-terms.link2": "y pol\xEDtica de privacidad de Flywire",
  "tokenizationForm.general-terms.link-joint": " y ",
  "tokenizationForm.general-terms.link1": "Condiciones de uso de Flywire",
  "tokenizationForm.payment-terms.link": "las condiciones de uso de Flywire para pagos automatizados",
  "tokenizationForm.labels.cvvTooltip": "3 d\xEDgitos en la parte posterior de la tarjeta o 4 en la parte frontal",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "Fecha de caducidad (MM/AA)",
  "tokenizationForm.labels.cardNumber": "N\xFAmero de tarjeta ",
  "tokenizationForm.labels.phone": "N\xFAmero de tel\xE9fono",
  "tokenizationForm.labels.zip": "C\xF3digo postal",
  "tokenizationForm.labels.address": "Direcci\xF3n",
  "cardsForm.labels.state": "Provincia",
  "tokenizationForm.labels.country": "Pais",
  "tokenizationForm.labels.city": "Ciudad",
  "tokenizationForm.labels.email": "Correo electr\xF3nico",
  "tokenizationForm.labels.lastName": "Apellido",
  "tokenizationForm.labels.firstName": "Nombre",
  "tokenizationForm.labels.dynamicFields.document": "N\xFAmero de CPF o CNPJ",
  "cardsForm.title": "Informaci\xF3n del titular de la tarjeta",
  "success.title": "Sus fondos est\xE1n en camino",
  "success.title.info": "Espere 2-3 d\xEDas laborables a que los fondos lleguen a su destino.\nRecibir\xE1 un correo electr\xF3nico cuando los fondos se hayan entregado.",
  "bankAccountForm.hints.generic": "Ejemplo: {{label}}",
  "bankAccountForm.hints.account_number": "La longitud del n\xFAmero de cuenta bancaria debe ser de entre 1 y 17 caracteres",
  "bankAccountForm.hints.routing_number": "La longitud del n\xFAmero de enrutamiento debe ser de 9 d\xEDgitos",
  "bankAccountForm.labels.accountZipCode": "C\xF3digo postal",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "C\xF3digo BIC",
  "bankAccountForm.labels.accountNumber": "N\xFAmero de cuenta",
  "bankAccountForm.labels.accountSortCode": "Sort code",
  "bankAccountForm.labels.accountRoutingNumber": "C\xF3digo de identificaci\xF3n bancaria",
  "bankAccountForm.labels.accountType": "Tipo de cuenta",
  "bankAccountForm.labels.eftProviderWidnow": "Le dirigiremos a nuestra plataforma de procesamiento para completar el pago. Una vez hecho esto, ser\xE1 redirigido de nuevo a esta p\xE1gina",
  "bankAccountForm.labels.termsFlywire": "He le\xEDdo, entiendo y acepto las <a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>Condiciones de uso</a> y la <a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Pol\xEDtica de privacidad</a> de Flywire",
  "bankAccountForm.labels.termsDirectDebit": "Confirmo que soy el titular de esta cuenta y el \xFAnico firmante necesario para autorizar este d\xE9bito directo",
  "bankAccountForm.labels.termsEft": "He le\xEDdo, entiendo y acepto el <a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Acuerdo de d\xE9bito preautorizado</a>",
  "bankAccountForm.labels.city": "Ciudad",
  "bankAccountForm.labels.country": "Pais",
  "bankAccountForm.labels.selectCountry": "Seleccione un pa\xEDs",
  "bankAccountForm.title": "Informaci\xF3n del titular de la cuenta",
  "failure.tryAgain": "Volver a intentarlo",
  "failure.title": "Transacci\xF3n no realizada",
  "failure.connectivity.message": "La operaci\xF3n ha fallado. Esto podr\xEDa deberse a alg\xFAn problema de conectividad.",
  "failure.message": "Error en la transacci\xF3n. Esto podr\xEDa deberse a problemas de conectividad. Int\xE9ntelo de nuevo. Si el problema persiste, pruebe con otro m\xE9todo de pago o p\xF3ngase en contacto con su banco",
  "sessionExpired.text": "La sesi\xF3n ha caducado",
  "LoadingError.title": "Se ha producido un error",
  "LoadingError.message": "Se ha producido un error al cargar el formulario",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "No hay opciones de pago disponibles para el pa\xEDs seleccionado",
  "bankAccountForm.labels.accountHolderType.personal": "Cuenta personal",
  "bankAccountForm.labels.accountHolderType.business": "Cuenta de empresa",
  "bankAccountForm.labels.name": "Nombre",
  "bankAccountForm.labels.businessName": "Nombre de la empresa",
  "bankAccountForm.labels.surname": "Apellido",
  "bankAccountForm.labels.phone": "N\xFAmero de tel\xE9fono",
  "bankAccountForm.labels.email": "Correo electr\xF3nico",
  "bankAccountForm.labels.zip": "C\xF3digo postal",
  "bankAccountForm.labels.accountAddress": "Direcci\xF3n",
  "bankAccountForm.labels.address": "Direcci\xF3n",
  "bankAccountForm.errors.dynamicFields": "{{field}} no v\xE1lido",
  "bankAccountForm.errors.dynamicFields.document": "N\xFAmero de CPF o CNPJ no v\xE1lido",
  "bankAccountForm.errors.dynamicFields.documentPattern": "Incluye tu n\xFAmero CPF/CNPJ sin guiones ni barras",
  "bankAccountForm.labels.saveButton": "Guardar",
  "bankAccountForm.labels.nextButton": "Siguiente",
  "bankAccountForm.labels.payButton": "Pagar",
  "bankAccountForm.errors.cardNumber": "N\xFAmero de tarjeta no v\xE1lido",
  "tokenizationForm.errors.cardNumber": "N\xFAmero de tarjeta no v\xE1lido",
  "tokenizationForm.errors.cvv": "N\xFAmero CVV no v\xE1lido",
  "bankAccountForm.errors.cvv": "N\xFAmero CVV no v\xE1lido",
  "tokenizationForm.errors.unsupportedCardTypes": "Solo se admiten {{acceptedCardsList}}",
  "tokenizationForm.errors.unsupportedCardType": "Solo se admite {{acceptedCard}}",
  "tokenizationForm.errors.cardType.and": "y",
  "tokenizationForm.errors.name": "Nombre no v\xE1lido",
  "tokenizationForm.errors.email": "Correo electr\xF3nico no v\xE1lido",
  "tokenizationForm.errors.country": "Pa\xEDs no v\xE1lido",
  "tokenizationForm.errors.state": "Provincia no v\xE1lida",
  "tokenizationForm.errors.city": "Ciudad no v\xE1lida",
  "tokenizationForm.errors.address": "Direcci\xF3n no v\xE1lida",
  "tokenizationForm.errors.addressIsPoBox": "No aceptamos apartados de correos en el campo de direcci\xF3n.",
  "tokenizationForm.errors.onlyLetterOrNumbers": "Los caracteres permitidos son \xFAnicamente A-Z y 0-9",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": "Los caracteres permitidos son \xFAnicamente A-Z, 0-9 y \xAB/, -\xBB",
  "tokenizationForm.errors.zip": "C\xF3digo postal no v\xE1lido",
  "tokenizationForm.errors.expiryDate": "Fecha de caducidad no v\xE1lida",
  "bankAccountForm.errors.expiryDate": "Fecha de caducidad no v\xE1lida",
  "tokenizationForm.errors.surname": "Apellido no v\xE1lido",
  "tokenizationForm.errors.phone": "N\xFAmero de tel\xE9fono incorrecto",
  "tokenizationForm.errors.length": "El campo es demasiado largo (el m\xE1ximo es de 256 caracteres)",
  "bankAccountForm.errors.name": "Nombre no v\xE1lido",
  "bankAccountForm.errors.name.maxSizeExceeded": "El nombre es demasiado largo (el m\xE1ximo es de 140 caracteres)",
  "form.errors.name.maxSizeExceeded": "El nombre es demasiado largo (el m\xE1ximo es de {{limit}} caracteres)",
  "form.errors.surname.maxSizeExceeded": "El apellido es demasiado largo (el m\xE1ximo es de {{limit}} caracteres)",
  "form.errors.business_name.maxSizeExceeded": "El nombre de la empresa es demasiado largo (el m\xE1ximo es de {{limit}} caracteres)",
  "form.errors.city.maxSizeExceeded": "La ciudad es demasiado larga (el m\xE1ximo es de {{limit}} caracteres)",
  "form.errors.address.maxSizeExceeded": "La direcci\xF3n es demasiado larga (el m\xE1ximo es de {{limit}} caracteres)",
  "bankAccountForm.errors.business_name": "Nombre de empresa no v\xE1lido",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "El nombre de la empresa es demasiado largo (el m\xE1ximo es de 140\xA0caracteres)",
  "bankAccountForm.errors.surname": "Apellido no v\xE1lido",
  "bankAccountForm.errors.surname.maxSizeExceeded": "El apellido es demasiado largo (el m\xE1ximo es de 140 caracteres)",
  "bankAccountForm.errors.country": "Pa\xEDs no v\xE1lido",
  "bankAccountForm.errors.address": "Direcci\xF3n no v\xE1lida",
  "bankAccountForm.errors.address.maxSizeExceeded": "La direcci\xF3n es demasiado larga (el m\xE1ximo es de 256 caracteres)",
  "bankAccountForm.errors.city": "Ciudad no v\xE1lida",
  "bankAccountForm.errors.city.maxSizeExceeded": "La ciudad es demasiado larga (el m\xE1ximo es de 256 caracteres)",
  "bankAccountForm.errors.email": "Correo electr\xF3nico no v\xE1lido",
  "bankAccountForm.errors.state": "Provincia no v\xE1lida",
  "bankAccountForm.errors.iban": "IBAN no v\xE1lido",
  "bankAccountForm.errors.bic": "C\xF3digo BIC no v\xE1lido",
  "bankAccountForm.errors.accountnumber": "N\xFAmero de cuenta no v\xE1lido",
  "bankAccountForm.errors.sortcode": "C\xF3digo de identificaci\xF3n no v\xE1lido",
  "bankAccountForm.errors.account_type": "Tipo de cuenta no v\xE1lido",
  "bankAccountForm.errors.addressIsPoBox": "No aceptamos apartados de correos en el campo de direcci\xF3n.",
  "bankAccountForm.errors.onlyLetterOrNumbers": "Los caracteres permitidos son \xFAnicamente A-Z y 0-9",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "Los caracteres v\xE1lidos son: A-Z 0-9 / , -",
  "bankAccountForm.errors.zip": "C\xF3digo postal no v\xE1lido",
  "bankAccountForm.errors.phone": "N\xFAmero de tel\xE9fono incorrecto",
  "bankAccountForm.errors.ach_account_number": "N\xFAmero de cuenta no v\xE1lido",
  "bankAccountForm.errors.routing_number": "N\xFAmero de enrutamiento no v\xE1lido",
  "bankAccountForm.errors.offer": "No hay opciones de pago disponibles. Si tiene una cuenta bancaria en otro pa\xEDs, seleccione ese pa\xEDs o elija otra tarjeta e int\xE9ntelo de nuevo. Si eso no resolviera el problema, p\xF3ngase en contacto con {{recipientName}}",
  "confirmationPage.labels.edit": "Editar",
  "confirmationPage.labels.confirm": "Confirmar",
  "confirmationPage.labels.title": "Revisar la informaci\xF3n de la orden de domiciliaci\xF3n",
  "confirmationPage.labels.typeOfPayment": "Tipo de pago",
  "confirmationPage.labels.paymentRecipient": "Destinatario del pago",
  "confirmationPage.labels.typeOfPayment.oneOff": "\xDAnico",
  "confirmationPage.labels.typeOfPayment.recurring": "Recurrente",
  "confirmationPage.labels.directDebitInformation": "Informaci\xF3n sobre el d\xE9bito directo",
  "confirmationPage.labels.directDebitInformation.title": "Instrucciones para el banco",
  "confirmationPage.labels.directDebitInformation.creditor": "Acreedor",
  "confirmationPage.labels.directDebitInformation.creditorId": "ID del acreedor",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "Nombre en su extracto",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "ID de usuario del servicio",
  "confirmationPage.labels.directDebitInformation.address": "Direcci\xF3n de Flywire",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "ID de Originator",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "Direcci\xF3n del Originator",
  "confirmationPage.labels.bankAccountInformation": "Information de la cuenta bancaria",
  "confirmationPage.labels.bankAccountInformation.name": "Nombre",
  "confirmationPage.labels.bankAccountInformation.iban": "N\xFAmero IBAN",
  "confirmationPage.labels.bankAccountInformation.email": "Correo electr\xF3nico",
  "confirmationPage.labels.bankAccountInformation.country": "Pais",
  "confirmationPage.labels.bankAccountInformation.state": "Provincia",
  "confirmationPage.labels.bankAccountInformation.city": "Ciudad",
  "confirmationPage.labels.bankAccountInformation.bicCode": "C\xF3digo BIC",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "N\xFAmero de cuenta",
  "confirmationPage.labels.bankAccountInformation.sortCode": "Sort code",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "N\xFAmero de cuenta",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "C\xF3digo de identificaci\xF3n bancaria",
  "confirmationPage.labels.bankAccountInformation.accountType": "Tipo de cuenta",
  "confirmationPage.labels.changeAccountEft": "Cambiar los datos de la cuenta bancaria",
  "confirmationPage.labels.editPayerEft": "Editar los detalles del pagador",
  "confirmationPage.labels.useAccountEft": "Usar la cuenta terminada en **** {{lastFour}}",
  "confirmationPage.labels.termsSepa": "Mediante la firma de esta orden de domiciliaci\xF3n, usted autoriza a (A) FLYWIRE EUROPE UAB a enviar instrucciones a su banco para cargar su cuenta y (B) a su banco para efectuar dichos cargos en su cuenta siguiendo las instrucciones de FLYWIRE EUROPE UAB. Se le notificar\xE1 al menos tres d\xEDas antes del cobro.",
  "confirmationPage.labels.termsBacs": "D\xE9 instrucciones a su banco para que pague a Flywire Payments Limited las operaciones de d\xE9bito directo desde la cuenta indicada en esta instrucci\xF3n seg\xFAn las disposiciones establecidas por la Garant\xEDa de D\xE9bito Directo. Entiendo que esta instrucci\xF3n puede permanecer en Flywire Payments Limited y, de ser as\xED, los datos se transferir\xE1n electr\xF3nicamente a mi banco/sociedad de cr\xE9dito hipotecario.",
  "confirmationPage.labels.termsAch": '\n     Al hacer clic en "Confirmar", usted afirma que tiene la debida autoridad y por la presente autoriza a Flywire en nombre del destinatario especificado \n     ("Beneficiario") a cargar en la cuenta bancaria proporcionada por usted cualquier cantidad adeudada por cargos derivados de su uso de los servicios \n     y/o compra de productos del Beneficiario, y si es necesario, a corregir cargos err\xF3neos, de conformidad con los t\xE9rminos del Beneficiario, hasta que esta \n     autorizaci\xF3n sea revocada.En el caso de que se rechace una transacci\xF3n ACH por fondos insuficientes, entiendo que se me cobrar\xE1 una tarifa de NSF, y que Flywire pueda, a su discreci\xF3n, intentar procesar el cargo de nuevo.\n     ',
  "confirmationPage.labels.termsAch2": "\n     Si utiliza o adquiere peri\xF3dicamente productos y/o servicios adicionales del Beneficiario, de conformidad con las condiciones del Beneficiario, autoriza a \n     Flywire, en nombre del Beneficiario, a efectuar peri\xF3dicamente cargos en la cuenta bancaria facilitada por usted.Los pagos que queden fuera del d\xE9bito \n     autorizado anteriormente solo se cargar\xE1n despu\xE9s de obtener su autorizaci\xF3n a trav\xE9s de su cuenta, o bien una contrase\xF1a, c\xF3digo u otro equivalente \n     de firma.\n     ",
  "confirmationPage.labels.termsAch3": "\n     Puede revocar esta autorizaci\xF3n en cualquier momento poni\xE9ndose en contacto con el Beneficiario. Su revocaci\xF3n debe recibirse al menos [10 d\xEDas h\xE1biles] \n      antes del siguiente pago previsto.\n    ",
  "confirmationPage.labels.print": "Imprimir acuerdo",
  "amountPanel.labels.amountFromLabel": "Usted pagar\xE1",
  "amountPanel.labels.surchargeFeeInfo": "Tasa de tarjeta incluida.",
  "amountPanel.labels.whyThisFee": "\xBFPor qu\xE9 se aplica esta tasa?",
  "amountPanel.labels.whyThisFeeTooltip": "\n  {{percentage}}\xA0% de tasa de la tarjeta en caso de continuar con el pago. La divisa de su tarjeta {{cardScheme}} es {{currency}}. Seleccione una tarjeta o un pa\xEDs que coincidan con la informaci\xF3n de su tarjeta a fin de evitar cargos adicionales.\n     ",
  "amountPanel.labels.currencyChangeWarning": "Se ha cambiado la divisa para que coincida con la de su tarjeta",
  "amountPanel.labels.amountToLabel": "{{recipientName}} recibir\xE1",
  AX: "Islas \xC5land",
  AD: "Andorra",
  BG: "Bulgaria",
  AT: "Austria",
  BE: "B\xE9lgica",
  HR: "Croacia",
  CY: "Chipre",
  CZ: "Rep\xFAblica checa",
  DK: "Dinamarca",
  EE: "Estonia",
  FI: "Finlandia",
  FR: "Francia",
  GP: "Guadalupe",
  DE: "Alemania",
  GR: "Grecia",
  HU: "Hungr\xEDa",
  IS: "Islandia",
  IE: "Irlanda",
  VA: "Santa Sede (Ciudad del Vaticano)",
  IT: "Italia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Luxemburgo",
  YT: "Mayotte",
  MT: "Malta",
  MQ: "Martinica",
  ES: "Espa\xF1a",
  NO: "Noruega",
  NL: "Pa\xEDses Bajos",
  PL: "Polonia",
  PT: "Portugal",
  SE: "Suecia",
  RE: "Reuni\xF3n",
  RO: "Ruman\xEDa",
  CH: "Suiza",
  BL: "San Bartolom\xE9",
  GB: "Reino Unido",
  MC: "M\xF3naco",
  MF: "San Mart\xEDn (Francia)",
  PM: "San Pedro y Miquel\xF3n",
  SM: "San Marino",
  SK: "Eslovaquia",
  SI: "Eslovenia",
  GF: "Guayana Francesa",
  LV: "Letonia",
  CA: "Canad\xE1",
  US: "Estados Unidos",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/locales/fr-FR.ts
var fr = {
  "session_expired.title": "La session a expir\xE9",
  "tokenizationForm.payment-terms.text1": "J'autorise Flywire \xE0 sauvegarderr et \xE0 d\xE9biter automatiquement ma carte de d\xE9bit/cr\xE9dit au nom de {{recipientName}}. J'ai lu, compris et j'accepte",
  "tokenizationForm.general-terms.link2": "politique de confidentialit\xE9",
  "tokenizationForm.general-terms.link-joint": " et ",
  "tokenizationForm.general-terms.link1": "conditions d'utilisation",
  "tokenizationForm.payment-terms.link": "les conditions d'utilisation de Flywire pour les paiements automatiques",
  "tokenizationForm.labels.cvvTooltip": "Les 3 chiffres au verso de votre carte ou les 4 chiffres au recto",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "Date d'expiration (MM/AA)",
  "tokenizationForm.labels.cardNumber": "Num\xE9ro de carte",
  "tokenizationForm.labels.phone": "Num\xE9ro de t\xE9l\xE9phone",
  "tokenizationForm.labels.zip": "Code postal",
  "tokenizationForm.labels.address": "Adresse",
  "cardsForm.labels.state": "\xC9tat",
  "tokenizationForm.labels.country": "Pays",
  "tokenizationForm.labels.city": "Ville",
  "tokenizationForm.labels.email": "E-mail",
  "tokenizationForm.labels.lastName": "Nom",
  "tokenizationForm.labels.firstName": "Pr\xE9nom",
  "tokenizationForm.labels.dynamicFields.document": "Num\xE9ro CPF ou CNPJ",
  "cardsForm.title": "Informations sur le titulaire de la carte",
  "success.title": "Vos fonds sont en route",
  "success.title.info": "Un d\xE9lai de 2 \xE0 3 jours ouvr\xE9s est n\xE9cessaire pour que vos fonds soient transf\xE9r\xE9s. \nVous recevrez un e-mail une fois les fonds d\xE9pos\xE9s.",
  "bankAccountForm.hints.generic": "Exemple\xA0: {{label}}",
  "bankAccountForm.hints.account_number": "Le num\xE9ro de compte doit comporter entre 1 et 17\xA0caract\xE8res",
  "bankAccountForm.hints.routing_number": "Le num\xE9ro de routage doit contenir 9\xA0chiffres",
  "bankAccountForm.labels.accountZipCode": "Code postal",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "Code BIC",
  "bankAccountForm.labels.accountNumber": "Num\xE9ro de compte",
  "bankAccountForm.labels.accountSortCode": "Code de tri",
  "bankAccountForm.labels.accountRoutingNumber": "Num\xE9ro d'acheminement",
  "bankAccountForm.labels.accountType": "Type de compte",
  "bankAccountForm.labels.eftProviderWidnow": "Vous allez \xEAtre redirig\xE9(e) vers la plateforme de traitement du partenaire pour finaliser ce paiement. Une fois ce dernier effectu\xE9, vous serez \xE0 nouveau redirig\xE9(e) vers cette page",
  "bankAccountForm.labels.termsFlywire": "J'ai lu, j'ai compris et j'accepte les <a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>Conditions d'utilisation</a> et la <a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Politique de confidentialit\xE9</a> de Flywire",
  "bankAccountForm.labels.termsDirectDebit": "Je confirme \xEAtre le titulaire de ce compte et le seul signataire requis pour autoriser ce pr\xE9l\xE8vement",
  "bankAccountForm.labels.termsEft": "J'ai lu, je comprends et accepte l'<a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Accord de pr\xE9l\xE8vement automatique</a>",
  "bankAccountForm.labels.city": "Ville",
  "bankAccountForm.labels.country": "Pays",
  "bankAccountForm.labels.selectCountry": "S\xE9lectionner le pays",
  "bankAccountForm.title": "Informations sur le titulaire du compte",
  "failure.tryAgain": "R\xE9essayer",
  "failure.title": "\xC9chec de la transaction",
  "failure.connectivity.message": "L'op\xE9ration a \xE9chou\xE9, cela peut \xEAtre d\xFB \xE0 des probl\xE8mes de connectivit\xE9.",
  "failure.message": "\xC9chec de la transaction. Cela peut \xEAtre d\xFB \xE0 des probl\xE8mes de connectivit\xE9. Veuillez r\xE9essayer. Si le probl\xE8me persiste, veuillez essayer un autre moyen de paiement ou contacter votre banque",
  "sessionExpired.text": "La session a expir\xE9",
  "LoadingError.title": "Une erreur s'est produite",
  "LoadingError.message": "Une erreur s'est produite lors du chargement du formulaire",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "Aucune option de paiement n'est disponible pour le pays s\xE9lectionn\xE9",
  "bankAccountForm.labels.accountHolderType.personal": "Compte personnel",
  "bankAccountForm.labels.accountHolderType.business": "Compte professionnel",
  "bankAccountForm.labels.name": "Pr\xE9nom",
  "bankAccountForm.labels.businessName": "Nom de l'entreprise",
  "bankAccountForm.labels.surname": "Nom",
  "bankAccountForm.labels.phone": "Num\xE9ro de t\xE9l\xE9phone",
  "bankAccountForm.labels.email": "E-mail",
  "bankAccountForm.labels.zip": "Code postal",
  "bankAccountForm.labels.accountAddress": "Adresse",
  "bankAccountForm.labels.address": "Adresse",
  "bankAccountForm.errors.dynamicFields": "{{field}}\xA0non valide",
  "bankAccountForm.errors.dynamicFields.document": "Num\xE9ro CPF ou CNPJ non valide",
  "bankAccountForm.errors.dynamicFields.documentPattern": "Veuillez inclure votre num\xE9ro CPF/CNPJ sans tiret ni trait d'union",
  "bankAccountForm.labels.saveButton": "Enregistrer",
  "bankAccountForm.labels.nextButton": "Suivant",
  "bankAccountForm.labels.payButton": "Payer",
  "bankAccountForm.errors.cardNumber": "Num\xE9ro de carte non valide",
  "tokenizationForm.errors.cardNumber": "Num\xE9ro de carte non valide",
  "tokenizationForm.errors.cvv": "Code CVV invalide",
  "bankAccountForm.errors.cvv": "Code CVV invalide",
  "tokenizationForm.errors.unsupportedCardTypes": "Seuls {{acceptedCardsList}} sont pris en charge",
  "tokenizationForm.errors.unsupportedCardType": "Seule la carte {{acceptedCard}} est prise en charge",
  "tokenizationForm.errors.cardType.and": "et",
  "tokenizationForm.errors.name": "Pr\xE9nom invalide",
  "tokenizationForm.errors.email": "Adresse e-mail invalide",
  "tokenizationForm.errors.country": "Pays non valide",
  "tokenizationForm.errors.state": "\xC9tat non valide",
  "tokenizationForm.errors.city": "Ville non valide",
  "tokenizationForm.errors.address": "Adresse non valide",
  "tokenizationForm.errors.addressIsPoBox": "Nous n'acceptons pas les bo\xEEtes postales dans le champ de l'adresse.",
  "tokenizationForm.errors.onlyLetterOrNumbers": "Les caract\xE8res valides incluent A-Z et 0-9 uniquement",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": "Les caract\xE8res valides comprennent A-Z, 0-9 et \xAB /, - \xBB uniquement",
  "tokenizationForm.errors.zip": "Code postal non valide",
  "tokenizationForm.errors.expiryDate": "Date d'expiration non valide",
  "bankAccountForm.errors.expiryDate": "Date d'expiration non valide",
  "tokenizationForm.errors.surname": "Nom de famille non valide",
  "tokenizationForm.errors.phone": "Num\xE9ro de t\xE9l\xE9phone non valide",
  "tokenizationForm.errors.length": "Le champ peut contenir 256\xA0caract\xE8res maximum",
  "bankAccountForm.errors.name": "Pr\xE9nom invalide",
  "bankAccountForm.errors.name.maxSizeExceeded": "Le pr\xE9nom est trop long (140\xA0caract\xE8res maximum)",
  "form.errors.name.maxSizeExceeded": "Le pr\xE9nom est trop long ({{limit}} caract\xE8res maximum)",
  "form.errors.surname.maxSizeExceeded": "Le nom de famille est trop long ({{limit}} caract\xE8res maximum)",
  "form.errors.business_name.maxSizeExceeded": "Le nom de l'entreprise est trop long ({{limit}} caract\xE8res)",
  "form.errors.city.maxSizeExceeded": "Le nom de la ville est trop long ({{limit}} caract\xE8res maximum)",
  "form.errors.address.maxSizeExceeded": "L'adresse est trop longue ({{limit}} caract\xE8res maximum)",
  "bankAccountForm.errors.business_name": "Nom d'entreprise non valide",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "Le nom de l'entreprise est trop long (140 caract\xE8res maximum)",
  "bankAccountForm.errors.surname": "Nom de famille invalide",
  "bankAccountForm.errors.surname.maxSizeExceeded": "Le nom de famille est trop long (140\xA0caract\xE8res maximum)",
  "bankAccountForm.errors.country": "Pays non valide",
  "bankAccountForm.errors.address": "Adresse non valide",
  "bankAccountForm.errors.address.maxSizeExceeded": "L'adresse est trop longue (256\xA0caract\xE8res maximum)",
  "bankAccountForm.errors.city": "Ville non valide",
  "bankAccountForm.errors.city.maxSizeExceeded": "Le nom de la ville est trop long (256\xA0caract\xE8res maximum)",
  "bankAccountForm.errors.email": "Adresse e-mail invalide",
  "bankAccountForm.errors.state": "\xC9tat non valide",
  "bankAccountForm.errors.iban": "IBAN non valide",
  "bankAccountForm.errors.bic": "Code BIC non valide",
  "bankAccountForm.errors.accountnumber": "Num\xE9ro de compte bancaire non valide",
  "bankAccountForm.errors.sortcode": "Code de tri non valide",
  "bankAccountForm.errors.account_type": "Type de compte non valide",
  "bankAccountForm.errors.addressIsPoBox": "Nous n'acceptons pas les bo\xEEtes postales dans le champ de l'adresse.",
  "bankAccountForm.errors.onlyLetterOrNumbers": "Les caract\xE8res valides incluent A-Z et 0-9 uniquement",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "Les caract\xE8res valides sont : A-Z 0-9 / , -",
  "bankAccountForm.errors.zip": "Code postal non valide",
  "bankAccountForm.errors.phone": "Num\xE9ro de t\xE9l\xE9phone non valide",
  "bankAccountForm.errors.ach_account_number": "Num\xE9ro de compte bancaire non valide",
  "bankAccountForm.errors.routing_number": "Num\xE9ro d'acheminement non valide",
  "bankAccountForm.errors.offer": "Aucune option de paiement n'est disponible. Si vous avez un compte bancaire dans un autre pays, veuillez s\xE9lectionner ce pays ou choisir une autre carte et r\xE9essayer. Si cela ne r\xE9sout pas le probl\xE8me, contactez {{recipientName}}",
  "confirmationPage.labels.edit": "Modifier",
  "confirmationPage.labels.confirm": "Confirmer",
  "confirmationPage.labels.title": "Examiner les informations du mandat",
  "confirmationPage.labels.typeOfPayment": "Type de paiement",
  "confirmationPage.labels.paymentRecipient": "Destinataire du paiement",
  "confirmationPage.labels.typeOfPayment.oneOff": "Ponctuel",
  "confirmationPage.labels.typeOfPayment.recurring": "R\xE9current",
  "confirmationPage.labels.directDebitInformation": "Informations relatives \xE0 l'autorisation de pr\xE9l\xE8vement",
  "confirmationPage.labels.directDebitInformation.title": "Instructions pour votre banque",
  "confirmationPage.labels.directDebitInformation.creditor": "Cr\xE9ancier",
  "confirmationPage.labels.directDebitInformation.creditorId": "Identifiant du cr\xE9ancier",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "Nom figurant sur votre relev\xE9",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "ID utilisateur du service",
  "confirmationPage.labels.directDebitInformation.address": "Adresse Flywire",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "Num\xE9ro d'identification Originator",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "Adresse Originator",
  "confirmationPage.labels.bankAccountInformation": "Informations du compte bancaire",
  "confirmationPage.labels.bankAccountInformation.name": "Nom",
  "confirmationPage.labels.bankAccountInformation.iban": "Num\xE9ro IBAN",
  "confirmationPage.labels.bankAccountInformation.email": "E-mail",
  "confirmationPage.labels.bankAccountInformation.country": "Pays",
  "confirmationPage.labels.bankAccountInformation.state": "\xC9tat",
  "confirmationPage.labels.bankAccountInformation.city": "Ville",
  "confirmationPage.labels.bankAccountInformation.bicCode": "Code BIC",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "Num\xE9ro de compte",
  "confirmationPage.labels.bankAccountInformation.sortCode": "Code de tri",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "Num\xE9ro de compte",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "Num\xE9ro d'acheminement",
  "confirmationPage.labels.bankAccountInformation.accountType": "Type de compte",
  "confirmationPage.labels.changeAccountEft": "Modifier les coordonn\xE9es du compte bancaire",
  "confirmationPage.labels.editPayerEft": "Modifier les informations du payeur",
  "confirmationPage.labels.useAccountEft": "Utiliser le compte se terminant par **** {{lastFour}}",
  "confirmationPage.labels.termsSepa": "En signant ce formulaire de mandat, vous autorisez (A) FLYWIRE EUROPE UAB \xE0 envoyer des instructions \xE0 votre banque pour d\xE9biter votre compte, et (B) votre banque \xE0 d\xE9biter votre compte conform\xE9ment aux instructions de FLYWIRE EUROPE UAB. Vous recevrez une notification au moins 3\xA0jours avant d'\xEAtre d\xE9bit\xE9.",
  "confirmationPage.labels.termsBacs": "Donnez l'ordre \xE0 votre banque de payer les pr\xE9l\xE8vements automatiques de Flywire Payments Limited \xE0 partir du compte d\xE9taill\xE9 dans cette instruction, sous r\xE9serve des garanties assur\xE9es par la garantie de pr\xE9l\xE8vement automatique. Je comprends que cette instruction peut demeurer chez Flywire Payments Limited et, dans ce cas, les d\xE9tails seront transmis \xE9lectroniquement \xE0 ma banque/soci\xE9t\xE9 de cr\xE9dit immobilier.",
  "confirmationPage.labels.termsAch": "\n     En cliquant sur \xAB\xA0Confirmer\xA0\xBB, vous certifiez \xEAtre habilit\xE9(e) \xE0 autoriser Flywire, et l'autorisez par la pr\xE9sente, au nom du destinataire indiqu\xE9 \n     (le \xAB\xA0B\xE9n\xE9ficiaire\xA0\xBB) \xE0 d\xE9biter le compte bancaire que vous avez fourni de tout montant d\xFB pour des frais d\xE9coulant de votre utilisation des services du B\xE9n\xE9ficiaire \n     et/ou de l'achat de produits aupr\xE8s du B\xE9n\xE9ficiaire et, si n\xE9cessaire, \xE0 corriger des d\xE9bits erron\xE9s, conform\xE9ment aux conditions du B\xE9n\xE9ficiaire, jusqu'\xE0 ce que la pr\xE9sente \n     autorisation soit r\xE9voqu\xE9e. En cas de rejet d'une transaction ACH pour cause de fonds insuffisants, je comprends que des \n     frais me seront factur\xE9s et que Flywire peut, \xE0 sa discr\xE9tion, tenter de proc\xE9der \xE0 nouveau au d\xE9bit.\n     ",
  "confirmationPage.labels.termsAch2": "\n     Si vous utilisez ou achetez p\xE9riodiquement des produits et/ou services suppl\xE9mentaires du B\xE9n\xE9ficiaire, conform\xE9ment aux conditions du B\xE9n\xE9ficiaire, vous autorisez \n     Flywire, au nom du B\xE9n\xE9ficiaire, \xE0 d\xE9biter p\xE9riodiquement le compte bancaire que vous avez fourni. Les paiements qui ne font pas partie du d\xE9bit \n     autoris\xE9 ci-dessus ne seront d\xE9bit\xE9s qu'apr\xE8s l'obtention de votre autorisation via votre compte, ou via un mot de passe, un code ou tout autre \n     m\xE9thode \xE9quivalent une signature.\n     ",
  "confirmationPage.labels.termsAch3": "\n     Vous pouvez r\xE9voquer cette autorisation \xE0 tout moment en contactant le B\xE9n\xE9ficiaire. Votre r\xE9vocation doit \xEAtre re\xE7ue au moins [10\xA0jours ouvrables] \n     avant le prochain paiement programm\xE9.\n    ",
  "confirmationPage.labels.print": "Imprimer l'accord",
  "amountPanel.labels.amountFromLabel": "Vous paierez",
  "amountPanel.labels.surchargeFeeInfo": "frais de carte inclus.",
  "amountPanel.labels.whyThisFee": "Pourquoi ces frais\xA0?",
  "amountPanel.labels.whyThisFeeTooltip": "\n  {{percentage}}\xA0% de frais de carte si vous proc\xE9dez au paiement. La devise de votre carte {{cardScheme}} est\xA0: {{currency}}. Veuillez s\xE9lectionner une carte ou un pays correspondant \xE0 votre carte pour \xE9viter des frais suppl\xE9mentaires.\n     ",
  "amountPanel.labels.currencyChangeWarning": "La devise a \xE9t\xE9 modifi\xE9e pour correspondre \xE0 la devise de votre carte",
  "amountPanel.labels.amountToLabel": "{{recipientName}} recevra",
  AX: "\xCEles \xC5land",
  AD: "Andorre",
  BG: "Bulgarie",
  AT: "Autriche",
  BE: "Belgique",
  HR: "Croatie",
  CY: "Chypre",
  CZ: "R\xE9publique tch\xE8que",
  DK: "Danemark",
  EE: "Estonie",
  FI: "Finlande",
  FR: "France",
  GP: "Guadeloupe",
  DE: "Allemagne",
  GR: "Gr\xE8ce",
  HU: "Hongrie",
  IS: "Islande",
  IE: "Irlande",
  VA: "Saint-Si\xE8ge (\xC9tat de la Cit\xE9 du Vatican)",
  IT: "Italie",
  LI: "Liechtenstein",
  LT: "Lituanie",
  LU: "Luxembourg",
  YT: "Mayotte",
  MT: "Malte",
  MQ: "Martinique",
  ES: "Espagne",
  NO: "Norv\xE8ge",
  NL: "Pays-Bas",
  PL: "Pologne",
  PT: "Portugal",
  SE: "Su\xE8de",
  RE: "La R\xE9union",
  RO: "Roumanie",
  CH: "Suisse",
  BL: "Saint-Barth\xE9lemy",
  GB: "Royaume-Uni",
  MC: "Monaco",
  MF: "Saint-Martin (partie fran\xE7aise)",
  PM: "Saint-Pierre-et-Miquelon",
  SM: "Saint-Marin",
  SK: "Slovaquie",
  SI: "Slov\xE9nie",
  GF: "Guyane fran\xE7aise",
  LV: "Lettonie",
  CA: "Canada",
  US: "\xC9tats-Unis",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/locales/id.ts
var id = {
  "session_expired.title": "Sesi telah kedaluwarsa",
  "tokenizationForm.payment-terms.text1": "Saya mengizinkan Flywire untuk menyimpan dan menagih kartu debit/kredit saya secara otomatis atas nama {{recipientName}}. Saya telah membaca, memahami, dan menyetujui",
  "tokenizationForm.general-terms.link2": "Kebijakan Pribadi",
  "tokenizationForm.general-terms.link-joint": " dan ",
  "tokenizationForm.general-terms.link1": "Syarat Penggunaan",
  "tokenizationForm.payment-terms.link": "Persyaratan Penggunaan Flywire untuk pembayaran otomatis",
  "tokenizationForm.labels.cvvTooltip": "3 digit di bagian belakang kartu Anda atau 4 digit di depan",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "Tanggal kedaluwarsa (BB/TT)",
  "tokenizationForm.labels.cardNumber": "Nomor kartu",
  "tokenizationForm.labels.phone": "Nomor Telepon",
  "tokenizationForm.labels.zip": "Kode pos",
  "tokenizationForm.labels.address": "Alamat",
  "cardsForm.labels.state": "Negara",
  "tokenizationForm.labels.country": "Negara",
  "tokenizationForm.labels.city": "Kota",
  "tokenizationForm.labels.email": "Email",
  "tokenizationForm.labels.lastName": "Nama belakang",
  "tokenizationForm.labels.firstName": "Nama depan",
  "tokenizationForm.labels.dynamicFields.document": "Nomor CPF atau CNPJ",
  "cardsForm.title": "Informasi pemegang kartu",
  "success.title": "Dana Anda dalam perjalanan",
  "success.title.info": "Harap tunggu 2-3 hari kerja hingga dana Anda tiba.\nAnda akan menerima surel ketika dana tersebut sampai.",
  "bankAccountForm.hints.generic": "Contoh: {{label}}",
  "bankAccountForm.hints.account_number": "Panjang nomor rekening harus antara 1 hingga 17 karakter",
  "bankAccountForm.hints.routing_number": "Panjang nomor perutean harus 9 digit",
  "bankAccountForm.labels.accountZipCode": "Kode pos",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "Kode BIC",
  "bankAccountForm.labels.accountNumber": "Nomor rekening",
  "bankAccountForm.labels.accountSortCode": "Kode sortir",
  "bankAccountForm.labels.accountRoutingNumber": "Routing number",
  "bankAccountForm.labels.accountType": "Jenis akun",
  "bankAccountForm.labels.eftProviderWidnow": "Anda akan dibawa ke platform pemrosesan mitra kami untuk menyelesaikan pembayaran ini. Setelah selesai, Anda akan dialihkan ke halaman ini lagi.",
  "bankAccountForm.labels.termsFlywire": "Saya telah membaca, memahami, dan menyetujui <a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>Syarat Penggunaan</a> dan <a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Kebijakan Privasi</a>Flywire",
  "bankAccountForm.labels.termsDirectDebit": "Saya menegaskan bahwa saya adalah pemilik rekening ini dan satu-satunya penanda tangan yang diperlukan untuk mengesahkan debit/langsung ini",
  "bankAccountForm.labels.termsEft": "Saya telah membaca, memahami, dan menyetujui <a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Perjanjian Pendebitan yang Diotorisasi Sebelumnya</a>",
  "bankAccountForm.labels.city": "Kota",
  "bankAccountForm.labels.country": "Negara",
  "bankAccountForm.labels.selectCountry": "Pilih negara",
  "bankAccountForm.title": "Informasi pemegang rekening",
  "failure.tryAgain": "Coba lagi",
  "failure.title": "Transaksi gagal",
  "failure.connectivity.message": "Operasi gagal, ini bisa disebabkan oleh masalah konektivitas.",
  "failure.message": "Transaksi gagal. Ini mungkin disebabkan oleh masalah konektivitas. Coba lagi. Jika masalah terus berlanjut, coba metode pembayaran lain atau hubungi bank Anda",
  "sessionExpired.text": "Sesi telah kedaluwarsa",
  "LoadingError.title": "Terjadi kesalahan",
  "LoadingError.message": "Terjadi kesalahan saat memuat formulir.",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "Tidak ada opsi pembayaran yang tersedia untuk negara yang dipilih",
  "bankAccountForm.labels.accountHolderType.personal": "Akun Pribadi",
  "bankAccountForm.labels.accountHolderType.business": "Akun Bisnis",
  "bankAccountForm.labels.name": "Nama depan",
  "bankAccountForm.labels.businessName": "Nama bisnis",
  "bankAccountForm.labels.surname": "Nama belakang",
  "bankAccountForm.labels.phone": "Nomor Telepon",
  "bankAccountForm.labels.email": "Email",
  "bankAccountForm.labels.zip": "Kode pos",
  "bankAccountForm.labels.accountAddress": "Alamat",
  "bankAccountForm.labels.address": "Alamat",
  "bankAccountForm.errors.dynamicFields": "Tidak valid {{field}}",
  "bankAccountForm.errors.dynamicFields.document": "Nomor CPF atau CNPJ tidak valid",
  "bankAccountForm.errors.dynamicFields.documentPattern": "Harap sertakan nomor CPF/CNPJ Anda tanpa tanda hubung atau tanda pisah",
  "bankAccountForm.labels.saveButton": "Menyimpan",
  "bankAccountForm.labels.nextButton": "Berikutnya",
  "bankAccountForm.labels.payButton": "Bayar",
  "bankAccountForm.errors.cardNumber": "Nomor kartu tidak valid",
  "tokenizationForm.errors.cardNumber": "Nomor kartu tidak valid",
  "tokenizationForm.errors.cvv": "Nomor CVV tidak valid",
  "bankAccountForm.errors.cvv": "Nomor CVV tidak valid",
  "tokenizationForm.errors.unsupportedCardTypes": "Hanya %{{acceptedCardsList}} yang didukung",
  "tokenizationForm.errors.unsupportedCardType": "Hanya {{acceptedCard}} yang didukung",
  "tokenizationForm.errors.cardType.and": "dan",
  "tokenizationForm.errors.name": "Nama depan tidak valid",
  "tokenizationForm.errors.email": "Surel tidak valid",
  "tokenizationForm.errors.country": "Negara tidak valid",
  "tokenizationForm.errors.state": "Negara bagian tidak valid",
  "tokenizationForm.errors.city": "Kota tidak valid",
  "tokenizationForm.errors.address": "Alamat tidak valid",
  "tokenizationForm.errors.addressIsPoBox": "Kami tidak memperbolehkan PO Box di bidang alamat.",
  "tokenizationForm.errors.onlyLetterOrNumbers": "Karakter yang valid hanya mencakup A-Z dan 0-9",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": 'Karakter yang valid hanya mencakup A-Z, 0-9, dan "/, -"',
  "tokenizationForm.errors.zip": "Kode pos tidak valid",
  "tokenizationForm.errors.expiryDate": "Tanggal kedaluwarsa tidak valid",
  "bankAccountForm.errors.expiryDate": "Tanggal kedaluwarsa tidak valid",
  "tokenizationForm.errors.surname": "Nama keluarga tidak valid",
  "tokenizationForm.errors.phone": "Nomor telepon tidak valid",
  "tokenizationForm.errors.length": "Bidang terlalu panjang (maksimum 256 karakter)",
  "bankAccountForm.errors.name": "Nama depan tidak valid",
  "bankAccountForm.errors.name.maxSizeExceeded": "Nama depan terlalu panjang (maksimum 140 karakter)",
  "form.errors.name.maxSizeExceeded": "Nama depan terlalu panjang (maksimum 140 {{limit}} karakter)",
  "form.errors.surname.maxSizeExceeded": "Nama belakang terlalu panjang (maksimum {{limit}} 140 karakter)",
  "form.errors.business_name.maxSizeExceeded": "Nama depan terlalu panjang (maksimum {{limit}} 140 karakter)",
  "form.errors.city.maxSizeExceeded": "Kota terlalu panjang (maksimum {{limit}} 256 karakter)",
  "form.errors.address.maxSizeExceeded": "Alamat terlalu panjang (maksimum {{limit}} 256 karakter)",
  "bankAccountForm.errors.business_name": "Nama bisnis tidak valid",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "Nama depan terlalu panjang (maksimum 140 karakter)",
  "bankAccountForm.errors.surname": "Nama belakang tidak valid",
  "bankAccountForm.errors.surname.maxSizeExceeded": "Nama belakang terlalu panjang (maksimum 140 karakter)",
  "bankAccountForm.errors.country": "Negara tidak valid",
  "bankAccountForm.errors.address": "Alamat tidak valid",
  "bankAccountForm.errors.address.maxSizeExceeded": "Alamat terlalu panjang (maksimum 256 karakter)",
  "bankAccountForm.errors.city": "Kota tidak valid",
  "bankAccountForm.errors.city.maxSizeExceeded": "Kota terlalu panjang (maksimum 256 karakter)",
  "bankAccountForm.errors.email": "Surel tidak valid",
  "bankAccountForm.errors.state": "Negara bagian tidak valid",
  "bankAccountForm.errors.iban": "IBAN tidak valid",
  "bankAccountForm.errors.bic": "Kode BIC tidak valid",
  "bankAccountForm.errors.accountnumber": "Nomor rekening tidak valid",
  "bankAccountForm.errors.sortcode": "Kode sortir tidak valid",
  "bankAccountForm.errors.account_type": "Jenis akun tidak valid",
  "bankAccountForm.errors.addressIsPoBox": "Kami tidak memperbolehkan PO Box di bidang alamat.",
  "bankAccountForm.errors.onlyLetterOrNumbers": "Karakter yang valid hanya mencakup A-Z dan 0-9",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "Karakter yang valid adalah: AZ 0-9 / , -",
  "bankAccountForm.errors.zip": "Kode pos tidak valid",
  "bankAccountForm.errors.phone": "Nomor telepon tidak valid",
  "bankAccountForm.errors.ach_account_number": "Nomor rekening tidak valid",
  "bankAccountForm.errors.routing_number": "Nomor perutean tidak valid",
  "bankAccountForm.errors.offer": "Tidak ada opsi pembayaran yang tersedia - Jika Anda memiliki rekening bank di negara lain, pilih negara ini atau pilih kartu lain dan coba lagi. Jika tindakan ini tidak menyelesaikan masalah, hubungi {{recipientName}}",
  "confirmationPage.labels.edit": "Edit",
  "confirmationPage.labels.confirm": "Konfirmasi",
  "confirmationPage.labels.title": "Periksa info mandat",
  "confirmationPage.labels.typeOfPayment": "Jenis pembayaran",
  "confirmationPage.labels.paymentRecipient": "Penerima pembayaran",
  "confirmationPage.labels.typeOfPayment.oneOff": "Satu kali",
  "confirmationPage.labels.typeOfPayment.recurring": "Berulang",
  "confirmationPage.labels.directDebitInformation": "Informasi debit langsung",
  "confirmationPage.labels.directDebitInformation.title": "Instruksi untuk bank Anda",
  "confirmationPage.labels.directDebitInformation.creditor": "Kreditur",
  "confirmationPage.labels.directDebitInformation.creditorId": "ID Kreditor",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "Nama dalam laporan mutasi Anda",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "ID pengguna layanan",
  "confirmationPage.labels.directDebitInformation.address": "Alamat Flywire",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "ID Originator",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "Alamat Originator",
  "confirmationPage.labels.bankAccountInformation": "Informasi rekening bank",
  "confirmationPage.labels.bankAccountInformation.name": "Nama",
  "confirmationPage.labels.bankAccountInformation.iban": "Nomor IBAN",
  "confirmationPage.labels.bankAccountInformation.email": "Email",
  "confirmationPage.labels.bankAccountInformation.country": "Negara",
  "confirmationPage.labels.bankAccountInformation.state": "Negara",
  "confirmationPage.labels.bankAccountInformation.city": "Kota",
  "confirmationPage.labels.bankAccountInformation.bicCode": "Kode BIC",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "Nomor rekening",
  "confirmationPage.labels.bankAccountInformation.sortCode": "Kode sortir",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "Nomor rekening",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "Routing number",
  "confirmationPage.labels.bankAccountInformation.accountType": "Jenis akun",
  "confirmationPage.labels.changeAccountEft": "Ubah perincian rekening bank",
  "confirmationPage.labels.editPayerEft": "Edit Perincian Pembayar",
  "confirmationPage.labels.useAccountEft": "Gunakan Rekening berakhiran **** {{lastFour}}",
  "confirmationPage.labels.termsSepa": "Dengan menandatangani formulir mandat ini, Anda memberi wewenang kepada (A) FLYWIRE EUROPE UAB untuk mengirim instruksi ke bank Anda agar mendebit rekening Anda dan (B) bank Anda untuk mendebit rekening Anda sesuai dengan instruksi dari FLYWIRE EUROPE UAB. Anda akan diberi tahu setidaknya 3 hari sebelum dikenakan biaya.",
  "confirmationPage.labels.termsBacs": "Instruksikan bank Anda untuk membayar Debit Langsung ke Flywire Payments Limited dari akun yang diperinci dalam instruksi ini dengan tunduk pada perlindungan yang dijamin oleh Jaminan Debit Langsung. Saya memahami bahwa instruksi ini mungkin tetap berada di Flywire Payments Limited dan, jika demikian, perinciannya akan diteruskan secara elektronik ke bank/koperasi saya.",
  "confirmationPage.labels.termsAch": '\n     Dengan mengklik "Konfirmasi", Anda menegaskan bahwa Anda memiliki wewenang yang tepat untuk dan dengan ini memberi wewenang kepada Flywire atas nama penerima yang ditentukan \n ("Penerima Pembayaran") untuk mendebit rekening bank yang Anda berikan untuk jumlah yang terutang untuk biaya yang timbul dari penggunaan Anda atas layanan Penerima Pembayaran \n dan/atau pembelian produk dari Penerima Pembayaran, dan jika perlu, untuk mengoreksi debit yang salah, sesuai dengan persyaratan Penerima Pembayaran, sampai otorisasi \n ini dicabut. Jika transaksi ACH ditolak karena dana tidak mencukupi, saya memahami bahwa saya akan dikenakan biaya \n NSF, dan bahwa Flywire dapat dengan kebijaksanaannya sendiri mencoba untuk memproses biaya tersebut kembali.\n     ',
  "confirmationPage.labels.termsAch2": "\n     Jika Anda menggunakan atau membeli produk dan/atau layanan tambahan dari Penerima Pembayaran secara berkala, sesuai dengan ketentuan Penerima Pembayaran, Anda memberi wewenang kepada \n Flywire, atas nama Penerima Pembayaran, untuk mendebit rekening bank yang Anda berikan secara berkala. Pembayaran yang berada di luar otorisasi debit \n di atas hanya akan didebit setelah otorisasi Anda diperoleh melalui akun Anda, atau dengan kata sandi, kode, atau tanda tangan lain yang setara dengan \n.\n     ",
  "confirmationPage.labels.termsAch3": "\n     Anda dapat mencabut otorisasi ini kapan saja dengan menghubungi Penerima Pembayaran. Pencabutan Anda harus diterima paling lambat [10 hari kerja] \n sebelum pembayaran terjadwal berikutnya.\n    ",
  "confirmationPage.labels.print": "Perjanjian cetak",
  "amountPanel.labels.amountFromLabel": "Anda akan membayar",
  "amountPanel.labels.surchargeFeeInfo": "sudah termasuk biaya kartu.",
  "amountPanel.labels.whyThisFee": "Mengapa biaya ini?",
  "amountPanel.labels.whyThisFeeTooltip": "\n  {{percentage}} % biaya kartu jika Anda melanjutkan pembayaran. Mata uang kartu {{cardScheme}} Anda adalah {{currency}}. Pilih kartu atau negara yang sesuai dengan kartu Anda untuk menghindari biaya tambahan.\n     ",
  "amountPanel.labels.currencyChangeWarning": "Mata uang telah diubah agar sesuai dengan mata uang kartu Anda",
  "amountPanel.labels.amountToLabel": "{{recipientName}} akan menerima",
  AX: "Kepulauan \xC5land",
  AD: "Andorra",
  BG: "Bulgaria",
  AT: "Austria",
  BE: "Belgia",
  HR: "Kroasia",
  CY: "Siprus",
  CZ: "Republik Ceko",
  DK: "Denmark",
  EE: "Estonia",
  FI: "Finlandia",
  FR: "Prancis",
  GP: "Guadeloupe",
  DE: "Jerman",
  GR: "Yunani",
  HU: "Hongaria",
  IS: "Islandia",
  IE: "Irlandia",
  VA: "Takhta Suci (Negara Kota Vatikan)",
  IT: "Italia",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luksemburg",
  YT: "Mayotte",
  MT: "Malta",
  MQ: "Martinik",
  ES: "Spanyol",
  NO: "Norwegia",
  NL: "Belanda",
  PL: "Polandia",
  PT: "Portugal",
  SE: "Swedia",
  RE: "R\xE9union",
  RO: "Rumania",
  CH: "Swiss",
  BL: "Saint Barth\xE9lemy",
  GB: "Inggris Raya",
  MC: "Monako",
  MF: "Saint Martin (Bagian Prancis)",
  PM: "Saint Pierre dan Miquelon",
  SM: "San Marino",
  SK: "Slowakia",
  SI: "Slovenia",
  GF: "Guyana Prancis",
  LV: "Latvia",
  CA: "Kanada",
  US: "Amerika Serikat",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/locales/it-IT.ts
var it = {
  "session_expired.title": "La sessione \xE8 scaduta",
  "tokenizationForm.payment-terms.text1": "Autorizzo Flywire a memorizzare e addebitare automaticamente la mia carta di debito/credito per conto di {{recipientName}}. Dichiaro di aver letto e compreso e di accettare le",
  "tokenizationForm.general-terms.link2": "Informativa sulla privacy",
  "tokenizationForm.general-terms.link-joint": " e ",
  "tokenizationForm.general-terms.link1": "Condizioni di utilizzo",
  "tokenizationForm.payment-terms.link": "condizioni d'uso di Flywire per i pagamenti automatici",
  "tokenizationForm.labels.cvvTooltip": "3 cifre sul retro della carta o 4 cifre sul davanti",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "Data di scadenza (MM/AA)",
  "tokenizationForm.labels.cardNumber": "Numero della carta",
  "tokenizationForm.labels.phone": "Numero di telefono",
  "tokenizationForm.labels.zip": "Codice postale",
  "tokenizationForm.labels.address": "Indirizzo",
  "cardsForm.labels.state": "STATO",
  "tokenizationForm.labels.country": "Paese",
  "tokenizationForm.labels.city": "Luogo",
  "tokenizationForm.labels.email": "E-mail",
  "tokenizationForm.labels.lastName": "Cognome",
  "tokenizationForm.labels.firstName": "Nome",
  "tokenizationForm.labels.dynamicFields.document": "Numero CPF o CNPJ",
  "cardsForm.title": "Informazioni sul titolare della carta",
  "success.title": "Il trasferimento dei fondi \xE8 in corso",
  "success.title.info": "Il trasferimento verr\xE0 completato entro 2-3 giorni lavorativi.\nRiceverete un'e-mail al momento dell'accredito dei fondi.",
  "bankAccountForm.hints.generic": "Esempio: {{label}}",
  "bankAccountForm.hints.account_number": "La lunghezza del numero di conto deve essere compresa tra 1 e 17 caratteri",
  "bankAccountForm.hints.routing_number": "La lunghezza del numero di routing deve essere di 9 cifre",
  "bankAccountForm.labels.accountZipCode": "Codice postale",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "Codice BIC",
  "bankAccountForm.labels.accountNumber": "Numero di conto",
  "bankAccountForm.labels.accountSortCode": "Codice distintivo",
  "bankAccountForm.labels.accountRoutingNumber": "Coordinate bancarie",
  "bankAccountForm.labels.accountType": "Tipo di conto",
  "bankAccountForm.labels.eftProviderWidnow": "Si verr\xE0 reindirizzati alla piattaforma di elaborazione del partner per il completamento del pagamento. Al termine dell'operazione, si verr\xE0 nuovamente reindirizzati su questa pagina",
  "bankAccountForm.labels.termsFlywire": "Dichiaro di aver letto, compreso e accettato i <a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>Termini d'uso</a> e l'<a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Informativa sulla privacy</a> di Flywire.",
  "bankAccountForm.labels.termsDirectDebit": "Confermo di essere il titolare del conto e di essere l'unico firmatario richiesto per autorizzare l'addebito diretto",
  "bankAccountForm.labels.termsEft": "Ho letto, compreso e accettato il <a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Contratto di addebito preautorizzato</a>",
  "bankAccountForm.labels.city": "Luogo",
  "bankAccountForm.labels.country": "Paese",
  "bankAccountForm.labels.selectCountry": "Seleziona un paese",
  "bankAccountForm.title": "Informazioni sul titolare del conto",
  "failure.tryAgain": "Riprova",
  "failure.title": "Transazione non riuscita",
  "failure.connectivity.message": "Operazione non riuscita. Potrebbero essersi verificati dei problemi di connessione.",
  "failure.message": "Transazione non riuscita per probabili problemi di connessione. Riprovare. Se il problema persiste, provare con un altro metodo di pagamento o contattare la propria banca",
  "sessionExpired.text": "La sessione \xE8 scaduta",
  "LoadingError.title": "Si \xE8 verificato un errore",
  "LoadingError.message": "Si \xE8 verificato un errore durante il caricamento del modulo",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "Non sono presenti opzioni di pagamento disponibili per il paese selezionato",
  "bankAccountForm.labels.accountHolderType.personal": "Conto personale",
  "bankAccountForm.labels.accountHolderType.business": "Conto aziendale",
  "bankAccountForm.labels.name": "Nome",
  "bankAccountForm.labels.businessName": "Ragione sociale",
  "bankAccountForm.labels.surname": "Cognome",
  "bankAccountForm.labels.phone": "Numero di telefono",
  "bankAccountForm.labels.email": "E-mail",
  "bankAccountForm.labels.zip": "Codice postale",
  "bankAccountForm.labels.accountAddress": "Indirizzo",
  "bankAccountForm.labels.address": "Indirizzo",
  "bankAccountForm.errors.dynamicFields": "{{field}} non valido",
  "bankAccountForm.errors.dynamicFields.document": "Numero CPF o CNPJ non valido",
  "bankAccountForm.errors.dynamicFields.documentPattern": "Includere il numero CPF/CNPJ senza trattini",
  "bankAccountForm.labels.saveButton": "Salva",
  "bankAccountForm.labels.nextButton": "Avanti",
  "bankAccountForm.labels.payButton": "Paga",
  "bankAccountForm.errors.cardNumber": "Numero di carta non valido",
  "tokenizationForm.errors.cardNumber": "Numero di carta non valido",
  "tokenizationForm.errors.cvv": "Numero CVV non valido",
  "bankAccountForm.errors.cvv": "Numero CVV non valido",
  "tokenizationForm.errors.unsupportedCardTypes": "Sono supportate solo {{acceptedCardsList}}",
  "tokenizationForm.errors.unsupportedCardType": "\xC8 supportata solo {{acceptedCard}}",
  "tokenizationForm.errors.cardType.and": "e",
  "tokenizationForm.errors.name": "Nome non valido",
  "tokenizationForm.errors.email": "Indirizzo e-mail non valido",
  "tokenizationForm.errors.country": "Paese non valido",
  "tokenizationForm.errors.state": "Stato non valido",
  "tokenizationForm.errors.city": "Luogo non valido",
  "tokenizationForm.errors.address": "Indirizzo non valido",
  "tokenizationForm.errors.addressIsPoBox": "Non accettiamo caselle postali nel campo indirizzo.",
  "tokenizationForm.errors.onlyLetterOrNumbers": "I caratteri consentiti comprendono soltanto lettere (A-Z) e numeri (0-9)",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": 'I caratteri validi includono solo A-Z, 0-9 e "/, -"',
  "tokenizationForm.errors.zip": "Codice postale non valido",
  "tokenizationForm.errors.expiryDate": "Data di scadenza non valida",
  "bankAccountForm.errors.expiryDate": "Data di scadenza non valida",
  "tokenizationForm.errors.surname": "Cognome non valido",
  "tokenizationForm.errors.phone": "Numero di telefono non valido",
  "tokenizationForm.errors.length": "Il campo \xE8 troppo lungo (massimo 256 caratteri)",
  "bankAccountForm.errors.name": "Nome non valido",
  "bankAccountForm.errors.name.maxSizeExceeded": "Il nome \xE8 troppo lungo (massimo 140 caratteri)",
  "form.errors.name.maxSizeExceeded": "Il nome \xE8 troppo lungo (massimo {{limit}} caratteri)",
  "form.errors.surname.maxSizeExceeded": "Il cognome \xE8 troppo lungo (massimo {{limit}} caratteri)",
  "form.errors.business_name.maxSizeExceeded": "La ragione sociale \xE8 troppo lunga (massimo {{limit}} caratteri)",
  "form.errors.city.maxSizeExceeded": "Il nome della citt\xE0 \xE8 troppo lungo (massimo {{limit}} caratteri)",
  "form.errors.address.maxSizeExceeded": "L'indirizzo \xE8 troppo lungo (massimo {{limit}} caratteri)",
  "bankAccountForm.errors.business_name": "Ragione sociale non valida",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "La ragione sociale \xE8 troppo lunga (massimo 140 caratteri)",
  "bankAccountForm.errors.surname": "Cognome non valido",
  "bankAccountForm.errors.surname.maxSizeExceeded": "Il cognome \xE8 troppo lungo (massimo 140 caratteri)",
  "bankAccountForm.errors.country": "Paese non valido",
  "bankAccountForm.errors.address": "Indirizzo non valido",
  "bankAccountForm.errors.address.maxSizeExceeded": "L'indirizzo \xE8 troppo lungo (massimo 256 caratteri)",
  "bankAccountForm.errors.city": "Luogo non valido",
  "bankAccountForm.errors.city.maxSizeExceeded": "Il nome della citt\xE0 \xE8 troppo lungo (massimo 256 caratteri)",
  "bankAccountForm.errors.email": "Indirizzo e-mail non valido",
  "bankAccountForm.errors.state": "Stato non valido",
  "bankAccountForm.errors.iban": "IBAN non valido",
  "bankAccountForm.errors.bic": "Codice BIC non valido",
  "bankAccountForm.errors.accountnumber": "Numero di conto non valido",
  "bankAccountForm.errors.sortcode": "Codice distintivo non valido",
  "bankAccountForm.errors.account_type": "Tipo di conto non valido",
  "bankAccountForm.errors.addressIsPoBox": "Non accettiamo caselle postali nel campo indirizzo.",
  "bankAccountForm.errors.onlyLetterOrNumbers": "I caratteri consentiti comprendono soltanto lettere (A-Z) e numeri (0-9)",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "I caratteri consentiti sono: A-Z 0-9 / , -",
  "bankAccountForm.errors.zip": "Codice postale non valido",
  "bankAccountForm.errors.phone": "Numero di telefono non valido",
  "bankAccountForm.errors.ach_account_number": "Numero di conto non valido",
  "bankAccountForm.errors.routing_number": "Coordinate bancarie non valide",
  "bankAccountForm.errors.offer": "Nessuna opzione di pagamento disponibile. Se si dispone un conto bancario in un altro Paese, selezionare il Paese o scegliere un'altra carta e riprovare. Se il problema permane, contattare {{recipientName}}",
  "confirmationPage.labels.edit": "Modifica",
  "confirmationPage.labels.confirm": "Conferma",
  "confirmationPage.labels.title": "Verifica le informazioni del mandato",
  "confirmationPage.labels.typeOfPayment": "Tipo di pagamento",
  "confirmationPage.labels.paymentRecipient": "Destinatario del pagamento",
  "confirmationPage.labels.typeOfPayment.oneOff": "Singolo",
  "confirmationPage.labels.typeOfPayment.recurring": "Ricorrente",
  "confirmationPage.labels.directDebitInformation": "Informazioni addebito diretto",
  "confirmationPage.labels.directDebitInformation.title": "Istruzioni per la vostra banca",
  "confirmationPage.labels.directDebitInformation.creditor": "Creditore",
  "confirmationPage.labels.directDebitInformation.creditorId": "ID creditore",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "Nome sull'estratto conto",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "ID utente del servizio",
  "confirmationPage.labels.directDebitInformation.address": "Indirizzo Flywire",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "ID Originator",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "Indirizzo Originator",
  "confirmationPage.labels.bankAccountInformation": "Informazioni sul conto bancario",
  "confirmationPage.labels.bankAccountInformation.name": "Nome",
  "confirmationPage.labels.bankAccountInformation.iban": "Codice IBAN",
  "confirmationPage.labels.bankAccountInformation.email": "E-mail",
  "confirmationPage.labels.bankAccountInformation.country": "Paese",
  "confirmationPage.labels.bankAccountInformation.state": "STATO",
  "confirmationPage.labels.bankAccountInformation.city": "Luogo",
  "confirmationPage.labels.bankAccountInformation.bicCode": "Codice BIC",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "Numero di conto",
  "confirmationPage.labels.bankAccountInformation.sortCode": "Codice distintivo",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "Numero di conto",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "Coordinate bancarie",
  "confirmationPage.labels.bankAccountInformation.accountType": "Tipo di conto",
  "confirmationPage.labels.changeAccountEft": "Modificare i dati del conto bancario",
  "confirmationPage.labels.editPayerEft": "Modificare i dettagli del pagatore",
  "confirmationPage.labels.useAccountEft": "Utilizzare il conto che termina con **** {{lastFour}}",
  "confirmationPage.labels.termsSepa": "La sottoscrizione del presente mandato comporta (A) l\u2019autorizzazione a FLYWIRE EUROPE UAB a richiedere alla banca del debitore l\u2019addebito del suo conto e (B) l\u2019autorizzazione alla banca del debitore di procedere a tale addebito conformemente alle disposizioni impartite da FLYWIRE EUROPE UAB. Verr\xE0 inviata una notifica almeno 3 giorni prima dell'addebito.",
  "confirmationPage.labels.termsBacs": "Chiedete alla vostra banca di pagare gli addebiti diretti di Flywire Payments Limited dall'account indicato nelle presenti istruzioni, in base alle misure della Garanzia sugli addebiti diretti. Comprendo che queste istruzioni potrebbero rimanere in possesso di Flywire Payments Limited e che, in tal caso, le informazioni verranno trasferite elettronicamente alla mia banca/al mio istituto di credito.",
  "confirmationPage.labels.termsAch": `
     Facendo clic su "Conferma", dichiara di avere l'autorit\xE0 richiesta e autorizza Flywire per conto del destinatario specificato 
     ("Beneficiario") a effettuare addebiti sul conto bancario da Lei fornito per importi dovuti per il Suo utilizzo dei servizi del Beneficiario 
     e/o per l'acquisto di prodotti dal Beneficiario e, se necessario, a correggere addebiti errati, in conformit\xE0 con i Termini del Beneficiario, fino a quando a presente autorizzazione non sar\xE0 
     revocata. In caso di rifiuto di una transazione ACH per fondi insufficienti, comprendo che mi sar\xE0 addebitata una 
     tassa NSF e che Flywire potr\xE0, a sua discrezione, tentare di effettuare il riaddebito.
     `,
  "confirmationPage.labels.termsAch2": "\n     Se utilizza o acquista periodicamente prodotti e/o servizi aggiuntivi dal Beneficiario, in conformit\xE0 con i Termini del Beneficiario, autorizza \n     Flywire, per conto del Beneficiario, a effettuare addebiti periodici sul conto bancario da Lei indicato. I pagamenti che non rientrano negli addebiti \n     sopra autorizzati saranno addebitati solo previa autorizzazione da parte Sua tramite l'account o in alternativa una password, un codice o un altro \n     equivalente della firma.\n     ",
  "confirmationPage.labels.termsAch3": "\n     Pu\xF2 revocare questa autorizzazione in qualsiasi momento contattando il Beneficiario. La revoca deve pervenire almeno [10 giorni lavorativi] \n     prima del successivo pagamento pianificato.\n    ",
  "confirmationPage.labels.print": "Stampa contratto",
  "amountPanel.labels.amountFromLabel": "Pagherai",
  "amountPanel.labels.surchargeFeeInfo": "commissione della carta inclusa.",
  "amountPanel.labels.whyThisFee": "Perch\xE9 questa commissione?",
  "amountPanel.labels.whyThisFeeTooltip": "\n  {{percentage}} pari a % di commissioni della carta se procedi con il pagamento. La valuta della tua carta {{cardScheme}} \xE8 {{currency}}. Seleziona una carta o un Paese compatibili con la tua carta per evitare ulteriori commissioni.\n     ",
  "amountPanel.labels.currencyChangeWarning": "La valuta \xE8 stata cambiata perch\xE9 corrispondesse a quella della carta",
  "amountPanel.labels.amountToLabel": "{{recipientName}} ricever\xE0",
  AX: "Isole \xC5land",
  AD: "Andorra",
  BG: "Bulgaria",
  AT: "Austria",
  BE: "Belgio",
  HR: "Croazia",
  CY: "Cipro",
  CZ: "Repubblica Ceca",
  DK: "Danimarca",
  EE: "Estonia",
  FI: "Finlandia",
  FR: "Francia",
  GP: "Guadalupa",
  DE: "Germania",
  GR: "Grecia",
  HU: "Ungheria",
  IS: "Islanda",
  IE: "Irlanda",
  VA: "Santa Sede (Citt\xE0 del Vaticano)",
  IT: "Italia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Lussemburgo",
  YT: "Mayotte",
  MT: "Malta",
  MQ: "Martinica",
  ES: "Spagna",
  NO: "Norvegia",
  NL: "Paesi Bassi",
  PL: "Polonia",
  PT: "Portogallo",
  SE: "Svezia",
  RE: "Riunione",
  RO: "Romania",
  CH: "Svizzera",
  BL: "Saint-Barth\xE9lemy",
  GB: "Regno Unito",
  MC: "Monaco",
  MF: "Saint Martin (parte francese)",
  PM: "Saint-Pierre e Miquelon",
  SM: "San Marino",
  SK: "Slovacchia",
  SI: "Slovenia",
  GF: "Guyana francese",
  LV: "Lettonia",
  CA: "Canada",
  US: "Stati Uniti",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/locales/ja.ts
var ja = {
  "session_expired.title": "\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F",
  "tokenizationForm.payment-terms.text1": "\u79C1\u306F\u30D5\u30E9\u30A4\u30EF\u30A4\u30E4\u30FC\u304C{{recipientName}}\u306E\u4EE3\u7406\u3068\u3057\u3066\u3001\u79C1\u306E\u30C7\u30D3\u30C3\u30C8/\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u306E\u60C5\u5831\u3092\u4FDD\u5B58\u3057\u3001\u81EA\u52D5\u7684\u306B\u8AB2\u91D1\u3059\u308B\u3053\u3068\u3092\u8A31\u53EF\u3057\u307E\u3059\u3002\u79C1\u306F\u3001\u6B21\u306E\u5185\u5BB9\u3092\u8AAD\u307F\u3001\u7406\u89E3\u3057\u305F\u4E0A\u3067\u540C\u610F\u3057\u307E\u3059 :",
  "tokenizationForm.general-terms.link2": "\u30D5\u30E9\u30A4\u30EF\u30A4\u30E4\u30FC \u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC",
  "tokenizationForm.general-terms.link-joint": " \u304A\u3088\u3073 ",
  "tokenizationForm.general-terms.link1": "\u30D5\u30E9\u30A4\u30EF\u30A4\u30E4\u30FC\u306E\u5229\u7528\u898F\u7D04",
  "tokenizationForm.payment-terms.link": "\u81EA\u52D5\u652F\u6255\u3044\u306B\u95A2\u3059\u308B\u30D5\u30E9\u30A4\u30EF\u30A4\u30E4\u30FC\u306E\u5229\u7528\u898F\u7D04",
  "tokenizationForm.labels.cvvTooltip": "\u30AB\u30FC\u30C9\u306E\u88CF\u9762\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B3\u6841\u306E\u6570\u5B57\u3001\u307E\u305F\u306F\u30AB\u30FC\u30C9\u306E\u8868\u9762\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B4\u6841\u306E\u6570\u5B57",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "\u6709\u52B9\u671F\u9650\u65E5 (\u6708\u6708/\u5E74\u5E74)",
  "tokenizationForm.labels.cardNumber": "\u30AB\u30FC\u30C9\u756A\u53F7",
  "tokenizationForm.labels.phone": "\u96FB\u8A71\u756A\u53F7",
  "tokenizationForm.labels.zip": "\u90F5\u4FBF\u756A\u53F7",
  "tokenizationForm.labels.address": "\u4F4F\u6240",
  "cardsForm.labels.state": "\u5DDE",
  "tokenizationForm.labels.country": "\u56FD",
  "tokenizationForm.labels.city": "\u5E02\u533A\u753A\u6751",
  "tokenizationForm.labels.email": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
  "tokenizationForm.labels.lastName": "\u59D3",
  "tokenizationForm.labels.firstName": "\u540D",
  "tokenizationForm.labels.dynamicFields.document": "CPF\u307E\u305F\u306F CNPJ\u756A\u53F7",
  "cardsForm.title": "\u30AB\u30FC\u30C9\u540D\u7FA9\u4EBA\u60C5\u5831",
  "success.title": "\u8CC7\u91D1\u306F\u307E\u3082\u306A\u304F\u5230\u7740\u3057\u307E\u3059",
  "success.title.info": "\u8CC7\u91D1\u306E\u5230\u7740\u307E\u30672\uFF5E3\u55B6\u696D\u65E5\u304B\u304B\u308A\u307E\u3059\u306E\u3067\u4E88\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002\u8CC7\u91D1\u306E\u632F\u8FBC\u304C\u5B8C\u4E86\u3059\u308B\u3068\u3001E\u30E1\u30FC\u30EB\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002",
  "bankAccountForm.hints.generic": "\u4F8B: {{label}}",
  "bankAccountForm.hints.account_number": "\u53E3\u5EA7\u756A\u53F7\u306E\u9577\u3055\u306F1\u6587\u5B57\u304B\u308917\u6587\u5B57\u3068\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
  "bankAccountForm.hints.routing_number": "\u30EB\u30FC\u30C6\u30A3\u30F3\u30B0\u756A\u53F7\u306E\u9577\u3055\u306F9\u6841\u3068\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
  "bankAccountForm.labels.accountZipCode": "\u90F5\u4FBF\u756A\u53F7",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "BIC \u30B3\u30FC\u30C9",
  "bankAccountForm.labels.accountNumber": "\u53E3\u5EA7\u756A\u53F7",
  "bankAccountForm.labels.accountSortCode": "\u30BD\u30FC\u30C8\u30FB\u30B3\u30FC\u30C9",
  "bankAccountForm.labels.accountRoutingNumber": "Routing\u756A\u53F7",
  "bankAccountForm.labels.accountType": "\u53E3\u5EA7\u306E\u7A2E\u985E",
  "bankAccountForm.labels.eftProviderWidnow": "\u3053\u306E\u304A\u652F\u6255\u3044\u3092\u5B8C\u4E86\u3059\u308B\u305F\u3081\u306B\u30D1\u30FC\u30C8\u30CA\u30FC\u306E\u624B\u7D9A\u304D\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002\u304A\u652F\u6255\u3044\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u3053\u306E\u30DA\u30FC\u30B8\u306B\u518D\u3073\u79FB\u52D5\u3057\u307E\u3059",
  "bankAccountForm.labels.termsFlywire": "\u79C1\u306F\u30D5\u30E9\u30A4\u30EF\u30A4\u30E4\u30FC\u306E<a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>\u5229\u7528\u898F\u7D04</a>\u304A\u3088\u3073<a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC</a>\u3092\u8AAD\u307F\u3001\u7406\u89E3\u3057\u305F\u3046\u3048\u3067\u540C\u610F\u3057\u307E\u3059",
  "bankAccountForm.labels.termsDirectDebit": "\u79C1\u306F\u3053\u306E\u53E3\u5EA7\u306E\u6240\u6709\u8005\u3067\u3042\u308B\u3053\u3068\u3001\u304A\u3088\u3073\u3053\u306E\u81EA\u52D5\u5F15\u304D\u843D\u3068\u3057\u306E\u627F\u8A8D\u306B\u5FC5\u8981\u306A\u552F\u4E00\u306E\u7F72\u540D\u8005\u3067\u3042\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u307E\u3059",
  "bankAccountForm.labels.termsEft": "\u79C1\u306F<a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>\u4E8B\u524D\u627F\u8A8D\u6E08\u307F\u53E3\u5EA7\u632F\u66FF\u5951\u7D04</a>\u3092\u8AAD\u307F\u3001\u5185\u5BB9\u3092\u7406\u89E3\u3057\u305F\u3046\u3048\u3067\u540C\u610F\u3057\u307E\u3059",
  "bankAccountForm.labels.city": "\u5E02\u533A\u753A\u6751",
  "bankAccountForm.labels.country": "\u56FD",
  "bankAccountForm.labels.selectCountry": "\u56FD\u3092\u9078\u629E",
  "bankAccountForm.title": "\u53E3\u5EA7\u540D\u7FA9\u4EBA\u60C5\u5831",
  "failure.tryAgain": "\u518D\u8A66\u884C\u3059\u308B",
  "failure.title": "\u53D6\u5F15\u306B\u5931\u6557\u3057\u307E\u3057\u305F",
  "failure.connectivity.message": "\u64CD\u4F5C\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u63A5\u7D9A\u306B\u554F\u984C\u304C\u3042\u308B\u3088\u3046\u3067\u3059\u3002",
  "failure.message": "\u53D6\u5F15\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u539F\u56E0\u3068\u3057\u3066\u63A5\u7D9A\u306E\u554F\u984C\u304C\u8003\u3048\u3089\u308C\u307E\u3059\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002\u5F15\u304D\u7D9A\u304D\u554F\u984C\u304C\u767A\u751F\u3059\u308B\u5834\u5408\u306F\u3001\u5225\u306E\u652F\u6255\u65B9\u6CD5\u3092\u304A\u8A66\u3057\u306B\u306A\u308B\u304B\u3001\u9280\u884C\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044",
  "sessionExpired.text": "\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F",
  "LoadingError.title": "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
  "LoadingError.message": "\u30D5\u30A9\u30FC\u30E0\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "\u9078\u629E\u3057\u305F\u56FD\u3067\u5229\u7528\u53EF\u80FD\u306A\u652F\u6255\u65B9\u6CD5\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
  "bankAccountForm.labels.accountHolderType.personal": "\u500B\u4EBA\u30A2\u30AB\u30A6\u30F3\u30C8",
  "bankAccountForm.labels.accountHolderType.business": "\u4F01\u696D\u30A2\u30AB\u30A6\u30F3\u30C8",
  "bankAccountForm.labels.name": "\u540D",
  "bankAccountForm.labels.businessName": "\u4F01\u696D\u540D",
  "bankAccountForm.labels.surname": "\u59D3",
  "bankAccountForm.labels.phone": "\u96FB\u8A71\u756A\u53F7",
  "bankAccountForm.labels.email": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
  "bankAccountForm.labels.zip": "\u90F5\u4FBF\u756A\u53F7",
  "bankAccountForm.labels.accountAddress": "\u4F4F\u6240",
  "bankAccountForm.labels.address": "\u4F4F\u6240",
  "bankAccountForm.errors.dynamicFields": "\u7121\u52B9\u306A{{field}}",
  "bankAccountForm.errors.dynamicFields.document": "\u7121\u52B9\u306ACPF\u307E\u305F\u306FCNPJ\u756A\u53F7",
  "bankAccountForm.errors.dynamicFields.documentPattern": "CPF/CNPJ\u756A\u53F7\u306F\u30CF\u30A4\u30D5\u30F3\u3084\u30C0\u30C3\u30B7\u30E5\u3092\u9664\u3044\u3066\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
  "bankAccountForm.labels.saveButton": "\u4FDD\u5B58",
  "bankAccountForm.labels.nextButton": "\u6B21\u3078",
  "bankAccountForm.labels.payButton": "\u652F\u6255\u3046",
  "bankAccountForm.errors.cardNumber": "\u7121\u52B9\u306A\u30AB\u30FC\u30C9\u756A\u53F7",
  "tokenizationForm.errors.cardNumber": "\u7121\u52B9\u306A\u30AB\u30FC\u30C9\u756A\u53F7",
  "tokenizationForm.errors.cvv": "\u7121\u52B9\u306A CVV \u756A\u53F7",
  "bankAccountForm.errors.cvv": "\u7121\u52B9\u306A CVV \u756A\u53F7",
  "tokenizationForm.errors.unsupportedCardTypes": "{{acceptedCardsList}}\u306E\u307F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059",
  "tokenizationForm.errors.unsupportedCardType": "{{acceptedCard}}\u306E\u307F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059",
  "tokenizationForm.errors.cardType.and": "\u304A\u3088\u3073",
  "tokenizationForm.errors.name": "\u7121\u52B9\u306A\u540D",
  "tokenizationForm.errors.email": "\u7121\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
  "tokenizationForm.errors.country": "\u56FD\u304C\u7121\u52B9\u3067\u3059",
  "tokenizationForm.errors.state": "\u5DDE / \u90FD\u9053\u5E9C\u770C\u304C\u7121\u52B9\u3067\u3059",
  "tokenizationForm.errors.city": "\u7121\u52B9\u306A\u5E02\u533A\u753A\u6751",
  "tokenizationForm.errors.address": "\u4F4F\u6240\u304C\u7121\u52B9\u3067\u3059",
  "tokenizationForm.errors.addressIsPoBox": "\u4F4F\u6240\u30D5\u30A3\u30FC\u30EB\u30C9\u3067\u306E\u79C1\u66F8\u7BB1\u306E\u4F7F\u7528\u306F\u8A31\u53EF\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
  "tokenizationForm.errors.onlyLetterOrNumbers": "\u6709\u52B9\u306A\u6587\u5B57\u306FA\uFF5EZ\u304A\u3088\u30730\uFF5E9\u3067\u3059",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": "\u4F7F\u7528\u53EF\u80FD\u306A\u6587\u5B57\u306F\u3001A-Z\u30010-9\u3001\u300C/\u300D\u3001\u300C-\u300D\u306E\u307F\u3067\u3059",
  "tokenizationForm.errors.zip": "\u90F5\u4FBF\u756A\u53F7\u304C\u7121\u52B9\u3067\u3059",
  "tokenizationForm.errors.expiryDate": "\u7121\u52B9\u306A\u6709\u52B9\u671F\u9650\u65E5",
  "bankAccountForm.errors.expiryDate": "\u7121\u52B9\u306A\u6709\u52B9\u671F\u9650\u65E5",
  "tokenizationForm.errors.surname": "\u7121\u52B9\u306A\u59D3",
  "tokenizationForm.errors.phone": "\u7121\u52B9\u306A\u96FB\u8A71\u756A\u53F7",
  "tokenizationForm.errors.length": "\u30D5\u30A3\u30FC\u30EB\u30C9\u3078\u306E\u5165\u529B\u6587\u5B57\u6570\u304C\u9577\u3059\u304E\u307E\u3059\uFF08\u4E0A\u9650\u306F256\u6587\u5B57\uFF09",
  "bankAccountForm.errors.name": "\u7121\u52B9\u306A\u540D",
  "bankAccountForm.errors.name.maxSizeExceeded": "\u540D\u524D\u304C\u9577\u3059\u304E\u307E\u3059\uFF08\u6700\u5927140\u6587\u5B57\uFF09",
  "form.errors.name.maxSizeExceeded": "\u540D\u524D\u304C\u9577\u3059\u304E\u307E\u3059\uFF08\u6700\u5927{{limit}}\u6587\u5B57\uFF09",
  "form.errors.surname.maxSizeExceeded": "\u540D\u5B57\u304C\u9577\u3059\u304E\u307E\u3059\uFF08\u6700\u5927{{limit}}\u6587\u5B57\uFF09",
  "form.errors.business_name.maxSizeExceeded": "\u30D3\u30B8\u30CD\u30B9\u540D\u304C\u9577\u3059\u304E\u307E\u3059\uFF08\u6700\u5927{{limit}}\u6587\u5B57\uFF09",
  "form.errors.city.maxSizeExceeded": "\u5E02\u753A\u6751\u533A\u304C\u9577\u3059\u304E\u307E\u3059\uFF08\u6700\u5927{{limit}}\u6587\u5B57\uFF09",
  "form.errors.address.maxSizeExceeded": "\u4F4F\u6240\u304C\u9577\u3059\u304E\u307E\u3059\uFF08\u6700\u5927{{limit}}\u6587\u5B57\uFF09",
  "bankAccountForm.errors.business_name": "\u7121\u52B9\u306A\u4F01\u696D\u540D",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "\u30D3\u30B8\u30CD\u30B9\u540D\u304C\u9577\u3059\u304E\u307E\u3059\uFF08\u6700\u5927140\u6587\u5B57\uFF09",
  "bankAccountForm.errors.surname": "\u7121\u52B9\u306A\u59D3",
  "bankAccountForm.errors.surname.maxSizeExceeded": "\u540D\u5B57\u304C\u9577\u3059\u304E\u307E\u3059\uFF08\u6700\u5927140\u6587\u5B57\uFF09",
  "bankAccountForm.errors.country": "\u7121\u52B9\u306A\u56FD",
  "bankAccountForm.errors.address": "\u7121\u52B9\u306A\u4F4F\u6240",
  "bankAccountForm.errors.address.maxSizeExceeded": "\u4F4F\u6240\u304C\u9577\u3059\u304E\u307E\u3059\uFF08\u6700\u5927256\u6587\u5B57\uFF09",
  "bankAccountForm.errors.city": "\u7121\u52B9\u306A\u5E02\u533A\u753A\u6751",
  "bankAccountForm.errors.city.maxSizeExceeded": "\u5E02\u753A\u6751\u533A\u304C\u9577\u3059\u304E\u307E\u3059\uFF08\u6700\u5927256\u6587\u5B57\uFF09",
  "bankAccountForm.errors.email": "\u7121\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
  "bankAccountForm.errors.state": "\u5DDE / \u90FD\u9053\u5E9C\u770C\u304C\u7121\u52B9\u3067\u3059",
  "bankAccountForm.errors.iban": "\u7121\u52B9\u306AIBAN",
  "bankAccountForm.errors.bic": "\u7121\u52B9\u306ABIC \u30B3\u30FC\u30C9",
  "bankAccountForm.errors.accountnumber": "\u7121\u52B9\u306A\u53E3\u5EA7\u756A\u53F7",
  "bankAccountForm.errors.sortcode": "\u7121\u52B9\u306A\u30BD\u30FC\u30C8\u30B3\u30FC\u30C9",
  "bankAccountForm.errors.account_type": "\u7121\u52B9\u306A\u53E3\u5EA7\u7A2E\u5225",
  "bankAccountForm.errors.addressIsPoBox": "\u4F4F\u6240\u30D5\u30A3\u30FC\u30EB\u30C9\u3067\u306E\u79C1\u66F8\u7BB1\u306E\u4F7F\u7528\u306F\u8A31\u53EF\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
  "bankAccountForm.errors.onlyLetterOrNumbers": "\u6709\u52B9\u306A\u6587\u5B57\u306FA\uFF5EZ\u304A\u3088\u30730\uFF5E9\u3067\u3059",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "\u6709\u52B9\u306A\u6587\u5B57\u306F\u4EE5\u4E0B\u306E\u901A\u308A\u3067\u3059\uFF1AA-Z 0-9 / , -",
  "bankAccountForm.errors.zip": "\u7121\u52B9\u306A\u90F5\u4FBF\u756A\u53F7",
  "bankAccountForm.errors.phone": "\u7121\u52B9\u306A\u96FB\u8A71\u756A\u53F7",
  "bankAccountForm.errors.ach_account_number": "\u7121\u52B9\u306A\u53E3\u5EA7\u756A\u53F7",
  "bankAccountForm.errors.routing_number": "\u7121\u52B9\u306ARouting\u756A\u53F7 (\u30EB\u30FC\u30C6\u30A3\u30F3\u30B0\u756A\u53F7)",
  "bankAccountForm.errors.offer": "\u5229\u7528\u53EF\u80FD\u306A\u652F\u6255\u65B9\u6CD5\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u4ED6\u306E\u56FD\u306B\u9280\u884C\u53E3\u5EA7\u3092\u304A\u6301\u3061\u306E\u5834\u5408\u306F\u3001\u305D\u306E\u56FD\u3092\u9078\u629E\u3059\u308B\u304B\u3001\u5225\u306E\u30AB\u30FC\u30C9\u3092\u9078\u629E\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u3067\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{{recipientName}}\u306B\u9023\u7D61\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "confirmationPage.labels.edit": "\u7DE8\u96C6",
  "confirmationPage.labels.confirm": "\u78BA\u5B9A",
  "confirmationPage.labels.title": "\u9280\u884C\u4F9D\u983C\u60C5\u5831\u306E\u78BA\u8A8D",
  "confirmationPage.labels.typeOfPayment": "\u652F\u6255\u3044\u306E\u7A2E\u985E",
  "confirmationPage.labels.paymentRecipient": "\u652F\u6255\u3044\u306E\u53D7\u53D6\u4EBA",
  "confirmationPage.labels.typeOfPayment.oneOff": "\u5358\u767A",
  "confirmationPage.labels.typeOfPayment.recurring": "\u5B9A\u671F\u7684",
  "confirmationPage.labels.directDebitInformation": "\u53E3\u5EA7\u632F\u66FF\u60C5\u5831",
  "confirmationPage.labels.directDebitInformation.title": "\u3054\u5229\u7528\u9280\u884C\u3078\u306E\u6307\u793A\u66F8",
  "confirmationPage.labels.directDebitInformation.creditor": "\u53D7\u53D6\u4EBA",
  "confirmationPage.labels.directDebitInformation.creditorId": "\u53D7\u53D6\u4EBAID",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "\u660E\u7D30\u66F8\u3078\u306E\u8A18\u8F09\u6C0F\u540D",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "\u30B5\u30FC\u30D3\u30B9\u30E6\u30FC\u30B6\u30FCID",
  "confirmationPage.labels.directDebitInformation.address": "\u30D5\u30E9\u30A4\u30EF\u30A4\u30E4\u30FC\u306E\u4F4F\u6240",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "Originator\u306EID",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "Originator\u306E\u4F4F\u6240",
  "confirmationPage.labels.bankAccountInformation": "\u9280\u884C\u53E3\u5EA7\u60C5\u5831",
  "confirmationPage.labels.bankAccountInformation.name": "\u540D\u524D",
  "confirmationPage.labels.bankAccountInformation.iban": "IBAN \u756A\u53F7",
  "confirmationPage.labels.bankAccountInformation.email": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
  "confirmationPage.labels.bankAccountInformation.country": "\u56FD",
  "confirmationPage.labels.bankAccountInformation.state": "\u5DDE",
  "confirmationPage.labels.bankAccountInformation.city": "\u5E02\u533A\u753A\u6751",
  "confirmationPage.labels.bankAccountInformation.bicCode": "BIC \u30B3\u30FC\u30C9",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "\u53E3\u5EA7\u756A\u53F7",
  "confirmationPage.labels.bankAccountInformation.sortCode": "\u30BD\u30FC\u30C8\u30FB\u30B3\u30FC\u30C9",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "\u53E3\u5EA7\u756A\u53F7",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "Routing\u756A\u53F7",
  "confirmationPage.labels.bankAccountInformation.accountType": "\u53E3\u5EA7\u306E\u7A2E\u985E",
  "confirmationPage.labels.changeAccountEft": "\u9280\u884C\u53E3\u5EA7\u306E\u8A73\u7D30\u3092\u5909\u66F4",
  "confirmationPage.labels.editPayerEft": "\u652F\u6255\u8005\u306E\u8A73\u7D30\u3092\u7DE8\u96C6",
  "confirmationPage.labels.useAccountEft": "\u672B\u5C3E\u304C**** {{lastFour}}\u306E\u53E3\u5EA7\u3092\u4F7F\u7528",
  "confirmationPage.labels.termsSepa": "\u3053\u306E\u9280\u884C\u4F9D\u983C\u30D5\u30A9\u30FC\u30E0\u306B\u7F72\u540D\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u3001(A) FLYWIRE EUROPE UAB \u304C\u3054\u5229\u7528\u306E\u9280\u884C\u306B\u53E3\u5EA7\u632F\u8FBC\u306E\u6307\u793A\u66F8\u3092\u9001\u308B\u3053\u3068\u3001\u304A\u3088\u3073 (B) \u3054\u5229\u7528\u306E\u9280\u884C\u304C\u3001FLYWIRE EUROPE UAB \u306E\u6307\u793A\u66F8\u306E\u8AAC\u660E\u306B\u5F93\u3063\u3066\u3001\u3042\u306A\u305F\u306E\u53E3\u5EA7\u304B\u3089\u632F\u8FBC\u3092\u884C\u3046\u3053\u3068\u3092\u627F\u8A8D\u3059\u308B\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002\u3054\u8ACB\u6C42\u306E3\u65E5\u524D\u307E\u3067\u306B\u8ACB\u6C42\u306B\u95A2\u3059\u308B\u901A\u77E5\u304C\u5C4A\u304D\u307E\u3059\u3002",
  "confirmationPage.labels.termsBacs": "Flywire Payments Limited\u3078\u306E\u53E3\u5EA7\u632F\u66FF\u306F\u3053\u306E\u652F\u6255\u6307\u793A\u66F8\u306B\u8A73\u8FF0\u3055\u308C\u308B\u53E3\u5EA7\u304B\u3089\u652F\u6255\u3046\u3088\u3046\u9280\u884C\u306B\u6307\u793A\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u306E\u53E3\u5EA7\u306F\u53E3\u5EA7\u632F\u66FF\u4FDD\u8A3C\u3067\u5B89\u5168\u304C\u4FDD\u8A3C\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u79C1\u306F\u3001\u3053\u306E\u6307\u793A\u66F8\u304CFlywire Payments Limited\u306B\u7D99\u7D9A\u7684\u306B\u9069\u7528\u3055\u308C\u308B\u5834\u5408\u304C\u3042\u308B\u3053\u3068\u3001\u9069\u7528\u3055\u308C\u308B\u5834\u5408\u306B\u306F\u3001\u79C1\u306E\u9280\u884C/\u4F4F\u5B85\u91D1\u878D\u7D44\u5408\u306B\u96FB\u5B50\u7684\u306B\u8EE2\u9001\u3055\u308C\u308B\u3053\u3068\u3092\u7406\u89E3\u3057\u307E\u3059\u3002",
  "confirmationPage.labels.termsAch": "\n     \u652F\u6255\u8005\u306F\uFF3B\u78BA\u5B9A\uFF3D\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3053\u3068\u3067\u3001\u81EA\u8EAB\u306B\u9069\u5207\u306A\u6A29\u9650\u304C\u3042\u308B\u3053\u3068\u3001\u304A\u3088\u3073\u305D\u306E\u6A29\u9650\u3067\u30D5\u30E9\u30A4\u30EF\u30A4\u30E4\u30FC\u304C\u7279\u5B9A\u306E\u53D7\u9818\u8005\uFF08\u300C\u53D7\u53D6\u4EBA\u300D\uFF09\u3092\u4EE3\u884C\u3057\u3066\u3001\n\u652F\u6255\u8005\u306B\u3088\u308B\u53D7\u53D6\u4EBA\u306E\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u3001\u304A\u3088\u3073\uFF0F\u307E\u305F\u306F\u53D7\u53D6\u4EBA\u306E\u5546\u54C1\u306E\u8CFC\u5165\u306B\u8D77\u56E0\u3059\u308B\u8ACB\u6C42\u984D\u3092\u652F\u6255\u8005\u306B\u3088\u3063\u3066\u63D0\u4F9B\u3055\u308C\u305F\u9280\u884C\u53E3\u5EA7\u304B\u3089\u5F15\u304D\u843D\u3068\u3059\u3053\u3068\u3001\n\u306A\u3089\u3073\u306B\u5FC5\u8981\u306A\u5834\u5408\u306F\u3001\u53D7\u53D6\u4EBA\u306E\u6761\u4EF6\u306B\u5F93\u3044\u8AA4\u3063\u305F\u5F15\u304D\u843D\u3068\u3057\u3092\u8A02\u6B63\u3059\u308B\u3053\u3068\u3092\u627F\u8A8D\u3059\u308B\u3053\u3068\uFF08\u305F\u3060\u3057\u5F53\u8A72\u627F\u8A8D\u304C\u53D6\u308A\u6D88\u3055\u308C\u308B\u524D\u306B\u4EE3\u884C\u3059\u308B\u5834\u5408\u306B\u9650\u5B9A\uFF09\u3092\n\u78BA\u7D04\u3057\u305F\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002\u8CC7\u91D1\u4E0D\u8DB3\u306B\u3088\u308AACH\u53D6\u5F15\u304C\u62D2\u5426\u3055\u308C\u305F\u5834\u5408\u3001\u79C1\u306FNSF\u624B\u6570\u6599\u304C\u8ACB\u6C42\u3055\u308C\u308B\u3053\u3068\u3001\u304A\u3088\u3073\u30D5\u30E9\u30A4\u30EF\u30A4\u30E4\u30FC\u304C\u81EA\u5DF1\u88C1\u91CF\u3067\u3053\u306E\u624B\u6570\u6599\u306E\u518D\u51E6\u7406\u3092\u8A66\u307F\u308B\u53EF\u80FD\u6027\u304C\u3042\u308B\u3053\u3068\u3092\u7406\u89E3\u3057\u3066\u3044\u307E\u3059\u3002\n     ",
  "confirmationPage.labels.termsAch2": "\n     \u652F\u6255\u8005\u306F\u3001\u53D7\u53D6\u4EBA\u306E\u5225\u306E\u5546\u54C1\u304A\u3088\u3073\uFF0F\u307E\u305F\u306F\u30B5\u30FC\u30D3\u30B9\u3092\u5B9A\u671F\u7684\u306B\u4F7F\u7528\u307E\u305F\u306F\u8CFC\u5165\u3059\u308B\u5834\u5408\u3001\u53D7\u53D6\u4EBA\u306E\u898F\u7D04\u306B\u5F93\u3044\u3001\u30D5\u30E9\u30A4\u30EF\u30A4\u30E4\u30FC\u304C\u53D7\u53D6\u4EBA\u3092\u4EE3\u884C\u3057\u3066\u3001\n\u652F\u6255\u8005\u306B\u3088\u3063\u3066\u63D0\u4F9B\u3055\u308C\u305F\u9280\u884C\u53E3\u5EA7\u304B\u3089\u5B9A\u671F\u7684\u306B\u5F15\u304D\u843D\u3068\u3059\u3053\u3068\u3092\u627F\u8A8D\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002\u524D\u8FF0\u306E\u627F\u8A8D\u3055\u308C\u305F\u5F15\u304D\u843D\u3068\u3057\u4EE5\u5916\u306E\u652F\u6255\u3044\u3067\u306F\u3001\n\u652F\u6255\u8005\u304C\u81EA\u5206\u306E\u53E3\u5EA7\u7D4C\u7531\u3067\u3001\u307E\u305F\u306F\u30D1\u30B9\u30EF\u30FC\u30C9\u3001\u30B3\u30FC\u30C9\u3001\u305D\u306E\u4ED6\u306E\u7F72\u540D\u306B\u76F8\u5F53\u3059\u308B\u65B9\u6CD5\u3067\u4E8B\u524D\u306B\u627F\u8A8D\u3057\u305F\u5834\u5408\u306E\u307F\u3001\n\u5F15\u304D\u843D\u3068\u3055\u308C\u307E\u3059\u3002\n     ",
  "confirmationPage.labels.termsAch3": "\n     \u652F\u6255\u8005\u306F\u53D7\u53D6\u4EBA\u306B\u9023\u7D61\u3059\u308B\u3053\u3068\u3067\u3001\u3044\u3064\u3067\u3082\u3053\u306E\u627F\u8A8D\u3092\u53D6\u308A\u6D88\u3059\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u652F\u6255\u8005\u306B\u3088\u308B\u53D6\u308A\u6D88\u3057\u306F\u3001\u6B21\u56DE\u652F\u6255\u4E88\u5B9A\u65E5\u306E\u5C11\u306A\u304F\u3068\u3082 [10\u55B6\u696D\u65E5]\u524D\u307E\u3067\u306B\n\u53D7\u7406\u3055\u308C\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\n    ",
  "confirmationPage.labels.print": "\u5951\u7D04\u66F8\u3092\u5370\u5237",
  "amountPanel.labels.amountFromLabel": "\u304A\u5BA2\u69D8\u306E\u304A\u652F\u6255\u3044\u91D1\u984D:",
  "amountPanel.labels.surchargeFeeInfo": "\u30AB\u30FC\u30C9\u624B\u6570\u6599\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059\u3002",
  "amountPanel.labels.whyThisFee": "\u624B\u6570\u6599\u304C\u304B\u304B\u308B\u7406\u7531\u306F\uFF1F",
  "amountPanel.labels.whyThisFeeTooltip": "\n  \u304A\u652F\u6255\u3044\u3092\u7D9A\u884C\u3059\u308B\u3068\u3001 {{percentage}}\uFF05\u306E\u30AB\u30FC\u30C9\u624B\u6570\u6599\u304C\u304B\u304B\u308A\u307E\u3059\u3002{{cardScheme}}\u30AB\u30FC\u30C9\u306E\u901A\u8CA8\u306F{{currency}}\u3067\u3059\u3002\u8FFD\u52A0\u6599\u91D1\u3092\u56DE\u907F\u3059\u308B\u305F\u3081\u306B\u3001\u30AB\u30FC\u30C9\u307E\u305F\u306F\u56FD\u306B\u5408\u3063\u305F\u30AB\u30FC\u30C9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n     ",
  "amountPanel.labels.currencyChangeWarning": "\u901A\u8CA8\u304C\u30AB\u30FC\u30C9\u306E\u901A\u8CA8\u3068\u4E00\u81F4\u3059\u308B\u3088\u3046\u306B\u5909\u66F4\u3055\u308C\u307E\u3057\u305F",
  "amountPanel.labels.amountToLabel": "{{recipientName}}\u306E\u53D7\u53D6\u984D:",
  AX: "\u30AA\u30FC\u30E9\u30F3\u30C9\u8AF8\u5CF6",
  AD: "\u30A2\u30F3\u30C9\u30E9",
  BG: "\u30D6\u30EB\u30AC\u30EA\u30A2",
  AT: "\u30AA\u30FC\u30B9\u30C8\u30EA\u30A2",
  BE: "\u30D9\u30EB\u30AE\u30FC",
  HR: "\u30AF\u30ED\u30A2\u30C1\u30A2",
  CY: "\u30AD\u30D7\u30ED\u30B9",
  CZ: "\u30C1\u30A7\u30B3\u5171\u548C\u56FD",
  DK: "\u30C7\u30F3\u30DE\u30FC\u30AF",
  EE: "\u30A8\u30B9\u30C8\u30CB\u30A2",
  FI: "\u30D5\u30A3\u30F3\u30E9\u30F3\u30C9",
  FR: "\u30D5\u30E9\u30F3\u30B9",
  GP: "\u30B0\u30A2\u30C9\u30EB\u30FC\u30D7",
  DE: "\u30C9\u30A4\u30C4",
  GR: "\u30AE\u30EA\u30B7\u30E3",
  HU: "\u30CF\u30F3\u30AC\u30EA\u30FC",
  IS: "\u30A2\u30A4\u30B9\u30E9\u30F3\u30C9",
  IE: "\u30A2\u30A4\u30EB\u30E9\u30F3\u30C9",
  VA: "\u6559\u7687\u5E81\uFF08\u30D0\u30C1\u30AB\u30F3\u5E02\u56FD\uFF09",
  IT: "\u30A4\u30BF\u30EA\u30A2",
  LI: "\u30EA\u30D2\u30C6\u30F3\u30B7\u30E5\u30BF\u30A4\u30F3",
  LT: "\u30EA\u30C8\u30A2\u30CB\u30A2",
  LU: "\u30EB\u30AF\u30BB\u30F3\u30D6\u30EB\u30AF",
  YT: "\u30DE\u30E8\u30C3\u30C8",
  MT: "\u30DE\u30EB\u30BF",
  MQ: "\u30DE\u30EB\u30C6\u30A3\u30CB\u30FC\u30AF",
  ES: "\u30B9\u30DA\u30A4\u30F3",
  NO: "\u30CE\u30EB\u30A6\u30A7\u30FC",
  NL: "\u30AA\u30E9\u30F3\u30C0",
  PL: "\u30DD\u30FC\u30E9\u30F3\u30C9",
  PT: "\u30DD\u30EB\u30C8\u30AC\u30EB",
  SE: "\u30B9\u30A6\u30A7\u30FC\u30C7\u30F3",
  RE: "\u30EC\u30E6\u30CB\u30AA\u30F3",
  RO: "\u30EB\u30FC\u30DE\u30CB\u30A2",
  CH: "\u30B9\u30A4\u30B9",
  BL: "\u30B5\u30F3\u30FB\u30D0\u30EB\u30C6\u30EB\u30DF\u30FC\u5CF6",
  GB: "\u82F1\u56FD",
  MC: "\u30E2\u30CA\u30B3",
  MF: "\u30B5\u30F3\u30FB\u30DE\u30EB\u30BF\u30F3\uFF08\u30D5\u30E9\u30F3\u30B9\u9818\uFF09",
  PM: "\u30B5\u30F3\u30D4\u30A8\u30FC\u30EB\u5CF6\u30FB\u30DF\u30AF\u30ED\u30F3\u5CF6",
  SM: "\u30B5\u30F3\u30DE\u30EA\u30CE",
  SK: "\u30B9\u30ED\u30D0\u30AD\u30A2",
  SI: "\u30B9\u30ED\u30D9\u30CB\u30A2",
  GF: "\u30D5\u30E9\u30F3\u30B9\u9818\u30AE\u30A2\u30CA",
  LV: "\u30E9\u30C8\u30D3\u30A2",
  CA: "\u30AB\u30CA\u30C0",
  US: "\u7C73\u56FD",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/locales/ko.ts
var ko = {
  "session_expired.title": "\uC138\uC158\uC774 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  "tokenizationForm.payment-terms.text1": "Flywire\uAC00 {{recipientName}}\uC744(\uB97C) \uB300\uC2E0\uD558\uC5EC \uB0B4 \uC9C1\uBD88/\uC2E0\uC6A9\uCE74\uB4DC\uB97C \uC800\uC7A5\uD558\uACE0 \uC790\uB3D9\uC73C\uB85C \uCCAD\uAD6C\uD560 \uC218 \uC788\uB3C4\uB85D \uC2B9\uC778\uD569\uB2C8\uB2E4. \uB2E4\uC74C\uC744 \uC77D\uACE0 \uC774\uD574\uD588\uC73C\uBA70 \uB3D9\uC758\uD569\uB2C8\uB2E4",
  "tokenizationForm.general-terms.link2": "\uB3D9\uC758\uD569\uB2C8\uB2E4.",
  "tokenizationForm.general-terms.link-joint": " \uBC0F ",
  "tokenizationForm.general-terms.link1": "\uC77D\uACE0,",
  "tokenizationForm.payment-terms.link": "Flywire\uC758 \uC790\uB3D9 \uACB0\uC81C \uC774\uC6A9 \uC57D\uAD00",
  "tokenizationForm.labels.cvvTooltip": "\uCE74\uB4DC \uB4B7\uBA74\uC758 3\uC790\uB9AC \uC22B\uC790 \uB610\uB294 \uC55E\uBA74\uC758 4\uC790\uB9AC \uC22B\uC790\uC785\uB2C8\uB2E4.",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "\uB9CC\uB8CC\uC77C (MM/YY)",
  "tokenizationForm.labels.cardNumber": "\uCE74\uB4DC \uBC88\uD638",
  "tokenizationForm.labels.phone": "\uC804\uD654\uBC88\uD638",
  "tokenizationForm.labels.zip": "\uC6B0\uD3B8\uBC88\uD638",
  "tokenizationForm.labels.address": "\uC8FC\uC18C",
  "cardsForm.labels.state": "\uC8FC",
  "tokenizationForm.labels.country": "\uAD6D\uAC00",
  "tokenizationForm.labels.city": "\uB3C4\uC2DC",
  "tokenizationForm.labels.email": "\uC774\uBA54\uC77C",
  "tokenizationForm.labels.lastName": "\uC131",
  "tokenizationForm.labels.firstName": "\uC774\uB984",
  "tokenizationForm.labels.dynamicFields.document": "CPF \uB610\uB294 CNPJ \uBC88\uD638",
  "cardsForm.title": "\uCE74\uB4DC \uC18C\uC720\uC790 \uC815\uBCF4",
  "success.title": "\uACB0\uC81C\uD558\uC2E0 \uB0B4\uC5ED\uC744 \uC1A1\uAE08 \uC911\uC785\uB2C8\uB2E4",
  "success.title.info": "\uC785\uAE08 \uD655\uC778\uAE4C\uC9C0\uB294 \uBCF4\uD1B5 \uC601\uC5C5\uC77C \uAE30\uC900 2~3\uC77C\uC774 \uC18C\uC694\uB429\uB2C8\uB2E4. \uC785\uAE08\uC774 \uD655\uC778\uB418\uBA74 \uC54C\uB9BC \uBA54\uC77C\uC744 \uBC1C\uC1A1\uD574\uB4DC\uB9BD\uB2C8\uB2E4.",
  "bankAccountForm.hints.generic": "\uC608: {{label}}",
  "bankAccountForm.hints.account_number": "\uC740\uD589 \uACC4\uC88C \uBC88\uD638\uB294 1~17\uC790\uC5EC\uC57C \uD569\uB2C8\uB2E4.",
  "bankAccountForm.hints.routing_number": "\uB77C\uC6B0\uD305 \uBC88\uD638\uB294 9\uC790\uB9AC\uC5EC\uC57C \uD569\uB2C8\uB2E4.",
  "bankAccountForm.labels.accountZipCode": "\uC6B0\uD3B8\uBC88\uD638",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "BIC \uCF54\uB4DC",
  "bankAccountForm.labels.accountNumber": "\uACC4\uC88C\uBC88\uD638",
  "bankAccountForm.labels.accountSortCode": "\uC740\uD589 \uC2DD\uBCC4 \uAE30\uD638",
  "bankAccountForm.labels.accountRoutingNumber": "\uB77C\uC6B0\uD305 \uBC88\uD638",
  "bankAccountForm.labels.accountType": "\uACC4\uC88C \uC720\uD615",
  "bankAccountForm.labels.eftProviderWidnow": "\uACB0\uC81C\uB97C \uC644\uB8CC\uD560 \uC218 \uC788\uB3C4\uB85D \uD30C\uD2B8\uB108\uC0AC\uC758 \uB300\uAE08 \uCC98\uB9AC \uD50C\uB7AB\uD3FC\uC73C\uB85C \uC774\uB3D9\uB429\uB2C8\uB2E4. \uACB0\uC81C\uAC00 \uC644\uB8CC\uB418\uBA74 \uC774 \uD398\uC774\uC9C0\uB85C \uB2E4\uC2DC \uC5F0\uACB0\uB429\uB2C8\uB2E4.",
  "bankAccountForm.labels.termsFlywire": "\uBCF8\uC778\uC740 Flywire\uC758 <a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>\uC774\uC6A9 \uC57D\uAD00</a> \uBC0F <a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>\uAC1C\uC778\uC815\uBCF4 \uBCF4\uD638\uC815\uCC45</a>\uC744 \uC77D\uACE0 \uC774\uD574\uD588\uC73C\uBA70 \uC774\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4.",
  "bankAccountForm.labels.termsDirectDebit": "\uBCF8\uC778\uC740 \uC774 \uACC4\uC815\uC758 \uACC4\uC815 \uC18C\uC720\uC790\uC774\uBA70, \uD574\uB2F9 \uC790\uB3D9 \uC774\uCCB4\uB97C \uC2B9\uC778\uD560 \uC218 \uC788\uB294 \uC720\uC77C\uD55C \uC11C\uBA85\uC778\uC784\uC744 \uD655\uC778\uD569\uB2C8\uB2E4",
  "bankAccountForm.labels.termsEft": "<a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>\uC0AC\uC804 \uC2B9\uC778 \uC778\uCD9C \uB3D9\uC758\uC11C</a>\uB97C \uC77D\uACE0 \uC774\uD574\uD588\uC73C\uBA70, \uC774\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4.",
  "bankAccountForm.labels.city": "\uB3C4\uC2DC",
  "bankAccountForm.labels.country": "\uAD6D\uAC00",
  "bankAccountForm.labels.selectCountry": "\uAD6D\uAC00 \uC120\uD0DD",
  "bankAccountForm.title": "\uACC4\uC88C \uBA85\uC758\uC790 \uC815\uBCF4",
  "failure.tryAgain": "\uB2E4\uC2DC \uC2DC\uB3C4",
  "failure.title": "\uAC70\uB798\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.",
  "failure.connectivity.message": "\uC791\uC5C5\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4. \uC778\uD130\uB137 \uC5F0\uACB0 \uBB38\uC81C\uAC00 \uC6D0\uC778\uC77C \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
  "failure.message": "\uAC70\uB798\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4. \uC5F0\uACB0 \uBB38\uC81C \uB54C\uBB38\uC77C \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694. \uBB38\uC81C\uAC00 \uC9C0\uC18D\uB418\uBA74 \uB2E4\uB978 \uACB0\uC81C \uC218\uB2E8\uC744 \uC0AC\uC6A9\uD558\uAC70\uB098 \uC740\uD589\uC5D0 \uBB38\uC758\uD558\uC138\uC694",
  "sessionExpired.text": "\uC138\uC158\uC774 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  "LoadingError.title": "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.",
  "LoadingError.message": "\uC591\uC2DD\uC744 \uBD88\uB7EC\uC624\uB294 \uC911\uC5D0 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "\uC120\uD0DD\uD55C \uAD6D\uAC00\uC5D0\uC11C \uC0AC\uC6A9\uD560 \uC218 \uC788\uB294 \uACB0\uC81C \uC635\uC158\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
  "bankAccountForm.labels.accountHolderType.personal": "\uAC1C\uC778 \uACC4\uC815",
  "bankAccountForm.labels.accountHolderType.business": "\uBE44\uC988\uB2C8\uC2A4 \uACC4\uC815",
  "bankAccountForm.labels.name": "\uC774\uB984",
  "bankAccountForm.labels.businessName": "\uBE44\uC988\uB2C8\uC2A4 \uC774\uB984",
  "bankAccountForm.labels.surname": "\uC131",
  "bankAccountForm.labels.phone": "\uC804\uD654\uBC88\uD638",
  "bankAccountForm.labels.email": "\uC774\uBA54\uC77C",
  "bankAccountForm.labels.zip": "\uC6B0\uD3B8\uBC88\uD638",
  "bankAccountForm.labels.accountAddress": "\uC8FC\uC18C",
  "bankAccountForm.labels.address": "\uC8FC\uC18C",
  "bankAccountForm.errors.dynamicFields": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 {{field}}",
  "bankAccountForm.errors.dynamicFields.document": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 CPF \uB610\uB294 CNPJ \uBC88\uD638",
  "bankAccountForm.errors.dynamicFields.documentPattern": "\uD558\uC774\uD508\uC774\uB098 \uB300\uC2DC \uC5C6\uC774 CPF/CNPJ \uBC88\uD638\uB97C \uC785\uB825\uD558\uC138\uC694.",
  "bankAccountForm.labels.saveButton": "\uC800\uC7A5",
  "bankAccountForm.labels.nextButton": "\uB2E4\uC74C",
  "bankAccountForm.labels.payButton": "\uACB0\uC81C",
  "bankAccountForm.errors.cardNumber": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uCE74\uB4DC \uBC88\uD638",
  "tokenizationForm.errors.cardNumber": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uCE74\uB4DC \uBC88\uD638",
  "tokenizationForm.errors.cvv": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 CVV \uBC88\uD638",
  "bankAccountForm.errors.cvv": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 CVV \uBC88\uD638",
  "tokenizationForm.errors.unsupportedCardTypes": "%{{acceptedCardsList}}\uB9CC \uC9C0\uC6D0\uB429\uB2C8\uB2E4.",
  "tokenizationForm.errors.unsupportedCardType": "{{acceptedCard}}\uB9CC \uC9C0\uC6D0\uB429\uB2C8\uB2E4.",
  "tokenizationForm.errors.cardType.and": "\uBC0F",
  "tokenizationForm.errors.name": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC774\uB984",
  "tokenizationForm.errors.email": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC774\uBA54\uC77C",
  "tokenizationForm.errors.country": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uAD6D\uAC00",
  "tokenizationForm.errors.state": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC8FC",
  "tokenizationForm.errors.city": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uB3C4\uC2DC",
  "tokenizationForm.errors.address": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC8FC\uC18C",
  "tokenizationForm.errors.addressIsPoBox": "\uC8FC\uC18C \uC785\uB825\uB780\uC5D0 \uC0AC\uC11C\uD568 \uC8FC\uC18C\uB97C \uC785\uB825\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
  "tokenizationForm.errors.onlyLetterOrNumbers": "A-Z \uC54C\uD30C\uBCB3\uACFC 0-9 \uC22B\uC790\uB9CC \uD574\uB2F9\uB429\uB2C8\uB2E4.",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": '\uC54C\uD30C\uBCB3 A-Z, \uC22B\uC790 0~9, "/, -" \uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
  "tokenizationForm.errors.zip": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC6B0\uD3B8\uBC88\uD638",
  "tokenizationForm.errors.expiryDate": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uB9CC\uB8CC\uC77C",
  "bankAccountForm.errors.expiryDate": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uB9CC\uB8CC\uC77C",
  "tokenizationForm.errors.surname": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC131",
  "tokenizationForm.errors.phone": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC804\uD654\uBC88\uD638",
  "tokenizationForm.errors.length": "\uC785\uB825\uD55C \uB0B4\uC6A9\uC774 \uB108\uBB34 \uAE41\uB2C8\uB2E4(\uCD5C\uB300 256\uC790).",
  "bankAccountForm.errors.name": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC774\uB984",
  "bankAccountForm.errors.name.maxSizeExceeded": "\uC774\uB984\uC774 \uB108\uBB34 \uAE41\uB2C8\uB2E4(\uCD5C\uB300 140\uC790)",
  "form.errors.name.maxSizeExceeded": "\uC774\uB984\uC774 \uB108\uBB34 \uAE41\uB2C8\uB2E4(\uCD5C\uB300 {{limit}}\uC790)",
  "form.errors.surname.maxSizeExceeded": "\uC131\uC774 \uB108\uBB34 \uAE41\uB2C8\uB2E4(\uCD5C\uB300 {{limit}}\uC790)",
  "form.errors.business_name.maxSizeExceeded": "\uBE44\uC988\uB2C8\uC2A4 \uC774\uB984\uC774 \uB108\uBB34 \uAE41\uB2C8\uB2E4(\uCD5C\uB300 {{limit}}\uC790)",
  "form.errors.city.maxSizeExceeded": "\uB3C4\uC2DC \uC774\uB984\uC774 \uB108\uBB34 \uAE41\uB2C8\uB2E4(\uCD5C\uB300 {{limit}}\uC790)",
  "form.errors.address.maxSizeExceeded": "\uC8FC\uC18C\uAC00 \uB108\uBB34 \uAE41\uB2C8\uB2E4(\uCD5C\uB300 {{limit}}\uC790)",
  "bankAccountForm.errors.business_name": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uBE44\uC988\uB2C8\uC2A4 \uC774\uB984",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "\uBE44\uC988\uB2C8\uC2A4 \uC774\uB984\uC774 \uB108\uBB34 \uAE41\uB2C8\uB2E4(\uCD5C\uB300 140\uC790)",
  "bankAccountForm.errors.surname": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC131",
  "bankAccountForm.errors.surname.maxSizeExceeded": "\uC131\uC774 \uB108\uBB34 \uAE41\uB2C8\uB2E4(\uCD5C\uB300 140\uC790)",
  "bankAccountForm.errors.country": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uAD6D\uAC00",
  "bankAccountForm.errors.address": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC8FC\uC18C",
  "bankAccountForm.errors.address.maxSizeExceeded": "\uC8FC\uC18C\uAC00 \uB108\uBB34 \uAE41\uB2C8\uB2E4(\uCD5C\uB300 256\uC790)",
  "bankAccountForm.errors.city": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uB3C4\uC2DC",
  "bankAccountForm.errors.city.maxSizeExceeded": "\uB3C4\uC2DC \uC774\uB984\uC774 \uB108\uBB34 \uAE41\uB2C8\uB2E4(\uCD5C\uB300 256\uC790)",
  "bankAccountForm.errors.email": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC774\uBA54\uC77C",
  "bankAccountForm.errors.state": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC8FC",
  "bankAccountForm.errors.iban": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 IBAN",
  "bankAccountForm.errors.bic": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 BIC \uCF54\uB4DC",
  "bankAccountForm.errors.accountnumber": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uACC4\uC88C \uBC88\uD638",
  "bankAccountForm.errors.sortcode": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC740\uD589 \uC2DD\uBCC4 \uAE30\uD638",
  "bankAccountForm.errors.account_type": "\uC798\uBABB\uB41C \uC740\uD589 \uACC4\uC88C \uC720\uD615",
  "bankAccountForm.errors.addressIsPoBox": "\uC8FC\uC18C \uC785\uB825\uB780\uC5D0 \uC0AC\uC11C\uD568 \uC8FC\uC18C\uB97C \uC785\uB825\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
  "bankAccountForm.errors.onlyLetterOrNumbers": "A-Z \uC54C\uD30C\uBCB3\uACFC 0-9 \uC22B\uC790\uB9CC \uD574\uB2F9\uB429\uB2C8\uB2E4.",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "A-Z \uC54C\uD30C\uBCB3, 0-9 \uC22B\uC790\uC640 / , - \uAE30\uD638\uB9CC \uD574\uB2F9\uB429\uB2C8\uB2E4.",
  "bankAccountForm.errors.zip": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC6B0\uD3B8\uBC88\uD638",
  "bankAccountForm.errors.phone": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uC804\uD654\uBC88\uD638",
  "bankAccountForm.errors.ach_account_number": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uACC4\uC88C \uBC88\uD638",
  "bankAccountForm.errors.routing_number": "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 \uB77C\uC6B0\uD305 \uBC88\uD638",
  "bankAccountForm.errors.offer": "\uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uACB0\uC81C \uC635\uC158 \uC5C6\uC74C - \uB2E4\uB978 \uAD6D\uAC00\uC758 \uC740\uD589 \uACC4\uC88C\uB97C \uBCF4\uC720\uD55C \uACBD\uC6B0, \uD574\uB2F9 \uAD6D\uAC00\uB97C \uC120\uD0DD\uD558\uAC70\uB098 \uB2E4\uB978 \uCE74\uB4DC\uB97C \uC120\uD0DD\uD558\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694. \uADF8\uB798\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {{recipientName}}\uC5D0 \uBB38\uC758\uD558\uC138\uC694.",
  "confirmationPage.labels.edit": "\uD3B8\uC9D1",
  "confirmationPage.labels.confirm": "\uD655\uC778",
  "confirmationPage.labels.title": "\uD544\uC218 \uC815\uBCF4 \uAC80\uD1A0",
  "confirmationPage.labels.typeOfPayment": "\uACB0\uC81C \uC720\uD615",
  "confirmationPage.labels.paymentRecipient": "\uACB0\uC81C \uC218\uB839\uC790",
  "confirmationPage.labels.typeOfPayment.oneOff": "\uC77C\uD68C\uC131",
  "confirmationPage.labels.typeOfPayment.recurring": "\uBC18\uBCF5",
  "confirmationPage.labels.directDebitInformation": "\uC790\uB3D9 \uC774\uCCB4 \uC815\uBCF4",
  "confirmationPage.labels.directDebitInformation.title": "\uC740\uD589\uC5D0 \uC548\uB0B4\uD560 \uC815\uBCF4",
  "confirmationPage.labels.directDebitInformation.creditor": "\uC218\uCDE8\uC778",
  "confirmationPage.labels.directDebitInformation.creditorId": "\uC218\uCDE8\uC778 ID",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "\uB0B4\uC5ED\uC758 \uC774\uB984",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "\uC11C\uBE44\uC2A4 \uC0AC\uC6A9\uC790 ID",
  "confirmationPage.labels.directDebitInformation.address": "Flywire \uC8FC\uC18C",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "Originator ID",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "Originator \uC8FC\uC18C",
  "confirmationPage.labels.bankAccountInformation": "\uC740\uD589 \uACC4\uC88C \uC815\uBCF4",
  "confirmationPage.labels.bankAccountInformation.name": "\uC774\uB984",
  "confirmationPage.labels.bankAccountInformation.iban": "IBAN \uBC88\uD638",
  "confirmationPage.labels.bankAccountInformation.email": "\uC774\uBA54\uC77C",
  "confirmationPage.labels.bankAccountInformation.country": "\uAD6D\uAC00",
  "confirmationPage.labels.bankAccountInformation.state": "\uC8FC",
  "confirmationPage.labels.bankAccountInformation.city": "\uB3C4\uC2DC",
  "confirmationPage.labels.bankAccountInformation.bicCode": "BIC \uCF54\uB4DC",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "\uACC4\uC88C\uBC88\uD638",
  "confirmationPage.labels.bankAccountInformation.sortCode": "\uC740\uD589 \uC2DD\uBCC4 \uAE30\uD638",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "\uACC4\uC88C\uBC88\uD638",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "\uB77C\uC6B0\uD305 \uBC88\uD638",
  "confirmationPage.labels.bankAccountInformation.accountType": "\uACC4\uC88C \uC720\uD615",
  "confirmationPage.labels.changeAccountEft": "\uC740\uD589 \uACC4\uC88C \uC138\uBD80 \uC815\uBCF4 \uBCC0\uACBD",
  "confirmationPage.labels.editPayerEft": "\uACB0\uC81C\uC790 \uC138\uBD80 \uC815\uBCF4 \uD3B8\uC9D1",
  "confirmationPage.labels.useAccountEft": "**** {{lastFour}}(\uC73C)\uB85C \uB05D\uB098\uB294 \uACC4\uC815 \uC0AC\uC6A9",
  "confirmationPage.labels.termsSepa": "\uC774 \uD544\uC218 \uC591\uC2DD\uC5D0 \uC11C\uBA85\uD568\uC73C\uB85C\uC368, (A) FLYWIRE EUROPE UAB\uAC00 \uACE0\uAC1D\uB2D8\uC758 \uACC4\uC88C\uC5D0\uC11C \uB300\uAE08\uC744 \uC778\uCD9C\uD560 \uC218 \uC788\uB3C4\uB85D \uAC70\uB798 \uC740\uD589\uC5D0 \uC548\uB0B4\uBB38\uC744 \uBCF4\uB0B4\uACE0 (B) \uAC70\uB798 \uC740\uD589\uC774 FLYWIRE EUROPE UAB\uC758 \uC548\uB0B4\uBB38\uC5D0 \uB530\uB77C \uACC4\uC88C\uC5D0\uC11C \uB300\uAE08\uC744 \uC778\uCD9C\uD558\uB294 \uAC83\uC744 \uC2B9\uC778\uD558\uC2DC\uAC8C \uB429\uB2C8\uB2E4. \uB300\uAE08 \uCCAD\uAD6C\uB85C\uBD80\uD130 \uCD5C\uC18C 3\uC77C \uC804\uC5D0 \uD1B5\uC9C0\uB97C \uB4DC\uB9BD\uB2C8\uB2E4.",
  "confirmationPage.labels.termsBacs": "\uC790\uB3D9 \uC774\uCCB4 \uBCF4\uC99D\uC5D0\uC11C \uBCF4\uC7A5\uD558\uB294 \uC548\uC804 \uC870\uCE58\uC5D0 \uB530\uB77C \uBCF8 \uC9C0\uCE68\uC5D0 \uAE30\uC220\uB41C \uACC4\uC88C\uC5D0\uC11C Flywire Payments Limited Direct Debits\uC5D0 \uC9C0\uBD88\uD558\uB3C4\uB85D \uC740\uD589\uC5D0 \uC9C0\uC2DC\uD558\uC138\uC694. \uBCF8\uC778\uC740 \uC774 \uC9C0\uCE68\uC774 Flywire Payments Limited\uC5D0 \uB0A8\uC744 \uC218 \uC788\uC73C\uBA70, \uC774\uB7EC\uD55C \uACBD\uC6B0 \uBCF8\uC778\uC758 \uC740\uD589/\uAC74\uBB3C\uD611\uD68C\uC5D0 \uC0C1\uC138 \uC815\uBCF4\uAC00 \uC804\uC790\uC801\uC73C\uB85C \uC804\uB2EC\uB420 \uC218 \uC788\uC74C\uC744 \uC774\uD574\uD569\uB2C8\uB2E4.",
  "confirmationPage.labels.termsAch": `
     '\uD655\uC778'\uC744 \uD074\uB9AD\uD568\uC73C\uB85C\uC368 \uADC0\uD558\uB294 \uC9C0\uC815\uB41C \uC218\uCDE8\uC778("\uC218\uCDE8\uC778")\uC744 \uB300\uC2E0\uD558\uC5EC \uADC0\uD558\uC758 \uC218\uCDE8\uC778\uC758 \uC11C\uBE44\uC2A4 \uC0AC\uC6A9 \uBC0F/\uB610\uB294 \uC218\uCDE8\uC778\uC758 \uC81C\uD488 \uAD6C\uB9E4\uB85C \uC778\uD574 \uBC1C\uC0DD\uD558\uB294 \uC694\uAE08\uC5D0 \uB300\uD574 
     Flywire\uC5D0\uC11C \uADC0\uD558\uAC00 \uC81C\uACF5\uD55C \uC740\uD589 \uACC4\uC88C\uC5D0\uC11C \uC778\uCD9C\uD560 \uC218 \uC788\uB3C4\uB85D \uD5C8\uC6A9\uD558\uB294 \uC801\uC808\uD55C \uAD8C\uD55C\uC774 \uC788\uC74C\uC744 \uD655\uC778\uD558\uACE0, \uB610\uD55C \uC774 \uC2B9\uC778\uC774 \uCDE8\uC18C\uB420 \uB54C\uAE4C\uC9C0, \uD544\uC694\uD55C \uACBD\uC6B0, 
     \uC218\uCDE8\uC778\uC758 \uC57D\uAD00\uC5D0 \uB530\uB77C Flywire\uC5D0\uC11C \uC798\uBABB\uB41C \uC778\uCD9C\uC744 \uC218\uC815\uD560 \uC218 \uC788\uB3C4\uB85D \uD5C8\uC6A9\uD558\uB294 \uC801\uC808\uD55C \uAD8C\uD55C\uC774 \uC788\uC74C\uC744 \uD655\uC778\uD569\uB2C8\uB2E4. 
     \uBCF8\uC778\uC740 \uC790\uAE08 \uBD80\uC871\uC73C\uB85C \uC778\uD574 ACH \uAC70\uB798\uAC00 \uAC70\uBD80\uB418\uB294 \uACBD\uC6B0, NSF \uC218\uC218\uB8CC\uAC00 \uBD80\uACFC\uB418\uBA70 Flywire\uAC00 \uC7AC\uB7C9\uC5D0 \uB530\uB77C \uCCAD\uAD6C\uB97C 
     \uB2E4\uC2DC \uCC98\uB9AC\uD558\uB824\uACE0 \uC2DC\uB3C4\uD560 \uC218 \uC788\uC74C\uC744 \uC774\uD574\uD569\uB2C8\uB2E4.
     `,
  "confirmationPage.labels.termsAch2": "\n     \uC218\uCDE8\uC778\uC758 \uC57D\uAD00\uC5D0 \uB530\uB77C \uC218\uCDE8\uC778\uC758 \uCD94\uAC00 \uC81C\uD488 \uBC0F/\uB610\uB294 \uC11C\uBE44\uC2A4\uB97C \uC8FC\uAE30\uC801\uC73C\uB85C \uC0AC\uC6A9\uD558\uAC70\uB098 \uAD6C\uB9E4\uD558\uB294 \uACBD\uC6B0, \uADC0\uD558\uB294 \uC218\uCDE8\uC778\uC744 \uB300\uC2E0\uD558\uC5EC \n     Flywire\uAC00 \uADC0\uD558\uAC00 \uC81C\uACF5\uD55C \uC740\uD589 \uACC4\uC88C\uC5D0\uC11C \uC8FC\uAE30\uC801\uC73C\uB85C \uC778\uCD9C\uD560 \uC218 \uC788\uB3C4\uB85D \uC2B9\uC778\uD569\uB2C8\uB2E4.\uC704\uC5D0\uC11C \uC2B9\uC778\uB41C \uCD9C\uAE08 \uBC94\uC704\uB97C \uBC97\uC5B4\uB098\uB294 \uACB0\uC81C\uB294 \n     \uD68C\uC6D0\uB2D8\uC758 \uACC4\uC815\uC744 \uD1B5\uD574 \uC2B9\uC778\uC744 \uBC1B\uAC70\uB098 \uBE44\uBC00\uBC88\uD638, \uCF54\uB4DC \uB610\uB294 \uAE30\uD0C0 \uC11C\uBA85\uC5D0 \uC0C1\uC751\uD558\uB294 \uBC29\uBC95\uC73C\uB85C \uC2B9\uC778\uC744 \uBC1B\uC740 \uD6C4\uC5D0\uB9CC \n     \uCD9C\uAE08\uB429\uB2C8\uB2E4.\n     ",
  "confirmationPage.labels.termsAch3": "\n     \uADC0\uD558\uB294 \uC218\uCDE8\uC778\uC5D0\uAC8C \uC5F0\uB77D\uD558\uC5EC \uC5B8\uC81C\uB4E0\uC9C0 \uC774 \uC2B9\uC778\uC744 \uCDE8\uC18C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uADC0\uD558\uC758 \uCCA0\uD68C\uB294 \uB2E4\uC74C \uC608\uC815\uB41C \uC9C0\uAE09\uC77C\uB85C\uBD80\uD130 \uCD5C\uC18C [\uC601\uC5C5\uC77C \uAE30\uC900 10\uC77C] \n     \uC804\uC5D0 \uC811\uC218\uB418\uC5B4\uC57C \uD569\uB2C8\uB2E4.\n    ",
  "confirmationPage.labels.print": "\uB3D9\uC758\uC11C \uC778\uC1C4",
  "amountPanel.labels.amountFromLabel": "\uACB0\uC81C\uD560 \uAE08\uC561:",
  "amountPanel.labels.surchargeFeeInfo": "\uCE74\uB4DC \uC218\uC218\uB8CC \uD3EC\uD568.",
  "amountPanel.labels.whyThisFee": "\uC774 \uC218\uC218\uB8CC\uAC00 \uBD80\uACFC\uB418\uB294 \uC774\uC720\uB294 \uBB34\uC5C7\uC778\uAC00\uC694?",
  "amountPanel.labels.whyThisFeeTooltip": "\n  \uACB0\uC81C\uB97C \uC9C4\uD589\uD558\uBA74 {{percentage}}%\uC758 \uCE74\uB4DC \uC218\uC218\uB8CC\uAC00 \uBD80\uACFC\uB429\uB2C8\uB2E4. \uADC0\uD558\uC758 {{cardScheme}} \uCE74\uB4DC \uD1B5\uD654\uB294 {{currency}}\uC785\uB2C8\uB2E4. \uCD94\uAC00 \uBE44\uC6A9\uC774 \uBD80\uACFC\uB418\uC9C0 \uC54A\uB3C4\uB85D \uCE74\uB4DC\uC640 \uC77C\uCE58\uD558\uB294 \uCE74\uB4DC \uB610\uB294 \uAD6D\uAC00\uB97C \uC120\uD0DD\uD558\uC138\uC694.\n     ",
  "amountPanel.labels.currencyChangeWarning": "\uCE74\uB4DC \uD1B5\uD654\uC640 \uC77C\uCE58\uD558\uB3C4\uB85D \uD1B5\uD654\uAC00 \uBCC0\uACBD\uB428",
  "amountPanel.labels.amountToLabel": "{{recipientName}}\uC774(\uAC00) \uC218\uB839\uD558\uB294 \uAE08\uC561",
  AX: "\uC62C\uB780\uB4DC \uC81C\uB3C4",
  AD: "\uC548\uB3C4\uB77C",
  BG: "\uBD88\uAC00\uB9AC\uC544",
  AT: "\uC624\uC2A4\uD2B8\uB9AC\uC544",
  BE: "\uBCA8\uAE30\uC5D0",
  HR: "\uD06C\uB85C\uC544\uD2F0\uC544",
  CY: "\uD0A4\uD504\uB85C\uC2A4",
  CZ: "\uCCB4\uCF54 \uACF5\uD654\uAD6D",
  DK: "\uB374\uB9C8\uD06C",
  EE: "\uC5D0\uC2A4\uD1A0\uB2C8\uC544",
  FI: "\uD540\uB780\uB4DC",
  FR: "\uD504\uB791\uC2A4",
  GP: "\uACFC\uB4E4\uB8E8\uD504",
  DE: "\uB3C5\uC77C",
  GR: "\uADF8\uB9AC\uC2A4",
  HU: "\uD5DD\uAC00\uB9AC",
  IS: "\uC544\uC774\uC2AC\uB780\uB4DC",
  IE: "\uC544\uC77C\uB79C\uB4DC",
  VA: "\uAD50\uD669\uCCAD(\uBC14\uD2F0\uCE78 \uC2DC\uAD6D)",
  IT: "\uC774\uD0C8\uB9AC\uC544",
  LI: "\uB9AC\uD788\uD150\uC288\uD0C0\uC778",
  LT: "\uB9AC\uD22C\uC544\uB2C8\uC544",
  LU: "\uB8E9\uC148\uBD80\uB974\uD06C",
  YT: "\uB9C8\uC694\uD2B8",
  MT: "\uBAB0\uD0C0",
  MQ: "\uB9C8\uB974\uD2F0\uB2C8\uD06C",
  ES: "\uC2A4\uD398\uC778",
  NO: "\uB178\uB974\uC6E8\uC774",
  NL: "\uB124\uB35C\uB780\uB4DC",
  PL: "\uD3F4\uB780\uB4DC",
  PT: "\uD3EC\uB974\uD22C\uAC08",
  SE: "\uC2A4\uC6E8\uB374",
  RE: "\uB808\uC704\uB2C8\uC639",
  RO: "\uB8E8\uB9C8\uB2C8\uC544",
  CH: "\uC2A4\uC704\uC2A4",
  BL: "\uC0DD \uBC14\uB974\uD154\uB808\uBBF8",
  GB: "\uC601\uAD6D",
  MC: "\uBAA8\uB098\uCF54",
  MF: "\uC138\uC778\uD2B8 \uB9C8\uD2F4(\uD504\uB791\uC2A4\uB839)",
  PM: "\uC0DD \uD53C\uC5D0\uB974 \uBBF8\uD074\uB871",
  SM: "\uC0B0 \uB9C8\uB9AC\uB178",
  SK: "\uC2AC\uB85C\uBC14\uD0A4\uC544",
  SI: "\uC2AC\uB85C\uBCA0\uB2C8\uC544",
  GF: "\uD504\uB791\uC2A4\uB839 \uAE30\uC544\uB098",
  LV: "\uB77C\uD2B8\uBE44\uC544",
  CA: "\uCE90\uB098\uB2E4",
  US: "\uBBF8\uAD6D",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/locales/pt-PT.ts
var pt = {
  "session_expired.title": "A sess\xE3o expirou",
  "tokenizationForm.payment-terms.text1": "Autorizo a Flywire a armazenar e debitar o meu cart\xE3o de d\xE9bito/cr\xE9dito automaticamente em nome de {{recipientName}}. Li, compreendi e concordo com os seguintes",
  "tokenizationForm.general-terms.link2": "Pol\xEDtica de privacidade",
  "tokenizationForm.general-terms.link-joint": " e ",
  "tokenizationForm.general-terms.link1": "Termos de utiliza\xE7\xE3o",
  "tokenizationForm.payment-terms.link": "Termos de utiliza\xE7\xE3o da Flywire para pagamentos automatizados",
  "tokenizationForm.labels.cvvTooltip": "3 algarismos no verso do seu cart\xE3o ou 4 algarismos na frente",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "Data de vencimento (MM/AA)",
  "tokenizationForm.labels.cardNumber": "N\xFAmero de cart\xE3o",
  "tokenizationForm.labels.phone": "N\xFAmero de telefone",
  "tokenizationForm.labels.zip": "C\xF3digo postal",
  "tokenizationForm.labels.address": "Endere\xE7o",
  "cardsForm.labels.state": "Estado",
  "tokenizationForm.labels.country": "Pa\xEDs",
  "tokenizationForm.labels.city": "Cidade",
  "tokenizationForm.labels.email": "E-mail",
  "tokenizationForm.labels.lastName": "Sobrenome",
  "tokenizationForm.labels.firstName": "Primeiro nome",
  "tokenizationForm.labels.dynamicFields.document": "N\xFAmero CPF ou CNPJ",
  "cardsForm.title": "Informa\xE7\xE3o do titular do cart\xE3o",
  "success.title": "Os seus fundos est\xE3o a caminho",
  "success.title.info": "Preveja 2 a 3 dias \xFAteis para a chegada dos fundos. \nReceber\xE1 um e-mail quando os fundos forem entregues.",
  "bankAccountForm.hints.generic": "Exemplo: {{label}}",
  "bankAccountForm.hints.account_number": "O n\xFAmero da conta deve ter entre 1 e 17 caracteres",
  "bankAccountForm.hints.routing_number": "O n\xFAmero de encaminhamento deve ter 9 d\xEDgitos",
  "bankAccountForm.labels.accountZipCode": "C\xF3digo Postal",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "C\xF3digo BIC",
  "bankAccountForm.labels.accountNumber": "N\xFAmero de conta banc\xE1ria",
  "bankAccountForm.labels.accountSortCode": "C\xF3digo de ordena\xE7\xE3o",
  "bankAccountForm.labels.accountRoutingNumber": "N\xFAmero de encaminhamento",
  "bankAccountForm.labels.accountType": "Tipo de conta",
  "bankAccountForm.labels.eftProviderWidnow": "Ser\xE1 encaminhado para a plataforma de processamento do parceiro para concluir este pagamento. Quando terminar, ser\xE1 redirecionado para esta p\xE1gina novamente",
  "bankAccountForm.labels.termsFlywire": "Li, entendi e concordo com os <a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>Termos de Uso</a> e com a <a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Pol\xEDtica de Privacidade</a> Flywire",
  "bankAccountForm.labels.termsDirectDebit": "Confirmo que sou o titular desta conta e que sou o \xFAnico signat\xE1rio exigido para autorizar este d\xE9bito direto",
  "bankAccountForm.labels.termsEft": "Li, entendi e concordo com o <a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Contrato de D\xE9bito Pr\xE9-autorizado</a>",
  "bankAccountForm.labels.city": "Cidade",
  "bankAccountForm.labels.country": "Pa\xEDs",
  "bankAccountForm.labels.selectCountry": "Selecione um pa\xEDs",
  "bankAccountForm.title": "Informa\xE7\xF5es do titular da conta",
  "failure.tryAgain": "Tente novamente",
  "failure.title": "A transa\xE7\xE3o falhou",
  "failure.connectivity.message": "A opera\xE7\xE3o falhou; isto pode dever-se a problemas de conectividade.",
  "failure.message": "A transa\xE7\xE3o falhou. Isto pode dever-se a problemas de conectividade. Tente novamente. Se o problema persistir, tente outro m\xE9todo de pagamento ou entre em contacto com seu banco",
  "sessionExpired.text": "A sess\xE3o expirou",
  "LoadingError.title": "Algo correu mal",
  "LoadingError.message": "Ocorreu um erro ao carregar o formul\xE1rio",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "N\xE3o h\xE1 op\xE7\xF5es de pagamento dispon\xEDveis para o pa\xEDs selecionado",
  "bankAccountForm.labels.accountHolderType.personal": "Conta pessoal",
  "bankAccountForm.labels.accountHolderType.business": "Conta empresarial",
  "bankAccountForm.labels.name": "Primeiro nome",
  "bankAccountForm.labels.businessName": "Nome da empresa",
  "bankAccountForm.labels.surname": "Sobrenome",
  "bankAccountForm.labels.phone": "N\xFAmero de telefone",
  "bankAccountForm.labels.email": "E-mail",
  "bankAccountForm.labels.zip": "C\xF3digo postal",
  "bankAccountForm.labels.accountAddress": "Endere\xE7o",
  "bankAccountForm.labels.address": "Endere\xE7o",
  "bankAccountForm.errors.dynamicFields": "Inv\xE1lido {{field}}",
  "bankAccountForm.errors.dynamicFields.document": "N\xFAmero CPF ou CNPJ inv\xE1lido",
  "bankAccountForm.errors.dynamicFields.documentPattern": "Inclui o teu n\xFAmero CPF/CNPJ sem h\xEDfenes ou tra\xE7os",
  "bankAccountForm.labels.saveButton": "Guardar",
  "bankAccountForm.labels.nextButton": "Pr\xF3ximo",
  "bankAccountForm.labels.payButton": "Paga",
  "bankAccountForm.errors.cardNumber": "N\xFAmero de cart\xE3o inv\xE1lido",
  "tokenizationForm.errors.cardNumber": "N\xFAmero de cart\xE3o inv\xE1lido",
  "tokenizationForm.errors.cvv": "N\xFAmero CVV inv\xE1lido",
  "bankAccountForm.errors.cvv": "N\xFAmero CVV inv\xE1lido",
  "tokenizationForm.errors.unsupportedCardTypes": "S\xF3 s\xE3o aceites {{acceptedCardsList}}",
  "tokenizationForm.errors.unsupportedCardType": "Apenas \xE9 aceite {{acceptedCard}}",
  "tokenizationForm.errors.cardType.and": "e",
  "tokenizationForm.errors.name": "Nome pr\xF3prio inv\xE1lido",
  "tokenizationForm.errors.email": "E-mail inv\xE1lido",
  "tokenizationForm.errors.country": "Pa\xEDs inv\xE1lido",
  "tokenizationForm.errors.state": "Estado inv\xE1lido",
  "tokenizationForm.errors.city": "Cidade inv\xE1lida",
  "tokenizationForm.errors.address": "Endere\xE7o inv\xE1lido",
  "tokenizationForm.errors.addressIsPoBox": "N\xE3o aceitamos apartados postais no campo de endere\xE7o.",
  "tokenizationForm.errors.onlyLetterOrNumbers": "Os caracteres v\xE1lidos s\xE3o apenas de A a Z e de 0 a 9",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": 'Os caracteres v\xE1lidos incluem apenas A-Z, 0-9 e "/, -"',
  "tokenizationForm.errors.zip": "C\xF3digo postal inv\xE1lido",
  "tokenizationForm.errors.expiryDate": "Data de vencimento inv\xE1lida",
  "bankAccountForm.errors.expiryDate": "Data de vencimento inv\xE1lida",
  "tokenizationForm.errors.surname": "Apelido/sobrenome inv\xE1lido",
  "tokenizationForm.errors.phone": "N\xFAmero de telefone inv\xE1lido",
  "tokenizationForm.errors.length": "O campo \xE9 demasiado longo (no m\xE1ximo 256 carateres)",
  "bankAccountForm.errors.name": "Nome pr\xF3prio inv\xE1lido",
  "bankAccountForm.errors.name.maxSizeExceeded": "O nome pr\xF3prio \xE9 demasiado longo (m\xE1ximo de 140 caracteres)",
  "form.errors.name.maxSizeExceeded": "O nome pr\xF3prio \xE9 demasiado longo (m\xE1ximo de {{limit}} caracteres)",
  "form.errors.surname.maxSizeExceeded": "O apelido \xE9 demasiado longo (m\xE1ximo de {{limit}} caracteres)",
  "form.errors.business_name.maxSizeExceeded": "O nome da empresa \xE9 demasiado longo (m\xE1ximo de {{limit}} caracteres)",
  "form.errors.city.maxSizeExceeded": "A cidade \xE9 demasiado longa (m\xE1ximo de {{limit}} carateres)",
  "form.errors.address.maxSizeExceeded": "O endere\xE7o \xE9 muito longo (m\xE1ximo de {{limit}} caracteres)",
  "bankAccountForm.errors.business_name": "Nome da empresa inv\xE1lido",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "O nome da empresa \xE9 demasiado longo (m\xE1ximo de 140 caracteres)",
  "bankAccountForm.errors.surname": "Apelido inv\xE1lido",
  "bankAccountForm.errors.surname.maxSizeExceeded": "O apelido \xE9 muito longo (m\xE1ximo de 140 caracteres)",
  "bankAccountForm.errors.country": "Pa\xEDs inv\xE1lido",
  "bankAccountForm.errors.address": "Endere\xE7o inv\xE1lido",
  "bankAccountForm.errors.address.maxSizeExceeded": "O endere\xE7o \xE9 muito longo (m\xE1ximo de 256 caracteres)",
  "bankAccountForm.errors.city": "Cidade inv\xE1lida",
  "bankAccountForm.errors.city.maxSizeExceeded": "A cidade \xE9 demasiado longa (m\xE1ximo de 256 carateres)",
  "bankAccountForm.errors.email": "E-mail inv\xE1lido",
  "bankAccountForm.errors.state": "Estado inv\xE1lido",
  "bankAccountForm.errors.iban": "IBAN inv\xE1lido",
  "bankAccountForm.errors.bic": "C\xF3digo BIC inv\xE1lido",
  "bankAccountForm.errors.accountnumber": "N\xFAmero de conta banc\xE1ria inv\xE1lido",
  "bankAccountForm.errors.sortcode": "C\xF3digo de ordena\xE7\xE3o inv\xE1lido",
  "bankAccountForm.errors.account_type": "Tipo de conta inv\xE1lido",
  "bankAccountForm.errors.addressIsPoBox": "N\xE3o aceitamos apartados postais no campo de endere\xE7o.",
  "bankAccountForm.errors.onlyLetterOrNumbers": "Os caracteres v\xE1lidos s\xE3o apenas de A a Z e de 0 a 9",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "Os caracteres v\xE1lidos s\xE3o: A-Z 0-9 / , -",
  "bankAccountForm.errors.zip": "C\xF3digo postal inv\xE1lido",
  "bankAccountForm.errors.phone": "N\xFAmero de telefone inv\xE1lido",
  "bankAccountForm.errors.ach_account_number": "N\xFAmero de conta banc\xE1ria inv\xE1lido",
  "bankAccountForm.errors.routing_number": "N\xFAmero de encaminhamento inv\xE1lido",
  "bankAccountForm.errors.offer": "N\xE3o h\xE1 op\xE7\xF5es de pagamento dispon\xEDveis. Se tiver uma conta banc\xE1ria noutro pa\xEDs, selecione esse pa\xEDs ou escolha outro cart\xE3o e tente novamente. Se isto n\xE3o resolver o problema, contacte {{recipientName}}",
  "confirmationPage.labels.edit": "Editar",
  "confirmationPage.labels.confirm": "Confirmar",
  "confirmationPage.labels.title": "Rever informa\xE7\xF5es de autoriza\xE7\xE3o",
  "confirmationPage.labels.typeOfPayment": "Tipos de pagamento",
  "confirmationPage.labels.paymentRecipient": "Destinat\xE1rio do pagamento",
  "confirmationPage.labels.typeOfPayment.oneOff": "Pontual",
  "confirmationPage.labels.typeOfPayment.recurring": "Recorrente",
  "confirmationPage.labels.directDebitInformation": "Informa\xE7\xF5es para d\xE9bito direto",
  "confirmationPage.labels.directDebitInformation.title": "Instru\xE7\xF5es para o seu banco",
  "confirmationPage.labels.directDebitInformation.creditor": "Credor",
  "confirmationPage.labels.directDebitInformation.creditorId": "ID do credor",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "Nome no seu extrato",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "ID de utilizador de servi\xE7o",
  "confirmationPage.labels.directDebitInformation.address": "Endere\xE7o da Flywire",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "ID do originador",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "Endere\xE7o do originador",
  "confirmationPage.labels.bankAccountInformation": "Informa\xE7\xF5es da conta banc\xE1ria",
  "confirmationPage.labels.bankAccountInformation.name": "Nome",
  "confirmationPage.labels.bankAccountInformation.iban": "N\xFAmero IBAN",
  "confirmationPage.labels.bankAccountInformation.email": "E-mail",
  "confirmationPage.labels.bankAccountInformation.country": "Pa\xEDs",
  "confirmationPage.labels.bankAccountInformation.state": "Estado",
  "confirmationPage.labels.bankAccountInformation.city": "Cidade",
  "confirmationPage.labels.bankAccountInformation.bicCode": "C\xF3digo BIC",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "N\xFAmero de conta banc\xE1ria",
  "confirmationPage.labels.bankAccountInformation.sortCode": "C\xF3digo de ordena\xE7\xE3o",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "N\xFAmero de conta banc\xE1ria",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "N\xFAmero de encaminhamento",
  "confirmationPage.labels.bankAccountInformation.accountType": "Tipo de conta",
  "confirmationPage.labels.changeAccountEft": "Alterar dados da conta banc\xE1ria",
  "confirmationPage.labels.editPayerEft": "Editar detalhes do pagador",
  "confirmationPage.labels.useAccountEft": "Usar conta terminada em **** {{lastFour}}",
  "confirmationPage.labels.termsSepa": "Ao subscrever esta autoriza\xE7\xE3o, est\xE1 a autorizar o (A) FLYWIRE EUROPE UAB a enviar instru\xE7\xF5es ao seu banco para debitar a sua conta e (B) o seu banco a debitar a sua conta, de acordo com as instru\xE7\xF5es do FLYWIRE EUROPE UAB. Ir\xE1 receber uma notifica\xE7\xE3o, pelo menos, 3 dias antes de ser efetuada a cobran\xE7a.",
  "confirmationPage.labels.termsBacs": "Instrua o seu banco a pagar d\xE9bitos diretos da Flywire Payments Limited a partir da conta detalhada nesta instru\xE7\xE3o, sujeito \xE0s salvaguardas asseguradas pela Garantia de D\xE9bito Direto. Compreendo que esta instru\xE7\xE3o pode permanecer com a Flywire Payments Limited e, em caso afirmativo, os detalhes ser\xE3o transmitidos eletronicamente ao meu banco/sociedade de constru\xE7\xE3o.",
  "confirmationPage.labels.termsAch": "\n     Ao clicar em \xABConfirmar\xBB, confirma que tem autoridade adequada e, por meio deste, autoriza a Flywire em nome do destinat\xE1rio especificado\n (\xABBenefici\xE1rio\xBB) a debitar da conta banc\xE1ria fornecida por si qualquer valor devido a cobran\xE7as decorrentes do uso dos servi\xE7os Payee\n e/ou da compra de produtos do Payee e, se necess\xE1rio, a corrigir d\xE9bitos incorretos, de acordo com os termos do Benefici\xE1rio, at\xE9 que esta\n autoriza\xE7\xE3o seja revogada. No caso de uma transa\xE7\xE3o ACH ser rejeitada por fundos insuficientes, entendo que ser-me-\xE1 cobrada uma taxa de NSF e que a Flywire poder\xE1, a seu crit\xE9rio, tentar processar a cobran\xE7a novamente.\n     ",
  "confirmationPage.labels.termsAch2": "\n     Se usar ou comprar produtos e/ou servi\xE7os adicionais do Benefici\xE1rio periodicamente, de acordo com os termos do Benefici\xE1rio, autoriza a\n Flywire, em nome do Benefici\xE1rio, a debitar periodicamente a conta banc\xE1ria fornecida por si. Pagamentos fora do d\xE9bito \n autorizado acima s\xF3 ser\xE3o debitados ap\xF3s a sua autoriza\xE7\xE3o ser obtida atrav\xE9s da sua conta, ou ent\xE3o atrav\xE9s de uma palavra-passe, c\xF3digo ou outro \n equivalente de assinatura.\n     ",
  "confirmationPage.labels.termsAch3": "\n     Pode revogar esta autoriza\xE7\xE3o a qualquer momento entrando em contacto com o benefici\xE1rio. A sua revoga\xE7\xE3o deve ser recebida no prazo de pelo menos [10 dias \xFAteis]\n antes do pr\xF3ximo pagamento agendado.\n    ",
  "confirmationPage.labels.print": "Imprimir o acordo",
  "amountPanel.labels.amountFromLabel": "Ir\xE1 pagar",
  "amountPanel.labels.surchargeFeeInfo": "taxa de cart\xE3o inclu\xEDda.",
  "amountPanel.labels.whyThisFee": "Porqu\xEA esta taxa?",
  "amountPanel.labels.whyThisFeeTooltip": "\n  Taxas de cart\xE3o de {{percentage}} % se avan\xE7ar com o pagamento. A moeda do seu cart\xE3o {{cardScheme}} \xE9 {{currency}}. Selecione um cart\xE3o ou um pa\xEDs compat\xEDvel com o seu cart\xE3o para evitar cobran\xE7as adicionais.\n     ",
  "amountPanel.labels.currencyChangeWarning": "A moeda foi alterada para corresponder \xE0 moeda do seu cart\xE3o",
  "amountPanel.labels.amountToLabel": "{{recipientName}} vai receber",
  AX: "Ilhas \xC5land",
  AD: "Andorra",
  BG: "Bulg\xE1ria",
  AT: "\xC1ustria",
  BE: "B\xE9lgica",
  HR: "Cro\xE1cia",
  CY: "Chipre",
  CZ: "Ch\xE9quia",
  DK: "Dinamarca",
  EE: "Est\xF3nia",
  FI: "Finl\xE2ndia",
  FR: "Fran\xE7a",
  GP: "Guadalupe",
  DE: "Alemanha",
  GR: "Gr\xE9cia",
  HU: "Hungria",
  IS: "Isl\xE2ndia",
  IE: "Irlanda",
  VA: "Santa S\xE9 (Cidade do Vaticano)",
  IT: "It\xE1lia",
  LI: "Liechtenstein",
  LT: "Litu\xE2nia",
  LU: "Luxemburgo",
  YT: "Maiote",
  MT: "Malta",
  MQ: "Martinica",
  ES: "Espanha",
  NO: "Noruega",
  NL: "Pa\xEDses Baixos",
  PL: "Pol\xF3nia",
  PT: "Portugal",
  SE: "Su\xE9cia",
  RE: "Reuni\xE3o",
  RO: "Rom\xE9nia",
  CH: "Su\xED\xE7a",
  BL: "S\xE3o Bartolomeu",
  GB: "Reino Unido",
  MC: "M\xF3naco",
  MF: "S\xE3o Martinho (parte francesa)",
  PM: "S\xE3o Pedro e Miquel\xE3o",
  SM: "S\xE3o Marinho",
  SK: "Eslov\xE1quia",
  SI: "Eslov\xE9nia",
  GF: "Guiana Francesa",
  LV: "Let\xF3nia",
  CA: "Canad\xE1",
  US: "Estados Unidos",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/locales/vi.ts
var vi = {
  "session_expired.title": "Phi\xEAn \u0111\xE3 h\u1EBFt h\u1EA1n",
  "tokenizationForm.payment-terms.text1": "T\xF4i cho ph\xE9p Flywire t\u1EF1 \u0111\u1ED9ng l\u01B0u tr\u1EEF v\xE0 t\xEDnh ph\xED v\xE0o th\u1EBB ghi n\u1EE3/t\xEDn d\u1EE5ng c\u1EE7a t\xF4i thay m\u1EB7t cho {{recipientName}}. T\xF4i \u0111\xE3 \u0111\u1ECDc, hi\u1EC3u v\xE0 \u0111\u1ED3ng \xFD v\u1EDBi",
  "tokenizationForm.general-terms.link2": "Chi\u0301nh sa\u0301ch quy\u1EC1n ri\xEAng t\u01B0",
  "tokenizationForm.general-terms.link-joint": " v\xE0 ",
  "tokenizationForm.general-terms.link1": "\u0110i\xEA\u0300u khoa\u0309n s\u01B0\u0309 du\u0323ng",
  "tokenizationForm.payment-terms.link": "\u0110i\u1EC1u kho\u1EA3n s\u1EED d\u1EE5ng c\u1EE7a Flywire v\u1EC1 thanh to\xE1n t\u1EF1 \u0111\u1ED9ng",
  "tokenizationForm.labels.cvvTooltip": "3 ch\u1EEF s\u1ED1 \u01A1\u0309 m\u1EB7t sau the\u0309 ho\u0103\u0323c 4 ch\u1EEF s\u1ED1 \u01A1\u0309 m\u1EB7t tr\u01B0\u01A1\u0301c the\u0309",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "Nga\u0300y h\xEA\u0301t ha\u0323n (TT/NN)",
  "tokenizationForm.labels.cardNumber": "S\xF4\u0301 the\u0309",
  "tokenizationForm.labels.phone": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
  "tokenizationForm.labels.zip": "M\xE3 Zip",
  "tokenizationForm.labels.address": "\u0110\u1ECBa ch\u1EC9",
  "cardsForm.labels.state": "Nh\xE0 n\u01B0\u1EDBc",
  "tokenizationForm.labels.country": "Qu\u1ED1c gia",
  "tokenizationForm.labels.city": "Th\xE0nh ph\u1ED1",
  "tokenizationForm.labels.email": "Email",
  "tokenizationForm.labels.lastName": "Ho\u0323",
  "tokenizationForm.labels.firstName": "T\xEAn",
  "tokenizationForm.labels.dynamicFields.document": "S\u1ED1 CPF ho\u1EB7c CNPJ",
  "cardsForm.title": "Th\xF4ng tin ch\u1EE7 th\u1EBB",
  "success.title": "Ti\u1EC1n c\u1EE7a b\u1EA1n \u0111ang tr\xEAn \u0111\u01B0\u1EDDng",
  "success.title.info": "Vui l\xF2ng ch\u1EDD 2-3 ng\xE0y l\xE0m vi\u1EC7c \u0111\u1EC3 ti\u1EC1n \u0111\u1EBFn n\u01A1i. B\u1EA1n s\u1EBD nh\u1EADn \u0111\u01B0\u1EE3c m\u1ED9t email khi ti\u1EC1n \u0111\xE3 \u0111\u01B0\u1EE3c chuy\u1EC3n.",
  "bankAccountForm.hints.generic": "V\xED d\u1EE5: {{label}}",
  "bankAccountForm.hints.account_number": "\u0110\u1ED9 d\xE0i s\u1ED1 t\xE0i kho\u1EA3n ng\xE2n h\xE0ng ph\u1EA3i t\u1EEB 1 \u0111\u1EBFn 17 k\xFD t\u1EF1",
  "bankAccountForm.hints.routing_number": "\u0110\u1ED9 d\xE0i s\u1ED1 \u0111\u1ECBnh tuy\u1EBFn ph\u1EA3i l\xE0 9 ch\u1EEF s\u1ED1",
  "bankAccountForm.labels.accountZipCode": "M\xE3 b\u01B0u ch\xEDnh",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "M\xE3 BIC",
  "bankAccountForm.labels.accountNumber": "S\u1ED1 t\xE0i kho\u1EA3n",
  "bankAccountForm.labels.accountSortCode": "M\xE3 s\u1EAFp x\u1EBFp ng\xE2n h\xE0ng",
  "bankAccountForm.labels.accountRoutingNumber": "S\u1ED1 \u0111\u1ECBnh tuy\u1EBFn",
  "bankAccountForm.labels.accountType": "Lo\u1EA1i t\xE0i kho\u1EA3n",
  "bankAccountForm.labels.eftProviderWidnow": "Ba\u0323n se\u0303 \u0111\u01B0\u01A1\u0323c chuy\xEA\u0309n \u0111\u1EBFn n\xEA\u0300n ta\u0309ng x\u01B0\u0309 ly\u0301 c\u1EE7a \u0111\xF4\u0301i ta\u0301c \u0111\xEA\u0309 hoa\u0300n t\xE2\u0301t thanh toa\u0301n na\u0300y. Sau khi ho\xE0n t\u1EA5t, b\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c chuy\u1EC3n h\u01B0\u1EDBng tr\u1EDF l\u1EA1i trang n\xE0y",
  "bankAccountForm.labels.termsFlywire": "T\xF4i \u0111\xE3 \u0111\u1ECDc, hi\u1EC3u v\xE0 \u0111\u1ED3ng \xFD v\u1EDBi <a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>\u0110i\u1EC1u kho\u1EA3n s\u1EED d\u1EE5ng</a> v\xE0 <a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Ch\xEDnh s\xE1ch b\u1EA3o m\u1EADt</a>c\u1EE7a Flywire",
  "bankAccountForm.labels.termsDirectDebit": "T\xF4i x\xE1c nh\u1EADn t\xF4i l\xE0 ch\u1EE7 t\xE0i kho\u1EA3n c\u1EE7a t\xE0i kho\u1EA3n n\xE0y v\xE0 l\xE0 b\xEAn k\xFD k\u1EBFt duy nh\u1EA5t ph\u1EA3i c\xF3 \u0111\u1EC3 u\u1EF7 quy\u1EC1n ghi n\u1EE3 tr\u1EF1c ti\u1EBFp n\xE0y",
  "bankAccountForm.labels.termsEft": "T\xF4i \u0111\xE3 \u0111\u1ECDc, hi\u1EC3u v\xE0 \u0111\u1ED3ng \xFD v\u1EDBi <a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Th\u1ECFa thu\u1EADn ghi n\u1EE3 \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n tr\u01B0\u1EDBc</a>",
  "bankAccountForm.labels.city": "Th\xE0nh ph\u1ED1",
  "bankAccountForm.labels.country": "Qu\u1ED1c gia",
  "bankAccountForm.labels.selectCountry": "Ch\u1ECDn m\u1ED9t qu\u1ED1c gia",
  "bankAccountForm.title": "Th\xF4ng tin ch\u1EE7 t\xE0i kho\u1EA3n",
  "failure.tryAgain": "Th\u1EED l\u1EA1i",
  "failure.title": "Giao d\u1ECBch kh\xF4ng th\xE0nh c\xF4ng",
  "failure.connectivity.message": "Thao t\xE1c kh\xF4ng th\xE0nh c\xF4ng, c\xF3 th\u1EC3 l\xE0 do c\xE1c v\u1EA5n \u0111\u1EC1 k\u1EBFt n\u1ED1i.",
  "failure.message": "Giao d\u1ECBch kh\xF4ng th\xE0nh c\xF4ng. C\xF3 th\u1EC3 l\xE0 do v\u1EA5n \u0111\u1EC1 k\u1EBFt n\u1ED1i. Vui l\xF2ng th\u1EED l\u1EA1i. N\u1EBFu s\u1EF1 c\u1ED1 v\u1EABn ti\u1EBFp di\u1EC5n, vui l\xF2ng th\u1EED ph\u01B0\u01A1ng th\u1EE9c thanh to\xE1n kh\xE1c ho\u1EB7c li\xEAn h\u1EC7 v\u1EDBi ng\xE2n h\xE0ng c\u1EE7a b\u1EA1n",
  "sessionExpired.text": "Phi\xEAn \u0111\xE3 h\u1EBFt h\u1EA1n",
  "LoadingError.title": "\u0110\xE3 x\u1EA3y ra l\u1ED7i",
  "LoadingError.message": "\u0110\xE3 x\u1EA3y ra l\u1ED7i khi t\u1EA3i m\u1EABu",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "Kh\xF4ng c\xF3 ph\u01B0\u01A1ng th\u1EE9c thanh to\xE1n n\xE0o cho qu\u1ED1c gia \u0111\xE3 ch\u1ECDn",
  "bankAccountForm.labels.accountHolderType.personal": "T\xE0i kho\u1EA3n c\xE1 nh\xE2n",
  "bankAccountForm.labels.accountHolderType.business": "T\xE0i kho\u1EA3n doanh nghi\u1EC7p",
  "bankAccountForm.labels.name": "T\xEAn",
  "bankAccountForm.labels.businessName": "T\xEAn doanh nghi\u1EC7p",
  "bankAccountForm.labels.surname": "Ho\u0323",
  "bankAccountForm.labels.phone": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
  "bankAccountForm.labels.email": "Email",
  "bankAccountForm.labels.zip": "M\xE3 Zip",
  "bankAccountForm.labels.accountAddress": "\u0110\u1ECBa ch\u1EC9",
  "bankAccountForm.labels.address": "\u0110\u1ECBa ch\u1EC9",
  "bankAccountForm.errors.dynamicFields": "{{field}} kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.dynamicFields.document": "S\u1ED1 CPF ho\u1EB7c CNPJ kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.dynamicFields.documentPattern": "Vui l\xF2ng bao g\u1ED3m s\u1ED1 CPF/CNPJ c\u1EE7a b\u1EA1n kh\xF4ng c\xF3 d\u1EA5u g\u1EA1ch n\u1ED1i ho\u1EB7c d\u1EA5u g\u1EA1ch ngang",
  "bankAccountForm.labels.saveButton": "L\u01B0u",
  "bankAccountForm.labels.nextButton": "Ti\u1EBFp theo",
  "bankAccountForm.labels.payButton": "Thanh to\xE1n",
  "bankAccountForm.errors.cardNumber": "S\u1ED1 th\u1EBB kh\xF4ng h\u1EE3p l\u1EC7",
  "tokenizationForm.errors.cardNumber": "S\u1ED1 th\u1EBB kh\xF4ng h\u1EE3p l\u1EC7",
  "tokenizationForm.errors.cvv": "S\xF4\u0301 CVV kh\xF4ng h\u01A1\u0323p l\xEA\u0323",
  "bankAccountForm.errors.cvv": "S\xF4\u0301 CVV kh\xF4ng h\u01A1\u0323p l\xEA\u0323",
  "tokenizationForm.errors.unsupportedCardTypes": "Chi\u0309 h\xF4\u0303 tr\u01A1\u0323 {{acceptedCardsList}}",
  "tokenizationForm.errors.unsupportedCardType": "Chi\u0309 h\xF4\u0303 tr\u01A1\u0323 {{acceptedCard}}",
  "tokenizationForm.errors.cardType.and": "v\xE0",
  "tokenizationForm.errors.name": "T\xEAn kh\xF4ng h\u1EE3p l\u1EC7",
  "tokenizationForm.errors.email": "Email kh\xF4ng h\u01A1\u0323p l\xEA\u0323",
  "tokenizationForm.errors.country": "Qu\u1ED1c gia kh\xF4ng h\u1EE3p l\u1EC7",
  "tokenizationForm.errors.state": "Ti\u1EC3u bang kh\xF4ng h\u1EE3p l\u1EC7",
  "tokenizationForm.errors.city": "Th\xE0nh ph\u1ED1 kh\xF4ng h\u1EE3p l\u1EC7",
  "tokenizationForm.errors.address": "\u0110\u1ECBa ch\u1EC9 kh\xF4ng h\u1EE3p l\u1EC7",
  "tokenizationForm.errors.addressIsPoBox": "Ch\xFAng t\xF4i kh\xF4ng ch\u1EA5p nh\u1EADn H\u1ED9p th\u01B0 b\u01B0u \u0111i\u1EC7n trong tr\u01B0\u1EDDng \u0111\u1ECBa ch\u1EC9.",
  "tokenizationForm.errors.onlyLetterOrNumbers": "Ca\u0301c ki\u0301 t\u01B0\u0323 chi\u0309 ch\u01B0\u0301a A-Z va\u0300 0-9",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": 'C\xE1c k\xFD t\u1EF1 h\u1EE3p l\u1EC7 ch\u1EC9 bao g\u1ED3m A-Z, 0-9 v\xE0 "/, -"',
  "tokenizationForm.errors.zip": "Zip kh\xF4ng h\u1EE3p l\u1EC7",
  "tokenizationForm.errors.expiryDate": "Nga\u0300y h\xEA\u0301t ha\u0323n kh\xF4ng h\u01A1\u0323p l\xEA\u0323",
  "bankAccountForm.errors.expiryDate": "Nga\u0300y h\xEA\u0301t ha\u0323n kh\xF4ng h\u01A1\u0323p l\xEA\u0323",
  "tokenizationForm.errors.surname": "H\u1ECD kh\xF4ng h\u1EE3p l\u1EC7",
  "tokenizationForm.errors.phone": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xF4ng h\u1EE3p l\u1EC7",
  "tokenizationForm.errors.length": "Tr\u01B0\u1EDDng qu\xE1 d\xE0i (t\u1ED1i \u0111a l\xE0 256 k\xFD t\u1EF1)",
  "bankAccountForm.errors.name": "T\xEAn kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.name.maxSizeExceeded": "T\xEAn qu\xE1 d\xE0i (t\u1ED1i \u0111a l\xE0 140 k\xFD t\u1EF1)",
  "form.errors.name.maxSizeExceeded": "T\xEAn qu\xE1 d\xE0i (t\u1ED1i \u0111a l\xE0 {{limit}} k\xFD t\u1EF1)",
  "form.errors.surname.maxSizeExceeded": "H\u1ECD qu\xE1 d\xE0i (t\u1ED1i \u0111a l\xE0 {{limit}} k\xFD t\u1EF1)",
  "form.errors.business_name.maxSizeExceeded": "T\xEAn doanh nghi\u1EC7p qu\xE1 d\xE0i (t\u1ED1i \u0111a l\xE0 {{limit}} k\xFD t\u1EF1)",
  "form.errors.city.maxSizeExceeded": "Th\xE0nh ph\u1ED1 qu\xE1 d\xE0i (t\u1ED1i \u0111a l\xE0 {{limit}} k\xFD t\u1EF1)",
  "form.errors.address.maxSizeExceeded": "\u0110\u1ECBa ch\u1EC9 qu\xE1 d\xE0i (t\u1ED1i \u0111a l\xE0 {{limit}} k\xFD t\u1EF1)",
  "bankAccountForm.errors.business_name": "T\xEAn doanh nghi\u1EC7p kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "T\xEAn doanh nghi\u1EC7p qu\xE1 d\xE0i (t\u1ED1i \u0111a l\xE0 140 k\xFD t\u1EF1)",
  "bankAccountForm.errors.surname": "H\u1ECD kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.surname.maxSizeExceeded": "H\u1ECD qu\xE1 d\xE0i (t\u1ED1i \u0111a l\xE0 140 k\xFD t\u1EF1)",
  "bankAccountForm.errors.country": "Qu\u1ED1c gia kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.address": "\u0110\u1ECBa ch\u1EC9 kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.address.maxSizeExceeded": "\u0110\u1ECBa ch\u1EC9 qu\xE1 d\xE0i (t\u1ED1i \u0111a l\xE0 256 k\xFD t\u1EF1)",
  "bankAccountForm.errors.city": "Th\xE0nh ph\u1ED1 kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.city.maxSizeExceeded": "Th\xE0nh ph\u1ED1 qu\xE1 d\xE0i (t\u1ED1i \u0111a l\xE0 256 k\xFD t\u1EF1)",
  "bankAccountForm.errors.email": "Email kh\xF4ng h\u01A1\u0323p l\xEA\u0323",
  "bankAccountForm.errors.state": "Ti\u1EC3u bang kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.iban": "IBAN kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.bic": "M\xE3 BIC kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.accountnumber": "S\u1ED1 t\xE0i kho\u1EA3n kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.sortcode": "M\xE3 s\u1EAFp x\u1EBFp ng\xE2n h\xE0ng kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.account_type": "Lo\u1EA1i t\xE0i kho\u1EA3n kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.addressIsPoBox": "Ch\xFAng t\xF4i kh\xF4ng ch\u1EA5p nh\u1EADn H\u1ED9p th\u01B0 b\u01B0u \u0111i\u1EC7n trong tr\u01B0\u1EDDng \u0111\u1ECBa ch\u1EC9.",
  "bankAccountForm.errors.onlyLetterOrNumbers": "Ca\u0301c ki\u0301 t\u01B0\u0323 chi\u0309 ch\u01B0\u0301a A-Z va\u0300 0-9",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "C\xE1c k\xFD t\u1EF1 h\u1EE3p l\u1EC7 l\xE0: A-Z 0-9 / , -",
  "bankAccountForm.errors.zip": "M\xE3 b\u01B0u ch\xEDnh kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.phone": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.ach_account_number": "S\u1ED1 t\xE0i kho\u1EA3n kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.routing_number": "S\u1ED1 \u0111\u1ECBnh tuy\u1EBFn kh\xF4ng h\u1EE3p l\u1EC7",
  "bankAccountForm.errors.offer": "Kh\xF4ng c\xF3 c\xE1c ph\u01B0\u01A1ng th\u1EE9c thanh to\xE1n - N\u1EBFu b\u1EA1n c\xF3 t\xE0i kho\u1EA3n ng\xE2n h\xE0ng \u1EDF m\u1ED9t qu\u1ED1c gia kh\xE1c, vui l\xF2ng ch\u1ECDn qu\u1ED1c gia n\xE0y ho\u1EB7c ch\u1ECDn m\u1ED9t th\u1EBB kh\xE1c v\xE0 th\u1EED l\u1EA1i. N\u1EBFu c\xE1ch n\xE0y kh\xF4ng gi\u1EA3i quy\u1EBFt \u0111\u01B0\u1EE3c s\u1EF1 c\u1ED1, vui l\xF2ng li\xEAn h\u1EC7 v\u1EDBi {{recipientName}}",
  "confirmationPage.labels.edit": "Ch\u1EC9nh s\u1EEDa",
  "confirmationPage.labels.confirm": "X\xE1c nh\u1EADn",
  "confirmationPage.labels.title": "Xem l\u1EA1i th\xF4ng tin u\u1EF7 nhi\u1EC7m",
  "confirmationPage.labels.typeOfPayment": "Lo\u1EA1i thanh to\xE1n",
  "confirmationPage.labels.paymentRecipient": "Ng\u01B0\u1EDDi nh\u1EADn thanh to\xE1n",
  "confirmationPage.labels.typeOfPayment.oneOff": "M\u1ED9t l\u1EA7n",
  "confirmationPage.labels.typeOfPayment.recurring": "\u0110\u1ECBnh k\u1EF3",
  "confirmationPage.labels.directDebitInformation": "Th\xF4ng tin ghi n\u1EE3 tr\u1EF1c ti\u1EBFp",
  "confirmationPage.labels.directDebitInformation.title": "Ch\u1EC9 d\u1EABn cho ng\xE2n h\xE0ng c\u1EE7a b\u1EA1n",
  "confirmationPage.labels.directDebitInformation.creditor": "B\xEAn th\u1EE5 h\u01B0\u1EDFng",
  "confirmationPage.labels.directDebitInformation.creditorId": "ID B\xEAn th\u1EE5 h\u01B0\u1EDFng",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "T\xEAn trong b\u1EA3ng sao k\xEA c\u1EE7a b\u1EA1n",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "ID ng\u01B0\u1EDDi d\xF9ng d\u1ECBch v\u1EE5",
  "confirmationPage.labels.directDebitInformation.address": "\u0110\u1ECBa ch\u1EC9 Flywire",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "ID c\u1EE7a Originator",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "\u0110\u1ECBa ch\u1EC9 c\u1EE7a Originator",
  "confirmationPage.labels.bankAccountInformation": "Th\xF4ng tin t\xE0i kho\u1EA3n ng\xE2n h\xE0ng",
  "confirmationPage.labels.bankAccountInformation.name": "T\xEAn",
  "confirmationPage.labels.bankAccountInformation.iban": "S\u1ED1 IBAN",
  "confirmationPage.labels.bankAccountInformation.email": "Email",
  "confirmationPage.labels.bankAccountInformation.country": "Qu\u1ED1c gia",
  "confirmationPage.labels.bankAccountInformation.state": "Nh\xE0 n\u01B0\u1EDBc",
  "confirmationPage.labels.bankAccountInformation.city": "Th\xE0nh ph\u1ED1",
  "confirmationPage.labels.bankAccountInformation.bicCode": "M\xE3 BIC",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "S\u1ED1 t\xE0i kho\u1EA3n",
  "confirmationPage.labels.bankAccountInformation.sortCode": "M\xE3 s\u1EAFp x\u1EBFp ng\xE2n h\xE0ng",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "S\u1ED1 t\xE0i kho\u1EA3n",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "S\u1ED1 \u0111\u1ECBnh tuy\u1EBFn",
  "confirmationPage.labels.bankAccountInformation.accountType": "Lo\u1EA1i t\xE0i kho\u1EA3n",
  "confirmationPage.labels.changeAccountEft": "Thay \u0111\u1ED5i th\xF4ng tin t\xE0i kho\u1EA3n ng\xE2n h\xE0ng",
  "confirmationPage.labels.editPayerEft": "Ch\u1EC9nh s\u1EEDa th\xF4ng tin ng\u01B0\u1EDDi tr\u1EA3 ti\u1EC1n",
  "confirmationPage.labels.useAccountEft": "S\u1EED d\u1EE5ng T\xE0i kho\u1EA3n k\u1EBFt th\xFAc b\u1EB1ng **** {{lastFour}}",
  "confirmationPage.labels.termsSepa": "B\u1EB1ng c\xE1ch k\xFD v\xE0o m\u1EABu u\u1EF7 nhi\u1EC7m n\xE0y, b\u1EA1n u\u1EF7 quy\u1EC1n cho (A) FLYWIRE EUROPE UAB g\u1EEDi c\xE1c ch\u1EC9 th\u1ECB t\u1EDBi ng\xE2n h\xE0ng c\u1EE7a b\u1EA1n \u0111\u1EC3 tr\xEDch n\u1EE3 t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n v\xE0 \u1EE7y quy\u1EC1n cho (B) ng\xE2n h\xE0ng c\u1EE7a b\u1EA1n \u0111\u1EC3 tr\xEDch n\u1EE3 t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n ph\xF9 h\u1EE3p v\u1EDBi c\xE1c ch\u1EC9 th\u1ECB t\u1EEB FLYWIRE EUROPE UAB. B\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c th\xF4ng b\xE1o \xEDt nh\u1EA5t 3 ng\xE0y tr\u01B0\u1EDBc khi b\u1ECB t\xEDnh ph\xED.",
  "confirmationPage.labels.termsBacs": "H\u01B0\u1EDBng d\u1EABn ng\xE2n h\xE0ng c\u1EE7a b\u1EA1n thanh to\xE1n Kho\u1EA3n n\u1EE3 Tr\u1EF1c ti\u1EBFp c\xF3 Gi\u1EDBi h\u1EA1n c\u1EE7a Flywire t\u1EEB t\xE0i kho\u1EA3n \u0111\u01B0\u1EE3c n\xEAu chi ti\u1EBFt trong h\u01B0\u1EDBng d\u1EABn n\xE0y theo c\xE1c bi\u1EC7n ph\xE1p b\u1EA3o v\u1EC7 \u0111\u01B0\u1EE3c \u0111\u1EA3m b\u1EA3o b\u1EDFi \u0110\u1EA3m b\u1EA3o Ghi n\u1EE3 Tr\u1EF1c ti\u1EBFp. T\xF4i hi\u1EC3u r\u1EB1ng h\u01B0\u1EDBng d\u1EABn n\xE0y c\xF3 th\u1EC3 v\u1EABn c\xF2n v\u1EDBi Thanh to\xE1n Flywire Gi\u1EDBi h\u1EA1n v\xE0, n\u1EBFu v\u1EADy, th\xF4ng tin chi ti\u1EBFt s\u1EBD \u0111\u01B0\u1EE3c chuy\u1EC3n qua \u0111i\u1EC7n t\u1EED \u0111\u1EBFn ng\xE2n h\xE0ng/ng\xE2n h\xE0ng ph\xE1t tri\u1EC3n gia c\u01B0 c\u1EE7a t\xF4i.",
  "confirmationPage.labels.termsAch": '\n     B\u1EB1ng c\xE1ch nh\u1EA5p v\xE0o "X\xE1c nh\u1EADn", b\u1EA1n x\xE1c nh\u1EADn r\u1EB1ng b\u1EA1n c\xF3 th\u1EA9m quy\u1EC1n th\xEDch h\u1EE3p v\xE0 \u1EE7y quy\u1EC1n cho Flywire thay m\u1EB7t cho ng\u01B0\u1EDDi nh\u1EADn \u0111\u01B0\u1EE3c ch\u1EC9 \u0111\u1ECBnh \n     ("Ng\u01B0\u1EDDi nh\u1EADn thanh to\xE1n") \u0111\u1EC3 ghi n\u1EE3 t\xE0i kho\u1EA3n ng\xE2n h\xE0ng do b\u1EA1n cung c\u1EA5p cho b\u1EA5t k\u1EF3 s\u1ED1 ti\u1EC1n n\xE0o c\xF2n n\u1EE3 \u0111\u1ED1i v\u1EDBi c\xE1c kho\u1EA3n ph\xED ph\xE1t sinh t\u1EEB vi\u1EC7c b\u1EA1n s\u1EED d\u1EE5ng c\xE1c d\u1ECBch v\u1EE5 c\u1EE7a Ng\u01B0\u1EDDi nh\u1EADn thanh to\xE1n \n     v\xE0 / ho\u1EB7c mua s\u1EA3n ph\u1EA9m t\u1EEB Ng\u01B0\u1EDDi nh\u1EADn thanh to\xE1n, v\xE0 n\u1EBFu c\u1EA7n, \u0111\u1EC3 s\u1EEDa c\xE1c kho\u1EA3n ghi n\u1EE3 sai, theo c\xE1c \u0111i\u1EC1u kho\u1EA3n c\u1EE7a Ng\u01B0\u1EDDi nh\u1EADn thanh to\xE1n, cho \u0111\u1EBFn khi \n     \u1EE7y quy\u1EC1n n\xE0y b\u1ECB h\u1EE7y b\u1ECF. Trong tr\u01B0\u1EDDng h\u1EE3p giao d\u1ECBch ACH b\u1ECB t\u1EEB ch\u1ED1i v\xEC kh\xF4ng \u0111\u1EE7 ti\u1EC1n, t\xF4i hi\u1EC3u r\u1EB1ng t\xF4i s\u1EBD b\u1ECB t\xEDnh \n ph\xED NSF v\xE0 Flywire c\xF3 th\u1EC3 theo quy\u1EBFt \u0111\u1ECBnh c\u1EE7a m\xECnh \u0111\u1EC3 x\u1EED l\xFD l\u1EA1i kho\u1EA3n ph\xED.\n     ',
  "confirmationPage.labels.termsAch2": "\n     N\u1EBFu b\u1EA1n s\u1EED d\u1EE5ng ho\u1EB7c mua c\xE1c s\u1EA3n ph\u1EA9m v\xE0/ho\u1EB7c d\u1ECBch v\u1EE5 b\u1ED5 sung c\u1EE7a Ng\u01B0\u1EDDi nh\u1EADn thanh to\xE1n theo \u0111\u1ECBnh k\u1EF3, theo c\xE1c \u0111i\u1EC1u kho\u1EA3n c\u1EE7a Ng\u01B0\u1EDDi nh\u1EADn thanh to\xE1n, b\u1EA1n \u1EE7y quy\u1EC1n \n     Flywire, thay m\u1EB7t cho Ng\u01B0\u1EDDi nh\u1EADn thanh to\xE1n, ghi n\u1EE3 \u0111\u1ECBnh k\u1EF3 v\xE0o t\xE0i kho\u1EA3n ng\xE2n h\xE0ng do b\u1EA1n cung c\u1EA5p. C\xE1c kho\u1EA3n thanh to\xE1n n\u1EB1m ngo\xE0i kho\u1EA3n ghi n\u1EE3 \n     \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n \u1EDF tr\xEAn s\u1EBD ch\u1EC9 \u0111\u01B0\u1EE3c ghi n\u1EE3 sau khi \u1EE7y quy\u1EC1n c\u1EE7a b\u1EA1n \u0111\u01B0\u1EE3c l\u1EA5y qua t\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n ho\u1EB7c m\u1EADt kh\u1EA9u, m\xE3 ho\u1EB7c \n     ch\u1EEF k\xFD t\u01B0\u01A1ng \u0111\u01B0\u01A1ng.\n     ",
  "confirmationPage.labels.termsAch3": "\n     B\u1EA1n c\xF3 th\u1EC3 h\u1EE7y b\u1ECF \u1EE7y quy\u1EC1n n\xE0y b\u1EA5t k\u1EF3 l\xFAc n\xE0o b\u1EB1ng c\xE1ch li\xEAn h\u1EC7 v\u1EDBi Ng\u01B0\u1EDDi nh\u1EADn thanh to\xE1n. Y\xEAu c\u1EA7u h\u1EE7y b\u1ECF c\u1EE7a b\u1EA1n ph\u1EA3i \u0111\u01B0\u1EE3c nh\u1EADn \xEDt nh\u1EA5t [10 ng\xE0y l\xE0m vi\u1EC7c] \n tr\u01B0\u1EDBc l\u1EA7n thanh to\xE1n theo l\u1ECBch ti\u1EBFp theo.\n    ",
  "confirmationPage.labels.print": "In th\u1ECFa thu\u1EADn",
  "amountPanel.labels.amountFromLabel": "B\u1EA1n s\u1EBD thanh to\xE1n",
  "amountPanel.labels.surchargeFeeInfo": "\u0111\xE3 bao g\u1ED3m ph\xED th\u1EBB.",
  "amountPanel.labels.whyThisFee": "V\xEC sao thu ph\xED n\xE0y?",
  "amountPanel.labels.whyThisFeeTooltip": "\n  Ph\xED th\u1EBB {{percentage}} % n\u1EBFu b\u1EA1n ti\u1EBFn h\xE0nh thanh to\xE1n. \u0110\u01A1n v\u1ECB ti\u1EC1n tr\xEAn th\u1EBB {{cardScheme}} c\u1EE7a b\u1EA1n l\xE0 {{currency}}. Vui l\xF2ng ch\u1ECDn th\u1EBB ho\u1EB7c qu\u1ED1c gia ph\xF9 h\u1EE3p v\u1EDBi th\u1EBB c\u1EE7a b\u1EA1n \u0111\u1EC3 tr\xE1nh ph\u1EA3i tr\u1EA3 th\xEAm ph\xED.\n     ",
  "amountPanel.labels.currencyChangeWarning": "Ti\u1EC1n t\u1EC7 \u0111\xE3 thay \u0111\u1ED5i \u0111\u1EC3 ph\xF9 h\u1EE3p v\u1EDBi \u0111\u01A1n v\u1ECB ti\u1EC1n t\u1EC7 th\u1EBB c\u1EE7a b\u1EA1n",
  "amountPanel.labels.amountToLabel": "{{recipientName}} s\u1EBD nh\u1EADn",
  AX: "Qu\u1EA7n \u0111\u1EA3o \xC5land",
  AD: "Andorra",
  BG: "Bulgaria",
  AT: "\xC1o",
  BE: "B\u1EC9",
  HR: "Croatia",
  CY: "\u0110\u1EA3o S\xEDp",
  CZ: "C\u1ED9ng ho\xE0 S\xE9c",
  DK: "\u0110an M\u1EA1ch",
  EE: "Estonia",
  FI: "Ph\u1EA7n Lan",
  FR: "Ph\xE1p",
  GP: "Guadeloupe",
  DE: "\u0110\u1EE9c",
  GR: "Hy L\u1EA1p",
  HU: "Hungary",
  IS: "Iceland",
  IE: "Ireland",
  VA: "Holy See (Th\xE0nh qu\u1ED1c Vatican)",
  IT: "\xDD",
  LI: "Liechtenstein",
  LT: "Litva",
  LU: "Luxembourg",
  YT: "Mayotte",
  MT: "Malta",
  MQ: "Martinique",
  ES: "T\xE2y Ban Nha",
  NO: "Na Uy",
  NL: "H\xE0 Lan",
  PL: "Ba Lan",
  PT: "B\u1ED3 \u0110\xE0o Nha",
  SE: "Th\u1EE5y \u0110i\u1EC3n",
  RE: "R\xE9union",
  RO: "Romania",
  CH: "Th\u1EE5y S\u0129",
  BL: "Saint Barth\xE9lemy",
  GB: "V\u01B0\u01A1ng qu\u1ED1c Anh",
  MC: "Monaco",
  MF: "Saint Martin (thu\u1ED9c Ph\xE1p)",
  PM: "Saint Pierre v\xE0 Miquelon",
  SM: "San Marino",
  SK: "Slovakia",
  SI: "Slovenia",
  GF: "Guyane thu\u1ED9c Ph\xE1p",
  LV: "Latvia",
  CA: "Canada",
  US: "Hoa K\u1EF3",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/locales/zh-CN.ts
var zh = {
  "session_expired.title": "\u4F1A\u8BDD\u5DF2\u8FC7\u671F",
  "tokenizationForm.payment-terms.text1": "\u6211\u6388\u6743\u98DE\u6C47\u4EE3\u8868\u201C{{recipientName}}\u201D\u81EA\u52A8\u5B58\u50A8\u6211\u7684\u501F\u8BB0\u5361/\u4FE1\u7528\u5361\u4FE1\u606F\u5E76\u5728\u6211\u7684\u501F\u8BB0\u5361/\u4FE1\u7528\u5361\u4E2D\u81EA\u52A8\u6263\u6B3E\u3002\u6211\u5DF2\u9605\u8BFB\u3001\u7406\u89E3\u5E76\u540C\u610F\u9075\u5B88",
  "tokenizationForm.general-terms.link2": "\u9690\u79C1\u653F\u7B56",
  "tokenizationForm.general-terms.link-joint": " \u548C ",
  "tokenizationForm.general-terms.link1": "\u4F7F\u7528\u6761\u6B3E",
  "tokenizationForm.payment-terms.link": "\u98DE\u6C47\u7684\u81EA\u52A8\u4ED8\u6B3E\u4F7F\u7528\u6761\u6B3E",
  "tokenizationForm.labels.cvvTooltip": "\u5361\u80CC\u9762\u7684 3 \u4F4D\u6570\u5B57\u6216\u6B63\u9762\u7684 4 \u4F4D\u6570\u5B57",
  "tokenizationForm.labels.cvv": "CVV",
  "tokenizationForm.labels.expiryDate": "\u5230\u671F\u65E5 (MM/YY)",
  "tokenizationForm.labels.cardNumber": "\u5361\u53F7",
  "tokenizationForm.labels.phone": "\u7535\u8BDD\u53F7\u7801",
  "tokenizationForm.labels.zip": "\u90AE\u653F\u7F16\u7801",
  "tokenizationForm.labels.address": "\u5730\u5740",
  "cardsForm.labels.state": "\u72B6\u6001",
  "tokenizationForm.labels.country": "\u56FD\u5BB6/\u5730\u533A",
  "tokenizationForm.labels.city": "\u57CE\u5E02",
  "tokenizationForm.labels.email": "\u90AE\u7BB1",
  "tokenizationForm.labels.lastName": "\u59D3",
  "tokenizationForm.labels.firstName": "\u540D",
  "tokenizationForm.labels.dynamicFields.document": "CPF \u6216 CNPJ \u53F7\u7801",
  "cardsForm.title": "\u6301\u5361\u4EBA\u4FE1\u606F",
  "success.title": "\u6B3E\u9879\u5728\u9014",
  "success.title.info": "\u8D44\u91D1\u5230\u8D26\u9700\u8981 2-3 \u4E2A\u5DE5\u4F5C\u65E5\u3002\n\u5230\u8D26\u540E\uFF0C\u60A8\u4F1A\u6536\u5230\u4E00\u5C01\u7535\u5B50\u90AE\u4EF6\u3002",
  "bankAccountForm.hints.generic": "\u4F8B\u5982\uFF1A{{label}}",
  "bankAccountForm.hints.account_number": "\u94F6\u884C\u8D26\u53F7\u957F\u5EA6\u5FC5\u987B\u4ECB\u4E8E 1 \u5230 17 \u4E2A\u5B57\u7B26\u4E4B\u95F4",
  "bankAccountForm.hints.routing_number": "\u6536\u6B3E\u884C\u6E05\u7B97\u53F7\u957F\u5EA6\u5FC5\u987B\u4E3A 9 \u4F4D\u6570\u5B57",
  "bankAccountForm.labels.accountZipCode": "\u90AE\u653F\u7F16\u7801",
  "bankAccountForm.labels.accountIban": "IBAN",
  "bankAccountForm.labels.accountBicCode": "BIC \u4EE3\u7801",
  "bankAccountForm.labels.accountNumber": "\u94F6\u884C\u8D26\u53F7",
  "bankAccountForm.labels.accountSortCode": "\u6E05\u7B97\u4EE3\u7801",
  "bankAccountForm.labels.accountRoutingNumber": "\u6536\u6B3E\u884C\u6E05\u7B97\u53F7",
  "bankAccountForm.labels.accountType": "\u8D26\u6237\u7C7B\u578B",
  "bankAccountForm.labels.eftProviderWidnow": "\u60A8\u5C06\u8DF3\u8F6C\u5230\u6211\u4EEC\u5408\u4F5C\u4F19\u4F34\u7684\u5904\u7406\u5E73\u53F0\u5B8C\u6210\u6B64\u4ED8\u6B3E\u3002\u5B8C\u6210\u4E4B\u540E\uFF0C\u60A8\u4F1A\u518D\u6B21\u56DE\u5230\u672C\u9875\u9762",
  "bankAccountForm.labels.termsFlywire": "\u6211\u5DF2\u9605\u8BFB\u3001\u7406\u89E3\u5E76\u540C\u610F\u98DE\u6C47<a class='Link' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>\u4F7F\u7528\u6761\u6B3E</a>\u548C<a class='Link' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>\u9690\u79C1\u653F\u7B56</a>",
  "bankAccountForm.labels.termsDirectDebit": "\u6211\u786E\u8BA4\uFF0C\u672C\u4EBA\u662F\u6B64\u8D26\u6237\u7684\u6240\u6709\u8005\u5E76\u4E14\u662F\u6388\u6743\u6B64\u8D37\u8BB0/\u501F\u8BB0\u6240\u9700\u7684\u552F\u4E00\u7B7E\u5B57\u4EBA",
  "bankAccountForm.labels.termsEft": "\u6211\u5DF2\u9605\u8BFB\u3001\u7406\u89E3\u5E76\u540C\u610F<a class='Link' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>\u9884\u6388\u6743\u501F\u8BB0\u534F\u8BAE</a>",
  "bankAccountForm.labels.city": "\u57CE\u5E02",
  "bankAccountForm.labels.country": "\u56FD\u5BB6/\u5730\u533A",
  "bankAccountForm.labels.selectCountry": "\u9009\u62E9\u56FD\u5BB6/\u5730\u533A",
  "bankAccountForm.title": "\u8D26\u6237\u6301\u6709\u4EBA\u4FE1\u606F",
  "failure.tryAgain": "\u91CD\u8BD5",
  "failure.title": "\u4EA4\u6613\u5931\u8D25",
  "failure.connectivity.message": "\u64CD\u4F5C\u5931\u8D25\uFF0C\u8FD9\u53EF\u80FD\u662F\u7531\u4E8E\u67D0\u4E9B\u8FDE\u63A5\u95EE\u9898\u5BFC\u81F4\u7684\u3002",
  "failure.message": "\u4EA4\u6613\u5931\u8D25\u3002\u8FD9\u53EF\u80FD\u662F\u7531\u4E8E\u8FDE\u63A5\u95EE\u9898\u3002\u8BF7\u91CD\u8BD5\u3002\u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u5C1D\u8BD5\u5176\u4ED6\u652F\u4ED8\u65B9\u5F0F\u6216\u8054\u7CFB\u60A8\u7684\u94F6\u884C",
  "sessionExpired.text": "\u4F1A\u8BDD\u5DF2\u8FC7\u671F",
  "LoadingError.title": "\u51FA\u73B0\u4E86\u9519\u8BEF",
  "LoadingError.message": "\u52A0\u8F7D\u8868\u5355\u65F6\u51FA\u9519",
  "tokenizationForm.errors.noPaymentOptionsAvailable": "\u6240\u9009\u56FD\u5BB6/\u5730\u533A\u6CA1\u6709\u53EF\u7528\u7684\u4ED8\u6B3E\u65B9\u5F0F",
  "bankAccountForm.labels.accountHolderType.personal": "\u4E2A\u4EBA\u8D26\u6237",
  "bankAccountForm.labels.accountHolderType.business": "\u4F01\u4E1A\u8D26\u6237",
  "bankAccountForm.labels.name": "\u540D",
  "bankAccountForm.labels.businessName": "\u4F01\u4E1A\u540D\u79F0",
  "bankAccountForm.labels.surname": "\u59D3",
  "bankAccountForm.labels.phone": "\u7535\u8BDD\u53F7\u7801",
  "bankAccountForm.labels.email": "\u90AE\u7BB1",
  "bankAccountForm.labels.zip": "\u90AE\u653F\u7F16\u7801",
  "bankAccountForm.labels.accountAddress": "\u5730\u5740",
  "bankAccountForm.labels.address": "\u5730\u5740",
  "bankAccountForm.errors.dynamicFields": "\u65E0\u6548\u7684 {{field}}",
  "bankAccountForm.errors.dynamicFields.document": "CPF \u6216 CNPJ \u53F7\u7801\u65E0\u6548",
  "bankAccountForm.errors.dynamicFields.documentPattern": "\u8BF7\u6CE8\u660E\u60A8\u7684 CPF/CNPJ \u53F7\u7801\uFF0C\u4E0D\u5F97\u4F7F\u7528\u8FDE\u5B57\u7B26\u6216\u7834\u6298\u53F7",
  "bankAccountForm.labels.saveButton": "\u4FDD\u5B58",
  "bankAccountForm.labels.nextButton": "\u4E0B\u4E00\u6B65",
  "bankAccountForm.labels.payButton": "\u652F\u4ED8",
  "bankAccountForm.errors.cardNumber": "\u5361\u53F7\u65E0\u6548",
  "tokenizationForm.errors.cardNumber": "\u5361\u53F7\u65E0\u6548",
  "tokenizationForm.errors.cvv": "CVV \u53F7\u7801\u65E0\u6548",
  "bankAccountForm.errors.cvv": "CVV \u53F7\u7801\u65E0\u6548",
  "tokenizationForm.errors.unsupportedCardTypes": "\u4EC5\u652F\u6301{{acceptedCardsList}}",
  "tokenizationForm.errors.unsupportedCardType": "\u4EC5\u652F\u6301 {{acceptedCard}}",
  "tokenizationForm.errors.cardType.and": "\u548C",
  "tokenizationForm.errors.name": "\u540D\u65E0\u6548",
  "tokenizationForm.errors.email": "\u7535\u5B50\u90AE\u4EF6\u65E0\u6548",
  "tokenizationForm.errors.country": "\u56FD\u5BB6/\u5730\u533A\u65E0\u6548",
  "tokenizationForm.errors.state": "\u65E0\u6548\u7684\u7701/\u76F4\u8F96\u5E02/\u81EA\u6CBB\u533A",
  "tokenizationForm.errors.city": "\u57CE\u5E02\u65E0\u6548",
  "tokenizationForm.errors.address": "\u5730\u5740\u65E0\u6548",
  "tokenizationForm.errors.addressIsPoBox": "\u5730\u5740\u680F\u4E2D\u4E0D\u80FD\u586B\u5199\u90AE\u653F\u4FE1\u7BB1\u3002",
  "tokenizationForm.errors.onlyLetterOrNumbers": "\u6709\u6548\u5B57\u7B26\u4EC5\u5305\u62EC A-Z \u548C 0-9",
  "tokenizationForm.errors.onlyLetterOrNumbersOrSymbol": "\u6709\u6548\u5B57\u7B26\u4EC5\u5305\u62EC A-Z\u30010-9 \u4EE5\u53CA / \u548C -",
  "tokenizationForm.errors.zip": "\u65E0\u6548\u7684\u90AE\u7F16",
  "tokenizationForm.errors.expiryDate": "\u5230\u671F\u65E5\u65E0\u6548",
  "bankAccountForm.errors.expiryDate": "\u5230\u671F\u65E5\u65E0\u6548",
  "tokenizationForm.errors.surname": "\u59D3\u6C0F\u65E0\u6548",
  "tokenizationForm.errors.phone": "\u7535\u8BDD\u53F7\u7801\u65E0\u6548",
  "tokenizationForm.errors.length": "\u5B57\u6BB5\u592A\u957F\uFF08\u6700\u591A 256 \u4E2A\u5B57\u7B26\uFF09",
  "bankAccountForm.errors.name": "\u540D\u65E0\u6548",
  "bankAccountForm.errors.name.maxSizeExceeded": "\u540D\u5B57\u592A\u957F\uFF08\u6700\u591A 140 \u4E2A\u5B57\u7B26\uFF09",
  "form.errors.name.maxSizeExceeded": "\u540D\u5B57\u592A\u957F\uFF08\u6700\u591A {{limit}} \u4E2A\u5B57\u7B26\uFF09",
  "form.errors.surname.maxSizeExceeded": "\u59D3\u6C0F\u592A\u957F\uFF08\u6700\u591A {{limit}} \u4E2A\u5B57\u7B26\uFF09",
  "form.errors.business_name.maxSizeExceeded": "\u4F01\u4E1A\u540D\u79F0\u592A\u957F\uFF08\u6700\u591A {{limit}} \u4E2A\u5B57\u7B26\uFF09",
  "form.errors.city.maxSizeExceeded": "\u57CE\u5E02\u592A\u957F\uFF08\u6700\u591A {{limit}} \u4E2A\u5B57\u7B26\uFF09",
  "form.errors.address.maxSizeExceeded": "\u5730\u5740\u592A\u957F\uFF08\u6700\u591A {{limit}} \u4E2A\u5B57\u7B26\uFF09",
  "bankAccountForm.errors.business_name": "\u4F01\u4E1A\u540D\u79F0\u65E0\u6548",
  "bankAccountForm.errors.business_name.maxSizeExceeded": "\u4F01\u4E1A\u540D\u79F0\u592A\u957F\uFF08\u6700\u591A 140 \u4E2A\u5B57\u7B26\uFF09",
  "bankAccountForm.errors.surname": "\u59D3\u65E0\u6548",
  "bankAccountForm.errors.surname.maxSizeExceeded": "\u59D3\u6C0F\u592A\u957F\uFF08\u6700\u591A 140 \u4E2A\u5B57\u7B26\uFF09",
  "bankAccountForm.errors.country": "\u56FD\u5BB6/\u5730\u533A\u65E0\u6548",
  "bankAccountForm.errors.address": "\u5730\u5740\u65E0\u6548",
  "bankAccountForm.errors.address.maxSizeExceeded": "\u5730\u5740\u592A\u957F\uFF08\u6700\u591A 256 \u4E2A\u5B57\u7B26\uFF09",
  "bankAccountForm.errors.city": "\u57CE\u5E02\u65E0\u6548",
  "bankAccountForm.errors.city.maxSizeExceeded": "\u57CE\u5E02\u592A\u957F\uFF08\u6700\u591A 256 \u4E2A\u5B57\u7B26\uFF09",
  "bankAccountForm.errors.email": "\u7535\u5B50\u90AE\u4EF6\u65E0\u6548",
  "bankAccountForm.errors.state": "\u65E0\u6548\u7684\u7701/\u76F4\u8F96\u5E02/\u81EA\u6CBB\u533A",
  "bankAccountForm.errors.iban": "IBAN \u65E0\u6548",
  "bankAccountForm.errors.bic": "BIC \u4EE3\u7801\u65E0\u6548",
  "bankAccountForm.errors.accountnumber": "\u94F6\u884C\u8D26\u53F7\u65E0\u6548",
  "bankAccountForm.errors.sortcode": "\u6E05\u7B97\u4EE3\u7801\u65E0\u6548",
  "bankAccountForm.errors.account_type": "\u8D26\u6237\u7C7B\u578B\u65E0\u6548",
  "bankAccountForm.errors.addressIsPoBox": "\u5730\u5740\u680F\u4E2D\u4E0D\u80FD\u586B\u5199\u90AE\u653F\u4FE1\u7BB1\u3002",
  "bankAccountForm.errors.onlyLetterOrNumbers": "\u6709\u6548\u5B57\u7B26\u4EC5\u5305\u62EC A-Z \u548C 0-9",
  "bankAccountForm.errors.onlyLetterOrNumberOrSymbol": "\u6709\u6548\u5B57\u7B26\u5305\u62EC\uFF1AA-Z 0-9 / \uFF0C -",
  "bankAccountForm.errors.zip": "\u90AE\u653F\u7F16\u7801\u65E0\u6548",
  "bankAccountForm.errors.phone": "\u7535\u8BDD\u53F7\u7801\u65E0\u6548",
  "bankAccountForm.errors.ach_account_number": "\u94F6\u884C\u8D26\u53F7\u65E0\u6548",
  "bankAccountForm.errors.routing_number": "\u6536\u6B3E\u884C\u6E05\u7B97\u53F7\u65E0\u6548",
  "bankAccountForm.errors.offer": "\u6CA1\u6709\u53EF\u7528\u7684\u4ED8\u6B3E\u65B9\u5F0F - \u5982\u679C\u60A8\u5728\u5176\u4ED6\u56FD\u5BB6/\u5730\u533A\u62E5\u6709\u94F6\u884C\u8D26\u6237\uFF0C\u8BF7\u9009\u62E9\u8BE5\u56FD\u5BB6/\u5730\u533A\u6216\u9009\u62E9\u5176\u4ED6\u5361\u5E76\u91CD\u8BD5\u3002\u5982\u679C\u4ECD\u7136\u65E0\u6CD5\u89E3\u51B3\u6B64\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB {{recipientName}}",
  "confirmationPage.labels.edit": "\u7F16\u8F91",
  "confirmationPage.labels.confirm": "\u786E\u8BA4",
  "confirmationPage.labels.title": "\u68C0\u67E5\u5FC5\u586B\u4FE1\u606F",
  "confirmationPage.labels.typeOfPayment": "\u4ED8\u6B3E\u7C7B\u578B",
  "confirmationPage.labels.paymentRecipient": "\u6536\u6B3E\u4EBA",
  "confirmationPage.labels.typeOfPayment.oneOff": "\u4E00\u6B21\u6027",
  "confirmationPage.labels.typeOfPayment.recurring": "\u7ECF\u5E38\u6027",
  "confirmationPage.labels.directDebitInformation": "\u76F4\u63A5\u6263\u6B3E\u4FE1\u606F",
  "confirmationPage.labels.directDebitInformation.title": "\u5173\u4E8E\u94F6\u884C\u7684\u8BF4\u660E",
  "confirmationPage.labels.directDebitInformation.creditor": "\u6536\u6B3E\u4EBA",
  "confirmationPage.labels.directDebitInformation.creditorId": "\u6536\u6B3E\u4EBA ID",
  "confirmationPage.labels.directDebitInformation.serviceUserStatement": "\u5BF9\u8D26\u5355\u4E2D\u7684\u59D3\u540D",
  "confirmationPage.labels.directDebitInformation.serviceUserId": "\u670D\u52A1\u7528\u6237 ID",
  "confirmationPage.labels.directDebitInformation.address": "\u98DE\u6C47\u5730\u5740",
  "confirmationPage.labels.directDebitInformation.originator": "Originator",
  "confirmationPage.labels.directDebitInformation.originatorId": "Originator ID",
  "confirmationPage.labels.directDebitInformation.originatorAddress": "Originator \u5730\u5740",
  "confirmationPage.labels.bankAccountInformation": "\u94F6\u884C\u8D26\u6237\u4FE1\u606F",
  "confirmationPage.labels.bankAccountInformation.name": "\u59D3\u540D",
  "confirmationPage.labels.bankAccountInformation.iban": "IBAN \u7F16\u53F7",
  "confirmationPage.labels.bankAccountInformation.email": "\u90AE\u7BB1",
  "confirmationPage.labels.bankAccountInformation.country": "\u56FD\u5BB6/\u5730\u533A",
  "confirmationPage.labels.bankAccountInformation.state": "\u72B6\u6001",
  "confirmationPage.labels.bankAccountInformation.city": "\u57CE\u5E02",
  "confirmationPage.labels.bankAccountInformation.bicCode": "BIC \u4EE3\u7801",
  "confirmationPage.labels.bankAccountInformation.accountNumber": "\u94F6\u884C\u8D26\u53F7",
  "confirmationPage.labels.bankAccountInformation.sortCode": "\u6E05\u7B97\u4EE3\u7801",
  "confirmationPage.labels.bankAccountInformation.achAccountNumber": "\u94F6\u884C\u8D26\u53F7",
  "confirmationPage.labels.bankAccountInformation.routingNumber": "\u6536\u6B3E\u884C\u6E05\u7B97\u53F7",
  "confirmationPage.labels.bankAccountInformation.accountType": "\u8D26\u6237\u7C7B\u578B",
  "confirmationPage.labels.changeAccountEft": "\u66F4\u6539\u94F6\u884C\u8D26\u6237\u8BE6\u7EC6\u4FE1\u606F",
  "confirmationPage.labels.editPayerEft": "\u7F16\u8F91\u4ED8\u6B3E\u4EBA\u8BE6\u7EC6\u4FE1\u606F",
  "confirmationPage.labels.useAccountEft": "\u4F7F\u7528\u4EE5 **** {{lastFour}} \u7ED3\u5C3E\u7684\u8D26\u6237",
  "confirmationPage.labels.termsSepa": "\u7B7E\u7F72\u6B64\u6388\u6743\u4E66\u5373\u8868\u793A\uFF0C\u60A8\u6388\u6743 (A) FLYWIRE EUROPE UAB \u5411\u60A8\u7684\u94F6\u884C\u53D1\u9001\u6263\u6B3E\u8BF4\u660E\uFF0C\u5E76\u6388\u6743 (B) \u60A8\u7684\u94F6\u884C\u6839\u636E FLYWIRE EUROPE UAB \u7684\u8BF4\u660E\u4ECE\u60A8\u7684\u8D26\u6237\u6263\u6B3E\u3002\u60A8\u4F1A\u5728\u6263\u6B3E\u524D\u81F3\u5C11 3 \u5929\u83B7\u5F97\u901A\u77E5\u3002",
  "confirmationPage.labels.termsBacs": "\u6307\u793A\u60A8\u7684\u94F6\u884C\u4ECE\u672C\u8BF4\u660E\u6240\u5217\u8D26\u6237\u76F4\u63A5\u6263\u6B3E\uFF0C\u7528\u4EE5\u652F\u4ED8\u98DE\u6C47\u4ED8\u6B3E\u4E13\u7528\u76F4\u63A5\u6263\u6B3E\u7684\u8D39\u7528\uFF0C\u4F46\u987B\u9075\u5B88\u76F4\u63A5\u6263\u6B3E\u62C5\u4FDD\u7684\u4FDD\u969C\u63AA\u65BD\u3002\u6211\u4E86\u89E3\uFF0C\u6B64\u8BF4\u660E\u53EF\u80FD\u7531 Flywire Payments Limited \u4FDD\u7BA1\uFF0C\u5982\u679C\u8FD9\u6837\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u5C06\u4EE5\u7535\u5B50\u65B9\u5F0F\u4F20\u9012\u7ED9\u6211\u7684\u94F6\u884C/\u5EFA\u623F\u4E92\u52A9\u534F\u4F1A\u3002",
  "confirmationPage.labels.termsAch": "\n     \u70B9\u51FB\u201C\u786E\u8BA4\u201D\uFF0C\u5373\u8868\u793A\u60A8\u786E\u8BA4\u60A8\u6709\u9002\u5F53\u6743\u9650\uFF0C\u5E76\u7279\u6B64\u6388\u6743\u98DE\u6C47\u4EE3\u8868\u6307\u5B9A\u63A5\u6536\u4EBA\n\uFF08\u201C\u6536\u6B3E\u4EBA\u201D\uFF09\u4ECE\u60A8\u7684\u94F6\u884C\u8D26\u6237\u6263\u9664\u56E0\u60A8\u4F7F\u7528\u6536\u6B3E\u4EBA\u7684\u670D\u52A1\n\u548C/\u6216\u8D2D\u4E70\u5176\u4EA7\u54C1\u4EA7\u751F\u7684\u4EFB\u4F55\u8D39\u7528\u3002\u5E76\u5728\u5FC5\u8981\u65F6\u6839\u636E\u6536\u6B3E\u4EBA\u7684\u6761\u6B3E\u66F4\u6B63\u9519\u8BEF\u6263\u6B3E\uFF0C\u76F4\u81F3\u6B64\n\u6B64\u7B49\u6388\u6743\u88AB\u64A4\u9500\u3002\u5982\u679C ACH \u4EA4\u6613\u56E0\u8D44\u91D1\u4E0D\u8DB3\u88AB\u62D2\u7EDD\uFF0C\u6211\u4E86\u89E3\u6211\u5C06\u88AB\u6263\u9664\n\u8D26\u6237\u4F59\u989D\u4E0D\u8DB3 (NSF) \u8D39\u7528\uFF0C\u5E76\u4E14\u98DE\u6C47\u53EF\u4EE5\u81EA\u884C\u51B3\u5B9A\u5C1D\u8BD5\u518D\u6B21\u5904\u7406\u6B64\u7C7B\u8D39\u7528\u3002\n     ",
  "confirmationPage.labels.termsAch2": "\n     \u6839\u636E\u6536\u6B3E\u4EBA\u6761\u6B3E\uFF0C\u5982\u679C\u60A8\u5B9A\u671F\u4F7F\u7528\u6216\u8D2D\u4E70\u6536\u6B3E\u4EBA\u7684\u5176\u4ED6\u4EA7\u54C1\u548C/\u6216\u670D\u52A1\uFF0C\u5373\u8868\u793A\u60A8\u6388\u6743\n\u98DE\u6C47\u4EE3\u8868\u6536\u6B3E\u4EBA\u5B9A\u671F\u4ECE\u60A8\u7684\u94F6\u884C\u8D26\u6237\u6263\u6B3E\u3002\u5BF9\u4E8E\u4E0A\u8FF0\u6388\u6743\u6263\u6B3E\n\u8303\u56F4\u4EE5\u5916\u7684\u4ED8\u6B3E\uFF0C\u53EA\u6709\u5728\u901A\u8FC7\u60A8\u7684\u8D26\u6237\u3001\u5BC6\u7801\u3001\u4EE3\u7801\u6216\u5176\u4ED6\u7B49\u6548\u7B7E\u540D\u83B7\u5F97\u60A8\u7684\u6388\u6743\u540E\u624D\u4F1A\u6263\u9664\u3002\n\n     ",
  "confirmationPage.labels.termsAch3": "\n     \u60A8\u53EF\u4EE5\u968F\u65F6\u8054\u7CFB\u6536\u6B3E\u4EBA\u64A4\u9500\u6B64\u7C7B\u6388\u6743\u3002\u6536\u6B3E\u4EBA\u5FC5\u987B\u5728\u4E0B\u4E00\u6B21\u9884\u5B9A\u4ED8\u6B3E\u524D\u81F3\u5C11 [10 \u4E2A\u5DE5\u4F5C\u65E5]\n\u5185\u6536\u5230\u60A8\u7684\u64A4\u9500\u3002\n    ",
  "confirmationPage.labels.print": "\u6253\u5370\u534F\u8BAE",
  "amountPanel.labels.amountFromLabel": "\u60A8\u5C06\u652F\u4ED8",
  "amountPanel.labels.surchargeFeeInfo": "\u5DF2\u542B\u5361\u8D39\u3002",
  "amountPanel.labels.whyThisFee": "\u4E3A\u4EC0\u4E48\u4F1A\u6536\u53D6\u8FD9\u7B14\u8D39\u7528\uFF1F",
  "amountPanel.labels.whyThisFeeTooltip": "\n  \u5982\u679C\u60A8\u7EE7\u7EED\u4ED8\u6B3E\uFF0C\u5219\u9700\u652F\u4ED8 {{percentage}}% \u7684\u5361\u8D39\u3002\u60A8\u7684 {{cardScheme}} \u5361\u5E01\u79CD\u4E3A {{currency}}\u3002\u8BF7\u9009\u62E9\u4E0E\u60A8\u7684\u5361\u4E00\u81F4\u7684\u5361\u6216\u56FD\u5BB6/\u5730\u533A\uFF0C\u4EE5\u907F\u514D\u989D\u5916\u8D39\u7528\u3002\n     ",
  "amountPanel.labels.currencyChangeWarning": "\u5E01\u79CD\u5DF2\u66F4\u6539\uFF0C\u4EE5\u4FBF\u4E0E\u60A8\u7684\u94F6\u884C\u5361\u5E01\u79CD\u76F8\u4E00\u81F4",
  "amountPanel.labels.amountToLabel": "\u201C{{recipientName}}\u201D\u5C06\u6536\u5230",
  AX: "\u5965\u5170\u7FA4\u5C9B",
  AD: "\u5B89\u9053\u5C14",
  BG: "\u4FDD\u52A0\u5229\u4E9A",
  AT: "\u5965\u5730\u5229",
  BE: "\u6BD4\u5229\u65F6",
  HR: "\u514B\u7F57\u5730\u4E9A",
  CY: "\u585E\u6D66\u8DEF\u65AF",
  CZ: "\u6377\u514B\u5171\u548C\u56FD",
  DK: "\u4E39\u9EA6",
  EE: "\u7231\u6C99\u5C3C\u4E9A",
  FI: "\u82AC\u5170",
  FR: "\u6CD5\u56FD",
  GP: "\u74DC\u5FB7\u7F57\u666E\u5C9B",
  DE: "\u5FB7\u56FD",
  GR: "\u5E0C\u814A",
  HU: "\u5308\u7259\u5229",
  IS: "\u51B0\u5C9B",
  IE: "\u7231\u5C14\u5170",
  VA: "\u7F57\u9A6C\u6559\u5EF7\uFF08\u68B5\u8482\u5188\u57CE\u56FD\uFF09",
  IT: "\u610F\u5927\u5229",
  LI: "\u5217\u652F\u6566\u58EB\u767B",
  LT: "\u7ACB\u9676\u5B9B",
  LU: "\u5362\u68EE\u5821",
  YT: "\u9A6C\u7EA6\u7279\u5C9B",
  MT: "\u9A6C\u8033\u4ED6",
  MQ: "\u9A6C\u63D0\u5C3C\u514B",
  ES: "\u897F\u73ED\u7259",
  NO: "\u632A\u5A01",
  NL: "\u8377\u5170",
  PL: "\u6CE2\u5170",
  PT: "\u8461\u8404\u7259",
  SE: "\u745E\u5178",
  RE: "\u7559\u5C3C\u6C6A\u5C9B",
  RO: "\u7F57\u9A6C\u5C3C\u4E9A",
  CH: "\u745E\u58EB",
  BL: "\u5723\u5DF4\u6CF0\u52D2\u7C73",
  GB: "\u82F1\u56FD",
  MC: "\u6469\u7EB3\u54E5",
  MF: "\u5723\u9A6C\u4E01\uFF08\u6CD5\u5C5E\uFF09",
  PM: "\u5723\u76AE\u57C3\u5C14\u548C\u5BC6\u514B\u9686\u7FA4\u5C9B",
  SM: "\u5723\u9A6C\u529B\u8BFA",
  SK: "\u65AF\u6D1B\u4F10\u514B",
  SI: "\u65AF\u6D1B\u6587\u5C3C\u4E9A",
  GF: "\u6CD5\u5C5E\u572D\u4E9A\u90A3",
  LV: "\u62C9\u8131\u7EF4\u4E9A",
  CA: "\u52A0\u62FF\u5927",
  US: "\u7F8E\u56FD",
  "modal.close": "Close"
};

// ../internal-components/src/utils/translations/index.ts
var locales = {
  en,
  "de-DE": de,
  "en-US": enUS,
  "zh-CN": zh,
  "es-ES": es,
  ko,
  ja,
  "fr-FR": fr,
  "pt-PT": pt,
  id,
  vi,
  ar,
  "it-IT": it
};
var DEFAULT_LOCALE = "en";

// ../internal-components/src/context/TranslationsContext.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
var TranslationsProvider = ({
  children,
  locale = DEFAULT_LOCALE,
  errorNotifier = (e) => console.error(e)
}) => {
  const [currentLocale, setLocale] = useState(locale);
  const keys = locales;
  return /* @__PURE__ */ jsx7(TranslationsContext.Provider, { value: { locale: currentLocale, setLocale, keys, errorNotifier }, children });
};
var TranslationsContext = createContext2(void 0);
TranslationsContext.displayName = "TranslationsContext";

// ../internal-components/src/hooks/useTranslations.ts
var UnknownI18nKey = class extends Error {
  constructor(message) {
    super(message);
    this.name = "UnknownI18nKey";
  }
};
var useTranslations = () => {
  const { keys, locale, setLocale, errorNotifier } = useSafeContext(TranslationsContext);
  const t = (...args) => {
    const [key, attrs] = args;
    const translations = keys[locale] || keys["en"];
    if (!Object.prototype.hasOwnProperty.call(translations, key) || !Object.prototype.hasOwnProperty.call(keys[DEFAULT_LOCALE], key)) {
      errorNotifier?.(new UnknownI18nKey(`Unknown key requested for translation: ${key}`));
      return key;
    }
    const translation = translations[key] || keys[DEFAULT_LOCALE][key];
    const chunks = translation.split(/({{[a-zA-Z]*}})/g).filter(Boolean);
    Object.keys(attrs || {}).forEach(
      (attr) => chunks.forEach((chunk, index) => {
        if (chunk === `{{${attr}}}` && attrs) {
          chunks[index] = attrs[attr];
        }
      })
    );
    return chunks.length === 1 ? chunks[0] : chunks.join("");
  };
  return { t, changeLocale: setLocale, currentLocale: locale };
};

// ../internal-components/src/components/CardCVV/CardCVV.tsx
import { jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
var CardCVV = (props) => {
  const { t } = useTranslations();
  const [showTooltip, setShowTooltip] = useState2(false);
  const tooltipId = "cvvInput-Label-Tooltip";
  const { cvvTooltip, className, onBlur, onFocus, ...restProps } = props;
  useEffect2(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        setShowTooltip(false);
      }
    };
    document.addEventListener("keydown", handleEscKey);
    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, []);
  const handleFocus = () => {
    setShowTooltip(true);
    onFocus?.();
  };
  const handleBlur = (name, value) => {
    setShowTooltip(false);
    onBlur?.(props.name, value);
  };
  const textInputClassName = classNames("fw-relative", className);
  return /* @__PURE__ */ jsxs4("div", { className: textInputClassName, children: [
    /* @__PURE__ */ jsx8(
      Input,
      {
        className: textInputClassName,
        "aria-described-by": tooltipId,
        onFocus: handleFocus,
        onBlur: handleBlur,
        mask: "....",
        type: "password",
        minLength: 1,
        autoComplete: "cc-csc",
        requiredErrorMessage: t("bankAccountForm.errors.cvv"),
        ...restProps
      }
    ),
    !props.error && /* @__PURE__ */ jsx8(
      HelpIcon,
      {
        "data-testid": "cvv-help-icon",
        onMouseOver: () => setShowTooltip(true),
        onMouseOut: () => setShowTooltip(false),
        className: "fw-absolute fw-top-1/2 fw-right-4 fw-center -fw-translate-y-1/2 fw-translate-x-1/2"
      }
    ),
    /* @__PURE__ */ jsx8(Tooltip, { message: cvvTooltip, show: showTooltip, domId: tooltipId })
  ] });
};

// ../internal-components/src/components/CardExpiryDate/CardExpiryDate.tsx
import classNames2 from "classnames";
import { jsx as jsx9 } from "react/jsx-runtime";
var CardExpiryDate = (props) => {
  const { t } = useTranslations();
  const cn = classNames2(props.className, "fw-relative");
  return /* @__PURE__ */ jsx9("div", { className: cn, children: /* @__PURE__ */ jsx9(
    Input,
    {
      ...props,
      requiredErrorMessage: t("bankAccountForm.errors.expiryDate"),
      autoComplete: "cc-exp"
    }
  ) });
};

// ../internal-components/src/components/CardForm/useCardIcon.tsx
import classNames3 from "classnames";
import { useMemo } from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
var CARD_TYPE_TO_TW_CLASS_NAME = {
  MC: "fw-bg-mastercard",
  AMEX: "fw-bg-amex",
  DINERS: "fw-bg-diners",
  DISC: "fw-bg-disc",
  JCB: "fw-bg-jcb",
  UNIONPAY: "fw-bg-unionpay",
  VISA: "fw-bg-visa",
  UNKNOWN: "fw-bg-unknown_card"
};
var UNRECOGNIZED_CARD_TYPE_CLASS_NAME = "fw-bg-unknown_card";
var getCardIconClassNameFromType = (type) => {
  let cardTypeClassName = CARD_TYPE_TO_TW_CLASS_NAME[type];
  if (!cardTypeClassName?.length) {
    cardTypeClassName = UNRECOGNIZED_CARD_TYPE_CLASS_NAME;
  }
  return cardTypeClassName;
};
var CardIcon = (props) => {
  const iconClassName = useMemo(() => {
    const iconClassName2 = getCardIconClassNameFromType(props.type);
    return classNames3(
      `fw-pointer-events-none fw-inline-block fw-bg-no-repeat fw-bg-center ${iconClassName2}`,
      props.className
    );
  }, [props.className, props.type]);
  return /* @__PURE__ */ jsx10("span", { "aria-label": `${props.type}-icon`, className: iconClassName });
};
var useCardIcon = () => {
  return { CardIcon };
};

// ../internal-components/src/components/CardNumber/CardNumber.tsx
import classNames4 from "classnames";
import { useState as useState3 } from "react";

// ../internal-components/src/components/CardNumber/validators/card.ts
var AMEX = "AMEX";
var VISA = "VISA";
var MASTERCARD = "MC";
var UNIONPAY = "UNIONPAY";
var UNIONPAY_VAULT = "UNION_PAY";
var JCB = "JCB";
var DISCOVER = "DISC";
var DINERS = "DINERS";
var UNKNOWN = "UNKNOWN";
var cardPatterns = [
  {
    vaultKey: AMEX,
    fullNumberPattern: /^(34|37)[0-9]{13}$/,
    binPattern: /^(34|37)[0-9]{4}$/
  },
  {
    vaultKey: MASTERCARD,
    fullNumberPattern: /^5[1-5][0-9]{14}|2[3-6][0-9]{14}|222[1-9][0-9]{12}|22[3-9][0-9]{13}|27[0-1][0-9]{13}|2720[0-9]{12}$/,
    binPattern: /^5[1-5][0-9]{4}|2[3-6][0-9]{4}|222[1-9][0-9]{2}|22[3-9][0-9]{3}|27[0-1][0-9]{3}|2720[0-9]{2}$/
  },
  {
    vaultKey: VISA,
    fullNumberPattern: /^4([0-9]{15}|[0-9]{12})$/,
    binPattern: /^4\d{5}$/
  },
  {
    vaultKey: UNIONPAY,
    fullNumberPattern: /^62([0-9]{14,17})$/,
    binPattern: /^62[0-9]{4}$/
  },
  {
    vaultKey: JCB,
    fullNumberPattern: /^(?:2131|1800|35\d{3})\d{11}$/,
    binPattern: /^(?:2131|1800)\d{2}|35\d{4}$/
  },
  {
    vaultKey: DISCOVER,
    fullNumberPattern: /^65[0-9]{14}|64[4-9][0-9]{13}|6011[0-9]{12}$/,
    binPattern: /^(?:65[0-9]{4}|64[4-9][0-9]{3}|6011[0-9]{2})$/
  },
  {
    vaultKey: DINERS,
    fullNumberPattern: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    binPattern: /^3(?:0[0-5]\d{3}|[68][0-9]{4})$/
  }
];
var getCardType = (cardNumber) => {
  const cardType = (cardPattern) => cardPattern.fullNumberPattern.test(cardNumber.replace(/ |-/g, ""));
  const card = cardPatterns.find(cardType);
  if (!card) {
    return UNKNOWN;
  }
  return card && card.vaultKey;
};
var getCardTypeByBin = (bin) => {
  const cardType = (cardPattern) => cardPattern.binPattern.test(bin.replace(/ |-/g, ""));
  const card = cardPatterns.find(cardType);
  if (!card)
    return UNKNOWN;
  return card && card.vaultKey;
};
var UNIONPAY_CODE = "UNIONPAY";
var validateCardNumber = (creditCardNumber, acceptedCards = []) => {
  if (acceptedCards.includes(UNIONPAY_CODE))
    return true;
  const cardType = getCardType(creditCardNumber);
  if (cardType === UNKNOWN)
    return false;
  return validLunhCheck(creditCardNumber);
};
var validateCardType = (creditCardNumber, acceptedCards) => {
  if (acceptedCards.includes(UNIONPAY_CODE))
    return true;
  const cardType = getCardType(creditCardNumber);
  return acceptedCards.includes(cardType);
};
var validLunhCheck = (value) => {
  if (/[^0-9-\s]+/.test(value))
    return false;
  let nCheck = 0;
  let nDigit = 0;
  let bEven = false;
  value = value.replace(/\D/g, "");
  for (let n = value.length - 1; n >= 0; n--) {
    const cDigit = value.charAt(n);
    nDigit = parseInt(cDigit, 10);
    if (bEven) {
      if ((nDigit *= 2) > 9)
        nDigit -= 9;
    }
    nCheck += nDigit;
    bEven = !bEven;
  }
  return nCheck % 10 === 0;
};
var validateExpirationDate = (expirationDateInput) => {
  const expirationDate = expirationDateInput.trim();
  return isValidFormat(expirationDate) && isValidMonth(expirationDate) && isFutureDate(expirationDate);
};
var validateCvvInput = (cvvNumber, cardType) => {
  const amexTypes = ["AMERICAN EXPRESS", "AMERICAN_EXPRESS", "AMEX"];
  const cvvMaxLength = amexTypes.includes(cardType) ? 4 : 3;
  return cvvNumber.toString().length === cvvMaxLength;
};
var isValidFormat = (expirationDate) => {
  const expireDateRegexp = /^[0-9]{2}\/[0-9]{2}$/g;
  return expireDateRegexp.test(expirationDate);
};
var isValidMonth = (expirationDate) => {
  const parts = expirationDate.split("/");
  const month = parseInt(parts[0]);
  return month > 0 && month <= 12;
};
var isFutureDate = (expirationDate) => {
  const parts = expirationDate.split("/");
  const month = parseInt(parts[0]);
  const year = parseInt(parts[1]);
  const now = new Date(Date.now());
  const today = new Date(now.getFullYear(), now.getMonth() + 1);
  const expiration = new Date(parseInt(`20${year}`), month);
  return expiration >= today;
};

// ../internal-components/src/components/CardNumber/CardNumber.tsx
import { jsx as jsx11, jsxs as jsxs5 } from "react/jsx-runtime";
var CARD_NUMBER_MASK = "....-....-....-....";
var CardNumber = (props) => {
  const { t } = useTranslations();
  const [cardType, setCardType] = useState3(UNKNOWN);
  const { CardIcon: CardIcon2 } = useCardIcon();
  const handleChange = (name, value) => {
    const cleanValue = value.replace(/\D/g, "");
    const cardType2 = getCardType(cleanValue);
    setCardType(cardType2);
    props.onChange?.(name, cleanValue);
  };
  const handleOnblur = (name, value) => {
    const cleanValue = value.replace(/\D/g, "");
    props.onBlur?.(name, cleanValue);
  };
  return /* @__PURE__ */ jsxs5("div", { className: classNames4(props.className, "fw-relative"), children: [
    /* @__PURE__ */ jsx11(
      Input,
      {
        ...props,
        requiredErrorMessage: t("bankAccountForm.errors.cardNumber"),
        onBlur: handleOnblur,
        onChange: handleChange,
        mask: CARD_NUMBER_MASK,
        autoComplete: "cc-number"
      }
    ),
    !props.error && /* @__PURE__ */ jsx11(
      CardIcon2,
      {
        className: "fw-absolute fw-right-2 fw-top-2 fw-w-4 fw-h-3 fw-bg-cover xs:fw-w-9 xs:fw-h-7 xs:fw-right-3 xs:fw-top-2.5 xs:fw-bg-contain",
        type: cardType
      }
    )
  ] });
};

// ../internal-components/src/hooks/useErrorLabelForField.ts
import { useFormContext as useFormContext2 } from "react-hook-form";
var useErrorLabelForField = () => {
  const {
    formState: { errors }
  } = useFormContext2();
  const { t } = useTranslations();
  const geti18nErrorLabelForField = (field) => {
    if (errors[field]?.type === "pattern") {
      return errors[field]?.message || t("bankAccountForm.errors.onlyLetterOrNumbers");
    }
    if (errors[field]?.type === "required") {
      return errors[field]?.message;
    }
    if (errors[field]?.type === "validate") {
      return errors[field]?.message;
    }
    if (errors[field]?.type === "apiError") {
      return errors[field]?.message;
    }
    if (errors[field]?.type === "invalid") {
      return t(`bankAccountForm.errors.${field}`);
    }
    return void 0;
  };
  return {
    getErrorLabel: geti18nErrorLabelForField
  };
};

// ../internal-components/src/utils/validations/validators.ts
var PHONE_NUMBER_PATTERN = /^\+[0-9]{1,4}\s?[0-9]{1,15}$/;
var ONLY_LATIN_CHARS_AND_NUMBERS_PATTERN = /[^\p{Script=Latin}\s'[0-9]/gimu;
var EMAIL_PATTERN = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
var LATIN_CHARS_NUMBERS_AND_SYMBOLS_PATTERN = /[^\p{Script=Latin}\s,\-/\\0-9]/gimu;
var POBOX_PATTERN = /^(((\d*\s?)?((p[. ]?o[. ]?)|(unit\s*\d*\s*box)|(post office box)|(office\s?box)|(p[. ]?o[. ]?\s?box)|(box)|(p[. ]?o[. ]?b[. ]?))(\s?\d*)?))(($)|(\s.*$))/gim;
var isEmpty = (value) => {
  return !value || value.trim() === "";
};
var isCVVValidAgainstCardNumber = (value, cardNumber) => {
  const cardType = getCardType(cardNumber);
  if (!cardType)
    return true;
  return validateCvvInput(value, cardType);
};

// ../internal-components/src/components/CardForm/CardForm.tsx
import { Field as Field4 } from "@flywire/react-headlessui";

// ../internal-components/src/components/CardForm/useCardTypeError.ts
var CARD_TYPE_NAMES = {
  VISA: "Visa",
  MC: "Mastercard",
  AMEX: "AMEX",
  UNIONPAY: "UnionPay",
  JCB: "JCB",
  DISC: "Discover",
  DINERS: "Diners Club International"
};
var useCardTypeError = () => {
  const { t } = useTranslations();
  const computeCardTypeError = (acceptedCards) => {
    if (acceptedCards.length === 0) {
      return void 0;
    }
    if (acceptedCards.length === 1) {
      return t("tokenizationForm.errors.unsupportedCardType", {
        acceptedCard: CARD_TYPE_NAMES[acceptedCards[0]]
      });
    }
    let acceptedCardsList = acceptedCards.reduce((list, acceptedCard, index) => {
      const cardTypeName = CARD_TYPE_NAMES[acceptedCard];
      const acceptedCardsLength = acceptedCards.length;
      if (index < acceptedCardsLength - 1)
        return `${list}, ${cardTypeName}`;
      return `${list} ${t("tokenizationForm.errors.cardType.and")} ${cardTypeName}`;
    }, "");
    if (acceptedCards.length > 1) {
      acceptedCardsList = acceptedCardsList.slice(2);
    }
    return t("tokenizationForm.errors.unsupportedCardTypes", {
      acceptedCardsList
    });
  };
  return { computeCardTypeError };
};

// ../internal-components/src/components/CardForm/CardForm.tsx
import { jsx as jsx12, jsxs as jsxs6 } from "react/jsx-runtime";
var CardFormContext = createContext3({
  acceptedCards: [],
  onChangeHandler: () => {
  }
});
CardFormContext.displayName = "CardFormContext";
var CARD_TYPE_TO_DISPLAY_NAME = {
  AMEX: "AMERICAN EXPRESS",
  DINERS: "DINERS",
  DISC: "DISCOVERY",
  JCB: "JCB",
  UNIONPAY: "UNIONPAY",
  MC: "MASTERCARD",
  VISA: "VISA",
  UNKNOWN: "UNKNOWN"
};
var ReadOnlyCardDetails = (props) => {
  const { CardIcon: CardIcon2 } = useCardIcon();
  const { cardType, lastFour, expiryMonth, expiryYear } = props;
  return /* @__PURE__ */ jsx12(
    Field4,
    {
      className: `${props.className} fw-text-base fw-text-mirage-900 fw-h-12 fw-w-full fw-appearance-none
          fw-rounded-sm fw-border fw-border-shuttle-gray-100 fw-hover:border-shuttle-gray-200 fw-outline-none
          fw-focus:border-primary-600 fw-px-4 fw-py-2 fw-focus:shadow-lg-blue fw-focus:outline-none fw-cursor-not-allowed fw-bg-shuttle-gray-50`,
      children: /* @__PURE__ */ jsxs6(Field4.Label, { className: "fw-cursor-not-allowed fw-flex fw-items-center fw-m-0 fw-h-full fw-text-shuttle-gray-500", children: [
        /* @__PURE__ */ jsx12(CardIcon2, { className: "fw-flex-grow-0 fw-w-9 fw-h-7 fw-bg-contain", type: props.cardType }),
        /* @__PURE__ */ jsx12("span", { className: "fw-inline-block fw-flex-1 fw-m-2 fw-text-xs xs:fw-text-base", children: `${CARD_TYPE_TO_DISPLAY_NAME[cardType] ?? "UNKNOWN"} **** ${lastFour} ${expiryMonth}/${expiryYear}` })
      ] })
    }
  );
};
var Expiry = (props) => {
  const { t } = useTranslations();
  const { getErrorLabel } = useErrorLabelForField();
  const cardExpiryDateError = getErrorLabel(FIELDS.CARD_EXPIRY_DATE);
  return /* @__PURE__ */ jsx12(
    CardExpiryDate,
    {
      mask: "../..",
      name: FIELDS.CARD_EXPIRY_DATE,
      required: true,
      error: cardExpiryDateError,
      className: classNames5(props.className),
      label: t("tokenizationForm.labels.expiryDate"),
      "data-testid": "expiry-date",
      validate: (value) => {
        if (!validateExpirationDate(value)) {
          return t(`bankAccountForm.errors.expiryDate`);
        }
      }
    }
  );
};
var Number2 = (props) => {
  const { t } = useTranslations();
  const { getErrorLabel } = useErrorLabelForField();
  const { onChangeHandler, acceptedCards } = useSafeContext(CardFormContext);
  const { computeCardTypeError } = useCardTypeError();
  const cardNumberError = getErrorLabel(FIELDS.CARD_NUMBER);
  return /* @__PURE__ */ jsx12(
    CardNumber,
    {
      name: FIELDS.CARD_NUMBER,
      onChange: onChangeHandler,
      error: props.error || cardNumberError,
      required: true,
      className: classNames5(props.className),
      label: t("tokenizationForm.labels.cardNumber"),
      "data-testid": "card-number",
      validate: (value) => {
        if (!validateCardNumber(value, acceptedCards)) {
          return t(`bankAccountForm.errors.cardNumber`);
        }
        if (!validateCardType(value, acceptedCards)) {
          return computeCardTypeError(acceptedCards);
        }
      }
    }
  );
};
var CVV = (props) => {
  const { t } = useTranslations();
  const { control } = useFormContext3();
  const cardNumber = useWatch2({ control, name: FIELDS.CARD_NUMBER });
  const { getErrorLabel } = useErrorLabelForField();
  const { onChangeHandler } = useSafeContext(CardFormContext);
  const cardCvvError = getErrorLabel(FIELDS.CARD_CVV);
  const defaultCvvValidate = useCallback(
    (value) => {
      if (!isEmpty(cardNumber) && !isCVVValidAgainstCardNumber(value, cardNumber)) {
        return t(`bankAccountForm.errors.cvv`);
      }
    },
    [cardNumber, t]
  );
  return /* @__PURE__ */ jsx12(
    CardCVV,
    {
      name: FIELDS.CARD_CVV,
      onChange: onChangeHandler,
      error: cardCvvError,
      required: props.required || true,
      className: classNames5(props.className),
      fieldDeps: [FIELDS.CARD_NUMBER],
      label: t("tokenizationForm.labels.cvv"),
      cvvTooltip: t("tokenizationForm.labels.cvvTooltip"),
      "data-testid": "cvv",
      validate: props.validate || defaultCvvValidate
    }
  );
};
var MIN_BIN_RANGE_SIZE = 9;
var isValidBin = (bin) => bin.length >= MIN_BIN_RANGE_SIZE;
var CardForm = ({
  className,
  children,
  onBinTyped,
  acceptedCards
}) => {
  const [binTyped, setBinTyped] = useState4("");
  const onChangeHandler = (name, value) => {
    const newBin = value.replaceAll("-", "").slice(0, MIN_BIN_RANGE_SIZE);
    setBinTyped(newBin);
    if (!onBinTyped || name !== "cardNumber" || !isValidBin(newBin)) {
      return;
    }
    if (binTyped !== newBin) {
      onBinTyped(newBin);
    }
  };
  const providerValue = {
    onChangeHandler,
    acceptedCards
  };
  return /* @__PURE__ */ jsx12(CardFormContext.Provider, { value: providerValue, children: /* @__PURE__ */ jsx12("div", { className: classNames5(className), children }) });
};
CardForm.CVV = CVV;
CardForm.CardNumber = Number2;
CardForm.ExpiryDate = Expiry;
CardForm.ReadOnlyCardDetails = ReadOnlyCardDetails;

// ../internal-components/src/components/Challenge/Challenge.tsx
import classNames6 from "classnames";
import { useCallback as useCallback2, useEffect as useEffect3, useMemo as useMemo2, useState as useState5 } from "react";
import { jsx as jsx13 } from "react/jsx-runtime";
var Challenge = ({ className = "", ...props }) => {
  const [isHidden, setIsHidden] = useState5(false);
  const onMessageHandler = useCallback2(
    async (event) => {
      const { startLoading, onChallengeCompleted, onRechallenged } = props;
      let errorMessage = null;
      try {
        const eventData = JSON.parse(event.data);
        const status = eventData.status;
        const redirectUrl = eventData.redirect_url;
        if (status === "redirected") {
          startLoading();
        } else if (status === "success") {
          setIsHidden(true);
          await onChallengeCompleted(status);
        } else if (status) {
          if ("errors" in eventData) {
            errorMessage = eventData.errors[0].message;
          }
          setIsHidden(true);
          await onChallengeCompleted(status, errorMessage);
        } else if (redirectUrl) {
          onRechallenged(redirectUrl);
        }
      } catch (e) {
        if (!(e instanceof SyntaxError)) {
          props.onError?.(e);
        }
      }
    },
    [props]
  );
  useEffect3(() => {
    setIsHidden(false);
    window.addEventListener("message", onMessageHandler);
    scrollToIframe();
    return () => window.removeEventListener("message", onMessageHandler);
  }, []);
  const boxClassName = useMemo2(
    () => classNames6(
      "Challenge",
      { "Challenge--hidden": isHidden },
      { "Challenge--unionpay": isHidden },
      className
    ),
    [isHidden, className]
  );
  return /* @__PURE__ */ jsx13("div", { className: boxClassName, children: /* @__PURE__ */ jsx13("iframe", { title: "Challenge Iframe", id: "opp-Challenge-Iframe", src: props.redirectUrl }) });
};
var scrollToIframe = () => {
  const element = document.getElementById("opp-Challenge-Iframe");
  let elementPosition = 0;
  if (element != null) {
    elementPosition = element.getBoundingClientRect().top * -1;
  }
  window.scrollTo({
    top: elementPosition,
    behavior: "smooth"
  });
};

// ../internal-components/src/context/CardElementContext.tsx
import { createContext as createContext4, useState as useState6 } from "react";
import { jsx as jsx14 } from "react/jsx-runtime";
var CardElementContext = createContext4(void 0);
CardElementContext.displayName = "CardElementContext";
var CardElementContextProvider = ({ children }) => {
  const [validationStrategy, setValidationStrategy] = useState6("senders");
  const [payerValidationErrors, setPayerValidationErrors] = useState6(
    null
  );
  const [currency, setCurrency] = useState6(void 0);
  const [country, setCountry] = useState6(void 0);
  const [offerError, setOfferError] = useState6(void 0);
  const [cardData, setCardData] = useState6(void 0);
  const [cardCurrency, setCardCurrency] = useState6();
  return /* @__PURE__ */ jsx14(
    CardElementContext.Provider,
    {
      value: {
        validationStrategy,
        setValidationStrategy,
        payerValidationErrors,
        setPayerValidationErrors,
        currency,
        setCurrency,
        country,
        setCountry,
        offerError,
        setOfferError,
        cardData,
        setCardData,
        cardCurrency,
        setCardCurrency
      },
      children
    }
  );
};

// ../internal-components/src/hooks/useSessionConfig.tsx
import useSWRImmutable from "swr/immutable";

// ../internal-components/src/utils/fetcher/fetcher.ts
import { v4 as uuidV4 } from "uuid";
var RequestError = class extends Error {
  constructor() {
    super(...arguments);
    __publicField(this, "status");
    __publicField(this, "response");
  }
};
var NotFoundError = class extends RequestError {
};
var buildRequestError = ({
  status,
  errors
}) => {
  let error;
  if (status === 404) {
    error = new NotFoundError("An error occurred while fetching the data.");
  } else {
    error = new RequestError("An error occurred while fetching the data.");
  }
  error.status = status;
  error.response = errors;
  return error;
};
var jsonFetcher = async (url, options) => {
  const res = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      "X-Request-Id": uuidV4(),
      ...options?.headers || {}
    },
    ...options
  });
  if (!res.ok) {
    const errors = await res.json();
    throw buildRequestError({ status: res.status, errors });
  }
  if (options?.noResponse) {
    return {};
  }
  return await res.json();
};
var textFetcher = async (url, options) => {
  const res = await fetch(url, {
    headers: { "X-Request-Id": uuidV4(), ...options?.headers || {} },
    ...options
  });
  if (!res.ok) {
    const errors = await res.text();
    throw buildRequestError({ status: res.status, errors });
  }
  return await res.text();
};

// ../internal-components/src/hooks/useSessionConfig.tsx
var environmentToCheckoutURL = (environment) => {
  switch (environment) {
    case "staging":
      return "https://payment-checkout.flywire.lol";
    case "demo-production":
      return "https://payment-checkout.demo.flywire.com";
    case "production":
      return "https://payment-checkout.flywire.com";
    default:
      return `https://payment-checkout-dev-${environment}.flywire.cc`;
  }
};
var useSessionConfig = (sessionId, environment) => {
  const baseURL = environmentToCheckoutURL(environment);
  const {
    data,
    error: fetchError,
    isLoading
  } = useSWRImmutable(
    sessionId ? `${baseURL}/v1/sessions/${sessionId}` : null,
    jsonFetcher,
    { shouldRetryOnError: false }
  );
  if (isLoading) {
    return {
      instructions: null,
      isLoading: true,
      error: null
    };
  }
  if (fetchError?.status === 404) {
    return {
      error: {
        type: "not_found",
        message: "The session requested could not be found.",
        cause: fetchError
      },
      isLoading: false,
      instructions: null
    };
  }
  if (fetchError) {
    return {
      error: { type: "internal_error", message: fetchError.message, cause: fetchError },
      isLoading: false,
      instructions: null
    };
  }
  if (!data) {
    return {
      instructions: null,
      isLoading: false,
      error: null
    };
  }
  return {
    instructions: data,
    isLoading: false,
    error: null
  };
};

// src/CardElement/model.ts
var PAYER_ELEMENT_FIELDS = [
  "name",
  "surname",
  "city",
  "address",
  "country",
  "email"
];
var CARD_ELEMENT_FIELDS = [
  ...PAYER_ELEMENT_FIELDS,
  "cardNumber",
  "expiryDate",
  "cvv"
];
var SNAKE_CASE_TO_PARAM = {
  first_name: "firstName",
  last_name: "lastName"
};
var buildInvalidFormErrorsFromApi = (errors) => {
  return errors.map((v) => ({
    field: v.param === "first_name" || v.param === "last_name" ? SNAKE_CASE_TO_PARAM[v.param] : v.param
  }));
};
var REQUIRED_PAYER_INFO_FROM_BACKEND_KEYS = [
  "name",
  "surname",
  "city",
  "country",
  "email",
  "address",
  "phone"
];
var transformPayerInfoToInternalFormat = (payerInfo) => {
  const { firstName, lastName, ...rest } = payerInfo;
  return {
    ...rest,
    name: firstName,
    surname: lastName
  };
};
var exceptionMessage = (msg) => `The CardElement requires the ${msg} in order to tokenize a card.
Please make sure that you either provide it when creating the session or when rendering the component.
Refer to the checkout session api reference to find out more: https://api-docs.flywire.lol/reference/v3/checkout#/checkout/post_v3_checkout_sessions`;
var resetForm = (form) => {
  form.resetField("cardNumber");
  form.resetField("expiryDate");
  form.resetField("cvv");
};

// src/CardElement/hooks/useOnSuccessWithPayerInfo.tsx
import { useWatch as useWatch3 } from "react-hook-form";
var useOnSuccessWithPayerInfo = ({
  formMethods,
  onSuccessProp
}) => {
  const { state } = useCardsContext();
  const values = useWatch3({ control: formMethods.control });
  const onSuccess = () => {
    onSuccessProp({ confirm: state.confirm, payer: adaptPayerValues(values) });
  };
  return { onSuccess };
};
var adaptPayerValues = (values) => ({
  firstName: values.name,
  lastName: values.surname,
  address: values.address,
  city: values.city,
  country: values.country,
  email: values.email,
  phone: values?.phone,
  state: values?.state,
  zip: values?.zip
});

// src/CardElement/hooks/useChallengeCompleteHandler.tsx
var useChallengeCompleteHandler = ({
  onEvent,
  onStartLoading,
  onEndLoading,
  onError,
  onSuccess: onSuccessProp,
  formMethods
}) => {
  const { state, dispatch } = useCardsContext();
  const { onSuccess } = useOnSuccessWithPayerInfo({ formMethods, onSuccessProp });
  const emitTelemetryEvent = (e) => {
    onEvent?.(e);
  };
  const onChallengeCompleted = async (status, error) => {
    onEndLoading();
    emitTelemetryEvent({ type: "return_from_challenge", extra: { status, error } });
    if (status === "success" || status === "unknown") {
      dispatch(returnFromSuccessfulChallenge());
      onStartLoading();
      await state.onReturnFromChallenge();
      onEndLoading();
      resetForm(formMethods);
      emitTelemetryEvent({ type: "success" });
      onSuccess();
    } else if (status === "cancelled") {
      resetForm(formMethods);
      dispatch(returnFromFailedChallenge());
      onError({ type: "challenge_error", extra: { status, error } });
    } else {
      resetForm(formMethods);
      dispatch(returnFromFailedChallenge());
      onError({ type: "challenge_error", extra: { status, error } });
    }
  };
  return { onChallengeCompleted };
};

// src/CardElement/hooks/useFormStateEventNotifier.tsx
import { useEffect as useEffect4 } from "react";
var useFormStateEventNotifier = ({
  formMethods,
  onEvent,
  instructions
}) => {
  const { isValid } = formMethods.formState;
  useEffect4(() => {
    if (instructions && onEvent) {
      onEvent?.({
        type: "form_changed",
        extra: { isValid }
      });
    }
  }, [instructions, isValid]);
};

// src/CardElement/hooks/useOnBinLookupHandler.tsx
import { useCallback as useCallback3 } from "react";

// ../internal-components/src/hooks/useBinLookup/useBinLookup.tsx
import useSWRMutation from "swr/mutation";
var BIN_NOT_FOUND_STATUS_CODE = 404;
var INVALID_PARAM_STATUS_CODE = 422;
var fetcher = async (url, { arg }) => {
  try {
    const response = await jsonFetcher(url, {
      method: "POST",
      body: JSON.stringify(arg)
    });
    const res = { result: "success", response: { ...response } };
    return res;
  } catch (e) {
    if (e instanceof RequestError) {
      if (e?.status === BIN_NOT_FOUND_STATUS_CODE) {
        return { result: "not_found", response: { message: e.message } };
      }
      if (e?.status === INVALID_PARAM_STATUS_CODE) {
        return {
          result: "invalid_param",
          response: { message: e.message, body: e.response, e }
        };
      }
    }
    throw e;
  }
};
var useBinLookup = (url) => {
  const { trigger } = useSWRMutation(url, fetcher, { revalidate: false });
  const binLookup = async (bin) => {
    return await trigger({ bin });
  };
  return { binLookup };
};

// src/CardElement/hooks/useOnBinLookupHandler.tsx
var useOnBinLookupHandler = ({
  onBinLookup,
  onEvent
}) => {
  const {
    state: { urls, sessionType }
  } = useCardsContext();
  const { setCardData } = useSafeContext(CardElementContext);
  const { binLookup } = useBinLookup(urls.binLookup);
  const onBinLookupHandler = useCallback3(
    async (bin) => {
      if (onBinLookup) {
        try {
          onEvent?.({ type: "bin_lookup_started" });
          const { result, response } = await binLookup(bin);
          if (result === "success") {
            const cardScheme = getCardTypeByBin(bin.slice(0, 6));
            const currency = response?.currency ? {
              code: response.currency
            } : void 0;
            onBinLookup?.({
              status: "success",
              result: {
                cardClassification: response.card_classification,
                country: response.country,
                productType: response.product_type,
                cardScheme,
                currency
              }
            });
            if (sessionType === "tokenization_and_pay") {
              setCardData({
                cardScheme,
                cardType: response.card_classification,
                cardCountry: response.country,
                cardProductType: response.product_type,
                currency
              });
            }
          } else if (result === "not_found") {
            onBinLookup?.({
              status: "not_found"
            });
          } else if (result === "invalid_param") {
            onBinLookup?.({
              status: "failed",
              result: {
                e: response.e,
                message: response.message,
                response: response.body,
                status: response.e.status
              }
            });
          }
        } catch (e) {
          const error = e;
          onBinLookup?.({
            status: "failed",
            result: {
              e: error,
              message: error.message,
              response: error.response,
              status: error.status
            }
          });
        } finally {
          onEvent?.({ type: "bin_lookup_finished" });
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [binLookup]
  );
  return { onBinLookupHandler };
};

// src/CardElement/hooks/useSubmit.tsx
import { useWatch as useWatch4 } from "react-hook-form";

// ../internal-components/src/hooks/useCardTokenization/useCardTokenization.ts
import { useCallback as useCallback5 } from "react";
import useSWRMutation2 from "swr/mutation";

// ../internal-components/src/utils/browserInfo/browserInfo.ts
var browserInfo = () => {
  return {
    accept_header: "*/*",
    color_depth: screen.colorDepth,
    java_enabled: navigator.javaEnabled(),
    language: navigator.language,
    screen_height: window.innerHeight,
    screen_width: window.innerWidth,
    time_zone_offset: (/* @__PURE__ */ new Date()).getTimezoneOffset(),
    user_agent: navigator.userAgent
  };
};

// ../internal-components/src/utils/windowSize/windowSize.ts
var getChallengeWindowSize = (width, height) => {
  if (width >= 600 && height >= 400) {
    return "LARGE";
  }
  if (width >= 500 && height >= 600) {
    return "NORMAL";
  }
  if (width >= 390 && height >= 400) {
    return "SMALL";
  }
  return "XTRA_SMALL";
};

// ../internal-components/src/hooks/useCardTokenization/payloadBuilders.ts
var buildUpdatePayerPayloadFrom = (form, validationType) => {
  return {
    first_name: form.name,
    last_name: form.surname,
    email: form.email,
    address: form.address,
    city: form.city,
    country: form.country,
    state: form.state,
    zip: form.zip,
    phone: form.phone,
    validation_type: validationType,
    ...areDynamicFieldsPresent(form) ? mappedDynamicFields(form) : {}
  };
};
var areDynamicFieldsPresent = (form) => {
  return form && Object.keys(form).filter((v) => v.includes("dynamicFields")).length > 0;
};
var mappedDynamicFields = (form) => {
  const dynamicFields = Object.keys(form).filter((v) => v.includes("dynamicFields"));
  return dynamicFields.reduce(
    (prev, key) => {
      const sanitizedKey = key.split("-").at(-1);
      return {
        dynamic_fields: {
          ...prev.dynamic_fields,
          ...sanitizedKey ? { [sanitizedKey]: form[key] } : {}
        }
      };
    },
    { dynamic_fields: {} }
  );
};
var buildStoreCardInVaultPayload = ({
  form,
  customerToken,
  accessKey,
  accessToken,
  validationType
}) => {
  const expiryValues = form.expiryDate.split("/");
  const expireMonth = expiryValues[0];
  const expireYear = `20${expiryValues[1]}`;
  const zip = validationType === "senders" ? form.zip || "" : form.zip;
  return {
    customer: {
      token: customerToken
    },
    paymentMethod: {
      isEcheck: false,
      accountFirstName: form.name,
      accountLastName: form.surname,
      accountNumber: form.cardNumber.replaceAll(/(\s|-)/g, ""),
      CVV: form.cvv,
      type: typeToVault(getCardType(form.cardNumber)),
      expireMonth,
      expireYear,
      billingAddress: {
        street1: form.address,
        city: form.city,
        state: form.state,
        zip: zip || ""
      }
    },
    authenticationRequest: {
      accessToken,
      key: accessKey
    }
  };
};
var typeToVault = (type) => {
  switch (type) {
    case UNIONPAY:
      return UNIONPAY_VAULT;
    default:
      return type;
  }
};
function buildCardDetailsPayload({
  formValues,
  lastFour,
  vaultShortToken,
  customerToken,
  ddcSessionId,
  cardsContext,
  currency
}) {
  const cardType = getCardType(formValues.cardNumber);
  if (cardType === UNKNOWN) {
    throw new Error("Could not identify card type");
  }
  const browserInformation = browserInfo();
  return {
    last_four: lastFour,
    payment_method_token: vaultShortToken,
    customer_token: customerToken,
    card_type: cardType,
    three_ds_version: cardsContext.threeDSVersion,
    ddc_session_id: ddcSessionId,
    locale: cardsContext.locale,
    currency_code: currency,
    window_size: getChallengeWindowSize(
      browserInformation.screen_width,
      browserInformation.screen_height
    ),
    browser_info: browserInformation
  };
}

// ../internal-components/src/hooks/useCardTokenization/types.ts
var RESPONSE_CHALLENGE_STATUS_CODE = 401;

// ../internal-components/src/hooks/useLegacyMagicValuesConversor/useLegacyMagicValuesConversor.tsx
import { useCallback as useCallback4 } from "react";
var MAGIC_VALUES = {
  worldpay: {
    threeDSunderscoreVoneunderscoreCHALLENGEunderscoreIDENTIFIED: "3DS_V1_CHALLENGE_IDENTIFIED",
    threeDSunderscoreVoneunderscoreCHALLENGEunderscoreNOTunderscoreIDENTIFIED: "3DS_V1_CHALLENGE_NOT_IDENTIFIED",
    threeDSunderscoreVoneunderscoreCHALLENGEunderscoreVALIDunderscoreERROR: "3DS_V1_CHALLENGE_VALID_ERROR",
    threeDSunderscoreVoneunderscoreNOTunderscoreENROLLED: "3DS_V1_NOT_ENROLLED",
    threeDSunderscoreVoneunderscoreUNKNOWNunderscoreENROLMENT: "3DS_V1_UNKNOWN_ENROLMENT",
    threeDSunderscoreVoneunderscoreCHALLENGEunderscoreUNKNOWNunderscoreIDENTITY: "3DS_V1_CHALLENGE_UNKNOWN_IDENTITY",
    threeDSunderscoreVtwounderscoreFRICTIONLESSunderscoreIDENTIFIED: "3DS_V2_FRICTIONLESS_IDENTIFIED",
    threeDSunderscoreVtwounderscoreFRICTIONLESSunderscoreNOTunderscoreIDENTIFIED: "3DS_V2_FRICTIONLESS_NOT_IDENTIFIED",
    threeDSunderscoreVtwounderscoreFRICTIONLESSunderscoreREJECTED: "3DS_V2_FRICTIONLESS_REJECTED",
    threeDSunderscoreVtwounderscoreFRICTIONLESSunderscoreVALIDunderscoreERROR: "3DS_V2_FRICTIONLESS_VALID_ERROR",
    threeDSunderscoreVtwounderscoreCHALLENGEunderscoreIDENTIFIED: "3DS_V2_CHALLENGE_IDENTIFIED",
    threeDSunderscoreVtwounderscoreCHALLENGEunderscoreVALIDunderscoreERROR: "3DS_V2_CHALLENGE_VALID_ERROR",
    threeDSunderscoreVtwounderscoreCHALLENGEunderscoreUNKNOWNunderscoreIDENTITY: "3DS_V2_CHALLENGE_UNKNOWN_IDENTITY",
    threeDSunderscoreVtwounderscoreBYPASSEDunderscoreAFTERunderscoreCHALLENGE: "3DS_V2_BYPASSED_AFTER_CHALLENGE",
    PAYMENT: "3DS_V2_FRICTIONLESS_IDENTIFIED"
  }
};
var useLegacyMagicValuesConversor = ({ enabled }) => {
  const convert = useCallback4(
    (firstName, lastName) => {
      if (enabled) {
        for (const partner in MAGIC_VALUES) {
          if (firstName in MAGIC_VALUES[partner]) {
            return {
              [FIELDS.NAME]: MAGIC_VALUES[partner][firstName],
              [FIELDS.SURNAME]: ""
            };
          }
        }
      }
      return { [FIELDS.NAME]: firstName, [FIELDS.SURNAME]: lastName };
    },
    [enabled]
  );
  return { convert };
};

// ../internal-components/src/utils/fetcher/fetchWithRetries.ts
function defaultShouldRetry(res) {
  return res.status >= 500;
}
function fetchWithRetries(url, options) {
  const defaultOptions = {
    maxRetries: 2,
    timeout: 15e3,
    delay: 500,
    attempts: 0,
    shouldRetry: defaultShouldRetry
  };
  const retryOptions = { ...defaultOptions, ...options };
  const { maxRetries, timeout, delay, attempts, shouldRetry, ...fetchOptions } = retryOptions;
  const retry = async () => {
    const wait = (ms) => new Promise((res) => setTimeout(res, ms));
    const incrementedAttempts = attempts + 1;
    await wait(incrementedAttempts * delay);
    return fetchWithRetries(url, {
      attempts: incrementedAttempts,
      maxRetries,
      timeout,
      delay,
      ...fetchOptions
    });
  };
  const controller = new AbortController();
  const signal = controller.signal;
  const timeoutFn = setTimeout(() => controller.abort(), timeout);
  return fetch(url, { signal, ...fetchOptions }).then(async (res) => {
    clearTimeout(timeoutFn);
    if (await shouldRetry(res.clone()) && attempts < maxRetries) {
      return retry();
    }
    return res;
  }).catch((e) => {
    clearTimeout(timeoutFn);
    if (attempts >= maxRetries) {
      throw e;
    }
    return retry();
  });
}

// ../internal-components/src/utils/tracing/tracing.ts
import { v4 as uuidV42 } from "uuid";
var tracingInstance = {
  requestId: "",
  init: function() {
    this.requestId = uuidV42();
  },
  currentRequestId: function() {
    if (!this.requestId) {
      this.init();
    }
    return this.requestId;
  }
};
var tracing = tracingInstance;

// ../internal-components/src/services/ddc/provider.ts
var requestDdcJwtToken = async ({ url }) => {
  const fetchOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Request-Id": tracing.currentRequestId()
    }
  };
  const response = await fetchWithRetries(url, fetchOptions);
  const jsonBody = await response.json();
  return jsonBody.ddcJwt;
};

// ../internal-components/src/services/ddc/iframe.ts
var createDDCIframes = async ({
  providerUrl,
  issuerUrl,
  cardNumber
}) => {
  const jwt = await requestDdcJwtToken({
    url: providerUrl
  });
  const binNumber = cardNumber.slice(0, 6);
  createDdcResponseIframe();
  createDdcRequestFormIframe(issuerUrl, binNumber, jwt);
};
function createDdcResponseIframe() {
  const ddcResponseIframe = document.createElement("iframe");
  ddcResponseIframe.id = "ddcResponseIframe";
  ddcResponseIframe.name = "ddcResponseIframe";
  ddcResponseIframe.width = "0";
  ddcResponseIframe.height = "0";
  ddcResponseIframe.style.visibility = "hidden";
  ddcResponseIframe.style.display = "none";
  ddcResponseIframe.src = "about:blank";
  document.body.appendChild(ddcResponseIframe);
}
function createDdcRequestFormIframe(issuerUrl, binNumber, jwt) {
  const innerHtml = "<body onload='document.ddcCollectionForm.submit();'><form id='ddcCollectionForm' name='ddcCollectionForm' method='POST' target='ddcResponseIframe' action='" + issuerUrl + "'><input type='hidden' name='Bin' value='" + binNumber + "'><input type='hidden' name='JWT' value='" + jwt + "'></form></body>";
  const ddcRequestIframe = document.createElement("iframe");
  ddcRequestIframe.id = "ddcRequestIframe";
  ddcRequestIframe.name = "ddcRequestIframe";
  ddcRequestIframe.width = "0";
  ddcRequestIframe.height = "0";
  ddcRequestIframe.style.visibility = "hidden";
  ddcRequestIframe.style.display = "none";
  ddcRequestIframe.srcdoc = innerHtml;
  document.body.appendChild(ddcRequestIframe);
}
var getDdcCollectionForm = () => {
  const requestIframe = document.getElementById("ddcRequestIframe");
  if (requestIframe == null || requestIframe == void 0) {
    return null;
  }
  const requestIframerDoc = requestIframe.contentDocument || requestIframe.contentWindow?.document;
  return requestIframerDoc?.getElementById("ddcCollectionForm");
};

// ../internal-components/src/services/ddc/ddc.ts
var getDDCSessionId = async ({
  providerUrl,
  cardNumber,
  domain,
  issuerUrl,
  ddcAssignedTimeout = 1e3,
  sendDdcFormRetries = 1,
  maxDdcAssignedTimeoutAttempts = 12
}) => {
  window.worldpayDDCSessionId = void 0;
  addDDCEventListener(domain);
  createDDCIframes({ providerUrl, issuerUrl, cardNumber });
  return obtainDDCSessionIdWithRetries(
    ddcAssignedTimeout,
    sendDdcFormRetries,
    maxDdcAssignedTimeoutAttempts,
    1
  );
};
var obtainDDCSessionIdWithRetries = (ddcAssignedTimeout, sendDdcFormRetries, maxDdcAssignedTimeoutAttempts, ddcCheckCounter) => {
  return new Promise((resolve, reject) => {
    if (timeHasExpired(maxDdcAssignedTimeoutAttempts, sendDdcFormRetries, ddcCheckCounter)) {
      return reject(new Error("no DDC Session Id retrieved"));
    }
    setTimeout(function() {
      const sessionId = window.worldpayDDCSessionId;
      window.worldpayDDCSessionId = void 0;
      if (sessionId !== void 0) {
        return resolve(sessionId);
      }
      if (maxDdcAssignedTimeoutAttempts === ddcCheckCounter) {
        sendDdcForm();
        ddcCheckCounter = 0;
        --sendDdcFormRetries;
      }
      obtainDDCSessionIdWithRetries(
        ddcAssignedTimeout,
        sendDdcFormRetries,
        maxDdcAssignedTimeoutAttempts,
        ++ddcCheckCounter
      ).then((value) => {
        resolve(value);
      }).catch((error) => reject(error));
    }, ddcAssignedTimeout);
  });
};
var timeHasExpired = (maxDdcAssignedTimeoutAttempts, sendDdcFormRetries, ddcCheckCounter) => {
  return maxDdcAssignedTimeoutAttempts === ddcCheckCounter && sendDdcFormRetries === 0;
};
var sendDdcForm = () => {
  const ddcCollectionForm = getDdcCollectionForm();
  if (ddcCollectionForm !== null && ddcCollectionForm !== void 0) {
    ddcCollectionForm.submit();
  }
};
var addDDCEventListener = (domain) => {
  window.addEventListener(
    "message",
    function(event) {
      if (event.origin === domain) {
        const data = JSON.parse(event.data);
        if (data && data.Status && data.SessionId) {
          window.worldpayDDCSessionId = data.SessionId;
        }
      }
    },
    false
  );
};

// ../internal-components/src/hooks/useCardTokenization/useCardTokenization.ts
var INVALID_PAYER = 422;
var SESSION_EXPIRED_STATUS = 404;
var useCardTokenization = () => {
  const { state: cardsContext } = useCardsContext();
  const { convert: convertMagicValues } = useLegacyMagicValuesConversor({
    enabled: cardsContext.magicValuesEnabled
  });
  const { trigger: updatePayer } = useSWRMutation2(
    cardsContext.urls.updateSessionsPayer,
    updateSessionsPayer,
    {
      revalidate: false
    }
  );
  const { trigger: storeCardInVaultTrigger } = useSWRMutation2(
    cardsContext.urls.storeCardInVault,
    storeCardInVault,
    {
      revalidate: false
    }
  );
  const { trigger: zeroDollarChargeTrigger } = useSWRMutation2(
    cardsContext.urls.zeroDollarCharge,
    zeroDollarCharge,
    {
      revalidate: false
    }
  );
  const { trigger: storeCardInPlatformTrigger } = useSWRMutation2(
    cardsContext.urls.storeCardInPlatform,
    storeCardInPlatform,
    {
      revalidate: false
    }
  );
  const { trigger: completeSessionTrigger } = useSWRMutation2(
    cardsContext.urls.completeSession,
    completeSession,
    {
      revalidate: false
    }
  );
  const onReturnFromChallenge = useCallback5(async () => {
    await storeCardInPlatformTrigger();
    await completeSessionTrigger();
  }, [completeSessionTrigger, storeCardInPlatformTrigger]);
  const tokenize = useCallback5(
    async ({
      formValues,
      currency,
      validationType
    }) => {
      const { payerValidationErrors, customerToken, hasSessionExpired } = await updatePayer(
        buildUpdatePayerPayloadFrom(
          {
            ...formValues,
            surname: formValues.surname
          },
          validationType
        )
      );
      if (payerValidationErrors) {
        return {
          payerValidationErrors,
          challengeRequired: false,
          hasSessionExpired: false,
          onReturnFromChallenge: null,
          redirectUrl: null
        };
      }
      if (hasSessionExpired) {
        return {
          payerValidationErrors: null,
          challengeRequired: false,
          hasSessionExpired: true,
          onReturnFromChallenge: null,
          redirectUrl: null
        };
      }
      const storeCardResponse = await storeCardInVaultTrigger(
        buildStoreCardInVaultPayload({
          form: { ...formValues, ...convertMagicValues(formValues.name, formValues.surname) },
          customerToken,
          accessKey: cardsContext.accessKey,
          accessToken: cardsContext.accessToken,
          validationType
        })
      );
      if (!storeCardResponse.operationResult) {
        throw buildRequestError({ status: 500, errors: storeCardResponse });
      }
      const ddcSessionId = await getDDCSessionId({
        providerUrl: cardsContext.urls.ddcProvider,
        issuerUrl: cardsContext.urls.ddcIssuer,
        domain: cardsContext.urls.ddcDomain,
        cardNumber: formValues.cardNumber
      });
      const {
        lastFour,
        token: { value: vaultShortToken }
      } = storeCardResponse.operationResultObject;
      const response = await zeroDollarChargeTrigger(
        buildCardDetailsPayload({
          formValues,
          lastFour,
          vaultShortToken,
          ddcSessionId,
          customerToken,
          cardsContext,
          currency
        })
      );
      const redirectUrl = response?.redirect_url;
      if (redirectUrl) {
        return {
          challengeRequired: true,
          redirectUrl,
          onReturnFromChallenge,
          hasSessionExpired: false,
          payerValidationErrors: null
        };
      } else {
        await storeCardInPlatformTrigger();
        await completeSessionTrigger();
        return {
          challengeRequired: false,
          hasSessionExpired: false,
          onReturnFromChallenge: null,
          payerValidationErrors: null,
          redirectUrl: null
        };
      }
    },
    [
      cardsContext,
      completeSessionTrigger,
      convertMagicValues,
      onReturnFromChallenge,
      storeCardInPlatformTrigger,
      storeCardInVaultTrigger,
      updatePayer,
      zeroDollarChargeTrigger
    ]
  );
  return { tokenize };
};
async function updateSessionsPayer(url, { arg }) {
  try {
    const response = await jsonFetcher(url, {
      method: "POST",
      body: JSON.stringify(arg)
    });
    return {
      customerToken: response.customer_token,
      payerValidationErrors: null,
      hasSessionExpired: false
    };
  } catch (e) {
    if (e instanceof RequestError) {
      if (e.status === INVALID_PAYER) {
        return {
          payerValidationErrors: e.response.errors,
          hasSessionExpired: false,
          customerToken: null
        };
      }
      if (e.status === SESSION_EXPIRED_STATUS) {
        return {
          hasSessionExpired: true,
          payerValidationErrors: null,
          customerToken: null
        };
      }
    }
    throw e;
  }
}
async function storeCardInVault(url, { arg }) {
  return await jsonFetcher(url, {
    method: "POST",
    body: JSON.stringify(arg)
  });
}
async function zeroDollarCharge(url, { arg }) {
  try {
    return await jsonFetcher(url, {
      method: "POST",
      body: JSON.stringify(arg)
    });
  } catch (e) {
    if (e instanceof RequestError) {
      if (e?.status === RESPONSE_CHALLENGE_STATUS_CODE) {
        return {
          redirect_url: e.response.redirect_url
        };
      }
    }
    throw e;
  }
}
async function storeCardInPlatform(url) {
  const res = await fetch(url, {
    method: "GET",
    headers: { "X-Request-Id": tracing.currentRequestId() }
  });
  if (!res.ok) {
    const error = buildRequestError({ status: res.status, errors: { message: await res.text() } });
    throw error;
  }
}
async function completeSession(url) {
  await textFetcher(url, {
    method: "POST"
  });
}

// ../internal-components/src/hooks/useCardTokenizationAndPay/useCardTokenizationAndPay.ts
import { useCallback as useCallback6 } from "react";
import useSWRMutation3 from "swr/mutation";
var INVALID_PAYER2 = 422;
var SESSION_EXPIRED_STATUS2 = 404;
var useCardTokenizationAndPay = () => {
  const { state: cardsContext } = useCardsContext();
  const { convert: convertMagicValues } = useLegacyMagicValuesConversor({
    enabled: cardsContext.magicValuesEnabled
  });
  const { trigger: updatePayer } = useSWRMutation3(
    cardsContext.urls.updateSessionsPayer,
    updateSessionsPayer2,
    {
      revalidate: false
    }
  );
  const { trigger: storeCardInVaultTrigger } = useSWRMutation3(
    cardsContext.urls.storeCardInVault,
    storeCardInVault2,
    {
      revalidate: false
    }
  );
  const { trigger: createPaymentTrigger } = useSWRMutation3(
    cardsContext.urls.createPayment,
    createPayment,
    {
      revalidate: false
    }
  );
  const { trigger: completeSessionTrigger } = useSWRMutation3(
    cardsContext.urls.completeSession,
    completeSession2,
    {
      revalidate: false
    }
  );
  const onReturnFromChallenge = useCallback6(async () => {
    await completeSessionTrigger();
  }, [completeSessionTrigger]);
  const tokenizeAndPay = async ({
    containerHeight,
    containerWidth,
    formValues
  }) => {
    const { payerValidationErrors, customerToken, hasSessionExpired } = await updatePayer(
      buildUpdatePayerPayloadFrom({
        ...formValues,
        surname: formValues.surname
      })
    );
    if (payerValidationErrors) {
      return {
        payerValidationErrors,
        challengeRequired: false,
        hasSessionExpired: false,
        onReturnFromChallenge: null,
        redirectUrl: null
      };
    }
    if (hasSessionExpired) {
      return {
        payerValidationErrors: null,
        challengeRequired: false,
        hasSessionExpired: true,
        onReturnFromChallenge: null,
        redirectUrl: null
      };
    }
    const storeCardResponse = await storeCardInVaultTrigger(
      buildStoreCardInVaultPayload({
        form: { ...formValues, ...convertMagicValues(formValues.name, formValues.surname) },
        customerToken,
        accessKey: cardsContext.accessKey,
        accessToken: cardsContext.accessToken
      })
    );
    if (!storeCardResponse.operationResult) {
      throw buildRequestError({ status: 500, errors: storeCardResponse });
    }
    const ddcSessionId = await getDDCSessionId({
      providerUrl: cardsContext.urls.ddcProvider,
      issuerUrl: cardsContext.urls.ddcIssuer,
      domain: cardsContext.urls.ddcDomain,
      cardNumber: formValues.cardNumber
    });
    const {
      lastFour,
      token: { value: vaultShortToken }
    } = storeCardResponse.operationResultObject;
    const response = await createPaymentTrigger(
      buildCreatePaymentPayload({
        formValues,
        state: cardsContext,
        containerHeight,
        containerWidth,
        customerToken,
        lastFour,
        oppToken: vaultShortToken,
        ddcSessionId
      })
    );
    const redirectUrl = response?.redirect_url;
    if (redirectUrl) {
      return {
        challengeRequired: true,
        redirectUrl,
        onReturnFromChallenge,
        hasSessionExpired: false,
        payerValidationErrors: null
      };
    } else {
      await completeSessionTrigger();
      return {
        challengeRequired: false,
        hasSessionExpired: false,
        onReturnFromChallenge: null,
        payerValidationErrors: null,
        redirectUrl: null
      };
    }
  };
  return { tokenizeAndPay };
};
async function updateSessionsPayer2(url, { arg }) {
  try {
    const response = await jsonFetcher(url, {
      method: "POST",
      body: JSON.stringify(arg)
    });
    return {
      customerToken: response.customer_token,
      hasSessionExpired: false,
      payerValidationErrors: null
    };
  } catch (e) {
    if (e instanceof RequestError) {
      if (e.status === INVALID_PAYER2) {
        return {
          payerValidationErrors: e.response.errors,
          customerToken: null,
          hasSessionExpired: false
        };
      }
      if (e.status === SESSION_EXPIRED_STATUS2) {
        return {
          hasSessionExpired: true,
          customerToken: null,
          payerValidationErrors: null
        };
      }
    }
    throw e;
  }
}
async function storeCardInVault2(url, { arg }) {
  return await jsonFetcher(url, {
    method: "POST",
    body: JSON.stringify(arg)
  });
}
async function createPayment(url, { arg }) {
  try {
    return await jsonFetcher(url, {
      method: "POST",
      body: JSON.stringify(arg)
    });
  } catch (e) {
    if (e instanceof RequestError) {
      if (e?.status === RESPONSE_CHALLENGE_STATUS_CODE) {
        return { redirect_url: e.response.redirect_url };
      }
    }
    throw e;
  }
}
async function completeSession2(url) {
  await textFetcher(url, {
    method: "POST"
  });
}
function buildCreatePaymentPayload({
  formValues,
  state,
  customerToken,
  lastFour,
  oppToken,
  ddcSessionId,
  containerWidth,
  containerHeight
}) {
  const cardType = getCardType(formValues.cardNumber);
  if (cardType === UNKNOWN)
    throw new Error("Unsupported card type");
  return {
    session_id: state.sessionId,
    customer_token: customerToken,
    last_four: lastFour,
    payment_method_token: oppToken,
    browser_info: browserInfo(),
    card_type: cardType,
    three_ds_version: state.threeDSVersion,
    ddc_session_id: ddcSessionId,
    locale: state.locale,
    window_size: getChallengeWindowSize(containerWidth, containerHeight)
  };
}

// ../internal-components/src/model.ts
var DD_SEPA = "dd_sepa";
var DD_BACS = "dd_bacs";
var DD_EFT = "dd_eft";
var DD_ACH = "dd_ach";
var TOKENIZATION = "tokenization";
var TOKENIZATION_AND_PAY = "tokenization_and_pay";

// src/CardElement/hooks/useSubmit.tsx
var useSubmit = ({
  onEndLoading,
  onError,
  onSuccess: onSuccessProp,
  onEvent,
  onStartLoading,
  currency,
  instructions,
  payerInfo,
  formMethods,
  challengeContainerRef
}) => {
  const { state, dispatch } = useCardsContext();
  const { tokenize } = useCardTokenization();
  const formValues = useWatch4({ control: formMethods.control });
  const { tokenizeAndPay } = useCardTokenizationAndPay();
  const { setPayerValidationErrors, validationStrategy, offerError, country } = useSafeContext(CardElementContext);
  const { onSuccess } = useOnSuccessWithPayerInfo({ formMethods, onSuccessProp });
  const emitTelemetryEvent = (e) => {
    onEvent?.(e);
  };
  const normalizePayerInfo = ({
    backendPayer,
    frontendPayer,
    formPayer
  }) => {
    const { firstName, lastName, ...restFrontendPayer } = frontendPayer || {};
    const name = formPayer?.name || firstName || backendPayer?.name;
    const surname = formPayer?.surname || lastName || backendPayer?.surname;
    return { ...backendPayer, ...restFrontendPayer, ...formPayer, name, surname };
  };
  const validateBackendPayload = (payerInfo2 = {}) => {
    if (!instructions) {
      throw new Error(
        "The form cannot be submitted without a sessionId. Please make sure that you are providing a sessionId to the CardElement component."
      );
    }
    const { currency: checkoutCurrency } = instructions;
    for (const key of REQUIRED_PAYER_INFO_FROM_BACKEND_KEYS) {
      if (!(key in payerInfo2) || !payerInfo2[key]) {
        throw new Error(exceptionMessage("payer information"));
      }
    }
    if (!checkoutCurrency && !currency) {
      throw new Error(exceptionMessage("currency iso code"));
    }
  };
  const submit = async () => {
    if (!state.sessionId || !instructions) {
      throw new Error(
        "The form cannot be submitted without a sessionId. Please make sure that you are providing a sessionId to the CardElement component."
      );
    }
    if (state.isLoading)
      return;
    const mergedPayerInfo = normalizePayerInfo({
      backendPayer: instructions?.payerInformation,
      frontendPayer: payerInfo,
      formPayer: formMethods.getValues()
    });
    validateBackendPayload(mergedPayerInfo);
    dispatch(showLoading());
    onStartLoading();
    try {
      let result;
      if (state.sessionType === TOKENIZATION_AND_PAY) {
        if (offerError?.type === "session_not_found") {
          notifyNotFoundError();
          return;
        }
        if (offerError?.type === "internal_error") {
          notifyInternalError(offerError);
          return;
        }
        if (offerError?.type === "offer_not_found") {
          emitNotFoundOfferEvent();
          return;
        }
        result = await tokenizeAndPay({
          containerHeight: challengeContainerRef?.current?.offsetHeight ?? 600,
          containerWidth: challengeContainerRef?.current?.offsetWidth ?? 400,
          formValues
        });
      } else {
        result = await tokenize({
          formValues: { ...formMethods.getValues(), ...mergedPayerInfo },
          currency: currency || instructions?.currency,
          validationType: validationStrategy === "senders" ? validationStrategy : void 0
        });
      }
      if (result.payerValidationErrors) {
        setPayerValidationErrors(result.payerValidationErrors);
        onError({
          type: "invalid_payer_info",
          errors: buildInvalidFormErrorsFromApi(result.payerValidationErrors)
        });
        resetForm(formMethods);
        return;
      }
      if (result.hasSessionExpired) {
        emitTelemetryEvent({
          type: "session_expired",
          extra: { message: "Session has expired" }
        });
        onError({ type: "not_found" });
        return;
      }
      if (result.challengeRequired) {
        emitTelemetryEvent({ type: "challenge_required" });
        dispatch(startChallenge(result.redirectUrl, result.onReturnFromChallenge));
        return;
      }
      resetForm(formMethods);
      emitTelemetryEvent({ type: "success" });
      onSuccess();
    } catch (e) {
      resetForm(formMethods);
      const error = e;
      onError({
        type: "internal_error",
        extra: {
          message: error.message,
          e: error,
          response: error.response,
          status: error.status
        }
      });
    } finally {
      onEndLoading();
      dispatch(hideLoading());
    }
  };
  const onInvalidForm = (errors) => {
    if (!state.sessionId || !instructions) {
      throw new Error(
        "The form cannot be submitted without a sessionId. Please make sure that you are providing a sessionId to the CardElement component."
      );
    }
    onError({
      type: "invalid_card_info",
      errors: mapErrors(errors)
    });
  };
  const mapErrors = (errors) => {
    return Object.keys(errors).reduce((acc, key) => {
      const error = errors[key];
      acc[key] = { type: error?.type, message: error?.message };
      return acc;
    }, {});
  };
  const notifyNotFoundError = () => {
    emitTelemetryEvent({
      type: "session_expired",
      extra: { message: "Session has expired" }
    });
    onError({ type: "not_found" });
  };
  const notifyInternalError = (offerError2) => {
    onError({
      type: "internal_error",
      extra: {
        message: offerError2.error.message,
        e: offerError2.error,
        response: offerError2.error.response,
        status: offerError2.error.status
      }
    });
  };
  const emitNotFoundOfferEvent = () => {
    emitTelemetryEvent({
      type: "offer_not_available",
      extra: {
        countryFrom: country,
        currency,
        amount: state.amount,
        sessionId: state.sessionId,
        recipient: { id: state.recipient.id }
      }
    });
  };
  return { submit, onInvalidForm };
};

// src/shared.ts
var BASE_CSS_CLASS = "fw-internal-react-elements";

// src/CardElement/CardElement.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var CardElementInternal = forwardRef((props, ref) => {
  const { name: firstName, surname: lastName } = props.instructions?.payerInformation || {};
  const formMethods = useForm({
    defaultValues: {
      ...transformPayerInfoToInternalFormat({
        firstName,
        lastName,
        ...props.payerInfo
      }),
      cvv: "",
      cardNumber: "",
      expiryDate: ""
    },
    mode: "onTouched",
    reValidateMode: "onChange"
  });
  const { onEndLoading, onError, onEvent, onStartLoading, onSuccess, onBinLookup } = props;
  const { state, dispatch } = useCardsContext();
  const challengeContainerRef = useRef2(null);
  const { submit, onInvalidForm } = useSubmit({
    ...props,
    formMethods,
    instructions: props.instructions,
    challengeContainerRef
  });
  const { onChallengeCompleted } = useChallengeCompleteHandler({
    onEndLoading,
    onError,
    onEvent,
    onStartLoading,
    onSuccess,
    formMethods
  });
  const { onBinLookupHandler } = useOnBinLookupHandler({ onBinLookup, onEvent });
  useFormStateEventNotifier({ formMethods, onEvent, instructions: props.instructions });
  useImperativeHandle(ref, () => ({
    submit: formMethods.handleSubmit(submit, onInvalidForm)
  }));
  if (state.inChallenge) {
    return /* @__PURE__ */ jsx15("div", { className: classNames7(BASE_CSS_CLASS, props.className), children: /* @__PURE__ */ jsx15(
      Challenge,
      {
        redirectUrl: state.redirectUrl ?? void 0,
        onChallengeCompleted,
        startLoading: () => props.onStartLoading(),
        onRechallenged: (redirectUrl) => {
          props.onEndLoading();
          dispatch(startRechallenge(redirectUrl));
        },
        onError: (e) => {
          props.onEndLoading();
          dispatch(returnFromFailedChallenge());
          props.onError({ type: "internal_error", extra: { e, message: e.message } });
        }
      }
    ) });
  }
  return /* @__PURE__ */ jsx15("div", { ref: challengeContainerRef, children: /* @__PURE__ */ jsx15(TranslationsProvider, { locale: props.instructions?.locale || "en", children: /* @__PURE__ */ jsx15(FormProvider, { ...formMethods, children: /* @__PURE__ */ jsx15(
    CardForm,
    {
      acceptedCards: props.instructions?.acceptedCards || [],
      className: props.className,
      onBinTyped: onBinLookupHandler,
      children: props.children
    }
  ) }) }) });
});
CardElementInternal.displayName = "CardElementInternal";
var EmptyCardElementWrapper = forwardRef(({ instructions, ...props }, ref) => {
  return /* @__PURE__ */ jsx15(TranslationsProvider, { locale: "en", children: /* @__PURE__ */ jsx15(CardsContextProvider, { ...instructions, children: /* @__PURE__ */ jsx15(CardElementInternal, { ...props, instructions, ref }) }) });
});
EmptyCardElementWrapper.displayName = "EmptyCardElementWrapper";
var CardElement = forwardRef((props, ref) => {
  const { isLoading, instructions, error } = useSessionConfig(props.sessionId, props.environment);
  useEffect5(() => {
    if (isLoading) {
      props.onStartLoading();
    }
  }, [isLoading]);
  useEffect5(() => {
    if (instructions || error) {
      props.onEndLoading();
    }
  }, [error, instructions]);
  useEffect5(() => {
    if (error?.type === "internal_error") {
      props.onError({
        type: "internal_error",
        extra: {
          message: error.message,
          e: error.cause,
          response: error.cause.response,
          status: error.cause?.status
        }
      });
    } else if (error?.type) {
      props.onError({ type: error?.type });
    }
  }, [error?.type]);
  if (error || !instructions) {
    return /* @__PURE__ */ jsx15(CardElementContextProvider, { children: /* @__PURE__ */ jsx15(EmptyCardElementWrapper, { instructions, ref, ...props }) });
  }
  return /* @__PURE__ */ jsx15(CardElementContextProvider, { children: /* @__PURE__ */ jsx15(CardsContextProvider, { ...instructions, children: /* @__PURE__ */ jsx15(CardElementInternal, { ...props, instructions, ref }) }) });
});
CardElement.displayName = "CardElement";
var PrefixedCVV = ({ className }) => {
  return /* @__PURE__ */ jsx15("div", { className: classNames7(BASE_CSS_CLASS, className), children: /* @__PURE__ */ jsx15(CardForm.CVV, {}) });
};
var PrefixedCardNumber = ({ className, error }) => {
  return /* @__PURE__ */ jsx15("div", { className: classNames7(BASE_CSS_CLASS, className), children: /* @__PURE__ */ jsx15(CardForm.CardNumber, { error }) });
};
var PrefixedExpiryDate = ({ className }) => {
  return /* @__PURE__ */ jsx15("div", { className: classNames7(BASE_CSS_CLASS, className), children: /* @__PURE__ */ jsx15(CardForm.ExpiryDate, {}) });
};
var CardElementNamespace = Object.assign(CardElement, {
  CardNumber: PrefixedCardNumber,
  ExpiryDate: PrefixedExpiryDate,
  CVV: PrefixedCVV
});

// src/CardNewMandate/CardNewMandate.tsx
import { forwardRef as forwardRef5 } from "react";

// src/CardNewMandate/CVV.tsx
import classNames8 from "classnames";

// ../internal-components/src/Cards/NewMandate/context/actions.ts
var startChallenge2 = (redirectUrl, onReturnFromChallenge, trace) => ({
  type: "START_CHALLENGE" /* START_CHALLENGE */,
  redirectUrl,
  onReturnFromChallenge,
  trace
});
var startRechallenge2 = (redirectUrl) => ({
  type: "START_RECHALLENGE" /* START_RECHALLENGE */,
  redirectUrl
});
var returnFromSuccessfulChallenge2 = () => ({
  type: "RETURN_FROM_SUCCESSFUL_CHALLENGE" /* RETURN_FROM_SUCCESSFUL_CHALLENGE */
});
var returnFromFailedChallenge2 = () => ({
  type: "RETURN_FROM_FAILED_CHALLENGE" /* RETURN_FROM_FAILED_CHALLENGE */
});
var showLoading2 = () => ({
  type: "SHOW_LOADING" /* SHOW_LOADING */
});
var hideLoading2 = () => ({
  type: "HIDE_LOADING" /* HIDE_LOADING */
});

// ../internal-components/src/Cards/NewMandate/context/model.ts
var defaultState2 = (urls, accessKey, accessToken, threeDSVersion, payerInformation, storedPaymentMethod, sessionId, acceptedCards, confirm, environment, onSuccess, onError, locale, actionButtonType) => ({
  sessionId,
  onSuccess,
  onError,
  isLoading: false,
  actionButtonType: actionButtonType || "save",
  urls,
  accessKey,
  accessToken,
  threeDSVersion,
  payerInformation,
  storedPaymentMethod,
  acceptedCards,
  confirm,
  locale: locale || "en",
  redirectUrl: null,
  inChallenge: false,
  successfulSession: false,
  onReturnFromChallenge: void 0,
  sessionExpired: false,
  error: void 0,
  environment
});

// ../internal-components/src/Cards/NewMandate/context/NewMandateContextProvider.tsx
import { createContext as createContext5, useReducer as useReducer2 } from "react";

// ../internal-components/src/Cards/NewMandate/context/reducer.ts
var reducer2 = (state, action) => {
  switch (action.type) {
    case "SHOW_EXPIRED_SESSION_ERROR" /* SHOW_EXPIRED_SESSION_ERROR */:
      return { ...state, isLoading: false, error: void 0, sessionExpired: true };
    case "SHOW_ERROR" /* SHOW_ERROR */:
      return {
        ...state,
        error: action?.error || { message: "error" },
        isLoading: false
      };
    case "START_CHALLENGE" /* START_CHALLENGE */:
      return {
        ...state,
        error: void 0,
        inChallenge: true,
        redirectUrl: action.redirectUrl,
        onReturnFromChallenge: action.onReturnFromChallenge,
        trace: action.trace
      };
    case "START_RECHALLENGE" /* START_RECHALLENGE */:
      return {
        ...state,
        error: void 0,
        inChallenge: true,
        redirectUrl: action.redirectUrl
      };
    case "RETURN_FROM_SUCCESSFUL_CHALLENGE" /* RETURN_FROM_SUCCESSFUL_CHALLENGE */:
      return {
        ...state,
        inChallenge: false,
        successfulSession: true,
        redirectUrl: null,
        error: void 0
      };
    case "RETURN_FROM_FAILED_CHALLENGE" /* RETURN_FROM_FAILED_CHALLENGE */:
      return {
        ...state,
        inChallenge: false,
        successfulSession: false,
        redirectUrl: null,
        error: { message: "challenge_error" }
      };
    case "SUCCESSFUL_SESSION" /* SUCCESSFUL_SESSION */:
      return {
        ...state,
        successfulSession: true,
        isLoading: false
      };
    case "RETURN_BACK_TO_FORM" /* RETURN_BACK_TO_FORM */:
      return {
        ...state,
        inChallenge: false,
        error: void 0,
        isLoading: false
      };
    case "SHOW_LOADING" /* SHOW_LOADING */:
      return { ...state, isLoading: true };
    case "HIDE_LOADING" /* HIDE_LOADING */:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

// ../internal-components/src/Cards/NewMandate/context/NewMandateContextProvider.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var NewMandateContext = createContext5(void 0);
NewMandateContext.displayName = "NewMandateContext";
var NewMandateContextProvider = (props) => {
  const {
    children,
    onSuccess,
    onError,
    ddcProviderUrl,
    ddcIssuerDomain,
    ddcIssuerUrl,
    accessKey,
    accessToken,
    threeDSVersion,
    locale,
    actionButtonType,
    verificationIdUrl,
    captureServiceUrl,
    reauthorizationUrl,
    getBinUrl,
    completeFormUrl,
    payerInformation,
    storedPaymentMethod,
    sessionId,
    acceptedCards,
    confirmUrl,
    environment
  } = props;
  const urls = {
    obtainVerificationId: verificationIdUrl,
    addPaymentVerification: captureServiceUrl,
    obtainBin: getBinUrl,
    generateNewMandate: reauthorizationUrl,
    obtainDDCId: ddcProviderUrl,
    completeForm: completeFormUrl,
    ddcDomain: ddcIssuerDomain,
    ddcIssuer: ddcIssuerUrl,
    ddcProvider: ddcProviderUrl
  };
  const [state, dispatch] = useReducer2(
    reducer2,
    defaultState2(
      urls,
      accessKey,
      accessToken,
      threeDSVersion,
      payerInformation,
      storedPaymentMethod,
      sessionId,
      acceptedCards,
      confirmUrl,
      environment,
      onSuccess,
      onError,
      locale,
      actionButtonType
    )
  );
  return /* @__PURE__ */ jsx16(NewMandateContext.Provider, { value: { state, dispatch }, children });
};

// ../internal-components/src/Cards/NewMandate/context/useNewMandateContext.ts
var useNewMandateContext = () => useSafeContext(NewMandateContext);

// src/CardNewMandate/CVV.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
var CVV2 = ({ className }) => {
  const {
    state: { storedPaymentMethod }
  } = useNewMandateContext();
  const { t } = useTranslations();
  return /* @__PURE__ */ jsx17("div", { className: classNames8(BASE_CSS_CLASS, className), children: /* @__PURE__ */ jsx17(
    CardForm.CVV,
    {
      required: true,
      validate: (cvv) => {
        if (!validateCvvInput(cvv, storedPaymentMethod.type)) {
          return t(`bankAccountForm.errors.cvv`);
        }
      }
    }
  ) });
};

// src/CardNewMandate/CardsNewMandateProvider.tsx
import { forwardRef as forwardRef4, useEffect as useEffect6 } from "react";

// src/CardNewMandate/CardNewMandateInternal.tsx
import classNames9 from "classnames";
import { forwardRef as forwardRef2, useCallback as useCallback9, useImperativeHandle as useImperativeHandle2 } from "react";
import { FormProvider as FormProvider2, useForm as useForm2 } from "react-hook-form";

// src/CardNewMandate/hooks/useTelemetryEvents.tsx
import { useCallback as useCallback7 } from "react";
var useTelemetryEvents = ({ onEvent }) => {
  const emitTelemetryEvent = useCallback7(
    (e) => {
      onEvent?.(e);
    },
    [onEvent]
  );
  return { emitTelemetryEvent };
};

// src/CardNewMandate/hooks/useOnChallengeCompleted.tsx
var useOnChallengeCompleted = ({
  onEvent,
  onStartLoading,
  onEndLoading,
  onSuccess,
  onError,
  onResetCVV
}) => {
  const { state, dispatch } = useNewMandateContext();
  const { emitTelemetryEvent } = useTelemetryEvents({ onEvent });
  const onChallengeCompleted = async (status, error) => {
    onEndLoading();
    emitTelemetryEvent({ type: "return_from_challenge", extra: { status, error } });
    if (status === "success" || status === "unknown") {
      dispatch(returnFromSuccessfulChallenge2());
      onStartLoading();
      await state.onReturnFromChallenge?.();
      onEndLoading();
      emitTelemetryEvent({ type: "success" });
      onSuccess({ confirm: state.confirm });
    } else if (status === "cancelled") {
      dispatch(returnFromFailedChallenge2());
      onError({ type: "challenge_error", extra: { status, error } });
    } else {
      dispatch(returnFromFailedChallenge2());
      onError({ type: "challenge_error", extra: { status, error } });
    }
    onResetCVV();
  };
  return { onChallengeCompleted };
};

// src/CardNewMandate/hooks/useSubmit.tsx
import { useWatch as useWatch5 } from "react-hook-form";

// ../internal-components/src/hooks/useCardNewMandate/useCardNewMandate.tsx
import { useCallback as useCallback8 } from "react";
import useSWRMutation4 from "swr/mutation";
var EXPIRED_SESSION_STATUS_CODE = 404;
var RESPONSE_CHALLENGE_STATUS_CODE2 = 401;
var useCardNewMandate = () => {
  const { state } = useNewMandateContext();
  const { trigger: requestPMVId } = useSWRMutation4(state.urls.obtainVerificationId, PMVIdFetcher, {
    revalidate: false
  });
  const { trigger: addPaymentVerification } = useSWRMutation4(
    `${state.urls.addPaymentVerification}/addPaymentMethodVerification`,
    addPaymentVerificationFetcher,
    {
      revalidate: false
    }
  );
  const { trigger: obtainBin } = useSWRMutation4(state.urls.obtainBin, obtainBinFetcher, {
    revalidate: false
  });
  const { trigger: generateMandate } = useSWRMutation4(
    state.urls.generateNewMandate,
    generateMandateFetcher,
    {
      revalidate: false
    }
  );
  const { trigger: completeSession3 } = useSWRMutation4(
    state.urls.completeForm,
    completeSessionFetcher,
    {
      revalidate: false
    }
  );
  const onReturnFromChallenge = useCallback8(async () => {
    if (state.urls.completeForm) {
      await completeSession3();
    }
  }, [completeSession3, state.urls.completeForm]);
  const generateNewMandate = async ({
    cvv,
    currency
  }) => {
    const pmvIdResponse = await requestPMVId();
    if (pmvIdResponse.hasSessionExpired) {
      return {
        hasSessionExpired: true,
        challengeRequired: false,
        onReturnFromChallenge: null,
        redirectUrl: null
      };
    }
    const addPMVResponse = await addPaymentVerification({
      paymentMethod: { CVV: cvv, pmvId: pmvIdResponse.pmv_id },
      authenticationRequest: {
        accessToken: state.accessToken,
        key: state.accessKey
      }
    });
    if (!addPMVResponse?.operationResult) {
      throw buildRequestError({ status: 500, errors: addPMVResponse });
    }
    const obtainBinResponse = await obtainBin();
    if (obtainBinResponse.hasSessionExpired) {
      return {
        hasSessionExpired: true,
        challengeRequired: false,
        onReturnFromChallenge: null,
        redirectUrl: null
      };
    }
    const ddcSessionId = await getDDCSessionId({
      providerUrl: state.urls.ddcProvider,
      issuerUrl: state.urls.ddcIssuer,
      domain: state.urls.ddcDomain,
      cardNumber: obtainBinResponse.bin
    });
    const browserInformation = browserInfo();
    const generateMandateResponse = await generateMandate({
      ddc_session_id: ddcSessionId,
      locale: state.locale,
      three_ds_version: state.threeDSVersion,
      window_size: getChallengeWindowSize(
        browserInformation.screen_width,
        browserInformation.screen_height
      ),
      browser_info: browserInformation,
      currency_code: currency
    });
    if (generateMandateResponse.redirect_url) {
      return {
        challengeRequired: true,
        redirectUrl: generateMandateResponse.redirect_url,
        onReturnFromChallenge,
        hasSessionExpired: false
      };
    }
    if (state.urls.completeForm) {
      await completeSession3();
    }
    return {};
  };
  return { generateNewMandate };
};
async function PMVIdFetcher(url) {
  try {
    return await jsonFetcher(url, {
      method: "GET"
    });
  } catch (e) {
    if (e instanceof RequestError) {
      if (e.status === EXPIRED_SESSION_STATUS_CODE) {
        return { hasSessionExpired: true };
      }
    }
    throw e;
  }
}
async function addPaymentVerificationFetcher(url, { arg }) {
  return await jsonFetcher(url, {
    method: "POST",
    body: JSON.stringify(arg)
  });
}
async function obtainBinFetcher(url) {
  try {
    return await jsonFetcher(url, {
      method: "GET"
    });
  } catch (e) {
    if (e instanceof RequestError) {
      if (e.status === EXPIRED_SESSION_STATUS_CODE) {
        return { hasSessionExpired: true };
      }
    }
    throw e;
  }
}
async function generateMandateFetcher(url, { arg }) {
  try {
    return await jsonFetcher(url, {
      method: "POST",
      body: JSON.stringify(arg)
    });
  } catch (e) {
    if (e instanceof RequestError) {
      if (e?.status === RESPONSE_CHALLENGE_STATUS_CODE2) {
        return { redirect_url: e.response.redirect_url };
      }
    }
    throw e;
  }
}
async function completeSessionFetcher(url) {
  await textFetcher(url, {
    method: "POST"
  });
}

// src/CardNewMandate/hooks/useSubmit.tsx
var useSubmit2 = ({
  currency,
  onEvent,
  onStartLoading,
  onEndLoading,
  onSuccess,
  onError,
  formMethods
}) => {
  const { state, dispatch } = useNewMandateContext();
  const { emitTelemetryEvent } = useTelemetryEvents({ onEvent });
  const { generateNewMandate } = useCardNewMandate();
  const cvv = useWatch5({ control: formMethods.control, name: FIELDS.CARD_CVV });
  const submit = async () => {
    if (!state.sessionId) {
      throw new Error(
        "The form cannot be submitted without a sessionId. Please make sure that you are providing a sessionId to the CardNewMandate component."
      );
    }
    if (state.isLoading)
      return;
    dispatch(showLoading2());
    onStartLoading();
    try {
      const { challengeRequired, hasSessionExpired, onReturnFromChallenge, redirectUrl } = await generateNewMandate({ cvv, currency });
      onEndLoading();
      dispatch(hideLoading2());
      if (hasSessionExpired) {
        emitTelemetryEvent({
          type: "session_expired",
          extra: { message: "Session has expired" }
        });
        onError({ type: "not_found" });
        return;
      }
      if (challengeRequired) {
        emitTelemetryEvent({ type: "challenge_required" });
        dispatch(startChallenge2(redirectUrl, onReturnFromChallenge));
        return;
      }
      formMethods.resetField("cvv");
      emitTelemetryEvent({ type: "success" });
      onSuccess({ confirm: state.confirm });
    } catch (e) {
      formMethods.resetField("cvv");
      const error = e;
      onError({
        type: "internal_error",
        extra: {
          message: error.message,
          e: error,
          response: error.response,
          status: error.status
        }
      });
      onEndLoading();
      dispatch(hideLoading2());
    }
  };
  const onInvalidForm = () => {
    if (!state.sessionId) {
      throw new Error(
        "The form cannot be submitted without a sessionId. Please make sure that you are providing a sessionId to the CardNewMandate component."
      );
    }
    emitTelemetryEvent({ type: "submit_invalid_form" });
    onError({ type: "invalid_cvv" });
  };
  return { submit, onInvalidForm };
};

// src/CardNewMandate/CardNewMandateInternal.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var CardNewMandateInternal = forwardRef2(
  (props, ref) => {
    const formMethods = useForm2({
      mode: "onTouched",
      reValidateMode: "onChange",
      defaultValues: { cvv: "" }
    });
    const { state, dispatch } = useNewMandateContext();
    const { submit, onInvalidForm } = useSubmit2({ ...props, formMethods });
    const onResetCVV = useCallback9(() => {
      formMethods.resetField("cvv");
    }, [formMethods]);
    const { onChallengeCompleted } = useOnChallengeCompleted({ ...props, onResetCVV });
    useImperativeHandle2(ref, () => ({ submit: formMethods.handleSubmit(submit, onInvalidForm) }));
    if (state.inChallenge) {
      return /* @__PURE__ */ jsx18("div", { className: classNames9(BASE_CSS_CLASS, props.className), children: /* @__PURE__ */ jsx18(
        Challenge,
        {
          redirectUrl: state.redirectUrl ?? void 0,
          onChallengeCompleted,
          startLoading: () => props.onStartLoading(),
          onRechallenged: (redirectUrl) => {
            props.onEndLoading();
            dispatch(startRechallenge2(redirectUrl));
          },
          onError: () => {
          }
        }
      ) });
    }
    return /* @__PURE__ */ jsx18(FormProvider2, { ...formMethods, children: /* @__PURE__ */ jsx18(CardForm, { acceptedCards: state.acceptedCards, children: props.children }) });
  }
);
CardNewMandateInternal.displayName = "CardNewMandateInternal";

// src/CardNewMandate/EmptyNewMandateWrapper.tsx
import { forwardRef as forwardRef3 } from "react";
import { jsx as jsx19 } from "react/jsx-runtime";
var EmptyNewMandateWrapper = forwardRef3(({ instructions, children, ...props }, ref) => {
  return /* @__PURE__ */ jsx19(TranslationsProvider, { locale: "en", children: /* @__PURE__ */ jsx19(
    NewMandateContextProvider,
    {
      ...instructions,
      payerInformation: {},
      onError: () => {
      },
      onSuccess: () => {
      },
      children: /* @__PURE__ */ jsx19(CardNewMandateInternal, { ref, ...props, children })
    }
  ) });
});
EmptyNewMandateWrapper.displayName = "EmptyNewMandateWrapper";

// src/CardNewMandate/CardsNewMandateProvider.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
var CardsNewMandateProvider = forwardRef4(
  (props, ref) => {
    const { children, sessionId, environment, onStartLoading, onEndLoading, onError } = props;
    const { isLoading, instructions, error } = useSessionConfig(sessionId, environment);
    useEffect6(() => {
      if (isLoading) {
        onStartLoading();
      }
    }, [isLoading]);
    useEffect6(() => {
      if (instructions || error) {
        onEndLoading();
      }
    }, [error, instructions]);
    useEffect6(() => {
      if (error?.type === "internal_error") {
        onError({ type: "internal_error", extra: { message: error.message, e: error.cause } });
      } else if (error?.type) {
        onError({ type: error?.type });
      }
    }, [error?.type]);
    if (!sessionId || !instructions || error) {
      return /* @__PURE__ */ jsx20(EmptyNewMandateWrapper, { instructions, ref, ...props });
    }
    return /* @__PURE__ */ jsx20(TranslationsProvider, { locale: instructions.locale || "en", children: /* @__PURE__ */ jsx20(
      NewMandateContextProvider,
      {
        ...instructions,
        payerInformation: {},
        onError: () => {
        },
        onSuccess: () => {
        },
        children: /* @__PURE__ */ jsx20(CardNewMandateInternal, { ref, ...props, children })
      }
    ) });
  }
);
CardsNewMandateProvider.displayName = "CardNewMandateProvider";

// src/CardNewMandate/CardNewMandate.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var CardNewMandate = forwardRef5((props, ref) => {
  return /* @__PURE__ */ jsx21(CardsNewMandateProvider, { ...props, ref });
});
var CardNewMandateNamespace = Object.assign(CardNewMandate, { CVV: CVV2 });
CardNewMandate.displayName = "CardNewMandate";

// src/PayerElement/PayerElement.tsx
import { useEffect as useEffect12 } from "react";

// ../internal-components/src/components/Address/Address.tsx
import { useMemo as useMemo3 } from "react";
import { useFormContext as useFormContext4 } from "react-hook-form";
import { jsx as jsx22 } from "react/jsx-runtime";
var Address = (props) => {
  const { pattern, minLength, required } = props;
  const maxLength = props.maxLength || 256;
  const { getErrorLabel } = useErrorLabelForField();
  const {
    getValues,
    formState: { errors }
  } = useFormContext4();
  const { t } = useTranslations();
  const error = useMemo3(() => {
    const addressError = errors.address;
    if (addressError?.type === "maxLength") {
      return t("form.errors.address.maxSizeExceeded", { limit: maxLength.toString() });
    }
    return getErrorLabel(FIELDS.ADDRESS);
  }, [errors.address, getErrorLabel, maxLength, t]);
  const inputProps = {
    name: FIELDS.ADDRESS,
    label: t("bankAccountForm.labels.address"),
    initialValue: getValues(FIELDS.ADDRESS) || "",
    required: required || true,
    "data-testid": "address",
    error,
    className: props.className,
    readOnly: props.readOnly,
    minLength: minLength || 1,
    maxLength,
    requiredErrorMessage: t("bankAccountForm.errors.address"),
    validate: (value) => {
      const appliedPattern = pattern || LATIN_CHARS_NUMBERS_AND_SYMBOLS_PATTERN;
      if (POBOX_PATTERN.test(value)) {
        return t("bankAccountForm.errors.addressIsPoBox");
      }
      if (appliedPattern.test(value)) {
        return t("bankAccountForm.errors.onlyLetterOrNumberOrSymbol");
      }
    }
  };
  return /* @__PURE__ */ jsx22(Input, { ...inputProps, autoComplete: "street-address" });
};
Address.displayName = "Address";

// ../internal-components/src/components/City/City.tsx
import { useMemo as useMemo4 } from "react";
import { useFormContext as useFormContext5 } from "react-hook-form";
import { jsx as jsx23 } from "react/jsx-runtime";
var City = (props) => {
  const { minLength, required } = props;
  const maxLength = props.maxLength || 256;
  const {
    getValues,
    formState: { errors }
  } = useFormContext5();
  const { getErrorLabel } = useErrorLabelForField();
  const { t } = useTranslations();
  const error = useMemo4(() => {
    if (errors.city?.type === "maxLength") {
      return t("form.errors.city.maxSizeExceeded", { limit: maxLength.toString() });
    }
    return getErrorLabel(FIELDS.CITY);
  }, [errors.city?.type, getErrorLabel, maxLength, t]);
  const inputProps = {
    name: FIELDS.CITY,
    label: t("bankAccountForm.labels.city"),
    initialValue: getValues(FIELDS.CITY) || "",
    required: required || true,
    "data-testid": "city",
    error,
    className: props.className,
    readOnly: props.readOnly || false,
    minLength: minLength || 1,
    maxLength,
    requiredErrorMessage: t("bankAccountForm.errors.city"),
    validate: (v) => {
      if (ONLY_LATIN_CHARS_AND_NUMBERS_PATTERN.test(v)) {
        return t(`bankAccountForm.errors.onlyLetterOrNumbers`);
      }
    }
  };
  return /* @__PURE__ */ jsx23(Input, { ...inputProps, autoComplete: "address-level2" });
};
City.displayName = "City";

// ../internal-components/src/components/Country/Country.tsx
import { useMemo as useMemo6 } from "react";
import { Controller as Controller2, useFormContext as useFormContext6 } from "react-hook-form";

// ../internal-components/src/components/Autocomplete/Autocomplete.tsx
import { Combobox, Transition } from "@headlessui/react";
import classNames10 from "classnames";
import {
  Fragment,
  createContext as createContext6,
  useContext as useContext2,
  useMemo as useMemo5,
  useRef as useRef3,
  useState as useState7
} from "react";

// ../internal-components/src/components/Icons/Chevron.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
var Chevron = ({ className }) => {
  return /* @__PURE__ */ jsx24(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      className,
      width: "10",
      height: "7",
      viewBox: "185 19 10 7",
      children: /* @__PURE__ */ jsx24(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M194.82 20.819l-.713-.68c-.198-.192-.518-.192-.714-.002L190 23.416l-3.423-3.303c-.2-.19-.518-.19-.716 0l-.713.68c-.196.186-.196.49 0 .678l4.494 4.33c.2.186.52.186.715 0l4.466-4.302c.2-.188.2-.492 0-.68z"
        }
      )
    }
  );
};

// ../internal-components/src/components/Autocomplete/Autocomplete.tsx
import { jsx as jsx25, jsxs as jsxs7 } from "react/jsx-runtime";
function standarizeText(text) {
  return text.toLowerCase().replace(/\s+/g, "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
var AutocompleteContext = createContext6({
  open: false,
  setQuery: () => {
  },
  filteredOptions: []
});
function Option({ option, render }) {
  const { name } = useContext2(AutocompleteContext);
  return /* @__PURE__ */ jsxs7(
    Combobox.Option,
    {
      className: ({ active }) => `fw-relative fw-cursor-default fw-select-none fw-min-h-[48px] fw-p-4 fw-text-sm ${active ? "fw-bg-primary-600 fw-text-white" : "fw-text-gray-900"}`,
      "aria-label": option.label,
      "data-testid": `${name}-${option.value}`,
      value: option.value,
      children: [
        render && render({ option }),
        !render && option.label
      ]
    }
  );
}
function Options({ className, render }) {
  const { filteredOptions, setQuery } = useContext2(AutocompleteContext);
  const cn = useMemo5(
    () => classNames10(
      `fw-absolute fw-z-10 fw-mt-0.5 fw-max-h-72 fw-w-full fw-overflow-auto
        fw-rounded-sm fw-border fw-shadow-lg-blue fw-border-primary-600 
        fw-bg-white fw-text-base fw-sm:text-sm fw-focus:outline-none`,
      className
    ),
    [className]
  );
  return /* @__PURE__ */ jsx25(
    Transition,
    {
      as: Fragment,
      afterLeave: () => setQuery(""),
      enter: "fw-transition-all fw-duration-200 fw-ease-in-out",
      enterFrom: "fw-transform fw-opacity-0 fw-max-h-0",
      enterTo: "fw-transform fw-opacity-100 fw-max-h-72",
      leaveFrom: "fw-transform fw-opacity-100 fw-max-h-72",
      leaveTo: "fw-transform fw-opacity-0 fw-max-h-0",
      children: /* @__PURE__ */ jsx25(Combobox.Options, { className: cn, children: filteredOptions.map((option) => /* @__PURE__ */ jsx25(Option, { option, render }, `${option.value}-${option.label}`)) })
    }
  );
}
function Error2(props) {
  return /* @__PURE__ */ jsx25(Input.Error, { ...props });
}
function Hint(props) {
  return /* @__PURE__ */ jsx25(Input.Hint, { ...props });
}
function AutocompleteInput({
  label,
  className,
  hideErrorText
}) {
  const {
    disabled,
    filteredOptions,
    name,
    readOnly,
    required,
    setQuery,
    error = "",
    open,
    dataTestid
  } = useContext2(AutocompleteContext);
  const buttonRef = useRef3(null);
  const displayValue = (selected) => {
    return selected && filteredOptions.find((option) => option.value === selected)?.label || "";
  };
  const displayLabel = required ? `${label} *` : label;
  const cn = useMemo5(
    () => classNames10(
      "fw-relative fw-text-base fw-text-mirage-900 fw-peer fw-block fw-h-12 fw-w-full fw-appearance-none fw-rounded-sm fw-border fw-border-shuttle-gray-100 fw-hover:border-shuttle-gray-200 fw-outline-none fw-px-2 fw-pt-4 fw-focus:border-primary-600 fw-focus:shadow-lg-blue fw-focus:outline-none fw-placeholder:invisible",
      "ui-open:fw-border-primary-600 ui-open:fw-shadow-lg-blue ui-open:fw-outline-none",
      "ui-not-open:fw-border-shuttle-gray-100 ui-not-open:hover:fw-border-shuttle-gray-200 ui-not-open:fw-shadow-none",
      {
        "fw-cursor-not-allowed fw-bg-huttle-gray-50": readOnly,
        "fw-shadow-lg-red !fw-border-red-600 fw-hover:border-red-600 fw-focus:border-red-600 fw-focus:shadow-lg-red": error && !open
      },
      className
    ),
    [className, error, open, readOnly]
  );
  return /* @__PURE__ */ jsxs7("div", { children: [
    /* @__PURE__ */ jsx25(Combobox.Button, { ref: buttonRef, className: "fw-border-0 fw-float-left" }),
    /* @__PURE__ */ jsx25(
      Combobox.Input,
      {
        id: name,
        className: cn,
        "data-testid": dataTestid,
        displayValue,
        onChange: (evt) => {
          setQuery(evt.target.value);
        },
        onClick: () => buttonRef.current?.click(),
        required: false,
        autoComplete: "off",
        placeholder: " ",
        "aria-required": required,
        readOnly,
        "aria-readonly": readOnly,
        "aria-disabled": disabled,
        "aria-autocomplete": "list",
        "aria-controls": `${name}-options`,
        "aria-labelledby": `${name}-label`
      }
    ),
    /* @__PURE__ */ jsx25(
      Combobox.Label,
      {
        className: "fw-absolute fw-top-[5px] fw-left-[8px] fw-m-0 fw-text-xs fw-text-shuttle-gray-500 fw-transition-all fw-peer-placeholder-shown:top-4 fw-peer-placeholder-shown:text-sm fw-peer-focus:top-[5px] fw-peer-focus:text-xs",
        onClick: () => buttonRef.current?.click(),
        "aria-label": label,
        children: displayLabel
      }
    ),
    /* @__PURE__ */ jsx25(
      Chevron,
      {
        className: `fw-absolute fw-top-[45%] fw-h-2 fw-w-3 fw-right-3 fw-text-shuttle-gray-500 fw-rotate-0 ${open ? "fw-rotate-180" : ""}`
      }
    ),
    error && !hideErrorText && /* @__PURE__ */ jsx25(Input.Error, { children: error })
  ] });
}
function Autocomplete({
  children,
  error,
  hint,
  name,
  onBlur,
  onChange,
  onFocus,
  options = [],
  value,
  required,
  readOnly,
  disabled,
  className,
  "data-testid": dataTestid
}) {
  const [query, setQuery] = useState7("");
  const filteredOptions = query === "" ? options : options.filter((option) => standarizeText(option.label).includes(standarizeText(query)));
  return /* @__PURE__ */ jsx25("div", { className: classNames10("fw-relative", className), children: /* @__PURE__ */ jsx25(
    Combobox,
    {
      as: "div",
      name,
      onBlur: () => {
        onBlur?.(name, query);
      },
      onChange,
      onFocus: () => {
        name && onFocus?.(name);
      },
      value,
      "data-testid": `${dataTestid}-container`,
      nullable: true,
      children: ({ open }) => /* @__PURE__ */ jsx25(
        AutocompleteContext.Provider,
        {
          value: {
            open,
            name,
            error,
            hint,
            required,
            readOnly,
            disabled,
            setQuery,
            filteredOptions,
            dataTestid
          },
          children
        }
      )
    }
  ) });
}
Autocomplete.Input = AutocompleteInput;
Autocomplete.Option = Option;
Autocomplete.Options = Options;
Autocomplete.Error = Error2;
Autocomplete.Hint = Hint;

// ../internal-components/src/components/DelayedInputSpinner/DelayedInputSpinner.tsx
import { useEffect as useEffect7, useState as useState8 } from "react";
import { jsx as jsx26 } from "react/jsx-runtime";
var DelayedInputSpinner = ({
  loading,
  delay = 500
}) => {
  const [spinnerOn, setSpinnerOn] = useState8(false);
  useEffect7(() => {
    if (!loading) {
      setSpinnerOn(false);
      return;
    }
    const timeout = window.setTimeout(() => {
      if (loading) {
        setSpinnerOn(true);
      }
    }, delay);
    return () => {
      window.clearTimeout(timeout);
    };
  }, [loading, delay]);
  return /* @__PURE__ */ jsx26(
    "span",
    {
      "aria-label": "delayed-spinner",
      role: "alert",
      "data-testid": "delayed-spinner",
      "aria-hidden": !spinnerOn,
      className: `delayed-input-spinner ${spinnerOn ? "delayed-input-spinner--shown" : "delayed-input-spinner--hidden"}`
    }
  );
};

// ../internal-components/src/components/Country/Country.tsx
import { jsx as jsx27, jsxs as jsxs8 } from "react/jsx-runtime";
var Country = (props) => {
  const required = props.required || true;
  const { control } = useFormContext6();
  const { getErrorLabel } = useErrorLabelForField();
  const { t } = useTranslations();
  const error = useMemo6(() => {
    if (props.error)
      return props.error;
    return getErrorLabel(FIELDS.COUNTRY);
  }, [getErrorLabel, props.error]);
  return /* @__PURE__ */ jsx27(
    Controller2,
    {
      name: FIELDS.COUNTRY,
      control,
      rules: {
        required: { value: required, message: t("bankAccountForm.errors.country") },
        validate: props.validate
      },
      render: ({ field: { value, onBlur, onChange, name, disabled } }) => {
        return /* @__PURE__ */ jsx27("div", { className: props.className, children: /* @__PURE__ */ jsxs8(
          Autocomplete,
          {
            onChange,
            onBlur,
            "data-testid": "country",
            value: value || null,
            options: props.countries ? countriesPropToOption(props.countries) : countries(t),
            error,
            disabled,
            name,
            readOnly: props.readOnly,
            children: [
              /* @__PURE__ */ jsx27(Autocomplete.Input, { label: t("bankAccountForm.labels.country") }),
              /* @__PURE__ */ jsx27(DelayedInputSpinner, { loading: props.loading || false, delay: 500 }),
              /* @__PURE__ */ jsx27(Autocomplete.Options, {})
            ]
          }
        ) });
      }
    }
  );
};
Country.displayName = "Country";
var countriesPropToOption = (countries2) => {
  return countries2.map((country) => ({ label: country.label, value: country.value }));
};
var countries = (t) => {
  const countries2 = COUNTRY_CODES.map((country) => {
    return { label: t(country), value: country };
  });
  return [...countries2];
};

// ../internal-components/src/components/EmailField/EmailField.tsx
import { useFormContext as useFormContext7 } from "react-hook-form";
import { jsx as jsx28 } from "react/jsx-runtime";
var EmailField = (props) => {
  const { minLength, required } = props;
  const { getValues } = useFormContext7();
  const { getErrorLabel } = useErrorLabelForField();
  const { t } = useTranslations();
  const error = getErrorLabel(FIELDS.EMAIL);
  const inputProps = {
    name: FIELDS.EMAIL,
    label: t("bankAccountForm.labels.email"),
    initialValue: getValues(FIELDS.EMAIL) || "",
    required: required || true,
    "data-testid": "email",
    error,
    className: props.className,
    readOnly: props.readOnly,
    minLength: minLength || 1,
    requiredErrorMessage: t("bankAccountForm.errors.email"),
    validate: (v) => {
      if (!EMAIL_PATTERN.test(v)) {
        return t("bankAccountForm.errors.email");
      }
    }
  };
  return /* @__PURE__ */ jsx28(Input, { ...inputProps, autoComplete: "email" });
};
EmailField.displayName = "EmailField";

// ../internal-components/src/components/FirstName/FirstName.tsx
import { useMemo as useMemo7 } from "react";
import { useFormContext as useFormContext8, useWatch as useWatch6 } from "react-hook-form";
import { jsx as jsx29 } from "react/jsx-runtime";
var FirstName = (props) => {
  const maxLength = props.maxLength || 256;
  const minLength = props.minLength || 1;
  const {
    getValues,
    formState: { errors },
    control
  } = useFormContext8();
  const accountHolderType = useWatch6({ control, name: FIELDS.ACCOUNT_HOLDER_TYPE });
  const { getErrorLabel } = useErrorLabelForField();
  const { t } = useTranslations();
  const error = useMemo7(() => {
    if (errors.name?.type === "maxLength") {
      const errorWithParam = {
        source: "translation",
        value: "form.errors.name.maxSizeExceeded",
        params: { limit: maxLength.toString() }
      };
      return t("form.errors.name.maxSizeExceeded", errorWithParam.params);
    }
    return getErrorLabel(FIELDS.NAME);
  }, [errors.name?.type, getErrorLabel, maxLength, t]);
  const inputProps = {
    name: FIELDS.NAME,
    label: t("bankAccountForm.labels.name"),
    initialValue: props.initialValue || getValues(FIELDS.NAME),
    required: props.required || true,
    "data-testid": "first-name",
    disabled: props.disabled,
    error,
    className: props.className,
    readOnly: props.readOnly || false,
    maxLength,
    minLength,
    requiredErrorMessage: t("bankAccountForm.errors.name"),
    validate: (value) => {
      const matches = value.match(ONLY_LATIN_CHARS_AND_NUMBERS_PATTERN);
      const invalidCharactersInValue = matches && matches.length > 0;
      if (accountHolderType && accountHolderType === PERSONAL_ACCOUNT_TYPE && invalidCharactersInValue) {
        return t("bankAccountForm.errors.onlyLetterOrNumbers");
      }
      if (invalidCharactersInValue) {
        return t("bankAccountForm.errors.onlyLetterOrNumbers");
      }
    }
  };
  return /* @__PURE__ */ jsx29(Input, { ...inputProps, autoComplete: "given-name" });
};
FirstName.displayName = "FirstName";

// ../internal-components/src/components/LastName/LastName.tsx
import { useMemo as useMemo8 } from "react";
import { useFormContext as useFormContext9 } from "react-hook-form";
import { jsx as jsx30 } from "react/jsx-runtime";
var LastName = (props) => {
  const maxLength = props.maxLength || 256;
  const minLength = props.minLength || 1;
  const {
    getValues,
    formState: { errors }
  } = useFormContext9();
  const { getErrorLabel } = useErrorLabelForField();
  const { t } = useTranslations();
  const error = useMemo8(() => {
    if (errors.surname?.type === "maxLength") {
      const errorWithParam = {
        source: "translation",
        value: "form.errors.surname.maxSizeExceeded",
        params: { limit: maxLength.toString() }
      };
      return t("form.errors.surname.maxSizeExceeded", errorWithParam.params);
    }
    return getErrorLabel(FIELDS.SURNAME);
  }, [errors.surname?.type, getErrorLabel, maxLength, t]);
  const inputProps = {
    name: FIELDS.SURNAME,
    label: t("bankAccountForm.labels.surname"),
    initialValue: props.initialValue || getValues(FIELDS.SURNAME),
    required: props.required || true,
    disabled: props.disabled,
    "data-testid": "last-name",
    error,
    className: props.className,
    readOnly: props.readOnly,
    maxLength,
    minLength,
    requiredErrorMessage: t("bankAccountForm.errors.surname"),
    validate: (value) => {
      const matches = value.match(ONLY_LATIN_CHARS_AND_NUMBERS_PATTERN);
      const invalidCharactersInValue = matches && matches.length > 0;
      if (invalidCharactersInValue) {
        return t("bankAccountForm.errors.onlyLetterOrNumbers");
      }
    }
  };
  return /* @__PURE__ */ jsx30(Input, { ...inputProps, autoComplete: "family-name" });
};
LastName.displayName = "LastName";

// ../internal-components/src/components/PayerInfo/PayerInfo.tsx
import classNames15 from "classnames";
import { Children, cloneElement, isValidElement, useMemo as useMemo15 } from "react";

// ../internal-components/src/components/AccountHolderName/AccountHolderName.tsx
import { useFormContext as useFormContext11, useWatch as useWatch8 } from "react-hook-form";

// ../internal-components/src/components/BusinessName/BusinessName.tsx
import classNames11 from "classnames";
import { useMemo as useMemo9 } from "react";
import { useFormContext as useFormContext10, useFormState, useWatch as useWatch7 } from "react-hook-form";

// ../internal-components/src/DirectDebit/Sepa/model.ts
var SEPA_FIELDS = {
  ACCOUNT_HOLDER_TYPE: "account_holder_type",
  BUSINESS_NAME: "business_name",
  NAME: "name",
  SURNAME: "surname",
  COUNTRY: "country",
  CITY: "city",
  ADDRESS: "address",
  EMAIL: "email",
  ZIP: "zip",
  BIC: "bic",
  IBAN: "iban",
  GENERAL_T_AND_C: "general-t-and-c",
  PAYMENT_METHOD_T_AND_C: "payment-method-t-and-c"
};

// ../internal-components/src/components/BusinessName/BusinessName.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
var BusinessName = (props) => {
  const { getErrorLabel } = useErrorLabelForField();
  const { t } = useTranslations();
  const { control } = useFormContext10();
  const { errors } = useFormState({ control });
  const accountHolderType = useWatch7({ control, name: SEPA_FIELDS.ACCOUNT_HOLDER_TYPE });
  const maxLength = props.maxLength || 256;
  const minLength = props.minLength || 1;
  const cn = useMemo9(
    () => classNames11("fw-col-span-1 xs:fw-col-span-2", props.className),
    [props.className]
  );
  const error = useMemo9(() => {
    if (errors[FIELDS.BUSINESS_NAME]?.type === "maxLength") {
      const errorWithParam = {
        source: "translation",
        value: "form.errors.business_name.maxSizeExceeded",
        params: { limit: maxLength.toString() }
      };
      return t("form.errors.business_name.maxSizeExceeded", errorWithParam.params);
    }
    return getErrorLabel(FIELDS.BUSINESS_NAME);
  }, [errors, getErrorLabel, maxLength, t]);
  const inputProps = {
    name: FIELDS.BUSINESS_NAME,
    label: t("bankAccountForm.labels.businessName"),
    required: props.required || false,
    "data-testid": "business-name",
    error,
    className: cn,
    readOnly: props.readOnly,
    requiredErrorMessage: t(`bankAccountForm.errors.business_name`),
    maxLength,
    minLength,
    validate: (v) => {
      if (accountHolderType === BUSINESS_ACCOUNT_TYPE && ONLY_LATIN_CHARS_AND_NUMBERS_PATTERN.test(v)) {
        return t("bankAccountForm.errors.onlyLetterOrNumbers");
      }
    }
  };
  return /* @__PURE__ */ jsx31(Input, { ...inputProps });
};

// ../internal-components/src/components/AccountHolderName/AccountHolderName.tsx
import { Fragment as Fragment2, jsx as jsx32, jsxs as jsxs9 } from "react/jsx-runtime";
var AccountHolderName = (props) => {
  const { control } = useFormContext11();
  const accountHolderType = useWatch8({ control, name: FIELDS.ACCOUNT_HOLDER_TYPE });
  if (accountHolderType === PERSONAL_ACCOUNT_TYPE) {
    return /* @__PURE__ */ jsxs9(Fragment2, { children: [
      !props.fieldSettings?.first_name.hidden && /* @__PURE__ */ jsx32(
        FirstName,
        {
          ...props,
          required: accountHolderType === PERSONAL_ACCOUNT_TYPE,
          readOnly: props.readOnly
        }
      ),
      !props.fieldSettings?.last_name.hidden && /* @__PURE__ */ jsx32(
        LastName,
        {
          ...props,
          required: accountHolderType === PERSONAL_ACCOUNT_TYPE,
          readOnly: props.readOnly
        }
      )
    ] });
  }
  return !props.fieldSettings?.business_name.hidden && /* @__PURE__ */ jsx32(
    BusinessName,
    {
      ...props,
      required: accountHolderType === BUSINESS_ACCOUNT_TYPE,
      readOnly: props.readOnly
    }
  );
};
AccountHolderName.displayName = "AccountHolderName";

// ../internal-components/src/components/DynamicFields/DynamicFields.tsx
import React3 from "react";

// ../internal-components/src/components/TermsAndConditions/useFlywireCheckbox.ts
import classNames12 from "classnames";
import { useFormContext as useFormContext12, useFormState as useFormState2 } from "react-hook-form";
var useFlywireCheckbox = (field) => {
  const { watch, control } = useFormContext12();
  const { errors } = useFormState2({ control, name: field });
  const checked = watch(field);
  const fieldHasError = !!errors[field];
  const cn = classNames12(
    "fw-w-5 fw-h-5 fw-items-center fw-flex-none fw-border fw-rounded-sm fw-flex focus:fw-outline-none focus:fw-border-primary-600 focus:fw-border-2",
    {
      "fw-bg-primary-600 fw-border-primary-600 fw-border-2": checked,
      "fw-border-gray-300": !checked,
      "fw-shadow-lg-red !fw-border-red-600 hover:fw-border-red-600 focus:fw-border-red-600 focus:fw-shadow-lg-red": fieldHasError && !checked
    }
  );
  return {
    className: cn
  };
};

// ../internal-components/src/components/DynamicFields/DynamicFields.tsx
import { Field as Field5 } from "@flywire/react-headlessui";
import { jsx as jsx33, jsxs as jsxs10 } from "react/jsx-runtime";
var formKeyFromFieldId = (id2) => `dynamicFields-${id2}`;
var DynamicFields = ({ fields, className }) => {
  const { getErrorLabel } = useErrorLabelForField();
  const { t } = useTranslations();
  const listItems = fields?.map((f) => {
    if (f.hidden) {
      return /* @__PURE__ */ jsx33(React3.Fragment, {}, f.id);
    } else if (f.type === "boolean") {
      return /* @__PURE__ */ jsx33("div", { children: /* @__PURE__ */ jsx33(CheckboxField, { ...fieldToCheckboxProps(f) }) }, f.id);
    } else if (f.type === "string") {
      return /* @__PURE__ */ jsx33("div", { className, children: /* @__PURE__ */ jsx33(
        Input,
        {
          ...fieldToInputProps(f, t),
          error: getErrorLabel(formKeyFromFieldId(f.id))
        }
      ) }, f.id);
    }
  });
  return listItems || [];
};
DynamicFields.displayName = "DynamicFields";
var CheckboxField = ({ name, label }) => {
  const { className: cn } = useFlywireCheckbox(name);
  return /* @__PURE__ */ jsx33("div", { className: "fw-flex fw-pb-4", children: /* @__PURE__ */ jsxs10(Field5.Checkbox, { className: cn, checked: true, ariaLabelledBy: name, children: [
    /* @__PURE__ */ jsx33(
      Field5.Label,
      {
        id: name,
        "aria-label": label,
        className: "fw-ml-3 fw-mb-0 fw-text-sm fw-text-gray-900"
      }
    ),
    /* @__PURE__ */ jsx33(
      Field5.CheckboxIndicator,
      {
        className: "fw-flex-1 fw-flex fw-items-center fw-justify-center",
        color: "#FFF"
      }
    ),
    label
  ] }) });
};
var BRAZILIAN_FIELD_ID = "document";
var fieldToInputProps = (field, t) => {
  const sanitizedPattern = field.pattern ? convertRubyPatternToJS(field.pattern) : void 0;
  const label = field.id === BRAZILIAN_FIELD_ID ? t(`tokenizationForm.labels.dynamicFields.document`) : field.label;
  const requiredErrorMessage = field.id === BRAZILIAN_FIELD_ID ? t(`bankAccountForm.errors.dynamicFields.document`) : t(`bankAccountForm.errors.dynamicFields`, { field: field.label });
  const patternErrorMessage = field.id === BRAZILIAN_FIELD_ID ? t(`bankAccountForm.errors.dynamicFields.documentPattern`) : field.patternMessage;
  return {
    label,
    name: formKeyFromFieldId(field.id),
    required: field.required,
    initialValue: field.value,
    hint: field.hint,
    patternErrorMessage,
    pattern: sanitizedPattern,
    requiredErrorMessage
  };
};
var fieldToCheckboxProps = (field) => ({
  label: field.label,
  name: formKeyFromFieldId(field.id),
  required: field.required,
  value: field.value || "",
  hint: field.hint
});
var convertRubyPatternToJS = (pattern) => {
  const ignoreCase = pattern.includes("(?i)");
  const patternStr = pattern.replace(/\\A/i, "^").replace(/\\Z/i, "$").replace(/\(\?i\)/g, "");
  return new RegExp(patternStr, ignoreCase ? "i" : void 0);
};

// ../internal-components/src/components/ReadonlyCountry/ReadonlyCountry.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var ReadonlyCountry = (props) => {
  const { getErrorLabel } = useErrorLabelForField();
  const { t } = useTranslations();
  const inputProps = {
    name: FIELDS.COUNTRY,
    label: t("bankAccountForm.labels.country"),
    error: getErrorLabel(FIELDS.COUNTRY),
    required: props.required || true,
    readOnly: true,
    "data-testid": "country",
    className: props.className,
    validate: props.validate,
    requiredErrorMessage: t("bankAccountForm.errors.country")
  };
  return /* @__PURE__ */ jsx34(Input, { ...inputProps });
};
ReadonlyCountry.displayName = "ReadonlyCountry";

// ../internal-components/src/components/State/State.tsx
import { useMemo as useMemo10 } from "react";
import { Controller as Controller3, useFormContext as useFormContext13, useWatch as useWatch9 } from "react-hook-form";

// ../internal-components/src/components/State/data/china.ts
var CHINA_PROVINCES = [
  { value: "AH", label: "Anhui Province" },
  { value: "BJ", label: "Beijing Municipality" },
  { value: "CQ", label: "Chongqing Municipality" },
  { value: "FJ", label: "Fujian Province" },
  { value: "GD", label: "Guangdong Province" },
  { value: "GS", label: "Gansu Province" },
  { value: "GX", label: "Guangxi Zhuang Autonomous Region" },
  { value: "GZ", label: "Guizhou Province" },
  { value: "HA", label: "Henan Province" },
  { value: "HB", label: "Hubei Province" },
  { value: "HE", label: "Hebei Province" },
  { value: "HI", label: "Hainan Province" },
  { value: "HK", label: "Hong Kong Special Administrative Region" },
  { value: "HL", label: "Heilongjiang Province" },
  { value: "HN", label: "Hunan Province" },
  { value: "JL", label: "Jilin Province" },
  { value: "JS", label: "Jiangsu Province" },
  { value: "JX", label: "Jiangxi Province" },
  { value: "LN", label: "Liaoning Province" },
  { value: "MO", label: "Macau Special Administrative Region" },
  { value: "NM", label: "Inner Mongolia Autonomous Region" },
  { value: "NX", label: "Ningxia Hui Autonomous Region" },
  { value: "QH", label: "Qinghai Province" },
  { value: "SC", label: "Sichuan Province" },
  { value: "SD", label: "Shandong Province" },
  { value: "SH", label: "Shanghai Municipality" },
  { value: "SN", label: "Shaanxi Province" },
  { value: "SX", label: "Shanxi Province" },
  { value: "TJ", label: "Tianjin Municipality" },
  { value: "TW", label: "Taiwan Province" },
  { value: "XJ", label: "Xinjiang Uyghur Autonomous Region" },
  { value: "XZ", label: "Tibet Autonomous Region" },
  { value: "YN", label: "Yunnan Province" },
  { value: "ZJ", label: "Zhejiang Province" }
];

// ../internal-components/src/components/State/data/usa.ts
var USA_STATES = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "District of Columbia", value: "DC" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansa", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Lousiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" }
];

// ../internal-components/src/components/State/State.tsx
import { jsx as jsx35, jsxs as jsxs11 } from "react/jsx-runtime";
var State = (props) => {
  const { control } = useFormContext13();
  const country = useWatch9({ control, name: "country" });
  const { getErrorLabel } = useErrorLabelForField();
  const { t } = useTranslations();
  const error = getErrorLabel(FIELDS.STATE);
  const stateOptions = useMemo10(() => {
    return statesForCountry(country).map((s) => ({ label: s.label, value: s.value }));
  }, [country]);
  const { required } = props;
  return /* @__PURE__ */ jsx35(
    Controller3,
    {
      name: FIELDS.STATE,
      control,
      rules: {
        required: { value: required || false, message: t("bankAccountForm.errors.state") },
        deps: ["country"],
        validate: props.validate
      },
      render: ({ field: { value, onChange, onBlur, name, disabled } }) => {
        return /* @__PURE__ */ jsx35("div", { className: props.className, children: /* @__PURE__ */ jsxs11(
          Autocomplete,
          {
            onChange,
            value: value || "",
            onBlur,
            "data-testid": "state",
            options: stateOptions,
            error,
            readOnly: props.readOnly,
            name,
            disabled,
            children: [
              /* @__PURE__ */ jsx35(Autocomplete.Input, { label: t("cardsForm.labels.state") }),
              /* @__PURE__ */ jsx35(Autocomplete.Options, {})
            ]
          }
        ) });
      }
    }
  );
};
var statesForCountry = (country) => {
  if (country === "US" || country === "United States")
    return USA_STATES;
  return CHINA_PROVINCES;
};
State.displayName = "State";

// ../internal-components/src/components/ZipCode/ZipCode.tsx
import { useFormContext as useFormContext14 } from "react-hook-form";
import { jsx as jsx36 } from "react/jsx-runtime";
var MAX_ZIP_LENGTH = 10;
var ZipCode = (props) => {
  const { getValues } = useFormContext14();
  const { getErrorLabel } = useErrorLabelForField();
  const { t } = useTranslations();
  const error = getErrorLabel(FIELDS.ZIP);
  const inputProps = {
    name: FIELDS.ZIP,
    label: t("bankAccountForm.labels.accountZipCode"),
    initialValue: getValues(FIELDS.ZIP) || "",
    required: props.required || true,
    "data-testid": "zip",
    error,
    className: props.className,
    readOnly: props.readOnly,
    requiredErrorMessage: t("bankAccountForm.errors.zip"),
    validate: (v) => {
      if (!/^([a-zA-Z0-9 ]*[\w áéíóúÁÉÍÓÚÑñ&]*)$/.test(v) || v?.length > MAX_ZIP_LENGTH) {
        return t(`bankAccountForm.errors.zip`);
      }
    }
  };
  return /* @__PURE__ */ jsx36(Input, { ...inputProps, autoComplete: "postal-code" });
};
ZipCode.displayName = "ZipCode";

// ../internal-components/src/components/PayerInfo/DefaultPayerInfo.tsx
import { useEffect as useEffect10 } from "react";
import { useFormContext as useFormContext16, useWatch as useWatch10 } from "react-hook-form";

// ../internal-components/src/hooks/useCountries/useCountries.ts
import { useMemo as useMemo11 } from "react";
import useSWRImmutable2 from "swr/immutable";
var useCountries = (url, locale) => {
  const fullUrl = useMemo11(() => `${url}?locale=${locale}`, [url, locale]);
  const {
    data = [],
    error,
    isLoading
  } = useSWRImmutable2(url ? fullUrl : null, jsonFetcher);
  const countries2 = useMemo11(() => {
    if (!isLoading) {
      return data.filter((c) => c.currency).map((c) => ({
        label: c.name,
        value: c.code,
        dialingCode: c.dialing_code,
        currency: c.currency
      }));
    }
  }, [data, isLoading]);
  return { countries: countries2, isLoading, error };
};

// ../internal-components/src/hooks/useOffer/useOffer.tsx
import { useEffect as useEffect8 } from "react";
import useSWRMutation5 from "swr/mutation";
async function offersFetcher(url, { arg }) {
  return await jsonFetcher(url, {
    method: "POST",
    body: JSON.stringify(arg)
  });
}
var useOffer = ({
  baseUrl,
  country,
  currency,
  amount,
  recipientId,
  sessionId,
  sessionType,
  cardType,
  cardScheme,
  cardCountry,
  cardProductType
}) => {
  const { trigger, isMutating, error, data: offer } = useSWRMutation5(baseUrl, offersFetcher);
  useEffect8(() => {
    const requestBody = {
      recipient: recipientId,
      amount,
      session_id: sessionId,
      country,
      currency,
      card_type: cardType,
      card_scheme: cardScheme,
      card_country: cardCountry,
      card_product_type: cardProductType
    };
    const shouldFetch = !!(sessionType === TOKENIZATION_AND_PAY && amount && baseUrl && currency && recipientId && sessionId && country);
    if (shouldFetch) {
      trigger(requestBody).catch(() => {
      });
    }
  }, [
    cardScheme,
    cardType,
    amount,
    currency,
    recipientId,
    sessionId,
    country,
    sessionType,
    baseUrl,
    cardCountry,
    cardProductType,
    trigger
  ]);
  const mappedOffer = offer ? mapOffer(offer) : offer;
  let customError = null;
  if (error) {
    customError = {
      type: error.response?.type || "unknown",
      error
    };
  }
  return { isMutating, offer: mappedOffer, error: customError };
};
var mapOffer = (offer) => ({
  id: offer.id,
  price: offer.price,
  fields: (offer.fields || []).map((f) => ({
    patternMessage: f.pattern_message,
    format: f.format,
    id: f.id,
    pattern: f.pattern,
    value: f.value,
    type: f.type,
    required: f.required,
    placeholder: f.view_options.placeholder,
    help: f.view_options.help,
    hidden: f.view_options.hidden,
    hint: f.view_options.hint,
    label: f.view_options.label,
    position: f.view_options.position
  })),
  surcharge: offer.surcharge
});

// ../internal-components/src/hooks/usePaymentOptions/usePaymentOptions.tsx
import { useMemo as useMemo12 } from "react";
import useSWRImmutable3 from "swr/immutable";
var adaptToModel = (fields) => {
  return (fields ?? []).map((f) => ({
    patternMessage: f.pattern_message,
    format: f.format,
    id: f.id,
    pattern: f.pattern,
    value: f.value,
    type: f.type,
    required: f.required,
    placeholder: f.view_options.placeholder,
    help: f.view_options.help,
    hidden: f.view_options.hidden,
    hint: f.view_options.hint,
    label: f.view_options.label,
    position: f.view_options.position
  }));
};
var usePaymentOptions = ({ url, country, recipient, sessionType }) => {
  const { t } = useTranslations();
  const fullUrl = useMemo12(
    () => `${url}?country=${country}&recipient=${recipient}`,
    [country, recipient, url]
  );
  const shouldFetch = sessionType === TOKENIZATION && country && recipient && url;
  const {
    data = { currencies: [], fields: [] },
    error: fetchError,
    isLoading
  } = useSWRImmutable3(shouldFetch ? fullUrl : null, jsonFetcher);
  if (!shouldFetch) {
    return { currencies: null, isLoading: false, error: null, fields: null };
  }
  const currencies = !isLoading ? data.currencies : null;
  const fields = !isLoading ? adaptToModel(data.fields) : null;
  const error = !isLoading && data.currencies.length === 0 || fetchError;
  return {
    currencies,
    fields,
    isLoading,
    error: error ? t("tokenizationForm.errors.noPaymentOptionsAvailable") : null
  };
};

// ../internal-components/src/constants.ts
var UNITED_STATES = "US";
var CHINA = "CN";

// ../internal-components/src/components/PhoneNumber/PhoneNumber.tsx
import classNames14 from "classnames";
import { useCallback as useCallback11, useMemo as useMemo14 } from "react";
import { Controller as Controller4, useFormContext as useFormContext15 } from "react-hook-form";

// ../internal-components/src/components/PhoneNumber/PrefixList.tsx
import { Listbox } from "@headlessui/react";
import classNames13 from "classnames";
import { useCallback as useCallback10, useEffect as useEffect9, useMemo as useMemo13, useState as useState9 } from "react";
import { Fragment as Fragment3, jsx as jsx37, jsxs as jsxs12 } from "react/jsx-runtime";
var Prefix = ({ option, active }) => {
  const cn = useCallback10(
    (active2) => classNames13(
      `fw-relative fw-cursor-default fw-select-none fw-min-h-[48px] fw-p-4 fw-text-sm fw-text-gray-900 fw-w-full`,
      {
        "fw-bg-primary-600 fw-text-white": active2,
        "fw-text-gray-900": !active2
      }
    ),
    []
  );
  return /* @__PURE__ */ jsxs12("div", { className: cn(active), children: [
    /* @__PURE__ */ jsx37("span", { className: "fw-text-base fw-pr-2", children: option.name }),
    /* @__PURE__ */ jsxs12("span", { className: "fw-text-gray-400", children: [
      "+",
      option.value
    ] })
  ] });
};
var PrefixList = ({
  value,
  options,
  onChange = () => {
  },
  onBlur = () => {
  },
  error = void 0,
  className = "",
  showBlank = true,
  inputName = ""
}) => {
  const [selected, setSelected] = useState9(options[0]);
  const handleChange = (value2) => {
    setSelected(value2);
    if (onChange) {
      onChange(value2);
    }
  };
  useEffect9(() => {
    if (value) {
      const selectedOption = options.find((option) => option.value === value);
      if (selectedOption) {
        setSelected(selectedOption);
      }
    }
  }, [value, options]);
  const buttonCn = useMemo13(
    () => classNames13(
      `fw-flex fw-h-12 fw-w-[95px] fw-relative fw-justify-center fw-items-center
        fw-bg-white fw-text-gray-900 fw-text-base fw-text-left fw-align-baseline fw-border fw-border-r-0
        ui-open:fw-border-primary-600 ui-open:fw-shadow-lg-blue ui-open:fw-outline-none
        ui-not-open:fw-border-shuttle-gray-100 ui-not-open:hover:fw-border-shuttle-gray-200 ui-not-open:fw-shadow-none
        fw-focus:border-primary-600 fw-focus:shadow-lg-blue fw-appearance-none fw-outline-none fw-focus:outline-none`,
      {
        "fw-shadow-lg-red fw-border-red-600": error,
        "fw-shadow-sm": !error
      }
    ),
    [error]
  );
  const chevronCn = useCallback10(
    (open) => classNames13(
      "fw-absolute fw-top-[45%] fw-right-1 fw-h-2 fw-w-3 fw-right-3 fw-text-shuttle-gray-500 fw-rotate-0",
      {
        "fw-rotate-180": open
      }
    ),
    []
  );
  const optionsCn = useCallback10(
    (open) => classNames13(
      `fw-absolute fw-z-10 fw-mt-1 fw-w-full fw-max-h-72 fw-w-full fw-overflow-auto 
        fw-bg-white fw-border fw-border-gray-300 fw-shadow-lg
        ui-open:fw-border-primary-600 ui-open:fw-shadow-lg-blue ui-open:fw-outline-none`,
      {
        "fw-block": open,
        "fw-hidden": !open
      }
    ),
    []
  );
  const optionCn = "fw-w-full fw-relative fw-cursor-default fw-select-none fw-min-h-[48px] fw-text-sm fw-text-gray-900";
  const buttonValue = useMemo13(
    () => selected?.value ? `+ ${selected?.value}` : "",
    [selected?.value]
  );
  return /* @__PURE__ */ jsx37(Listbox, { as: "div", className, onChange: handleChange, onBlur, children: ({ open }) => /* @__PURE__ */ jsx37(Fragment3, { children: /* @__PURE__ */ jsxs12("div", { className: "fw-relative fw-w-full", children: [
    /* @__PURE__ */ jsxs12(Listbox.Button, { "aria-label": inputName, as: "button", className: buttonCn, children: [
      `${buttonValue}`,
      /* @__PURE__ */ jsx37(Chevron, { className: chevronCn(open) })
    ] }),
    /* @__PURE__ */ jsx37(Listbox.Options, { as: "ul", className: optionsCn(open), children: options.filter((option) => showBlank || option.value !== "").map((option, index) => /* @__PURE__ */ jsx37(Listbox.Option, { value: option, className: optionCn, children: ({ active }) => /* @__PURE__ */ jsx37(Prefix, { option, active }) }, index)) })
  ] }) }) });
};

// ../internal-components/src/components/PhoneNumber/utils.ts
var splitPhoneNumber = (phoneValue, dialingCodes = []) => {
  if (!phoneValue || phoneValue === "" || !dialingCodes.length) {
    return {
      phoneNumber: "",
      prefix: ""
    };
  }
  const onlyDigits = removeNonDigits(phoneValue);
  const prefix = includesPreffix(phoneValue) ? getDialingCodeFromPhone(onlyDigits, dialingCodes) : "";
  const phoneNumber = prefix ? onlyDigits.replace(prefix, "") : onlyDigits;
  return {
    phoneNumber,
    prefix
  };
};
var includesPreffix = (number) => number[0] === "+";
var joinPhoneNumberWithPrefix = (prefix = "", phoneNumber) => {
  const phoneNumberFormatted = removeNonDigits(phoneNumber);
  return prefix ? `+${prefix} ${phoneNumberFormatted}` : phoneNumberFormatted;
};
var getDialingCodeFromPhone = (phoneNumber, dialingCodes = []) => {
  const selectedCountries = dialingCodes.filter((dialingCode) => phoneNumber.startsWith(dialingCode)).sort(compareDialingCodes);
  return selectedCountries.length ? selectedCountries[0] : void 0;
};
var removeNonDigits = (value) => value.replace(/[^\d]/g, "");
var compareDialingCodes = (dialingCode1, dialingCode2) => {
  const length1 = dialingCode1 && dialingCode1.length || 0;
  const length2 = dialingCode2 && dialingCode2.length || 0;
  if (length1 > length2)
    return -1;
  if (length1 < length2)
    return 1;
  return 0;
};

// ../internal-components/src/utils/keys.ts
var Keys = {
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
  C: "c",
  COMMA: ",",
  DELETE: "Backspace",
  ENTER: "Enter",
  ESC: "Escape",
  NUMPAD_0: "0",
  NUMPAD_1: "1",
  NUMPAD_2: "2",
  NUMPAD_3: "3",
  NUMPAD_4: "4",
  NUMPAD_5: "5",
  NUMPAD_6: "6",
  NUMPAD_7: "7",
  NUMPAD_8: "8",
  NUMPAD_9: "9",
  PERIOD: ".",
  SPACE: " ",
  SUPR: "Delete",
  TAB: "Tab",
  V: "v",
  X: "x"
};

// ../internal-components/src/components/PhoneNumber/PhoneNumber.tsx
import { Field as Field6 } from "@flywire/react-headlessui";
import { jsx as jsx38, jsxs as jsxs13 } from "react/jsx-runtime";
var PhoneNumber = (props) => {
  const { pattern = PHONE_NUMBER_PATTERN, minLength, maxLength, required = false } = props;
  const { t } = useTranslations();
  const { getErrorLabel } = useErrorLabelForField();
  const error = getErrorLabel(FIELDS.PHONE);
  const label = useMemo14(() => t("tokenizationForm.labels.phone"), [t]);
  const { getValues, control, setValue } = useFormContext15();
  const dialingCodes = useMemo14(() => props.countries.map((c) => c.dialingCode), [props.countries]);
  const options = useMemo14(
    () => props.countries.map((c) => ({ name: c.label, value: c.dialingCode })),
    [props.countries]
  );
  const validate = (value) => {
    if (!pattern.test(value)) {
      return t("bankAccountForm.errors.phone");
    }
  };
  const inputCn = useMemo14(
    () => classNames14(
      `fw-relative fw-peer fw-block fw-h-12 fw-w-full fw-px-2 fw-pt-4
        fw-text-base fw-text-mirage-900 fw-appearance-none fw-rounded-sm fw-border fw-border-shuttle-gray-100 fw-rounded-l-none
        hover:fw-border-shuttle-gray-200 fw-outline-none focus:fw-border-primary-600 focus:fw-shadow-lg-blue focus:fw-outline-none placeholder:fw-invisible`,
      {
        "fw-shadow-lg-red !fw-border-red-600 hover:fw-border-red-600 focus:fw-border-red-600 focus:fw-shadow-lg-red": error
      }
    ),
    [error]
  );
  const handlePrefixChange = useCallback11(
    (option) => {
      const currentValue = getValues(FIELDS.PHONE);
      const phone = splitPhoneNumber(currentValue, dialingCodes).phoneNumber;
      const newValue = joinPhoneNumberWithPrefix(option.value, phone);
      setValue(FIELDS.PHONE, newValue);
    },
    [dialingCodes, getValues, setValue]
  );
  const handlePhoneChange = useCallback11(
    (e) => {
      const phone = getValues(FIELDS.PHONE);
      const prefix = splitPhoneNumber(phone, dialingCodes).prefix;
      const value = joinPhoneNumberWithPrefix(prefix, e.target.value);
      setValue(FIELDS.PHONE, value, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
    },
    [dialingCodes, getValues, setValue]
  );
  return /* @__PURE__ */ jsx38("div", { "data-testid": "phone-test", className: props.className, children: /* @__PURE__ */ jsx38(
    Controller4,
    {
      defaultValue: getValues(FIELDS.PHONE) || "",
      name: FIELDS.PHONE,
      control,
      disabled: props.disabled,
      rules: {
        maxLength: maxLength || 256,
        minLength: minLength || 1,
        required: {
          value: required,
          message: t("bankAccountForm.errors.phone") || "Invalid field"
        },
        validate
      },
      render: ({ field: { value, onBlur } }) => {
        const phone = splitPhoneNumber(value, dialingCodes);
        return /* @__PURE__ */ jsxs13(Field6.Group, { className: "fw-w-full", as: "div", children: [
          /* @__PURE__ */ jsx38(
            PrefixList,
            {
              onChange: handlePrefixChange,
              value: phone.prefix,
              options,
              error,
              showBlank: false,
              inputName: "phone country code"
            }
          ),
          /* @__PURE__ */ jsxs13(Field6, { className: "fw-absolute fw-top-0 fw-left-[95px] fw-right-0", children: [
            /* @__PURE__ */ jsx38(
              Field6.Input,
              {
                className: inputCn,
                placeholder: " ",
                onKeyDown: onInputKeyDown,
                onChange: handlePhoneChange,
                value: phone.phoneNumber,
                required: false,
                onBlur
              }
            ),
            /* @__PURE__ */ jsx38(InputLabel, { placeholder: label, children: label })
          ] }),
          /* @__PURE__ */ jsx38(InputError, { children: error })
        ] });
      }
    }
  ) });
};
var onInputKeyDown = (evt) => {
  const isControl = evt.ctrlKey || evt.metaKey;
  const isCopy = isControl && evt.key === Keys.C;
  const isCut = isControl && evt.key === Keys.X;
  const isNumber = /\d/.test(evt.key);
  const isPaste = isControl && evt.key === Keys.V;
  const allowedChars = [
    Keys.DELETE,
    Keys.ARROW_LEFT,
    Keys.NUMPAD_0,
    Keys.NUMPAD_1,
    Keys.NUMPAD_2,
    Keys.NUMPAD_3,
    Keys.NUMPAD_4,
    Keys.NUMPAD_5,
    Keys.NUMPAD_6,
    Keys.NUMPAD_7,
    Keys.NUMPAD_8,
    Keys.NUMPAD_9,
    Keys.ARROW_RIGHT,
    Keys.SUPR,
    Keys.TAB
  ].includes(evt.key);
  if (!isNumber && !allowedChars && !isPaste && !isCopy && !isCut) {
    evt.preventDefault();
  }
};
PhoneNumber.displayName = "PhoneNumber";

// ../internal-components/src/components/PayerInfo/formHelpers.tsx
function adaptAPIPayerErrorsToForm(validationErrors) {
  return validationErrors?.map((e) => {
    if (e.param === "first_name") {
      return { ...e, param: "name" };
    }
    if (e.param === "last_name") {
      return { ...e, param: "surname" };
    }
    if (e.param === "bin") {
      return { ...e, param: "cardNumber" };
    }
    return e;
  });
}

// ../internal-components/src/components/PayerInfo/DefaultPayerInfo.tsx
import { Fragment as Fragment4, jsx as jsx39, jsxs as jsxs14 } from "react/jsx-runtime";
var DefaultPayerInfo = ({ schema }) => {
  const {
    state: { urls, locale, sessionType, recipient, amount, sessionId }
  } = useCardsContext();
  const { control, setError } = useFormContext16();
  const country = useWatch10({ control, name: FIELDS.COUNTRY });
  const { payerValidationErrors, cardData } = useSafeContext(CardElementContext);
  const { t } = useTranslations();
  const { countries: countries2 } = useCountries(urls.fetchCountries, locale);
  const { offer } = useOffer({
    baseUrl: urls.fetchOffer,
    amount,
    country,
    currency: countries2 && country ? countries2.find((c) => c.value === country)?.currency : void 0,
    recipientId: recipient.id,
    sessionId,
    sessionType,
    cardScheme: cardData?.cardScheme,
    cardType: cardData?.cardType
  });
  useEffect10(() => {
    const formErrors = adaptAPIPayerErrorsToForm(payerValidationErrors);
    formErrors?.map((error) => {
      if (error.param) {
        setError(error.param, {
          type: "invalid"
        });
      }
    });
  }, [payerValidationErrors, setError]);
  const {
    fields: optionFields,
    error: currencyError,
    isLoading: areCurrenciesLoading
  } = usePaymentOptions({
    url: urls.fetchPaymentOptions,
    country,
    recipient: recipient.id,
    sessionType
  });
  const dynamicFields = sessionType === TOKENIZATION_AND_PAY ? offer?.fields : optionFields;
  const shouldShowState = !!(country && (country === UNITED_STATES || country === CHINA));
  switch (schema) {
    case DD_BACS:
    case DD_ACH:
    case DD_SEPA:
    case DD_EFT:
    default:
      return /* @__PURE__ */ jsxs14(Fragment4, { children: [
        /* @__PURE__ */ jsx39(FirstName, {}),
        /* @__PURE__ */ jsx39(LastName, {}),
        /* @__PURE__ */ jsx39(EmailField, {}),
        /* @__PURE__ */ jsx39(City, {}),
        /* @__PURE__ */ jsx39(
          Country,
          {
            countries: countries2,
            error: currencyError || void 0,
            loading: areCurrenciesLoading
          }
        ),
        shouldShowState && /* @__PURE__ */ jsx39(
          State,
          {
            required: country === "US" || country === "CN",
            validate: (value) => {
              if ((country === "US" || country === "CN") && !value) {
                return t("bankAccountForm.errors.state");
              }
            }
          }
        ),
        /* @__PURE__ */ jsx39(Address, { className: "xs:fw-col-span-2" }),
        /* @__PURE__ */ jsx39(ZipCode, {}),
        /* @__PURE__ */ jsx39(PhoneNumber, { countries: countries2 || [], required: true }),
        /* @__PURE__ */ jsx39(DynamicFields, { fields: dynamicFields || [] })
      ] });
  }
};

// ../internal-components/src/components/PayerInfo/PayerInfo.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
var PhoneNumber2 = () => void 0;
PhoneNumber2.displayName = "PhoneNumber";
var VALID_ELEMENTS = [
  FirstName,
  LastName,
  City,
  Address,
  State,
  ZipCode,
  AccountHolderName,
  EmailField,
  ReadonlyCountry,
  Country,
  DynamicFields,
  PhoneNumber2
];
var PayerInfo = (props) => {
  const { children } = props;
  const cn = useMemo15(
    () => classNames15("fw-grid fw-grid-cols-1 xs:fw-grid-cols-2 fw-gap-y-9 fw-gap-x-5", props.className),
    [props.className]
  );
  const renderChildren = useMemo15(() => {
    let validChildCount = 0;
    const _children = Children.map(children, (child) => {
      if (!isValidElement(child)) {
        return null;
      }
      const elementType = typeof child.type === "string" ? child.type : child.type.displayName;
      if (!elementType)
        return null;
      if (!VALID_ELEMENTS.map((e) => e.displayName).includes(elementType)) {
        return null;
      }
      validChildCount++;
      return cloneElement(child, {
        ...child.props,
        className: classNames15("fw-relative", child.props.className)
      });
    });
    if (validChildCount > 0) {
      return _children;
    }
    return /* @__PURE__ */ jsx40(DefaultPayerInfo, {});
  }, [children]);
  return /* @__PURE__ */ jsx40("div", { className: cn, style: props.style, children: renderChildren });
};

// src/PayerElement/usePayerElementOnChange.tsx
import { useContext as useContext3, useEffect as useEffect11, useMemo as useMemo16 } from "react";
import { useFormContext as useFormContext17, useWatch as useWatch11 } from "react-hook-form";
var usePayerElementOnChange = ({ onChange }) => {
  const { control } = useFormContext17();
  const cardElementContext = useContext3(CardElementContext);
  const {
    state: { urls, locale }
  } = useCardsContext();
  const { countries: countries2 } = useCountries(urls.fetchCountries, locale);
  const country = useWatch11({ control, name: FIELDS.COUNTRY });
  const countryCurrency = useMemo16(
    () => countries2 && country ? countries2.find((c) => c.value === country)?.currency : void 0,
    [countries2, country]
  );
  useEffect11(() => {
    onChange?.({ country });
    if (!cardElementContext) {
      return;
    }
    cardElementContext.setCountry(country);
    cardElementContext.setCurrency(countryCurrency);
  }, [country, countryCurrency, cardElementContext?.setCountry, cardElementContext?.setCurrency]);
};

// src/PayerElement/PayerElement.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var PayerElement = (props) => {
  const { setValidationStrategy } = useSafeContext(CardElementContext);
  usePayerElementOnChange({ onChange: props.onChange });
  useEffect12(() => {
    setValidationStrategy(props.validationStrategy || "senders");
  }, [props?.validationStrategy, setValidationStrategy]);
  return /* @__PURE__ */ jsx41("div", { className: BASE_CSS_CLASS, children: /* @__PURE__ */ jsx41(PayerInfo, { ...props }) });
};
PayerElement.FirstName = FirstName;
PayerElement.LastName = LastName;
PayerElement.Country = Country;
PayerElement.Email = EmailField;
PayerElement.Phone = PhoneNumber;
PayerElement.State = State;
PayerElement.Address = Address;
PayerElement.City = City;
PayerElement.Zip = ZipCode;

// src/AmountElement/AmountElement.tsx
import useDeepCompareEffect from "use-deep-compare-effect";

// ../internal-components/src/components/AmountPanel/AmountPanel.tsx
import classNames16 from "classnames";
import { useMemo as useMemo17 } from "react";

// ../internal-components/src/hooks/useBinLookup/useIntlPercentageFormatter/useIntlPercentageFormatter.tsx
var useIntlPercentageFormatter = () => {
  const formatPercentage = (value) => {
    if (typeof Intl !== "undefined" && Intl.NumberFormat) {
      const formatter = new Intl.NumberFormat(navigator.language, {
        style: "percent",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      return formatter.format(value);
    } else {
      return `${(value * 100).toFixed(2)}%`;
    }
  };
  return { formatPercentage };
};

// ../internal-components/src/components/AmountPanel/FeeInformationTooltip.tsx
import { jsx as jsx42 } from "react/jsx-runtime";
var FeeInformationTooltip = (props) => {
  return /* @__PURE__ */ jsx42(
    "div",
    {
      id: props.domId,
      className: `
           fw-w-72 fw-cursor-default
           fw-transition-opacity fw-duration-200 fw-ease-in-out fw-bg-no-repeat
           fw-pointer-events-none fw-py-3 fw-px-4 fw-top-6 fw-h-auto
           fw-block fw-z-10 fw-bg-slate-800 fw-absolute fw-rounded-md
          fw-opacity-0 group-hover:fw-opacity-100
            `,
      role: "tooltip",
      children: /* @__PURE__ */ jsx42("div", { className: " fw-font-normal fw-tracking-[0.003em] fw-text-[0.8rem] fw-text-white/80 fw-leading-[1.4]", children: props.message })
    }
  );
};

// ../internal-components/src/components/AmountPanel/WarningIcon.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
function WarningIcon(props) {
  return /* @__PURE__ */ jsx43("span", { ...props, children: /* @__PURE__ */ jsx43(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      className: props.className,
      children: /* @__PURE__ */ jsx43(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM6.00011 5.99992H8.00011V10.9999H6.00011V5.99992ZM8.00011 3.00006H6.00011V5.00006H8.00011V3.00006Z",
          fill: "#5A687B"
        }
      )
    }
  ) });
}

// ../internal-components/src/components/AmountPanel/formatAmount.ts
import Dinero from "dinero.js";
var formatAmount = ({
  amount,
  currencyCode,
  subunitToUnit,
  format,
  locale
}) => {
  const calculatedPrecision = Math.log10(subunitToUnit);
  const precision = Number.isInteger(calculatedPrecision) ? calculatedPrecision : 0;
  return Dinero({
    amount,
    currency: currencyCode,
    precision
  }).setLocale(locale ?? "en-US").toFormat(format ?? "$0,0.00");
};

// ../internal-components/src/components/AmountPanel/AmountPanel.tsx
import { Fragment as Fragment5, jsx as jsx44, jsxs as jsxs15 } from "react/jsx-runtime";
var AmountPanel = (props) => {
  const { offer, recipient, loading, error, amountTo, cardScheme, locale } = props;
  const { t } = useTranslations();
  const { formatPercentage } = useIntlPercentageFormatter();
  const offerDecision = offer?.surcharge?.decision;
  const percentageValue = offer?.surcharge?.percentage ?? 0;
  const formattedPercentage = useMemo17(() => {
    return formatPercentage(percentageValue);
  }, [formatPercentage, percentageValue]);
  const labels = useMemo17(
    () => ({
      amountFromLabel: t("amountPanel.labels.amountFromLabel"),
      surchargeFeeInfo: t("amountPanel.labels.surchargeFeeInfo"),
      whyThisFee: t("amountPanel.labels.whyThisFee"),
      whyThisFeeTooltip: t("amountPanel.labels.whyThisFeeTooltip", {
        percentage: formattedPercentage.toString(),
        currency: offer?.price?.currency?.code || "",
        cardScheme: cardScheme || ""
      }),
      currencyChangeWarning: t("amountPanel.labels.currencyChangeWarning"),
      amountToLabel: t("amountPanel.labels.amountToLabel", {
        recipientName: recipient.name
      })
    }),
    [t, formattedPercentage, offer?.price?.currency?.code, cardScheme, recipient?.name]
  );
  const className = useMemo17(() => {
    let cn = "fw-bg-iron-50 fw-flex fw-min-h-28 fw-relative";
    if (error) {
      cn = `${cn} ${cn}--error`;
    }
    return cn;
  }, [error]);
  const errorMessage = useMemo17(() => {
    if (error?.type === "session_not_found") {
      return t("sessionExpired.text");
    } else if (error) {
      return t("bankAccountForm.errors.offer", { recipientName: recipient.name });
    }
    return null;
  }, [t, recipient, error]);
  if (loading) {
    return /* @__PURE__ */ jsx44(LoadingSkeleton, {});
  }
  const CardFeeInformation = ({ locale: locale2 }) => {
    return /* @__PURE__ */ jsxs15("div", { className: "fw-text-xs fw-text-shuttle-gray-500", children: [
      /* @__PURE__ */ jsxs15("span", { className: "fw-mr-2", children: [
        formatAmount({
          amount: offer?.surcharge?.fee_amount ?? 0,
          currencyCode: offer?.price.currency.code ?? "USD",
          subunitToUnit: offer?.price.currency.subunit_to_unit ?? 100,
          format: "USD0,0.0",
          locale: locale2
        }),
        " ",
        labels.surchargeFeeInfo
      ] }),
      /* @__PURE__ */ jsxs15("span", { className: "fw-group fw-relative fw-inline-block fw-underline fw-decoration-dotted fw-text-primary-600", children: [
        labels.whyThisFee,
        /* @__PURE__ */ jsx44(
          FeeInformationTooltip,
          {
            message: labels.whyThisFeeTooltip,
            domId: "whyThisFee-Label-Tooltip"
          }
        )
      ] })
    ] });
  };
  const CurrencyChangedWarning = () => {
    return /* @__PURE__ */ jsxs15("div", { className: "fw-flex fw-text-xs fw-text-shuttle-gray-500 fw-mt-1.5", children: [
      /* @__PURE__ */ jsx44(WarningIcon, { className: "fw-mt-[0.5px]" }),
      /* @__PURE__ */ jsx44("span", { className: "fw-ml-1.5", children: labels.currencyChangeWarning })
    ] });
  };
  return /* @__PURE__ */ jsxs15("div", { className: "fw-flex fw-flex-col fw-mb-7 fw-w-full", children: [
    /* @__PURE__ */ jsxs15("div", { className, children: [
      /* @__PURE__ */ jsxs15(PriceContainer, { className: "p-4 sm:p-8", children: [
        /* @__PURE__ */ jsx44("div", { className: "text-sm sm:text-base fw-text-shuttle-gray-500", children: labels.amountFromLabel }),
        /* @__PURE__ */ jsx44(
          "div",
          {
            className: "text-xl sm:text-2xl fw-font-medium fw-text-mirage-900",
            "data-testid": "amount-panel-amount-from",
            children: offer && !errorMessage ? formatAmount({
              amount: offer.price.value,
              currencyCode: offer.price.currency.code,
              subunitToUnit: offer.price.currency.subunit_to_unit,
              locale
            }) : "--"
          }
        ),
        offerDecision === "block" && !errorMessage && /* @__PURE__ */ jsx44(CurrencyChangedWarning, {}),
        offerDecision === "surcharge" && !errorMessage && /* @__PURE__ */ jsx44(CardFeeInformation, { locale })
      ] }),
      /* @__PURE__ */ jsxs15(PriceContainer, { className: "p-4 sm:p-8 fw-items-end fw-border-none", children: [
        /* @__PURE__ */ jsx44("div", { className: "text-sm sm:text-base", children: labels.amountToLabel }),
        /* @__PURE__ */ jsx44("div", { className: "text-xl sm:text-2xl", "data-testid": "amount-panel-amount-to", children: formatAmount({
          amount: amountTo,
          currencyCode: recipient.currency.code,
          subunitToUnit: recipient.currency.subunit_to_unit,
          locale
        }) })
      ] })
    ] }),
    error && errorMessage ? /* @__PURE__ */ jsx44(OfferError, { errorMessage }) : /* @__PURE__ */ jsx44(Fragment5, {})
  ] });
};
var OfferError = ({ errorMessage }) => {
  return /* @__PURE__ */ jsx44("p", { className: "fw-text-[#d63442] fw-block fw-text-xs fw-font-medium fw-leading-[1.4] fw-mt-2 fw-mb-0 fw-mx-0 ", children: errorMessage });
};
var LoadingSkeleton = () => {
  return /* @__PURE__ */ jsx44("div", { "data-testid": "skeleton-loader", className: "fw-flex fw-flex-col fw-mb-7 fw-w-full", children: /* @__PURE__ */ jsxs15("div", { className: "fw-bg-iron-50 fw-flex fw-min-h-[106px] fw-relative", children: [
    /* @__PURE__ */ jsxs15(PriceContainer, { children: [
      /* @__PURE__ */ jsx44(SkeletonBar, {}),
      /* @__PURE__ */ jsx44(SkeletonBar, { className: "!fw-w-28" })
    ] }),
    /* @__PURE__ */ jsxs15(PriceContainer, { className: "fw-items-end fw-border-none", children: [
      /* @__PURE__ */ jsx44(SkeletonBar, {}),
      /* @__PURE__ */ jsx44(SkeletonBar, { className: "!fw-w-28" })
    ] })
  ] }) });
};
var SkeletonBar = ({ className }) => {
  return /* @__PURE__ */ jsx44(
    "div",
    {
      "aria-hidden": "true",
      className: classNames16(
        "fw-w-36 fw-p-2.5 fw-mb-1 fw-bg-iron-200 fw-text-iron-200 fw-border fw-rounded fw-border-solid fw-border-iron-200 fw-animate-pulse",
        className
      )
    }
  );
};
var PriceContainer = ({
  className,
  children
}) => {
  const cn = classNames16(
    className,
    "fw-flex fw-flex-1 fw-flex-col fw-justify-between fw-p-4 fw-border-r-iron-200 fw-border-r fw-border-solid"
  );
  return /* @__PURE__ */ jsx44("div", { className: cn, children });
};

// src/AmountElement/hooks/useSurchargeBlock.tsx
import { useEffect as useEffect13 } from "react";
var useSurchargeBlock = ({ offer }) => {
  const { setOfferError, cardData, setCardCurrency } = useSafeContext(CardElementContext);
  useEffect13(() => {
    if (offer?.surcharge?.decision === "block" && !cardData?.currency && cardData?.cardScheme) {
      setOfferError({
        type: "offer_not_found",
        error: new RequestError("card currency is null for blocked surcharge decision")
      });
      setCardCurrency(void 0);
    } else if (offer?.surcharge?.decision === "block" && cardData?.currency && cardData?.cardScheme) {
      setOfferError(void 0);
      setCardCurrency(cardData?.currency);
    }
  }, [
    offer?.surcharge?.decision,
    cardData?.currency,
    setOfferError,
    cardData?.cardScheme,
    setCardCurrency
  ]);
};

// src/AmountElement/AmountElement.tsx
import { Fragment as Fragment6, jsx as jsx45 } from "react/jsx-runtime";
var AmountElement = () => {
  const { country, currency, setOfferError, cardData, offerError, cardCurrency } = useSafeContext(CardElementContext);
  const {
    state: { recipient, sessionType, amount, urls, sessionId, locale }
  } = useCardsContext();
  const isTokenizationAndPay = sessionType === "tokenization_and_pay";
  const baseUrl = urls.fetchOffer;
  const {
    offer,
    error: requestedOfferError,
    isMutating: isOfferLoading
  } = useOffer({
    baseUrl,
    sessionId,
    sessionType,
    recipientId: recipient.id,
    amount,
    country,
    currency: cardCurrency?.code ?? currency,
    cardScheme: cardData?.cardScheme,
    cardType: cardData?.cardType,
    cardCountry: cardData?.cardCountry,
    cardProductType: cardData?.cardProductType
  });
  useSurchargeBlock({ offer });
  useDeepCompareEffect(() => {
    setOfferError(requestedOfferError ?? void 0);
  }, [setOfferError, requestedOfferError]);
  return /* @__PURE__ */ jsx45(Fragment6, { children: isTokenizationAndPay && amount && /* @__PURE__ */ jsx45(
    AmountPanel,
    {
      offer,
      amountTo: amount,
      error: offerError ?? requestedOfferError,
      loading: isOfferLoading,
      cardScheme: cardData?.cardScheme,
      recipient,
      locale
    }
  ) });
};
export {
  AmountElement,
  CardElementNamespace as CardElement,
  CardNewMandateNamespace as CardNewMandate,
  PayerElement
};
//# sourceMappingURL=index.js.map
